/* eslint-disable */
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Custom GraphQL date type. */
  Date: any;
  /** Custom GraphQL datetime type. */
  DateTime: any;
  /** The `Iterable` scalar type represents an array or a Traversable with any kind of data. */
  Iterable: any;
  /** Custom GraphQL time type. */
  Time: any;
};

export enum AccessErrorTypeEnum {
  LicenseExpired = "license_expired",
  UserInactive = "user_inactive",
  WrongPassword = "wrong_password",
  WrongPinCode = "wrong_pin_code"
}

export type AccessLog = Node & {
  _id: Scalars["Int"];
  accessStatus: AccessStatusEnum;
  accessTypeEnum: AccessTypeEnum;
  browser: Scalars["String"];
  createdAt: Scalars["DateTime"];
  errorType?: Maybe<AccessErrorTypeEnum>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  ip: Scalars["String"];
  user: User;
};

export type AccessLogEndFilter = {
  user_firstName?: InputMaybe<Scalars["String"]>;
  user_lastName?: InputMaybe<Scalars["String"]>;
};

export type AccessLogEqualFilter = {
  createdAt?: InputMaybe<Scalars["String"]>;
  user_firstName?: InputMaybe<Scalars["String"]>;
  user_lastName?: InputMaybe<Scalars["String"]>;
};

export type AccessLogExistsFilter = {
  createdAt?: InputMaybe<Scalars["Boolean"]>;
  user_firstName?: InputMaybe<Scalars["Boolean"]>;
  user_lastName?: InputMaybe<Scalars["Boolean"]>;
};

export type AccessLogFilter = {
  OR?: InputMaybe<Array<InputMaybe<AccessLogFilter>>>;
  concat?: InputMaybe<AccessLogFilterConcat>;
  end?: InputMaybe<AccessLogEndFilter>;
  equal?: InputMaybe<AccessLogEqualFilter>;
  exists?: InputMaybe<AccessLogExistsFilter>;
  in?: InputMaybe<AccessLogInFilter>;
  like?: InputMaybe<AccessLogLikeFilter>;
  range?: InputMaybe<AccessLogRangeFilter>;
  start?: InputMaybe<AccessLogStartFilter>;
};

export type AccessLogFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: AccessLogFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AccessLogFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type AccessLogFilter_Order = {
  user_firstName?: InputMaybe<Scalars["String"]>;
  user_lastName?: InputMaybe<Scalars["String"]>;
};

export type AccessLogInFilter = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  user_firstName?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  user_lastName?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type AccessLogLikeFilter = {
  user_firstName?: InputMaybe<Scalars["String"]>;
  user_lastName?: InputMaybe<Scalars["String"]>;
};

/** Page connection for AccessLog. */
export type AccessLogPageConnection = {
  collection: Array<AccessLog>;
  paginationInfo: AccessLogPaginationInfo;
};

/** Information about the pagination. */
export type AccessLogPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AccessLogRangeFilter = {
  createdAt?: InputMaybe<RangeFilter>;
};

export type AccessLogStartFilter = {
  user_firstName?: InputMaybe<Scalars["String"]>;
  user_lastName?: InputMaybe<Scalars["String"]>;
};

export enum AccessStatusEnum {
  Successful = "successful",
  Unsuccessful = "unsuccessful"
}

export enum AccessTypeEnum {
  LogIn = "log_in",
  LogInPin = "log_in_pin",
  LogOut = "log_out"
}

export type AdditionalDiagnosticTest = Node & {
  _id: Scalars["Int"];
  diagnosticTesting: DiagnosticTesting;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  test: Scalars["String"];
  toPerform: Scalars["Boolean"];
};

export type AdditionalDiagnosticTestEndFilter = {
  test?: InputMaybe<Scalars["String"]>;
};

export type AdditionalDiagnosticTestEqualFilter = {
  diagnosticTesting_id?: InputMaybe<Scalars["Int"]>;
  test?: InputMaybe<Scalars["String"]>;
};

export type AdditionalDiagnosticTestExistsFilter = {
  diagnosticTesting_id?: InputMaybe<Scalars["Boolean"]>;
  test?: InputMaybe<Scalars["Boolean"]>;
};

export type AdditionalDiagnosticTestFilter = {
  OR?: InputMaybe<Array<InputMaybe<AdditionalDiagnosticTestFilter>>>;
  concat?: InputMaybe<AdditionalDiagnosticTestFilterConcat>;
  end?: InputMaybe<AdditionalDiagnosticTestEndFilter>;
  equal?: InputMaybe<AdditionalDiagnosticTestEqualFilter>;
  exists?: InputMaybe<AdditionalDiagnosticTestExistsFilter>;
  in?: InputMaybe<AdditionalDiagnosticTestInFilter>;
  like?: InputMaybe<AdditionalDiagnosticTestLikeFilter>;
  range?: InputMaybe<AdditionalDiagnosticTestRangeFilter>;
  start?: InputMaybe<AdditionalDiagnosticTestStartFilter>;
};

export type AdditionalDiagnosticTestFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: AdditionalDiagnosticTestFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AdditionalDiagnosticTestFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type AdditionalDiagnosticTestInFilter = {
  diagnosticTesting_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  test?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type AdditionalDiagnosticTestLikeFilter = {
  test?: InputMaybe<Scalars["String"]>;
};

/** Page connection for AdditionalDiagnosticTest. */
export type AdditionalDiagnosticTestPageConnection = {
  collection: Array<AdditionalDiagnosticTest>;
  paginationInfo: AdditionalDiagnosticTestPaginationInfo;
};

/** Information about the pagination. */
export type AdditionalDiagnosticTestPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AdditionalDiagnosticTestRangeFilter = {
  diagnosticTesting_id?: InputMaybe<RangeFilter>;
};

export type AdditionalDiagnosticTestStartFilter = {
  test?: InputMaybe<Scalars["String"]>;
};

export enum AnesthesiaSystemEnum {
  NonRebreathing = "non_rebreathing",
  Rebreathing = "rebreathing"
}

export type AnestheticGas = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  inhalantAnestheticAgent?: Maybe<Scalars["Float"]>;
  organization: Organization;
  oxygen?: Maybe<Scalars["Float"]>;
  patient: Patient;
  timeMonitoring?: Maybe<Scalars["DateTime"]>;
};

export type AnestheticGasEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type AnestheticGasExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type AnestheticGasFilter = {
  OR?: InputMaybe<Array<InputMaybe<AnestheticGasFilter>>>;
  concat?: InputMaybe<AnestheticGasFilterConcat>;
  equal?: InputMaybe<AnestheticGasEqualFilter>;
  exists?: InputMaybe<AnestheticGasExistsFilter>;
  in?: InputMaybe<AnestheticGasInFilter>;
  range?: InputMaybe<AnestheticGasRangeFilter>;
};

export type AnestheticGasFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: AnestheticGasFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AnestheticGasFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type AnestheticGasInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export enum AnestheticGasMedicationEnum {
  Isoflurane = "isoflurane",
  Sevoflurane = "sevoflurane"
}

/** Page connection for AnestheticGas. */
export type AnestheticGasPageConnection = {
  collection: Array<AnestheticGas>;
  paginationInfo: AnestheticGasPaginationInfo;
};

/** Information about the pagination. */
export type AnestheticGasPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AnestheticGasRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type AnestheticProtocol = Node & {
  _id: Scalars["Int"];
  createdBy: User;
  defaultProtocol: Scalars["Boolean"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medicationCalculations?: Maybe<
    AnestheticProtocolMedicationCalculationPageConnection
  >;
  name: Scalars["String"];
  organization: Organization;
  regionalBlocks?: Maybe<AnestheticProtocolRegionalBlockPageConnection>;
};

export type AnestheticProtocolMedicationCalculationsArgs = {
  filter?: InputMaybe<AnestheticProtocolMedicationCalculationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type AnestheticProtocolRegionalBlocksArgs = {
  filter?: InputMaybe<AnestheticProtocolRegionalBlockFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type AnestheticProtocolEndFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type AnestheticProtocolEqualFilter = {
  createdBy_id?: InputMaybe<Scalars["Int"]>;
  defaultProtocol?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type AnestheticProtocolExistsFilter = {
  createdBy_id?: InputMaybe<Scalars["Boolean"]>;
  defaultProtocol?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
};

export type AnestheticProtocolFilter = {
  OR?: InputMaybe<Array<InputMaybe<AnestheticProtocolFilter>>>;
  concat?: InputMaybe<AnestheticProtocolFilterConcat>;
  end?: InputMaybe<AnestheticProtocolEndFilter>;
  equal?: InputMaybe<AnestheticProtocolEqualFilter>;
  exists?: InputMaybe<AnestheticProtocolExistsFilter>;
  in?: InputMaybe<AnestheticProtocolInFilter>;
  like?: InputMaybe<AnestheticProtocolLikeFilter>;
  range?: InputMaybe<AnestheticProtocolRangeFilter>;
  start?: InputMaybe<AnestheticProtocolStartFilter>;
};

export type AnestheticProtocolFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: AnestheticProtocolFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AnestheticProtocolFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type AnestheticProtocolInFilter = {
  createdBy_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  defaultProtocol?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type AnestheticProtocolLikeFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type AnestheticProtocolMedicationCalculation = Node & {
  _id: Scalars["Int"];
  additionalVolumeAdministered?: Maybe<Scalars["Float"]>;
  additionalVolumeDrawn?: Maybe<Scalars["Float"]>;
  anestheticProtocol: AnestheticProtocol;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medication: Scalars["String"];
  organization: Organization;
  route: RouteEnum;
  type: MedicationCalculationTypeEnum;
  volumeAdministered?: Maybe<Scalars["Float"]>;
};

export type AnestheticProtocolMedicationCalculationEqualFilter = {
  anestheticProtocol_id?: InputMaybe<Scalars["Int"]>;
};

export type AnestheticProtocolMedicationCalculationExistsFilter = {
  anestheticProtocol_id?: InputMaybe<Scalars["Boolean"]>;
};

export type AnestheticProtocolMedicationCalculationFilter = {
  OR?: InputMaybe<
    Array<InputMaybe<AnestheticProtocolMedicationCalculationFilter>>
  >;
  concat?: InputMaybe<AnestheticProtocolMedicationCalculationFilterConcat>;
  equal?: InputMaybe<AnestheticProtocolMedicationCalculationEqualFilter>;
  exists?: InputMaybe<AnestheticProtocolMedicationCalculationExistsFilter>;
  in?: InputMaybe<AnestheticProtocolMedicationCalculationInFilter>;
  range?: InputMaybe<AnestheticProtocolMedicationCalculationRangeFilter>;
};

export type AnestheticProtocolMedicationCalculationFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: AnestheticProtocolMedicationCalculationFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AnestheticProtocolMedicationCalculationFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type AnestheticProtocolMedicationCalculationInFilter = {
  anestheticProtocol_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for AnestheticProtocolMedicationCalculation. */
export type AnestheticProtocolMedicationCalculationPageConnection = {
  collection: Array<AnestheticProtocolMedicationCalculation>;
  paginationInfo: AnestheticProtocolMedicationCalculationPaginationInfo;
};

/** Information about the pagination. */
export type AnestheticProtocolMedicationCalculationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AnestheticProtocolMedicationCalculationRangeFilter = {
  anestheticProtocol_id?: InputMaybe<RangeFilter>;
};

/** Page connection for AnestheticProtocol. */
export type AnestheticProtocolPageConnection = {
  collection: Array<AnestheticProtocol>;
  paginationInfo: AnestheticProtocolPaginationInfo;
};

/** Information about the pagination. */
export type AnestheticProtocolPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AnestheticProtocolRangeFilter = {
  createdBy_id?: InputMaybe<RangeFilter>;
};

export type AnestheticProtocolRegionalBlock = Node & {
  _id: Scalars["Int"];
  anestheticProtocol: AnestheticProtocol;
  concentration: Scalars["Float"];
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medication: Scalars["String"];
  organization: Organization;
  type: RegionalBlockTypeEnum;
  volumeToBeInfused?: Maybe<Scalars["Float"]>;
};

export type AnestheticProtocolRegionalBlockEqualFilter = {
  anestheticProtocol_id?: InputMaybe<Scalars["Int"]>;
};

export type AnestheticProtocolRegionalBlockExistsFilter = {
  anestheticProtocol_id?: InputMaybe<Scalars["Boolean"]>;
};

export type AnestheticProtocolRegionalBlockFilter = {
  OR?: InputMaybe<Array<InputMaybe<AnestheticProtocolRegionalBlockFilter>>>;
  concat?: InputMaybe<AnestheticProtocolRegionalBlockFilterConcat>;
  equal?: InputMaybe<AnestheticProtocolRegionalBlockEqualFilter>;
  exists?: InputMaybe<AnestheticProtocolRegionalBlockExistsFilter>;
  in?: InputMaybe<AnestheticProtocolRegionalBlockInFilter>;
  range?: InputMaybe<AnestheticProtocolRegionalBlockRangeFilter>;
};

export type AnestheticProtocolRegionalBlockFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: AnestheticProtocolRegionalBlockFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum AnestheticProtocolRegionalBlockFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type AnestheticProtocolRegionalBlockInFilter = {
  anestheticProtocol_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for AnestheticProtocolRegionalBlock. */
export type AnestheticProtocolRegionalBlockPageConnection = {
  collection: Array<AnestheticProtocolRegionalBlock>;
  paginationInfo: AnestheticProtocolRegionalBlockPaginationInfo;
};

/** Information about the pagination. */
export type AnestheticProtocolRegionalBlockPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AnestheticProtocolRegionalBlockRangeFilter = {
  anestheticProtocol_id?: InputMaybe<RangeFilter>;
};

export type AnestheticProtocolStartFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type ApplicationSettings = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  user: User;
};

export type Authentication = Node & {
  applicationSettings: ApplicationSettings;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  refreshToken: Scalars["String"];
  sessionId: Scalars["String"];
  username: Scalars["String"];
};

export type Authorization = Node & {
  _id: Scalars["Int"];
  condition: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medicalCase: MedicalCase;
  organization: Organization;
  selected: Scalars["Boolean"];
};

/** Page connection for Authorization. */
export type AuthorizationPageConnection = {
  collection: Array<Authorization>;
  paginationInfo: AuthorizationPaginationInfo;
};

/** Information about the pagination. */
export type AuthorizationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type AuthorizationSetting = Node & {
  _id: Scalars["Int"];
  condition: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  organizationSetting: OrganizationSetting;
};

/** Page connection for AuthorizationSetting. */
export type AuthorizationSettingPageConnection = {
  collection: Array<AuthorizationSetting>;
  paginationInfo: AuthorizationSettingPaginationInfo;
};

/** Information about the pagination. */
export type AuthorizationSettingPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum BillingTypeEnum {
  Annually = "annually",
  Monthly = "monthly"
}

export enum BloodPressureMonitoringEnum {
  Invasive = "invasive",
  NonInvasive = "non_invasive"
}

export type BodyConditionScoreDescription = Node & {
  _id: Scalars["Int"];
  description: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  score: Scalars["Int"];
  species: SpeciesEnum;
};

export type BodyConditionScoreDescriptionEndFilter = {
  species?: InputMaybe<Scalars["String"]>;
};

export type BodyConditionScoreDescriptionEqualFilter = {
  score?: InputMaybe<Scalars["Int"]>;
  species?: InputMaybe<SpeciesEnum>;
};

export type BodyConditionScoreDescriptionExistsFilter = {
  score?: InputMaybe<Scalars["Boolean"]>;
  species?: InputMaybe<Scalars["Boolean"]>;
};

export type BodyConditionScoreDescriptionFilter = {
  OR?: InputMaybe<Array<InputMaybe<BodyConditionScoreDescriptionFilter>>>;
  concat?: InputMaybe<BodyConditionScoreDescriptionFilterConcat>;
  end?: InputMaybe<BodyConditionScoreDescriptionEndFilter>;
  equal?: InputMaybe<BodyConditionScoreDescriptionEqualFilter>;
  exists?: InputMaybe<BodyConditionScoreDescriptionExistsFilter>;
  in?: InputMaybe<BodyConditionScoreDescriptionInFilter>;
  like?: InputMaybe<BodyConditionScoreDescriptionLikeFilter>;
  range?: InputMaybe<BodyConditionScoreDescriptionRangeFilter>;
  start?: InputMaybe<BodyConditionScoreDescriptionStartFilter>;
};

export type BodyConditionScoreDescriptionFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: BodyConditionScoreDescriptionFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum BodyConditionScoreDescriptionFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type BodyConditionScoreDescriptionInFilter = {
  score?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  species?: InputMaybe<Array<InputMaybe<SpeciesEnum>>>;
};

export type BodyConditionScoreDescriptionLikeFilter = {
  species?: InputMaybe<Scalars["String"]>;
};

/** Page connection for BodyConditionScoreDescription. */
export type BodyConditionScoreDescriptionPageConnection = {
  collection: Array<BodyConditionScoreDescription>;
  paginationInfo: BodyConditionScoreDescriptionPaginationInfo;
};

/** Information about the pagination. */
export type BodyConditionScoreDescriptionPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type BodyConditionScoreDescriptionRangeFilter = {
  score?: InputMaybe<RangeFilter>;
};

export type BodyConditionScoreDescriptionStartFilter = {
  species?: InputMaybe<Scalars["String"]>;
};

export type Breed = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  species: SpeciesEnum;
};

export type BreedEndFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  species?: InputMaybe<Scalars["String"]>;
};

export type BreedEqualFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  species?: InputMaybe<SpeciesEnum>;
};

export type BreedExistsFilter = {
  id?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
  species?: InputMaybe<Scalars["Boolean"]>;
};

export type BreedFilter = {
  OR?: InputMaybe<Array<InputMaybe<BreedFilter>>>;
  concat?: InputMaybe<BreedFilterConcat>;
  end?: InputMaybe<BreedEndFilter>;
  equal?: InputMaybe<BreedEqualFilter>;
  exists?: InputMaybe<BreedExistsFilter>;
  in?: InputMaybe<BreedInFilter>;
  like?: InputMaybe<BreedLikeFilter>;
  start?: InputMaybe<BreedStartFilter>;
};

export type BreedFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: BreedFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum BreedFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type BreedInFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  species?: InputMaybe<Array<InputMaybe<SpeciesEnum>>>;
};

export type BreedLikeFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  species?: InputMaybe<Scalars["String"]>;
};

/** Page connection for Breed. */
export type BreedPageConnection = {
  collection: Array<Breed>;
  paginationInfo: BreedPaginationInfo;
};

/** Information about the pagination. */
export type BreedPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type BreedStartFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  species?: InputMaybe<Scalars["String"]>;
};

export type BulkAdditionalDiagnosticTest = Node & {
  collection: Array<AdditionalDiagnosticTest>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkAnestheticProtocol = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkAnestheticProtocolMedicationCalculation = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkAnestheticProtocolRegionalBlock = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkAuthorizationSetting = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkCurrentMedication = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkDefibMedication = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkDentalCharting = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkDentalSketchComment = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkDisclaimerProcedureSetting = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkMedicalCase = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkMedicationCalculation = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkPatientTest = Node & {
  collection: Array<PatientTest>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkPinAuthentication = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkRegionalBlock = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkSuspension = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkTablet = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type BulkVaccine = Node & {
  collection: Array<Vaccine>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type CalculationAgreement = Node & {
  _id: Scalars["Int"];
  agreed: Scalars["Boolean"];
  fakeId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
  id: Scalars["ID"];
  organization: Organization;
  patient?: Maybe<Patient>;
  signedAt?: Maybe<Scalars["DateTime"]>;
};

export type CalculationAgreementEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type CalculationAgreementExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type CalculationAgreementFilter = {
  OR?: InputMaybe<Array<InputMaybe<CalculationAgreementFilter>>>;
  concat?: InputMaybe<CalculationAgreementFilterConcat>;
  equal?: InputMaybe<CalculationAgreementEqualFilter>;
  exists?: InputMaybe<CalculationAgreementExistsFilter>;
  in?: InputMaybe<CalculationAgreementInFilter>;
  range?: InputMaybe<CalculationAgreementRangeFilter>;
};

export type CalculationAgreementFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: CalculationAgreementFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum CalculationAgreementFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type CalculationAgreementInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for CalculationAgreement. */
export type CalculationAgreementPageConnection = {
  collection: Array<CalculationAgreement>;
  paginationInfo: CalculationAgreementPaginationInfo;
};

/** Information about the pagination. */
export type CalculationAgreementPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type CalculationAgreementRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type CalculationsAnestheticProtocol = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medicationCalculations: Array<MedicationCalculation>;
  regionalBlocks: Array<RegionalBlock>;
};

export enum CalculusEnum {
  C1 = "c1",
  C2 = "c2",
  C3 = "c3"
}

export enum CalculusIndexEnum {
  CalculusIndex_0 = "calculus_index_0",
  CalculusIndex_1 = "calculus_index_1",
  CalculusIndex_2 = "calculus_index_2",
  CalculusIndex_3 = "calculus_index_3"
}

export enum CaseStatusEnum {
  Active = "active",
  Archived = "archived"
}

export enum CatheterLocationEnum {
  Intracardiac = "intracardiac",
  Intraosseous = "intraosseous",
  IntraosseousFemoral = "intraosseous_femoral",
  IntraosseousPlastroCarapacialBridge = "intraosseous_plastro_carapacial_bridge",
  IntraosseousTibial = "intraosseous_tibial",
  IntraosseousUlnar = "intraosseous_ulnar",
  LeftBasilicVein = "left_basilic_vein",
  LeftCephalic = "left_cephalic",
  LeftJugular = "left_jugular",
  LeftLateralSaphenous = "left_lateral_saphenous",
  LeftMedialSaphenous = "left_medial_saphenous",
  LeftMedialTarsometatarsalVein = "left_medial_tarsometatarsal_vein",
  LeftPeripheralAuricularVein = "left_peripheral_auricular_vein",
  PalatineVein = "palatine_vein",
  RightBasilicVein = "right_basilic_vein",
  RightCephalic = "right_cephalic",
  RightJugular = "right_jugular",
  RightLateralSaphenous = "right_lateral_saphenous",
  RightMedialSaphenous = "right_medial_saphenous",
  RightMedialTarsometatarsalVein = "right_medial_tarsometatarsal_vein",
  RightPeripheralAuricularVein = "right_peripheral_auricular_vein",
  VentralTailVein = "ventral_tail_vein"
}

export type CatheterSizeOption = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  value: Scalars["Int"];
};

/** Page connection for CatheterSizeOption. */
export type CatheterSizeOptionPageConnection = {
  collection: Array<CatheterSizeOption>;
  paginationInfo: CatheterSizeOptionPaginationInfo;
};

/** Information about the pagination. */
export type CatheterSizeOptionPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type City = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  state: State;
  zipCodes?: Maybe<ZipCodePageConnection>;
};

export type CityZipCodesArgs = {
  filter?: InputMaybe<ZipCodeFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type CityEndFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  state_id?: InputMaybe<Scalars["String"]>;
  state_name?: InputMaybe<Scalars["String"]>;
};

export type CityEqualFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  state_id?: InputMaybe<Scalars["String"]>;
  state_name?: InputMaybe<Scalars["String"]>;
};

export type CityExistsFilter = {
  id?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
  state_id?: InputMaybe<Scalars["Boolean"]>;
  state_name?: InputMaybe<Scalars["Boolean"]>;
};

export type CityFilter = {
  OR?: InputMaybe<Array<InputMaybe<CityFilter>>>;
  concat?: InputMaybe<CityFilterConcat>;
  end?: InputMaybe<CityEndFilter>;
  equal?: InputMaybe<CityEqualFilter>;
  exists?: InputMaybe<CityExistsFilter>;
  in?: InputMaybe<CityInFilter>;
  like?: InputMaybe<CityLikeFilter>;
  start?: InputMaybe<CityStartFilter>;
};

export type CityFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: CityFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum CityFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type CityInFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  state_id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  state_name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type CityLikeFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  state_id?: InputMaybe<Scalars["String"]>;
  state_name?: InputMaybe<Scalars["String"]>;
};

/** Page connection for City. */
export type CityPageConnection = {
  collection: Array<City>;
  paginationInfo: CityPaginationInfo;
};

/** Information about the pagination. */
export type CityPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type CityStartFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  state_id?: InputMaybe<Scalars["String"]>;
  state_name?: InputMaybe<Scalars["String"]>;
};

export type Client = Node & {
  _id: Scalars["Int"];
  accountNumber?: Maybe<Scalars["String"]>;
  apartments?: Maybe<Scalars["String"]>;
  city?: Maybe<City>;
  disclaimer: Disclaimer;
  email?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  lastName?: Maybe<Scalars["String"]>;
  medicalCase?: Maybe<MedicalCase>;
  notAvailableTime?: Maybe<Scalars["String"]>;
  organization: Organization;
  patient: Patient;
  phoneFirst?: Maybe<Scalars["String"]>;
  phoneSecond?: Maybe<Scalars["String"]>;
  state?: Maybe<State>;
  streetAddress?: Maybe<Scalars["String"]>;
  zipCode?: Maybe<Scalars["String"]>;
};

/** Page connection for Client. */
export type ClientPageConnection = {
  collection: Array<Client>;
  paginationInfo: ClientPaginationInfo;
};

/** Information about the pagination. */
export type ClientPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type ClientReportExport = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type ClientReportPrint = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
  id: Scalars["ID"];
};

export enum ContactFormTypeEnum {
  ChoosePlan = "choose_plan",
  GetStarted = "get_started",
  SignUp = "sign_up"
}

export type ContactRequest = Node & {
  billingType?: Maybe<BillingTypeEnum>;
  contactFormType: ContactFormTypeEnum;
  email: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  firstName: Scalars["String"];
  id: Scalars["ID"];
  lastName: Scalars["String"];
  numberOfUsers?: Maybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  practiceName: Scalars["String"];
  practiceSize: Scalars["String"];
  price?: Maybe<Scalars["Float"]>;
  roleName: Scalars["String"];
};

export type CurrentMedication = Node & {
  _id: Scalars["Int"];
  dose: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  frequency: MedicationFrequencyEnum;
  id: Scalars["ID"];
  lastGivenAt: Scalars["DateTime"];
  medication?: Maybe<Scalars["String"]>;
  organization: Organization;
  patient: Patient;
};

/** Page connection for CurrentMedication. */
export type CurrentMedicationPageConnection = {
  collection: Array<CurrentMedication>;
  paginationInfo: CurrentMedicationPaginationInfo;
};

/** Information about the pagination. */
export type CurrentMedicationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum DateFormatEnum {
  DdMmYyyyWithSlash = "dd_mm_yyyy_with_slash",
  MmDdYyyyWithSlash = "mm_dd_yyyy_with_slash",
  MmDdYyyyWithSpace = "mm_dd_yyyy_with_space"
}

export type DefibMedication = Node & {
  _id: Scalars["Int"];
  dosageMax?: Maybe<Scalars["Float"]>;
  dosageMin?: Maybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  initials?: Maybe<Scalars["String"]>;
  medication: Scalars["String"];
  organization: Organization;
  patient: Patient;
  timeAdministered?: Maybe<Scalars["Time"]>;
};

export type DefibMedicationEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type DefibMedicationExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type DefibMedicationFilter = {
  OR?: InputMaybe<Array<InputMaybe<DefibMedicationFilter>>>;
  concat?: InputMaybe<DefibMedicationFilterConcat>;
  equal?: InputMaybe<DefibMedicationEqualFilter>;
  exists?: InputMaybe<DefibMedicationExistsFilter>;
  in?: InputMaybe<DefibMedicationInFilter>;
  range?: InputMaybe<DefibMedicationRangeFilter>;
};

export type DefibMedicationFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: DefibMedicationFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum DefibMedicationFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type DefibMedicationInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for DefibMedication. */
export type DefibMedicationPageConnection = {
  collection: Array<DefibMedication>;
  paginationInfo: DefibMedicationPaginationInfo;
};

/** Information about the pagination. */
export type DefibMedicationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DefibMedicationRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export enum DentalChartEnum {
  Adult = "adult",
  Deciduous = "deciduous"
}

export type DentalCharting = Node & {
  _id: Scalars["Int"];
  calculus?: Maybe<CalculusEnum>;
  crCementation?: Maybe<Scalars["String"]>;
  distalMarFile?: Maybe<Scalars["Float"]>;
  distalWorkingLength?: Maybe<Scalars["Float"]>;
  enamel?: Maybe<EnamelEnum>;
  endodontics: Array<ToothEndodonticsEnum>;
  fakeId?: Maybe<Scalars["String"]>;
  fracture?: Maybe<FractureEnum>;
  furcation?: Maybe<FurcationEnum>;
  gingivalRecessionBuccal?: Maybe<Scalars["Float"]>;
  gingivalRecessionDBuc?: Maybe<Scalars["Float"]>;
  gingivalRecessionDLingPal?: Maybe<Scalars["Float"]>;
  gingivalRecessionLingPal?: Maybe<Scalars["Float"]>;
  gingivalRecessionMBuc?: Maybe<Scalars["Float"]>;
  gingivalRecessionMLingPal?: Maybe<Scalars["Float"]>;
  gingivitis?: Maybe<GingivitisEnum>;
  id: Scalars["ID"];
  mesialMarFile?: Maybe<Scalars["Float"]>;
  mesialWorkingLength?: Maybe<Scalars["Float"]>;
  mobility?: Maybe<MobilityEnum>;
  notesTimer?: Maybe<Scalars["String"]>;
  obturation?: Maybe<Scalars["String"]>;
  oralSurgeries: Array<ToothOralSurgeryEnum>;
  organization: Organization;
  other: Array<OtherEnum>;
  palatalMarFile?: Maybe<Scalars["Float"]>;
  palatalWorkingLength?: Maybe<Scalars["Float"]>;
  patient: Patient;
  periodontal?: Maybe<PeriodontalEnum>;
  periodontalPocketBuccal?: Maybe<Scalars["Float"]>;
  periodontalPocketDBuc?: Maybe<Scalars["Float"]>;
  periodontalPocketDLingPal?: Maybe<Scalars["Float"]>;
  periodontalPocketLingPal?: Maybe<Scalars["Float"]>;
  periodontalPocketMBuc?: Maybe<Scalars["Float"]>;
  periodontalPocketMLingPal?: Maybe<Scalars["Float"]>;
  resorption?: Maybe<ResorptionEnum>;
  restorations: Array<ToothRestorationEnum>;
  restoratives?: Maybe<Scalars["String"]>;
  sutureMaterial?: Maybe<Scalars["String"]>;
  technique?: Maybe<Scalars["String"]>;
  timerDurationSec: Scalars["Int"];
  tooth: Tooth;
  toothState?: Maybe<ToothStateEnum>;
  treatmentComment?: Maybe<Scalars["String"]>;
};

/** Page connection for DentalCharting. */
export type DentalChartingPageConnection = {
  collection: Array<DentalCharting>;
  paginationInfo: DentalChartingPaginationInfo;
};

/** Information about the pagination. */
export type DentalChartingPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DentalReportExport = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type DentalReportPrint = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
  id: Scalars["ID"];
};

export type DentalScoreDescription = Node & {
  _id: Scalars["Int"];
  description: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  score: Scalars["Int"];
};

export type DentalScoreDescriptionEqualFilter = {
  score?: InputMaybe<Scalars["Int"]>;
};

export type DentalScoreDescriptionExistsFilter = {
  score?: InputMaybe<Scalars["Boolean"]>;
};

export type DentalScoreDescriptionFilter = {
  OR?: InputMaybe<Array<InputMaybe<DentalScoreDescriptionFilter>>>;
  concat?: InputMaybe<DentalScoreDescriptionFilterConcat>;
  equal?: InputMaybe<DentalScoreDescriptionEqualFilter>;
  exists?: InputMaybe<DentalScoreDescriptionExistsFilter>;
  in?: InputMaybe<DentalScoreDescriptionInFilter>;
  range?: InputMaybe<DentalScoreDescriptionRangeFilter>;
};

export type DentalScoreDescriptionFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: DentalScoreDescriptionFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum DentalScoreDescriptionFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type DentalScoreDescriptionInFilter = {
  score?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for DentalScoreDescription. */
export type DentalScoreDescriptionPageConnection = {
  collection: Array<DentalScoreDescription>;
  paginationInfo: DentalScoreDescriptionPaginationInfo;
};

/** Information about the pagination. */
export type DentalScoreDescriptionPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DentalScoreDescriptionRangeFilter = {
  score?: InputMaybe<RangeFilter>;
};

export type DentalSketchComment = Node & {
  _id: Scalars["Int"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy: User;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  locationX: Scalars["Float"];
  locationY: Scalars["Float"];
  organization: Organization;
  patient: Patient;
  text: Scalars["String"];
};

/** Page connection for DentalSketchComment. */
export type DentalSketchCommentPageConnection = {
  collection: Array<DentalSketchComment>;
  paginationInfo: DentalSketchCommentPaginationInfo;
};

/** Information about the pagination. */
export type DentalSketchCommentPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DiagnosticTesting = Node & {
  _id: Scalars["Int"];
  abnormalitiesAndNotes?: Maybe<Scalars["String"]>;
  additionalTests?: Maybe<AdditionalDiagnosticTestPageConnection>;
  doctor?: Maybe<User>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient?: Maybe<Patient>;
  reviewedByDvm?: Maybe<Scalars["Boolean"]>;
};

export type DiagnosticTestingAdditionalTestsArgs = {
  filter?: InputMaybe<AdditionalDiagnosticTestFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type DiagnosticTestingEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type DiagnosticTestingExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type DiagnosticTestingFilter = {
  OR?: InputMaybe<Array<InputMaybe<DiagnosticTestingFilter>>>;
  concat?: InputMaybe<DiagnosticTestingFilterConcat>;
  equal?: InputMaybe<DiagnosticTestingEqualFilter>;
  exists?: InputMaybe<DiagnosticTestingExistsFilter>;
  in?: InputMaybe<DiagnosticTestingInFilter>;
  range?: InputMaybe<DiagnosticTestingRangeFilter>;
};

export type DiagnosticTestingFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: DiagnosticTestingFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum DiagnosticTestingFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type DiagnosticTestingInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for DiagnosticTesting. */
export type DiagnosticTestingPageConnection = {
  collection: Array<DiagnosticTesting>;
  paginationInfo: DiagnosticTestingPaginationInfo;
};

/** Information about the pagination. */
export type DiagnosticTestingPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DiagnosticTestingRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type Dictionary = Node & {
  _id: Scalars["String"];
  additionalDiagnosticTestEnum: Scalars["Iterable"];
  anesthesiaSystemEnum: Scalars["Iterable"];
  bloodPressureMonitoringEnum: Scalars["Iterable"];
  calculusEnum: Scalars["Iterable"];
  calculusIndexEnum: Scalars["Iterable"];
  caseStatusEnum: Scalars["Iterable"];
  catheterLocationEnum: Scalars["Iterable"];
  cathetherSizes: Scalars["Iterable"];
  doseUnitEnum: Scalars["Iterable"];
  enamelEnum: Scalars["Iterable"];
  fakeId?: Maybe<Scalars["String"]>;
  fluidRates: Scalars["Iterable"];
  fluidTypes: Scalars["Iterable"];
  fractureEnum: Scalars["Iterable"];
  furcationEnum: Scalars["Iterable"];
  gingivalIndexEnum: Scalars["Iterable"];
  gingivitisEnum: Scalars["Iterable"];
  id: Scalars["ID"];
  initialDiagnosticTestEnum: Scalars["Iterable"];
  lifeSavingMeasureEnum: Scalars["Iterable"];
  malocclusionEnum: Scalars["Iterable"];
  medicationCalculationTypeEnum: Scalars["Iterable"];
  medicationFrequencyEnum: Scalars["Iterable"];
  mobilityEnum: Scalars["Iterable"];
  otherEnum: Scalars["Iterable"];
  patientPhysicalStatusEnum: Scalars["Iterable"];
  patientSexEnum: Scalars["Iterable"];
  patientStateEnum: Scalars["Iterable"];
  patientTestDefaultBySpecies: Scalars["Iterable"];
  patientTestEnum: Scalars["Iterable"];
  periodontalDiseaseEnum: Scalars["Iterable"];
  periodontalEnum: Scalars["Iterable"];
  plaqueIndexEnum: Scalars["Iterable"];
  qualityOfSedationEnum: Scalars["Iterable"];
  qualityRecoveryEnum: Scalars["Iterable"];
  regionalBlockTypeEnum: Scalars["Iterable"];
  resorptionEnum: Scalars["Iterable"];
  routeEnum: Scalars["Iterable"];
  speciesEnum: Scalars["Iterable"];
  toothStateEnum: Scalars["Iterable"];
  userRoleEnum: Scalars["Iterable"];
  vaccineDefaultBySpecies: Scalars["Iterable"];
  vaccineEnum: Scalars["Iterable"];
  weightMeasure: Scalars["Iterable"];
};

export type Disclaimer = Node & {
  _id: Scalars["Int"];
  agreeWithTerms?: Maybe<Scalars["Boolean"]>;
  client?: Maybe<Client>;
  createdAt: Scalars["Date"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  signature?: Maybe<File>;
};

export type DisclaimerProcedure = Node & {
  _id: Scalars["Int"];
  description: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medicalCase: MedicalCase;
  organization: Organization;
  selected: Scalars["Boolean"];
  title: Scalars["String"];
};

/** Page connection for DisclaimerProcedure. */
export type DisclaimerProcedurePageConnection = {
  collection: Array<DisclaimerProcedure>;
  paginationInfo: DisclaimerProcedurePaginationInfo;
};

/** Information about the pagination. */
export type DisclaimerProcedurePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DisclaimerProcedureSetting = Node & {
  _id: Scalars["Int"];
  description: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  organizationSetting: OrganizationSetting;
  title: Scalars["String"];
};

/** Page connection for DisclaimerProcedureSetting. */
export type DisclaimerProcedureSettingPageConnection = {
  collection: Array<DisclaimerProcedureSetting>;
  paginationInfo: DisclaimerProcedureSettingPaginationInfo;
};

/** Information about the pagination. */
export type DisclaimerProcedureSettingPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type DropOff = Node & {
  _id: Scalars["Int"];
  admittingConcern?: Maybe<Scalars["String"]>;
  doctor?: Maybe<User>;
  evaluateTestAndTreat: Scalars["Boolean"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient?: Maybe<Patient>;
  performInitialEvaluation: Scalars["Boolean"];
};

export type EmailLog = Node & {
  _id: Scalars["Int"];
  emailSubject: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  recipientsEmail: Scalars["String"];
  recipientsUsername?: Maybe<Scalars["String"]>;
  sentAt: Scalars["DateTime"];
};

export type EmailLogEqualFilter = {
  sentAt?: InputMaybe<Scalars["String"]>;
};

export type EmailLogExistsFilter = {
  sentAt?: InputMaybe<Scalars["Boolean"]>;
};

export type EmailLogFilter = {
  OR?: InputMaybe<Array<InputMaybe<EmailLogFilter>>>;
  concat?: InputMaybe<EmailLogFilterConcat>;
  equal?: InputMaybe<EmailLogEqualFilter>;
  exists?: InputMaybe<EmailLogExistsFilter>;
  in?: InputMaybe<EmailLogInFilter>;
  range?: InputMaybe<EmailLogRangeFilter>;
};

export type EmailLogFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: EmailLogFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum EmailLogFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type EmailLogInFilter = {
  sentAt?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

/** Page connection for EmailLog. */
export type EmailLogPageConnection = {
  collection: Array<EmailLog>;
  paginationInfo: EmailLogPaginationInfo;
};

/** Information about the pagination. */
export type EmailLogPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type EmailLogRangeFilter = {
  sentAt?: InputMaybe<RangeFilter>;
};

export enum EnamelEnum {
  Ab = "ab",
  At = "at",
  Ca = "ca",
  ED = "e_d",
  EH = "e_h",
  EHm = "e_hm"
}

export type ExamNote = Node & {
  _id: Scalars["Int"];
  additionalNotes?: Maybe<Scalars["String"]>;
  allergies?: Maybe<Scalars["String"]>;
  bloodwork?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  lastMealAt?: Maybe<Scalars["DateTime"]>;
  organization: Organization;
  patient?: Maybe<Patient>;
  patientPersonalItems?: Maybe<Scalars["String"]>;
  previousSurgery?: Maybe<Scalars["String"]>;
  treatmentPlan?: Maybe<Scalars["String"]>;
  vaccines?: Maybe<Scalars["String"]>;
};

export type ExamNoteEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type ExamNoteExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type ExamNoteFilter = {
  OR?: InputMaybe<Array<InputMaybe<ExamNoteFilter>>>;
  concat?: InputMaybe<ExamNoteFilterConcat>;
  equal?: InputMaybe<ExamNoteEqualFilter>;
  exists?: InputMaybe<ExamNoteExistsFilter>;
  in?: InputMaybe<ExamNoteInFilter>;
  range?: InputMaybe<ExamNoteRangeFilter>;
};

export type ExamNoteFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: ExamNoteFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum ExamNoteFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type ExamNoteInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for ExamNote. */
export type ExamNotePageConnection = {
  collection: Array<ExamNote>;
  paginationInfo: ExamNotePaginationInfo;
};

/** Information about the pagination. */
export type ExamNotePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type ExamNoteRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type File = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  mimeType: Scalars["String"];
  name: Scalars["String"];
  organization?: Maybe<Organization>;
  path: Scalars["String"];
  size: Scalars["Int"];
};

/** Page connection for File. */
export type FilePageConnection = {
  collection: Array<File>;
  paginationInfo: FilePaginationInfo;
};

/** Information about the pagination. */
export type FilePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type FluidBolus = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient?: Maybe<Patient>;
  totalAmount?: Maybe<Scalars["Float"]>;
};

export type FluidBolusEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type FluidBolusExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type FluidBolusFilter = {
  OR?: InputMaybe<Array<InputMaybe<FluidBolusFilter>>>;
  concat?: InputMaybe<FluidBolusFilterConcat>;
  equal?: InputMaybe<FluidBolusEqualFilter>;
  exists?: InputMaybe<FluidBolusExistsFilter>;
  in?: InputMaybe<FluidBolusInFilter>;
  range?: InputMaybe<FluidBolusRangeFilter>;
};

export type FluidBolusFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: FluidBolusFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum FluidBolusFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type FluidBolusInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for FluidBolus. */
export type FluidBolusPageConnection = {
  collection: Array<FluidBolus>;
  paginationInfo: FluidBolusPaginationInfo;
};

/** Information about the pagination. */
export type FluidBolusPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type FluidBolusRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type FluidRateOption = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  value: Scalars["Int"];
};

/** Page connection for FluidRateOption. */
export type FluidRateOptionPageConnection = {
  collection: Array<FluidRateOption>;
  paginationInfo: FluidRateOptionPaginationInfo;
};

/** Information about the pagination. */
export type FluidRateOptionPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type FluidTemperature = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  fluidRate?: Maybe<Scalars["Float"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient: Patient;
  temperature?: Maybe<Scalars["Float"]>;
  timeMonitoring?: Maybe<Scalars["DateTime"]>;
  volumeInfused?: Maybe<Scalars["Float"]>;
  volumeToBeInfused?: Maybe<Scalars["Float"]>;
};

export type FluidTemperatureEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type FluidTemperatureExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type FluidTemperatureFilter = {
  OR?: InputMaybe<Array<InputMaybe<FluidTemperatureFilter>>>;
  concat?: InputMaybe<FluidTemperatureFilterConcat>;
  equal?: InputMaybe<FluidTemperatureEqualFilter>;
  exists?: InputMaybe<FluidTemperatureExistsFilter>;
  in?: InputMaybe<FluidTemperatureInFilter>;
  range?: InputMaybe<FluidTemperatureRangeFilter>;
};

export type FluidTemperatureFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: FluidTemperatureFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum FluidTemperatureFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type FluidTemperatureInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for FluidTemperature. */
export type FluidTemperaturePageConnection = {
  collection: Array<FluidTemperature>;
  paginationInfo: FluidTemperaturePaginationInfo;
};

/** Information about the pagination. */
export type FluidTemperaturePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type FluidTemperatureRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type FluidTypeOption = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  value: Scalars["String"];
};

/** Page connection for FluidTypeOption. */
export type FluidTypeOptionPageConnection = {
  collection: Array<FluidTypeOption>;
  paginationInfo: FluidTypeOptionPaginationInfo;
};

/** Information about the pagination. */
export type FluidTypeOptionPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum FractureEnum {
  TFxCcf = "t_fx_ccf",
  TFxCcrf = "t_fx_ccrf",
  TFxEf = "t_fx_ef",
  TFxEi = "t_fx_ei",
  TFxRf = "t_fx_rf",
  TFxUcf = "t_fx_ucf",
  TFxUcrf = "t_fx_ucrf"
}

export type FullMonitoringInformation = Node & {
  anestheticGas: AnestheticGas;
  fakeId?: Maybe<Scalars["String"]>;
  fluidTemperature: FluidTemperature;
  id: Scalars["ID"];
  vital: Vital;
};

export enum FurcationEnum {
  F1 = "f1",
  F2 = "f2",
  F3 = "f3"
}

export type GeneralAssessment = Node & {
  _id: Scalars["Int"];
  additionalCommentsAndNotes?: Maybe<Scalars["String"]>;
  additionalPhotos?: Maybe<FilePageConnection>;
  afterPhotoFront?: Maybe<File>;
  afterPhotoLeft?: Maybe<File>;
  afterPhotoRight?: Maybe<File>;
  beforePhotoFront?: Maybe<File>;
  beforePhotoLeft?: Maybe<File>;
  beforePhotoRight?: Maybe<File>;
  between25And50PerCentBoneLoss: Array<Scalars["String"]>;
  boneAugmentation: Scalars["Boolean"];
  boneAugmentationDetails?: Maybe<Scalars["String"]>;
  buccalMucosa?: Maybe<OralStateEnum>;
  calculusIndex?: Maybe<CalculusIndexEnum>;
  caudalOralMucosa?: Maybe<OralStateEnum>;
  cbctComments?: Maybe<Scalars["String"]>;
  dentalChart?: Maybe<DentalChartEnum>;
  externalCervicalToothResorption: Array<Scalars["String"]>;
  externalInflammatoryToothResorption: Array<Scalars["String"]>;
  externalReplacementRootResorption: Array<Scalars["String"]>;
  externalSurfaceRootResorption: Array<Scalars["String"]>;
  extraoral?: Maybe<OralStateEnum>;
  fakeId?: Maybe<Scalars["String"]>;
  fistula?: Maybe<Scalars["Boolean"]>;
  gingivalIndex?: Maybe<GingivalIndexEnum>;
  greaterThan50PerCentBoneLoss: Array<Scalars["String"]>;
  hardPalate?: Maybe<OralStateEnum>;
  id: Scalars["ID"];
  internalToothResorption: Array<Scalars["String"]>;
  intraoralRadiographicComments?: Maybe<Scalars["String"]>;
  leftInferiorAlveolar?: Maybe<Scalars["Float"]>;
  leftInfraorbital?: Maybe<Scalars["Float"]>;
  leftMaxillary?: Maybe<Scalars["Float"]>;
  leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
  leftRostralMandibular?: Maybe<Scalars["Float"]>;
  lessThan25PerCentBoneLoss: Array<Scalars["String"]>;
  lymphNodes?: Maybe<OralStateEnum>;
  missingTeeth: Array<Scalars["String"]>;
  notesForClientDentalReport?: Maybe<Scalars["String"]>;
  notesTimer?: Maybe<Scalars["String"]>;
  occlusion?: Maybe<OcclusionEnum>;
  occlusionDescription?: Maybe<Scalars["String"]>;
  oralSurgeries: Array<OralSurgeryEnum>;
  organization: Organization;
  orthodontics: Array<OrthodonticsEnum>;
  parulisSinusTract?: Maybe<Scalars["Boolean"]>;
  patient?: Maybe<Patient>;
  periapicalLucency: Array<Scalars["String"]>;
  periapicalRarefaction: Array<Scalars["String"]>;
  periodontalDisease?: Maybe<PeriodontalDiseaseEnum>;
  periodontics: Array<PeriodonticsEnum>;
  planingAndSubgingivalCurettage?: Maybe<
    RootPlaningAndSubgingivalCurettageEnum
  >;
  plaqueIndex?: Maybe<PlaqueIndexEnum>;
  radiographicFindingsPhotos?: Maybe<FilePageConnection>;
  referralNotesAndComments?: Maybe<Scalars["String"]>;
  retainedToothRoots: Array<Scalars["String"]>;
  rightInferiorAlveolar?: Maybe<Scalars["Float"]>;
  rightInfraorbital?: Maybe<Scalars["Float"]>;
  rightMaxillary?: Maybe<Scalars["Float"]>;
  rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
  rightRostralMandibular?: Maybe<Scalars["Float"]>;
  skullType?: Maybe<SkullTypeEnum>;
  softPalate?: Maybe<OralStateEnum>;
  tongue?: Maybe<OralStateEnum>;
  tonsils?: Maybe<OralStateEnum>;
  toothResorptionType1: Array<Scalars["String"]>;
  toothResorptionType2: Array<Scalars["String"]>;
  toothResorptionType3: Array<Scalars["String"]>;
  treatmentAdditionalFindingsCommentsAndNotes?: Maybe<Scalars["String"]>;
  uneruptedTeeth: Array<Scalars["String"]>;
  widenedPulpCanal: Array<Scalars["String"]>;
};

export type GeneralAssessmentAdditionalPhotosArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type GeneralAssessmentRadiographicFindingsPhotosArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

/** Page connection for GeneralAssessment. */
export type GeneralAssessmentPageConnection = {
  collection: Array<GeneralAssessment>;
  paginationInfo: GeneralAssessmentPaginationInfo;
};

/** Information about the pagination. */
export type GeneralAssessmentPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum GingivalIndexEnum {
  GingivalIndex_0 = "gingival_index_0",
  GingivalIndex_1 = "gingival_index_1",
  GingivalIndex_2 = "gingival_index_2",
  GingivalIndex_3 = "gingival_index_3"
}

export enum GingivitisEnum {
  Gi1 = "gi1",
  Gi2 = "gi2",
  Gi3 = "gi3"
}

export type Legend = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  text?: Maybe<Scalars["String"]>;
};

/** Page connection for Legend. */
export type LegendPageConnection = {
  collection: Array<Legend>;
  paginationInfo: LegendPaginationInfo;
};

/** Information about the pagination. */
export type LegendPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type License = Node & {
  _id: Scalars["Int"];
  active: Scalars["Boolean"];
  deletedAt?: Maybe<Scalars["DateTime"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  maxNumberOfUsers: Scalars["Int"];
  name: Scalars["String"];
  orders?: Maybe<OrderPageConnection>;
  period: LicensePeriodEnum;
  price: Scalars["Float"];
};

export type LicenseOrdersArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type LicenseEndFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type LicenseEqualFilter = {
  active?: InputMaybe<Scalars["Boolean"]>;
  deletedAt?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type LicenseExistsFilter = {
  active?: InputMaybe<Scalars["Boolean"]>;
  deletedAt?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
};

export type LicenseFilter = {
  OR?: InputMaybe<Array<InputMaybe<LicenseFilter>>>;
  concat?: InputMaybe<LicenseFilterConcat>;
  end?: InputMaybe<LicenseEndFilter>;
  equal?: InputMaybe<LicenseEqualFilter>;
  exists?: InputMaybe<LicenseExistsFilter>;
  in?: InputMaybe<LicenseInFilter>;
  like?: InputMaybe<LicenseLikeFilter>;
  range?: InputMaybe<LicenseRangeFilter>;
  start?: InputMaybe<LicenseStartFilter>;
};

export type LicenseFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: LicenseFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum LicenseFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type LicenseInFilter = {
  active?: InputMaybe<Array<InputMaybe<Scalars["Boolean"]>>>;
  deletedAt?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type LicenseLikeFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

/** Page connection for License. */
export type LicensePageConnection = {
  collection: Array<License>;
  paginationInfo: LicensePaginationInfo;
};

/** Information about the pagination. */
export type LicensePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum LicensePeriodEnum {
  Monthly = "monthly",
  Yearly = "yearly"
}

export type LicenseRangeFilter = {
  deletedAt?: InputMaybe<RangeFilter>;
  id?: InputMaybe<RangeFilter>;
};

export type LicenseStartFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type LightMonitoringInformation = Node & {
  anestheticGas: AnestheticGas;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  vital: Vital;
};

export type Logout = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type MedicalCase = Node & {
  _id: Scalars["Int"];
  authorizations?: Maybe<AuthorizationPageConnection>;
  client: Client;
  clientMutationId?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  createdFrom?: Maybe<MedicalCase>;
  disclaimerProcedures?: Maybe<DisclaimerProcedurePageConnection>;
  disclaimerText: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  fromVetspire: Scalars["Boolean"];
  id: Scalars["ID"];
  initiatorUserId?: Maybe<Scalars["Int"]>;
  isSubscriptionDeleted?: Maybe<Scalars["Boolean"]>;
  mercureUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  offline?: Maybe<Scalars["Boolean"]>;
  organization: Organization;
  status: CaseStatusEnum;
  temperatureUnit?: Maybe<TemperatureUnitEnum>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type MedicalCaseAuthorizationsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type MedicalCaseDisclaimerProceduresArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type MedicalCaseEndFilter = {
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export type MedicalCaseEqualFilter = {
  client_patient_diagnosticTesting_doctor_id?: InputMaybe<Scalars["Int"]>;
  client_patient_dropOff_doctor_id?: InputMaybe<Scalars["Int"]>;
  client_patient_procedureDate?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<CaseStatusEnum>;
};

export type MedicalCaseExistsFilter = {
  client_patient_diagnosticTesting_doctor_id?: InputMaybe<Scalars["Boolean"]>;
  client_patient_dropOff_doctor_id?: InputMaybe<Scalars["Boolean"]>;
  client_patient_procedureDate?: InputMaybe<Scalars["Boolean"]>;
  createdAt?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<Scalars["Boolean"]>;
};

export type MedicalCaseFilter = {
  OR?: InputMaybe<Array<InputMaybe<MedicalCaseFilter>>>;
  concat?: InputMaybe<MedicalCaseFilterConcat>;
  end?: InputMaybe<MedicalCaseEndFilter>;
  equal?: InputMaybe<MedicalCaseEqualFilter>;
  excludeIds?: InputMaybe<Array<Scalars["Int"]>>;
  exists?: InputMaybe<MedicalCaseExistsFilter>;
  in?: InputMaybe<MedicalCaseInFilter>;
  like?: InputMaybe<MedicalCaseLikeFilter>;
  procedures?: InputMaybe<Array<Scalars["String"]>>;
  range?: InputMaybe<MedicalCaseRangeFilter>;
  start?: InputMaybe<MedicalCaseStartFilter>;
};

export type MedicalCaseFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: MedicalCaseFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum MedicalCaseFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type MedicalCaseFilter_Order = {
  name?: InputMaybe<Scalars["String"]>;
};

export type MedicalCaseInFilter = {
  client_patient_diagnosticTesting_doctor_id?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]>>
  >;
  client_patient_dropOff_doctor_id?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]>>
  >;
  client_patient_procedureDate?: InputMaybe<
    Array<InputMaybe<Scalars["String"]>>
  >;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  status?: InputMaybe<Array<InputMaybe<CaseStatusEnum>>>;
};

export type MedicalCaseLikeFilter = {
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

/** Page connection for MedicalCase. */
export type MedicalCasePageConnection = {
  collection: Array<MedicalCase>;
  paginationInfo: MedicalCasePaginationInfo;
};

/** Information about the pagination. */
export type MedicalCasePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type MedicalCaseRangeFilter = {
  client_patient_diagnosticTesting_doctor_id?: InputMaybe<RangeFilter>;
  client_patient_dropOff_doctor_id?: InputMaybe<RangeFilter>;
  client_patient_procedureDate?: InputMaybe<RangeFilter>;
  createdAt?: InputMaybe<RangeFilter>;
};

export type MedicalCaseStartFilter = {
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export type MedicalRecordExport = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type MedicalRecordPrint = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
  id: Scalars["ID"];
};

export type Medication = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  concentration?: Maybe<Scalars["Float"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type MedicationCalculation = Node & {
  _id: Scalars["Int"];
  additionalVolumeAdministered?: Maybe<Scalars["Float"]>;
  additionalVolumeDrawn?: Maybe<Scalars["Float"]>;
  calculationType: MedicationCalculationTypeEnum;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  initials?: Maybe<Scalars["String"]>;
  medication: Scalars["String"];
  organization: Organization;
  patient: Patient;
  route: RouteEnum;
  timeAdministered?: Maybe<Scalars["Time"]>;
  totalAmount?: Maybe<Scalars["Float"]>;
  totalVolume?: Maybe<Scalars["Float"]>;
  volumeAdministered?: Maybe<Scalars["Float"]>;
};

export type MedicationCalculationEndFilter = {
  calculationType?: InputMaybe<Scalars["String"]>;
};

export type MedicationCalculationEqualFilter = {
  calculationType?: InputMaybe<MedicationCalculationTypeEnum>;
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type MedicationCalculationExistsFilter = {
  calculationType?: InputMaybe<Scalars["Boolean"]>;
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type MedicationCalculationFilter = {
  OR?: InputMaybe<Array<InputMaybe<MedicationCalculationFilter>>>;
  concat?: InputMaybe<MedicationCalculationFilterConcat>;
  end?: InputMaybe<MedicationCalculationEndFilter>;
  equal?: InputMaybe<MedicationCalculationEqualFilter>;
  exists?: InputMaybe<MedicationCalculationExistsFilter>;
  in?: InputMaybe<MedicationCalculationInFilter>;
  like?: InputMaybe<MedicationCalculationLikeFilter>;
  range?: InputMaybe<MedicationCalculationRangeFilter>;
  start?: InputMaybe<MedicationCalculationStartFilter>;
};

export type MedicationCalculationFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: MedicationCalculationFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum MedicationCalculationFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type MedicationCalculationInFilter = {
  calculationType?: InputMaybe<
    Array<InputMaybe<MedicationCalculationTypeEnum>>
  >;
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type MedicationCalculationLikeFilter = {
  calculationType?: InputMaybe<Scalars["String"]>;
};

/** Page connection for MedicationCalculation. */
export type MedicationCalculationPageConnection = {
  collection: Array<MedicationCalculation>;
  paginationInfo: MedicationCalculationPaginationInfo;
};

/** Information about the pagination. */
export type MedicationCalculationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type MedicationCalculationRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type MedicationCalculationStartFilter = {
  calculationType?: InputMaybe<Scalars["String"]>;
};

export enum MedicationCalculationTypeEnum {
  Additional = "additional",
  AntiArrhythmic = "anti_arrhythmic",
  Arrest = "arrest",
  Induction = "induction",
  PreAnesthetic = "pre_anesthetic",
  Reversal = "reversal"
}

export type MedicationEndFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type MedicationEqualFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type MedicationExistsFilter = {
  name?: InputMaybe<Scalars["Boolean"]>;
};

export type MedicationFilter = {
  OR?: InputMaybe<Array<InputMaybe<MedicationFilter>>>;
  concat?: InputMaybe<MedicationFilterConcat>;
  end?: InputMaybe<MedicationEndFilter>;
  equal?: InputMaybe<MedicationEqualFilter>;
  exists?: InputMaybe<MedicationExistsFilter>;
  in?: InputMaybe<MedicationInFilter>;
  like?: InputMaybe<MedicationLikeFilter>;
  start?: InputMaybe<MedicationStartFilter>;
};

export type MedicationFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: MedicationFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum MedicationFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export enum MedicationFrequencyEnum {
  Hr_2 = "hr_2",
  Hr_4 = "hr_4",
  Hr_6 = "hr_6",
  Hr_8 = "hr_8",
  Hr_10 = "hr_10",
  Hr_12 = "hr_12",
  Hr_14 = "hr_14",
  Hr_16 = "hr_16",
  Hr_18 = "hr_18",
  Hr_20 = "hr_20",
  Hr_22 = "hr_22",
  Hr_24 = "hr_24",
  Prn = "prn"
}

export type MedicationInFilter = {
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type MedicationLikeFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

/** Page connection for Medication. */
export type MedicationPageConnection = {
  collection: Array<Medication>;
  paginationInfo: MedicationPaginationInfo;
};

/** Information about the pagination. */
export type MedicationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type MedicationStartFilter = {
  name?: InputMaybe<Scalars["String"]>;
};

export type MiscellaneousGroup = Node & {
  _id: Scalars["Int"];
  anesthesiaSystem?: Maybe<AnesthesiaSystemEnum>;
  bagSize?: Maybe<Scalars["Float"]>;
  bloodPressureMonitoring?: Maybe<BloodPressureMonitoringEnum>;
  catheterLocation?: Maybe<CatheterLocationEnum>;
  catheterSize?: Maybe<Scalars["Int"]>;
  endotrachealTubeSize?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  fluidRate?: Maybe<Scalars["Int"]>;
  fluidRateValue?: Maybe<Scalars["Float"]>;
  fluidType?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  intubated?: Maybe<Scalars["Boolean"]>;
  organization: Organization;
  oxygenFlowRate?: Maybe<Scalars["Float"]>;
  patient?: Maybe<Patient>;
  qualityOfSedation?: Maybe<QualityOfSedationEnum>;
};

export type MiscellaneousGroupEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type MiscellaneousGroupExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type MiscellaneousGroupFilter = {
  OR?: InputMaybe<Array<InputMaybe<MiscellaneousGroupFilter>>>;
  concat?: InputMaybe<MiscellaneousGroupFilterConcat>;
  equal?: InputMaybe<MiscellaneousGroupEqualFilter>;
  exists?: InputMaybe<MiscellaneousGroupExistsFilter>;
  in?: InputMaybe<MiscellaneousGroupInFilter>;
  range?: InputMaybe<MiscellaneousGroupRangeFilter>;
};

export type MiscellaneousGroupFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: MiscellaneousGroupFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum MiscellaneousGroupFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type MiscellaneousGroupInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for MiscellaneousGroup. */
export type MiscellaneousGroupPageConnection = {
  collection: Array<MiscellaneousGroup>;
  paginationInfo: MiscellaneousGroupPaginationInfo;
};

/** Information about the pagination. */
export type MiscellaneousGroupPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type MiscellaneousGroupRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export enum MobilityEnum {
  M1 = "m1",
  M2 = "m2",
  M3 = "m3"
}

export type Monitoring = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  monitoringBy?: Maybe<User>;
  organization: Organization;
  patient: Patient;
};

export type MonitoringEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type MonitoringExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type MonitoringFilter = {
  OR?: InputMaybe<Array<InputMaybe<MonitoringFilter>>>;
  concat?: InputMaybe<MonitoringFilterConcat>;
  equal?: InputMaybe<MonitoringEqualFilter>;
  exists?: InputMaybe<MonitoringExistsFilter>;
  in?: InputMaybe<MonitoringInFilter>;
  range?: InputMaybe<MonitoringRangeFilter>;
};

export type MonitoringFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: MonitoringFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum MonitoringFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type MonitoringInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for Monitoring. */
export type MonitoringPageConnection = {
  collection: Array<Monitoring>;
  paginationInfo: MonitoringPaginationInfo;
};

/** Information about the pagination. */
export type MonitoringPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type MonitoringRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type Mutation = {
  /** Copys a MedicalCase. */
  copyMedicalCase?: Maybe<CopyMedicalCasePayload>;
  /** Creates a AdditionalDiagnosticTest. */
  createAdditionalDiagnosticTest?: Maybe<CreateAdditionalDiagnosticTestPayload>;
  /** Creates a AnestheticGas. */
  createAnestheticGas?: Maybe<CreateAnestheticGasPayload>;
  /** Creates a AnestheticProtocol. */
  createAnestheticProtocol?: Maybe<CreateAnestheticProtocolPayload>;
  /** Creates a AnestheticProtocolMedicationCalculation. */
  createAnestheticProtocolMedicationCalculation?: Maybe<
    CreateAnestheticProtocolMedicationCalculationPayload
  >;
  /** Creates a AnestheticProtocolRegionalBlock. */
  createAnestheticProtocolRegionalBlock?: Maybe<
    CreateAnestheticProtocolRegionalBlockPayload
  >;
  /** Creates a Authentication. */
  createAuthentication?: Maybe<CreateAuthenticationPayload>;
  /** Creates a Authorization. */
  createAuthorization?: Maybe<CreateAuthorizationPayload>;
  /** Creates a AuthorizationSetting. */
  createAuthorizationSetting?: Maybe<CreateAuthorizationSettingPayload>;
  /** Creates a BulkAdditionalDiagnosticTest. */
  createBulkAdditionalDiagnosticTest?: Maybe<
    CreateBulkAdditionalDiagnosticTestPayload
  >;
  /** Creates a ClientReportExport. */
  createClientReportExport?: Maybe<CreateClientReportExportPayload>;
  /** Creates a ClientReportPrint. */
  createClientReportPrint?: Maybe<CreateClientReportPrintPayload>;
  /** Creates a ContactRequest. */
  createContactRequest?: Maybe<CreateContactRequestPayload>;
  /** Creates a CurrentMedication. */
  createCurrentMedication?: Maybe<CreateCurrentMedicationPayload>;
  /** Creates a DefibMedication. */
  createDefibMedication?: Maybe<CreateDefibMedicationPayload>;
  /** Creates a DentalCharting. */
  createDentalCharting?: Maybe<CreateDentalChartingPayload>;
  /** Creates a DentalReportExport. */
  createDentalReportExport?: Maybe<CreateDentalReportExportPayload>;
  /** Creates a DentalReportPrint. */
  createDentalReportPrint?: Maybe<CreateDentalReportPrintPayload>;
  /** Creates a DentalSketchComment. */
  createDentalSketchComment?: Maybe<CreateDentalSketchCommentPayload>;
  /** Creates a DisclaimerProcedure. */
  createDisclaimerProcedure?: Maybe<CreateDisclaimerProcedurePayload>;
  /** Creates a DisclaimerProcedureSetting. */
  createDisclaimerProcedureSetting?: Maybe<
    CreateDisclaimerProcedureSettingPayload
  >;
  /** Creates a File. */
  createFile?: Maybe<CreateFilePayload>;
  /** Creates a FluidBolus. */
  createFluidBolus?: Maybe<CreateFluidBolusPayload>;
  /** Creates a FluidTemperature. */
  createFluidTemperature?: Maybe<CreateFluidTemperaturePayload>;
  /** Creates a License. */
  createLicense?: Maybe<CreateLicensePayload>;
  /** Creates a Logout. */
  createLogout?: Maybe<CreateLogoutPayload>;
  /** Creates a MedicalCase. */
  createMedicalCase?: Maybe<CreateMedicalCasePayload>;
  /** Creates a MedicalRecordExport. */
  createMedicalRecordExport?: Maybe<CreateMedicalRecordExportPayload>;
  /** Creates a MedicalRecordPrint. */
  createMedicalRecordPrint?: Maybe<CreateMedicalRecordPrintPayload>;
  /** Creates a MedicationCalculation. */
  createMedicationCalculation?: Maybe<CreateMedicationCalculationPayload>;
  /** Creates a Order. */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Creates a OrganizationRegistration. */
  createOrganizationRegistration?: Maybe<CreateOrganizationRegistrationPayload>;
  /** Creates a PasswordChange. */
  createPasswordChange?: Maybe<CreatePasswordChangePayload>;
  /** Creates a PasswordRecoveryRequest. */
  createPasswordRecoveryRequest?: Maybe<CreatePasswordRecoveryRequestPayload>;
  /** Creates a PatientProcedure. */
  createPatientProcedure?: Maybe<CreatePatientProcedurePayload>;
  /** Creates a PinAuthentication. */
  createPinAuthentication?: Maybe<CreatePinAuthenticationPayload>;
  /** Creates a PostAnestheticVital. */
  createPostAnestheticVital?: Maybe<CreatePostAnestheticVitalPayload>;
  /** Creates a ReferralDocumentExport. */
  createReferralDocumentExport?: Maybe<CreateReferralDocumentExportPayload>;
  /** Creates a ReferralDocumentPrint. */
  createReferralDocumentPrint?: Maybe<CreateReferralDocumentPrintPayload>;
  /** Creates a RefreshToken. */
  createRefreshToken?: Maybe<CreateRefreshTokenPayload>;
  /** Creates a RegionalBlock. */
  createRegionalBlock?: Maybe<CreateRegionalBlockPayload>;
  /** Creates a RegistrationCompletion. */
  createRegistrationCompletion?: Maybe<CreateRegistrationCompletionPayload>;
  /** Creates a Suspension. */
  createSuspension?: Maybe<CreateSuspensionPayload>;
  /** Creates a Tablet. */
  createTablet?: Maybe<CreateTabletPayload>;
  /** Creates a User. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a Vital. */
  createVital?: Maybe<CreateVitalPayload>;
  /** Deletes a AdditionalDiagnosticTest. */
  deleteAdditionalDiagnosticTest?: Maybe<DeleteAdditionalDiagnosticTestPayload>;
  /** Deletes a AnestheticProtocol. */
  deleteAnestheticProtocol?: Maybe<DeleteAnestheticProtocolPayload>;
  /** Deletes a AnestheticProtocolMedicationCalculation. */
  deleteAnestheticProtocolMedicationCalculation?: Maybe<
    DeleteAnestheticProtocolMedicationCalculationPayload
  >;
  /** Deletes a AnestheticProtocolRegionalBlock. */
  deleteAnestheticProtocolRegionalBlock?: Maybe<
    DeleteAnestheticProtocolRegionalBlockPayload
  >;
  /** Deletes a CurrentMedication. */
  deleteCurrentMedication?: Maybe<DeleteCurrentMedicationPayload>;
  /** Deletes a DefibMedication. */
  deleteDefibMedication?: Maybe<DeleteDefibMedicationPayload>;
  /** Deletes a DentalSketchComment. */
  deleteDentalSketchComment?: Maybe<DeleteDentalSketchCommentPayload>;
  /** Deletes a File. */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Deletes a FluidBolus. */
  deleteFluidBolus?: Maybe<DeleteFluidBolusPayload>;
  /** Deletes a License. */
  deleteLicense?: Maybe<DeleteLicensePayload>;
  /** Deletes a MedicalCase. */
  deleteMedicalCase?: Maybe<DeleteMedicalCasePayload>;
  /** Deletes a MedicationCalculation. */
  deleteMedicationCalculation?: Maybe<DeleteMedicationCalculationPayload>;
  /** Deletes a Order. */
  deleteOrder?: Maybe<DeleteOrderPayload>;
  /** Deletes a RegionalBlock. */
  deleteRegionalBlock?: Maybe<DeleteRegionalBlockPayload>;
  /** Deletes a Suspension. */
  deleteSuspension?: Maybe<DeleteSuspensionPayload>;
  /** Deletes a Tablet. */
  deleteTablet?: Maybe<DeleteTabletPayload>;
  /** Deletes a User. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** ExportPdfTos a VetspireMedicalCase. */
  exportPdfToVetspireMedicalCase?: Maybe<ExportPdfToVetspireMedicalCasePayload>;
  /** Imports a VetspireMedicalCase. */
  importVetspireMedicalCase?: Maybe<ImportVetspireMedicalCasePayload>;
  /** Logs a BulkPinAuthentication. */
  logBulkPinAuthentication?: Maybe<LogBulkPinAuthenticationPayload>;
  /**
   * Logs a PinLogin.
   * @deprecated Use logBulkPinAuthentication instead
   */
  logPinLogin?: Maybe<LogPinLoginPayload>;
  /** Mutation_collection_querys a AdditionalDiagnosticTest. */
  mutation_collection_queryAdditionalDiagnosticTest?: Maybe<
    Mutation_Collection_QueryAdditionalDiagnosticTestPayload
  >;
  /** Mutation_collection_querys a MedicationCalculation. */
  mutation_collection_queryMedicationCalculation?: Maybe<
    Mutation_Collection_QueryMedicationCalculationPayload
  >;
  /** Mutation_collection_querys a PatientTest. */
  mutation_collection_queryPatientTest?: Maybe<
    Mutation_Collection_QueryPatientTestPayload
  >;
  /** Mutation_collection_querys a RegionalBlock. */
  mutation_collection_queryRegionalBlock?: Maybe<
    Mutation_Collection_QueryRegionalBlockPayload
  >;
  /** Mutation_collection_querys a Vaccine. */
  mutation_collection_queryVaccine?: Maybe<
    Mutation_Collection_QueryVaccinePayload
  >;
  /** Removes a BulkAnestheticProtocol. */
  removeBulkAnestheticProtocol?: Maybe<RemoveBulkAnestheticProtocolPayload>;
  /** Removes a BulkAnestheticProtocolMedicationCalculation. */
  removeBulkAnestheticProtocolMedicationCalculation?: Maybe<
    RemoveBulkAnestheticProtocolMedicationCalculationPayload
  >;
  /** Removes a BulkAnestheticProtocolRegionalBlock. */
  removeBulkAnestheticProtocolRegionalBlock?: Maybe<
    RemoveBulkAnestheticProtocolRegionalBlockPayload
  >;
  /** Removes a BulkAuthorizationSetting. */
  removeBulkAuthorizationSetting?: Maybe<RemoveBulkAuthorizationSettingPayload>;
  /** Removes a BulkCurrentMedication. */
  removeBulkCurrentMedication?: Maybe<RemoveBulkCurrentMedicationPayload>;
  /** Removes a BulkDefibMedication. */
  removeBulkDefibMedication?: Maybe<RemoveBulkDefibMedicationPayload>;
  /** Removes a BulkDentalSketchComment. */
  removeBulkDentalSketchComment?: Maybe<RemoveBulkDentalSketchCommentPayload>;
  /** Removes a BulkDisclaimerProcedureSetting. */
  removeBulkDisclaimerProcedureSetting?: Maybe<
    RemoveBulkDisclaimerProcedureSettingPayload
  >;
  /** Removes a BulkMedicalCase. */
  removeBulkMedicalCase?: Maybe<RemoveBulkMedicalCasePayload>;
  /** Removes a BulkMedicationCalculation. */
  removeBulkMedicationCalculation?: Maybe<
    RemoveBulkMedicationCalculationPayload
  >;
  /** Removes a BulkRegionalBlock. */
  removeBulkRegionalBlock?: Maybe<RemoveBulkRegionalBlockPayload>;
  /** Removes a BulkSuspension. */
  removeBulkSuspension?: Maybe<RemoveBulkSuspensionPayload>;
  /** Removes a BulkTablet. */
  removeBulkTablet?: Maybe<RemoveBulkTabletPayload>;
  /** Resends a OrganizationInvite. */
  resendOrganizationInvite?: Maybe<ResendOrganizationInvitePayload>;
  /** Sets a FullMonitoringInformation. */
  setFullMonitoringInformation?: Maybe<SetFullMonitoringInformationPayload>;
  /** Sets a LightMonitoringInformation. */
  setLightMonitoringInformation?: Maybe<SetLightMonitoringInformationPayload>;
  /** Updates a AdditionalDiagnosticTest. */
  updateAdditionalDiagnosticTest?: Maybe<UpdateAdditionalDiagnosticTestPayload>;
  /** Updates a AnestheticGas. */
  updateAnestheticGas?: Maybe<UpdateAnestheticGasPayload>;
  /** Updates a AnestheticProtocol. */
  updateAnestheticProtocol?: Maybe<UpdateAnestheticProtocolPayload>;
  /** Updates a AnestheticProtocolMedicationCalculation. */
  updateAnestheticProtocolMedicationCalculation?: Maybe<
    UpdateAnestheticProtocolMedicationCalculationPayload
  >;
  /** Updates a AnestheticProtocolRegionalBlock. */
  updateAnestheticProtocolRegionalBlock?: Maybe<
    UpdateAnestheticProtocolRegionalBlockPayload
  >;
  /** Updates a Authorization. */
  updateAuthorization?: Maybe<UpdateAuthorizationPayload>;
  /** Updates a AuthorizationSetting. */
  updateAuthorizationSetting?: Maybe<UpdateAuthorizationSettingPayload>;
  /** Updates a CalculationAgreement. */
  updateCalculationAgreement?: Maybe<UpdateCalculationAgreementPayload>;
  /** Updates a Client. */
  updateClient?: Maybe<UpdateClientPayload>;
  /** Updates a CurrentMedication. */
  updateCurrentMedication?: Maybe<UpdateCurrentMedicationPayload>;
  /** Updates a DefibMedication. */
  updateDefibMedication?: Maybe<UpdateDefibMedicationPayload>;
  /** Updates a DentalCharting. */
  updateDentalCharting?: Maybe<UpdateDentalChartingPayload>;
  /** Updates a DentalSketchComment. */
  updateDentalSketchComment?: Maybe<UpdateDentalSketchCommentPayload>;
  /** Updates a DiagnosticTesting. */
  updateDiagnosticTesting?: Maybe<UpdateDiagnosticTestingPayload>;
  /** Updates a Disclaimer. */
  updateDisclaimer?: Maybe<UpdateDisclaimerPayload>;
  /** Updates a DisclaimerProcedure. */
  updateDisclaimerProcedure?: Maybe<UpdateDisclaimerProcedurePayload>;
  /** Updates a DisclaimerProcedureSetting. */
  updateDisclaimerProcedureSetting?: Maybe<
    UpdateDisclaimerProcedureSettingPayload
  >;
  /** Updates a DropOff. */
  updateDropOff?: Maybe<UpdateDropOffPayload>;
  /** Updates a ExamNote. */
  updateExamNote?: Maybe<UpdateExamNotePayload>;
  /** Updates a File. */
  updateFile?: Maybe<UpdateFilePayload>;
  /** Updates a FluidBolus. */
  updateFluidBolus?: Maybe<UpdateFluidBolusPayload>;
  /** Updates a FluidTemperature. */
  updateFluidTemperature?: Maybe<UpdateFluidTemperaturePayload>;
  /** Updates a GeneralAssessment. */
  updateGeneralAssessment?: Maybe<UpdateGeneralAssessmentPayload>;
  /** Updates a License. */
  updateLicense?: Maybe<UpdateLicensePayload>;
  /** Updates a MedicalCase. */
  updateMedicalCase?: Maybe<UpdateMedicalCasePayload>;
  /** Updates a MedicationCalculation. */
  updateMedicationCalculation?: Maybe<UpdateMedicationCalculationPayload>;
  /** Updates a MiscellaneousGroup. */
  updateMiscellaneousGroup?: Maybe<UpdateMiscellaneousGroupPayload>;
  /** Updates a Monitoring. */
  updateMonitoring?: Maybe<UpdateMonitoringPayload>;
  /** Updates a Order. */
  updateOrder?: Maybe<UpdateOrderPayload>;
  /** Updates a Organization. */
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  /** Updates a OrganizationSetting. */
  updateOrganizationSetting?: Maybe<UpdateOrganizationSettingPayload>;
  /** Updates a Patient. */
  updatePatient?: Maybe<UpdatePatientPayload>;
  /** Updates a PatientProcedure. */
  updatePatientProcedure?: Maybe<UpdatePatientProcedurePayload>;
  /** Updates a PatientTest. */
  updatePatientTest?: Maybe<UpdatePatientTestPayload>;
  /** Updates a PhysicalExam. */
  updatePhysicalExam?: Maybe<UpdatePhysicalExamPayload>;
  /** Updates a PostAnestheticVital. */
  updatePostAnestheticVital?: Maybe<UpdatePostAnestheticVitalPayload>;
  /** Updates a PostAnestheticVitalComment. */
  updatePostAnestheticVitalComment?: Maybe<
    UpdatePostAnestheticVitalCommentPayload
  >;
  /** Updates a PreAnestheticExam. */
  updatePreAnestheticExam?: Maybe<UpdatePreAnestheticExamPayload>;
  /** Updates a ProphylacticDentalProcedure. */
  updateProphylacticDentalProcedure?: Maybe<
    UpdateProphylacticDentalProcedurePayload
  >;
  /** UpdateQuickCharts a BulkDentalCharting. */
  updateQuickChartBulkDentalCharting?: Maybe<
    UpdateQuickChartBulkDentalChartingPayload
  >;
  /** Updates a RegionalBlock. */
  updateRegionalBlock?: Maybe<UpdateRegionalBlockPayload>;
  /** UpdateStatuss a BulkDentalCharting. */
  updateStatusBulkDentalCharting?: Maybe<UpdateStatusBulkDentalChartingPayload>;
  /** UpdateStatuss a BulkMedicalCase. */
  updateStatusBulkMedicalCase?: Maybe<UpdateStatusBulkMedicalCasePayload>;
  /** UpdateStatuss a BulkPatientTest. */
  updateStatusBulkPatientTest?: Maybe<UpdateStatusBulkPatientTestPayload>;
  /** UpdateStatuss a BulkVaccine. */
  updateStatusBulkVaccine?: Maybe<UpdateStatusBulkVaccinePayload>;
  /** Updates a Suspension. */
  updateSuspension?: Maybe<UpdateSuspensionPayload>;
  /** Updates a Tablet. */
  updateTablet?: Maybe<UpdateTabletPayload>;
  /** Updates a TibialPlateauLevelingOsteotomyPlanning. */
  updateTibialPlateauLevelingOsteotomyPlanning?: Maybe<
    UpdateTibialPlateauLevelingOsteotomyPlanningPayload
  >;
  /** Updates a Treatment. */
  updateTreatment?: Maybe<UpdateTreatmentPayload>;
  /** Updates a User. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a Vaccine. */
  updateVaccine?: Maybe<UpdateVaccinePayload>;
  /** Updates a Vital. */
  updateVital?: Maybe<UpdateVitalPayload>;
  /** Updates a VitalComment. */
  updateVitalComment?: Maybe<UpdateVitalCommentPayload>;
  /** Uses a CalculationsAnestheticProtocol. */
  useCalculationsAnestheticProtocol?: Maybe<
    UseCalculationsAnestheticProtocolPayload
  >;
};

export type MutationCopyMedicalCaseArgs = {
  input: CopyMedicalCaseInput;
};

export type MutationCreateAdditionalDiagnosticTestArgs = {
  input: CreateAdditionalDiagnosticTestInput;
};

export type MutationCreateAnestheticGasArgs = {
  input: CreateAnestheticGasInput;
};

export type MutationCreateAnestheticProtocolArgs = {
  input: CreateAnestheticProtocolInput;
};

export type MutationCreateAnestheticProtocolMedicationCalculationArgs = {
  input: CreateAnestheticProtocolMedicationCalculationInput;
};

export type MutationCreateAnestheticProtocolRegionalBlockArgs = {
  input: CreateAnestheticProtocolRegionalBlockInput;
};

export type MutationCreateAuthenticationArgs = {
  input: CreateAuthenticationInput;
};

export type MutationCreateAuthorizationArgs = {
  input: CreateAuthorizationInput;
};

export type MutationCreateAuthorizationSettingArgs = {
  input: CreateAuthorizationSettingInput;
};

export type MutationCreateBulkAdditionalDiagnosticTestArgs = {
  input: CreateBulkAdditionalDiagnosticTestInput;
};

export type MutationCreateClientReportExportArgs = {
  input: CreateClientReportExportInput;
};

export type MutationCreateClientReportPrintArgs = {
  input: CreateClientReportPrintInput;
};

export type MutationCreateContactRequestArgs = {
  input: CreateContactRequestInput;
};

export type MutationCreateCurrentMedicationArgs = {
  input: CreateCurrentMedicationInput;
};

export type MutationCreateDefibMedicationArgs = {
  input: CreateDefibMedicationInput;
};

export type MutationCreateDentalChartingArgs = {
  input: CreateDentalChartingInput;
};

export type MutationCreateDentalReportExportArgs = {
  input: CreateDentalReportExportInput;
};

export type MutationCreateDentalReportPrintArgs = {
  input: CreateDentalReportPrintInput;
};

export type MutationCreateDentalSketchCommentArgs = {
  input: CreateDentalSketchCommentInput;
};

export type MutationCreateDisclaimerProcedureArgs = {
  input: CreateDisclaimerProcedureInput;
};

export type MutationCreateDisclaimerProcedureSettingArgs = {
  input: CreateDisclaimerProcedureSettingInput;
};

export type MutationCreateFileArgs = {
  input: CreateFileInput;
};

export type MutationCreateFluidBolusArgs = {
  input: CreateFluidBolusInput;
};

export type MutationCreateFluidTemperatureArgs = {
  input: CreateFluidTemperatureInput;
};

export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};

export type MutationCreateLogoutArgs = {
  input: CreateLogoutInput;
};

export type MutationCreateMedicalCaseArgs = {
  input: CreateMedicalCaseInput;
};

export type MutationCreateMedicalRecordExportArgs = {
  input: CreateMedicalRecordExportInput;
};

export type MutationCreateMedicalRecordPrintArgs = {
  input: CreateMedicalRecordPrintInput;
};

export type MutationCreateMedicationCalculationArgs = {
  input: CreateMedicationCalculationInput;
};

export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

export type MutationCreateOrganizationRegistrationArgs = {
  input: CreateOrganizationRegistrationInput;
};

export type MutationCreatePasswordChangeArgs = {
  input: CreatePasswordChangeInput;
};

export type MutationCreatePasswordRecoveryRequestArgs = {
  input: CreatePasswordRecoveryRequestInput;
};

export type MutationCreatePatientProcedureArgs = {
  input: CreatePatientProcedureInput;
};

export type MutationCreatePinAuthenticationArgs = {
  input: CreatePinAuthenticationInput;
};

export type MutationCreatePostAnestheticVitalArgs = {
  input: CreatePostAnestheticVitalInput;
};

export type MutationCreateReferralDocumentExportArgs = {
  input: CreateReferralDocumentExportInput;
};

export type MutationCreateReferralDocumentPrintArgs = {
  input: CreateReferralDocumentPrintInput;
};

export type MutationCreateRefreshTokenArgs = {
  input: CreateRefreshTokenInput;
};

export type MutationCreateRegionalBlockArgs = {
  input: CreateRegionalBlockInput;
};

export type MutationCreateRegistrationCompletionArgs = {
  input: CreateRegistrationCompletionInput;
};

export type MutationCreateSuspensionArgs = {
  input: CreateSuspensionInput;
};

export type MutationCreateTabletArgs = {
  input: CreateTabletInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateVitalArgs = {
  input: CreateVitalInput;
};

export type MutationDeleteAdditionalDiagnosticTestArgs = {
  input: DeleteAdditionalDiagnosticTestInput;
};

export type MutationDeleteAnestheticProtocolArgs = {
  input: DeleteAnestheticProtocolInput;
};

export type MutationDeleteAnestheticProtocolMedicationCalculationArgs = {
  input: DeleteAnestheticProtocolMedicationCalculationInput;
};

export type MutationDeleteAnestheticProtocolRegionalBlockArgs = {
  input: DeleteAnestheticProtocolRegionalBlockInput;
};

export type MutationDeleteCurrentMedicationArgs = {
  input: DeleteCurrentMedicationInput;
};

export type MutationDeleteDefibMedicationArgs = {
  input: DeleteDefibMedicationInput;
};

export type MutationDeleteDentalSketchCommentArgs = {
  input: DeleteDentalSketchCommentInput;
};

export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};

export type MutationDeleteFluidBolusArgs = {
  input: DeleteFluidBolusInput;
};

export type MutationDeleteLicenseArgs = {
  input: DeleteLicenseInput;
};

export type MutationDeleteMedicalCaseArgs = {
  input: DeleteMedicalCaseInput;
};

export type MutationDeleteMedicationCalculationArgs = {
  input: DeleteMedicationCalculationInput;
};

export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};

export type MutationDeleteRegionalBlockArgs = {
  input: DeleteRegionalBlockInput;
};

export type MutationDeleteSuspensionArgs = {
  input: DeleteSuspensionInput;
};

export type MutationDeleteTabletArgs = {
  input: DeleteTabletInput;
};

export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

export type MutationExportPdfToVetspireMedicalCaseArgs = {
  input: ExportPdfToVetspireMedicalCaseInput;
};

export type MutationImportVetspireMedicalCaseArgs = {
  input: ImportVetspireMedicalCaseInput;
};

export type MutationLogBulkPinAuthenticationArgs = {
  input: LogBulkPinAuthenticationInput;
};

export type MutationLogPinLoginArgs = {
  input: LogPinLoginInput;
};

export type MutationMutation_Collection_QueryAdditionalDiagnosticTestArgs = {
  input: Mutation_Collection_QueryAdditionalDiagnosticTestInput;
};

export type MutationMutation_Collection_QueryMedicationCalculationArgs = {
  input: Mutation_Collection_QueryMedicationCalculationInput;
};

export type MutationMutation_Collection_QueryPatientTestArgs = {
  input: Mutation_Collection_QueryPatientTestInput;
};

export type MutationMutation_Collection_QueryRegionalBlockArgs = {
  input: Mutation_Collection_QueryRegionalBlockInput;
};

export type MutationMutation_Collection_QueryVaccineArgs = {
  input: Mutation_Collection_QueryVaccineInput;
};

export type MutationRemoveBulkAnestheticProtocolArgs = {
  input: RemoveBulkAnestheticProtocolInput;
};

export type MutationRemoveBulkAnestheticProtocolMedicationCalculationArgs = {
  input: RemoveBulkAnestheticProtocolMedicationCalculationInput;
};

export type MutationRemoveBulkAnestheticProtocolRegionalBlockArgs = {
  input: RemoveBulkAnestheticProtocolRegionalBlockInput;
};

export type MutationRemoveBulkAuthorizationSettingArgs = {
  input: RemoveBulkAuthorizationSettingInput;
};

export type MutationRemoveBulkCurrentMedicationArgs = {
  input: RemoveBulkCurrentMedicationInput;
};

export type MutationRemoveBulkDefibMedicationArgs = {
  input: RemoveBulkDefibMedicationInput;
};

export type MutationRemoveBulkDentalSketchCommentArgs = {
  input: RemoveBulkDentalSketchCommentInput;
};

export type MutationRemoveBulkDisclaimerProcedureSettingArgs = {
  input: RemoveBulkDisclaimerProcedureSettingInput;
};

export type MutationRemoveBulkMedicalCaseArgs = {
  input: RemoveBulkMedicalCaseInput;
};

export type MutationRemoveBulkMedicationCalculationArgs = {
  input: RemoveBulkMedicationCalculationInput;
};

export type MutationRemoveBulkRegionalBlockArgs = {
  input: RemoveBulkRegionalBlockInput;
};

export type MutationRemoveBulkSuspensionArgs = {
  input: RemoveBulkSuspensionInput;
};

export type MutationRemoveBulkTabletArgs = {
  input: RemoveBulkTabletInput;
};

export type MutationResendOrganizationInviteArgs = {
  input: ResendOrganizationInviteInput;
};

export type MutationSetFullMonitoringInformationArgs = {
  input: SetFullMonitoringInformationInput;
};

export type MutationSetLightMonitoringInformationArgs = {
  input: SetLightMonitoringInformationInput;
};

export type MutationUpdateAdditionalDiagnosticTestArgs = {
  input: UpdateAdditionalDiagnosticTestInput;
};

export type MutationUpdateAnestheticGasArgs = {
  input: UpdateAnestheticGasInput;
};

export type MutationUpdateAnestheticProtocolArgs = {
  input: UpdateAnestheticProtocolInput;
};

export type MutationUpdateAnestheticProtocolMedicationCalculationArgs = {
  input: UpdateAnestheticProtocolMedicationCalculationInput;
};

export type MutationUpdateAnestheticProtocolRegionalBlockArgs = {
  input: UpdateAnestheticProtocolRegionalBlockInput;
};

export type MutationUpdateAuthorizationArgs = {
  input: UpdateAuthorizationInput;
};

export type MutationUpdateAuthorizationSettingArgs = {
  input: UpdateAuthorizationSettingInput;
};

export type MutationUpdateCalculationAgreementArgs = {
  input: UpdateCalculationAgreementInput;
};

export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};

export type MutationUpdateCurrentMedicationArgs = {
  input: UpdateCurrentMedicationInput;
};

export type MutationUpdateDefibMedicationArgs = {
  input: UpdateDefibMedicationInput;
};

export type MutationUpdateDentalChartingArgs = {
  input: UpdateDentalChartingInput;
};

export type MutationUpdateDentalSketchCommentArgs = {
  input: UpdateDentalSketchCommentInput;
};

export type MutationUpdateDiagnosticTestingArgs = {
  input: UpdateDiagnosticTestingInput;
};

export type MutationUpdateDisclaimerArgs = {
  input: UpdateDisclaimerInput;
};

export type MutationUpdateDisclaimerProcedureArgs = {
  input: UpdateDisclaimerProcedureInput;
};

export type MutationUpdateDisclaimerProcedureSettingArgs = {
  input: UpdateDisclaimerProcedureSettingInput;
};

export type MutationUpdateDropOffArgs = {
  input: UpdateDropOffInput;
};

export type MutationUpdateExamNoteArgs = {
  input: UpdateExamNoteInput;
};

export type MutationUpdateFileArgs = {
  input: UpdateFileInput;
};

export type MutationUpdateFluidBolusArgs = {
  input: UpdateFluidBolusInput;
};

export type MutationUpdateFluidTemperatureArgs = {
  input: UpdateFluidTemperatureInput;
};

export type MutationUpdateGeneralAssessmentArgs = {
  input: UpdateGeneralAssessmentInput;
};

export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};

export type MutationUpdateMedicalCaseArgs = {
  input: UpdateMedicalCaseInput;
};

export type MutationUpdateMedicationCalculationArgs = {
  input: UpdateMedicationCalculationInput;
};

export type MutationUpdateMiscellaneousGroupArgs = {
  input: UpdateMiscellaneousGroupInput;
};

export type MutationUpdateMonitoringArgs = {
  input: UpdateMonitoringInput;
};

export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

export type MutationUpdateOrganizationSettingArgs = {
  input: UpdateOrganizationSettingInput;
};

export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
};

export type MutationUpdatePatientProcedureArgs = {
  input: UpdatePatientProcedureInput;
};

export type MutationUpdatePatientTestArgs = {
  input: UpdatePatientTestInput;
};

export type MutationUpdatePhysicalExamArgs = {
  input: UpdatePhysicalExamInput;
};

export type MutationUpdatePostAnestheticVitalArgs = {
  input: UpdatePostAnestheticVitalInput;
};

export type MutationUpdatePostAnestheticVitalCommentArgs = {
  input: UpdatePostAnestheticVitalCommentInput;
};

export type MutationUpdatePreAnestheticExamArgs = {
  input: UpdatePreAnestheticExamInput;
};

export type MutationUpdateProphylacticDentalProcedureArgs = {
  input: UpdateProphylacticDentalProcedureInput;
};

export type MutationUpdateQuickChartBulkDentalChartingArgs = {
  input: UpdateQuickChartBulkDentalChartingInput;
};

export type MutationUpdateRegionalBlockArgs = {
  input: UpdateRegionalBlockInput;
};

export type MutationUpdateStatusBulkDentalChartingArgs = {
  input: UpdateStatusBulkDentalChartingInput;
};

export type MutationUpdateStatusBulkMedicalCaseArgs = {
  input: UpdateStatusBulkMedicalCaseInput;
};

export type MutationUpdateStatusBulkPatientTestArgs = {
  input: UpdateStatusBulkPatientTestInput;
};

export type MutationUpdateStatusBulkVaccineArgs = {
  input: UpdateStatusBulkVaccineInput;
};

export type MutationUpdateSuspensionArgs = {
  input: UpdateSuspensionInput;
};

export type MutationUpdateTabletArgs = {
  input: UpdateTabletInput;
};

export type MutationUpdateTibialPlateauLevelingOsteotomyPlanningArgs = {
  input: UpdateTibialPlateauLevelingOsteotomyPlanningInput;
};

export type MutationUpdateTreatmentArgs = {
  input: UpdateTreatmentInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateVaccineArgs = {
  input: UpdateVaccineInput;
};

export type MutationUpdateVitalArgs = {
  input: UpdateVitalInput;
};

export type MutationUpdateVitalCommentArgs = {
  input: UpdateVitalCommentInput;
};

export type MutationUseCalculationsAnestheticProtocolArgs = {
  input: UseCalculationsAnestheticProtocolInput;
};

/** A node, according to the Relay specification. */
export type Node = {
  /** The id of this node. */
  id: Scalars["ID"];
};

export enum OcclusionEnum {
  Mal1 = "mal1",
  Mal2 = "mal2",
  Mal3 = "mal3",
  Mal4Dv = "mal4_dv",
  Mal4Rc = "mal4_rc",
  Mal4Sts = "mal4_sts",
  Normal = "normal"
}

export enum OralStateEnum {
  Abnormal = "abnormal",
  Normal = "normal"
}

export enum OralSurgeryEnum {
  AcrylicWireButtons = "acrylic_wire_buttons",
  BiopsyExcisional = "biopsy_excisional",
  BiopsyIncisional = "biopsy_incisional",
  JawFxStabilization = "jaw_fx_stabilization",
  MassResection = "mass_resection",
  OnfOafRepair = "onf_oaf_repair"
}

export type Order = Node & {
  _id: Scalars["Int"];
  expirationDate: Scalars["Date"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  license: License;
  organization: Organization;
  price: Scalars["Float"];
  startDate: Scalars["Date"];
};

/** Page connection for Order. */
export type OrderPageConnection = {
  collection: Array<Order>;
  paginationInfo: OrderPaginationInfo;
};

/** Information about the pagination. */
export type OrderPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type Organization = Node & {
  _id: Scalars["Int"];
  adminRegistrationCompleted: Scalars["Boolean"];
  contactEmail?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  description?: Maybe<Scalars["String"]>;
  domain: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  logo?: Maybe<File>;
  name: Scalars["String"];
  order?: Maybe<Order>;
  organizationSetting?: Maybe<OrganizationSetting>;
  status: OrganizationStatusEnum;
  users?: Maybe<UserPageConnection>;
  vetspireApiKey?: Maybe<Scalars["String"]>;
};

export type OrganizationUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type OrganizationCounter = Node & {
  _id: Scalars["String"];
  activeOrganizationsCount: Scalars["Int"];
  archivedOrganizationsCount: Scalars["Int"];
  dateFilter?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  usersCount: Scalars["Int"];
};

export type OrganizationEndFilter = {
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export type OrganizationEqualFilter = {
  id?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<OrganizationStatusEnum>;
};

export type OrganizationExistsFilter = {
  id?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<Scalars["Boolean"]>;
};

export type OrganizationFilter = {
  OR?: InputMaybe<Array<InputMaybe<OrganizationFilter>>>;
  concat?: InputMaybe<OrganizationFilterConcat>;
  end?: InputMaybe<OrganizationEndFilter>;
  equal?: InputMaybe<OrganizationEqualFilter>;
  exists?: InputMaybe<OrganizationExistsFilter>;
  in?: InputMaybe<OrganizationInFilter>;
  like?: InputMaybe<OrganizationLikeFilter>;
  name?: InputMaybe<Scalars["String"]>;
  range?: InputMaybe<OrganizationRangeFilter>;
  start?: InputMaybe<OrganizationStartFilter>;
};

export type OrganizationFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: OrganizationFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum OrganizationFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type OrganizationInFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  status?: InputMaybe<Array<InputMaybe<OrganizationStatusEnum>>>;
};

export type OrganizationInvite = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type OrganizationLikeFilter = {
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

/** Page connection for Organization. */
export type OrganizationPageConnection = {
  collection: Array<Organization>;
  paginationInfo: OrganizationPaginationInfo;
};

/** Information about the pagination. */
export type OrganizationPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type OrganizationRangeFilter = {
  id?: InputMaybe<RangeFilter>;
};

export type OrganizationRegistration = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type OrganizationSetting = Node & {
  _id: Scalars["Int"];
  authorizationSettings?: Maybe<AuthorizationSettingPageConnection>;
  dateFormat: DateFormatEnum;
  disclaimerProcedureSettings?: Maybe<DisclaimerProcedureSettingPageConnection>;
  disclaimerText: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  temperatureUnit: TemperatureUnitEnum;
};

export type OrganizationSettingAuthorizationSettingsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type OrganizationSettingDisclaimerProcedureSettingsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type OrganizationStartFilter = {
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export enum OrganizationStatusEnum {
  Active = "active",
  Archived = "archived"
}

export type OrganizationUserMedicalCaseCounter = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medicalCaseCount: Scalars["Int"];
  organizationId: Scalars["Int"];
  organizationName: Scalars["String"];
  userCount: Scalars["Int"];
};

/** Page connection for OrganizationUserMedicalCaseCounter. */
export type OrganizationUserMedicalCaseCounterPageConnection = {
  collection: Array<OrganizationUserMedicalCaseCounter>;
  paginationInfo: OrganizationUserMedicalCaseCounterPaginationInfo;
};

/** Information about the pagination. */
export type OrganizationUserMedicalCaseCounterPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum OrthodonticsEnum {
  Adjustment = "adjustment",
  BracketPlacementElastics = "bracket_placement_elastics",
  ImpressionModel = "impression_model",
  InclinePlane = "incline_plane",
  MaxillaryExpansionDevice = "maxillary_expansion_device",
  SplintRemoval = "splint_removal"
}

export enum OtherEnum {
  Ab = "ab",
  At = "at",
  Cwd = "cwd",
  Dt = "dt",
  Dtc = "dtc",
  Ge = "ge",
  Gh = "gh",
  Gm = "gm",
  MnFx = "mn_fx",
  MxFx = "mx_fx",
  Oaf = "oaf",
  Om = "om",
  Onf = "onf",
  Rot = "rot",
  Rr = "rr",
  Rrt = "rrt",
  Si = "si",
  TNv = "t_nv",
  TPe = "t_pe",
  TSn = "t_sn"
}

export type PasswordChange = Node & {
  applicationSettings: ApplicationSettings;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  sessionId: Scalars["String"];
};

export type PasswordRecoveryRequest = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type PasswordRecoveryToken = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  valid: Scalars["Boolean"];
};

export type Patient = Node & {
  _id: Scalars["Int"];
  alerts?: Maybe<Scalars["String"]>;
  anestheticGasMedication: AnestheticGasMedicationEnum;
  anestheticGases?: Maybe<AnestheticGasPageConnection>;
  breed?: Maybe<Scalars["String"]>;
  calculationAgreement?: Maybe<CalculationAgreement>;
  client?: Maybe<Client>;
  currentMedications?: Maybe<CurrentMedicationPageConnection>;
  dateOfBirth?: Maybe<Scalars["Date"]>;
  defibMedications?: Maybe<DefibMedicationPageConnection>;
  dentalChartings?: Maybe<DentalChartingPageConnection>;
  dentalSketch?: Maybe<File>;
  dentalSketchComments?: Maybe<DentalSketchCommentPageConnection>;
  diagnosticTesting: DiagnosticTesting;
  dropOff: DropOff;
  examNote: ExamNote;
  fakeId?: Maybe<Scalars["String"]>;
  fluidBolus?: Maybe<FluidBolus>;
  fluidTemperatures?: Maybe<FluidTemperaturePageConnection>;
  generalAssessment?: Maybe<GeneralAssessment>;
  id: Scalars["ID"];
  image?: Maybe<File>;
  medicationCalculations?: Maybe<MedicationCalculationPageConnection>;
  miscellaneousGroup?: Maybe<MiscellaneousGroup>;
  monitoring: Monitoring;
  name?: Maybe<Scalars["String"]>;
  organization: Organization;
  patientProcedures?: Maybe<PatientProcedurePageConnection>;
  patientTests?: Maybe<PatientTestPageConnection>;
  physicalExam: PhysicalExam;
  postAnestheticVitalComment?: Maybe<PostAnestheticVitalComment>;
  postAnestheticVitals?: Maybe<PostAnestheticVitalPageConnection>;
  preAnestheticExam: PreAnestheticExam;
  procedureDate: Scalars["Date"];
  procedures: Array<Scalars["String"]>;
  prophylacticDentalProcedure: ProphylacticDentalProcedure;
  regionalBlocks?: Maybe<RegionalBlockPageConnection>;
  sex?: Maybe<PatientSexEnum>;
  species?: Maybe<SpeciesEnum>;
  suspensions?: Maybe<SuspensionPageConnection>;
  tablets?: Maybe<TabletPageConnection>;
  tibialPlateauLevelingOsteotomyPlanning?: Maybe<
    TibialPlateauLevelingOsteotomyPlanning
  >;
  treatment?: Maybe<Treatment>;
  vaccines?: Maybe<VaccinePageConnection>;
  vitalComment?: Maybe<VitalComment>;
  vitals?: Maybe<VitalPageConnection>;
  weight?: Maybe<Scalars["Float"]>;
  weightMeasure: WeightMeasureEnum;
};

export type PatientAnestheticGasesArgs = {
  filter?: InputMaybe<AnestheticGasFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientCurrentMedicationsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientDefibMedicationsArgs = {
  filter?: InputMaybe<DefibMedicationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientDentalChartingsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientDentalSketchCommentsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientFluidTemperaturesArgs = {
  filter?: InputMaybe<FluidTemperatureFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientMedicationCalculationsArgs = {
  filter?: InputMaybe<MedicationCalculationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientPatientProceduresArgs = {
  filter?: InputMaybe<PatientProcedureFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientPatientTestsArgs = {
  filter?: InputMaybe<PatientTestFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientPostAnestheticVitalsArgs = {
  filter?: InputMaybe<PostAnestheticVitalFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientRegionalBlocksArgs = {
  filter?: InputMaybe<RegionalBlockFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientSuspensionsArgs = {
  filter?: InputMaybe<SuspensionFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientTabletsArgs = {
  filter?: InputMaybe<TabletFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientVaccinesArgs = {
  filter?: InputMaybe<VaccineFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type PatientVitalsArgs = {
  filter?: InputMaybe<VitalFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

/** Page connection for Patient. */
export type PatientPageConnection = {
  collection: Array<Patient>;
  paginationInfo: PatientPaginationInfo;
};

/** Information about the pagination. */
export type PatientPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum PatientPhysicalStatus {
  Emergency = "emergency",
  Mild = "mild",
  Moderate = "moderate",
  Moribund = "moribund",
  Normal = "normal",
  Severe = "severe"
}

export type PatientProcedure = Node & {
  _id: Scalars["Int"];
  endTime?: Maybe<Scalars["DateTime"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  organization: Organization;
  patient: Patient;
  startTime?: Maybe<Scalars["DateTime"]>;
  totalTimeSeconds?: Maybe<Scalars["Float"]>;
};

export type PatientProcedureEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type PatientProcedureExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type PatientProcedureFilter = {
  OR?: InputMaybe<Array<InputMaybe<PatientProcedureFilter>>>;
  concat?: InputMaybe<PatientProcedureFilterConcat>;
  equal?: InputMaybe<PatientProcedureEqualFilter>;
  exists?: InputMaybe<PatientProcedureExistsFilter>;
  in?: InputMaybe<PatientProcedureInFilter>;
  range?: InputMaybe<PatientProcedureRangeFilter>;
};

export type PatientProcedureFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PatientProcedureFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PatientProcedureFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PatientProcedureInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for PatientProcedure. */
export type PatientProcedurePageConnection = {
  collection: Array<PatientProcedure>;
  paginationInfo: PatientProcedurePaginationInfo;
};

/** Information about the pagination. */
export type PatientProcedurePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PatientProcedureRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export enum PatientSexEnum {
  Female = "female",
  Male = "male",
  NeuteredMale = "neutered_male",
  SpayedFemale = "spayed_female"
}

export enum PatientStateEnum {
  Abnormal = "abnormal",
  Normal = "normal"
}

export type PatientTest = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient: Patient;
  test: PatientTestEnum;
  toPerform: Scalars["Boolean"];
};

export type PatientTestEndFilter = {
  test?: InputMaybe<Scalars["String"]>;
};

export enum PatientTestEnum {
  Fecal = "fecal",
  FelvFiv = "felv_fiv",
  Heartworm = "heartworm",
  UrineAnalysis = "urine_analysis"
}

export type PatientTestEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
  test?: InputMaybe<PatientTestEnum>;
};

export type PatientTestExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
  test?: InputMaybe<Scalars["Boolean"]>;
};

export type PatientTestFilter = {
  OR?: InputMaybe<Array<InputMaybe<PatientTestFilter>>>;
  concat?: InputMaybe<PatientTestFilterConcat>;
  end?: InputMaybe<PatientTestEndFilter>;
  equal?: InputMaybe<PatientTestEqualFilter>;
  exists?: InputMaybe<PatientTestExistsFilter>;
  in?: InputMaybe<PatientTestInFilter>;
  like?: InputMaybe<PatientTestLikeFilter>;
  range?: InputMaybe<PatientTestRangeFilter>;
  start?: InputMaybe<PatientTestStartFilter>;
};

export type PatientTestFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PatientTestFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PatientTestFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PatientTestInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  test?: InputMaybe<Array<InputMaybe<PatientTestEnum>>>;
};

export type PatientTestLikeFilter = {
  test?: InputMaybe<Scalars["String"]>;
};

/** Page connection for PatientTest. */
export type PatientTestPageConnection = {
  collection: Array<PatientTest>;
  paginationInfo: PatientTestPaginationInfo;
};

/** Information about the pagination. */
export type PatientTestPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PatientTestRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type PatientTestStartFilter = {
  test?: InputMaybe<Scalars["String"]>;
};

export enum PeriodontalDiseaseEnum {
  PeriodontalDisease_0 = "periodontal_disease_0",
  PeriodontalDisease_1 = "periodontal_disease_1",
  PeriodontalDisease_2 = "periodontal_disease_2",
  PeriodontalDisease_3 = "periodontal_disease_3",
  PeriodontalDisease_4 = "periodontal_disease_4"
}

export enum PeriodontalEnum {
  Pd1 = "pd1",
  Pd2 = "pd2",
  Pd3 = "pd3",
  Pd4 = "pd4"
}

export enum PeriodonticsEnum {
  GingivectomyGingivoplasty = "gingivectomy_gingivoplasty",
  RootPlaningAndSubgingivalCurettage = "root_planing_and_subgingival_curettage",
  UltrasonicScalingAndPolishing = "ultrasonic_scaling_and_polishing"
}

export type PhysicalExam = Node & {
  _id: Scalars["Int"];
  cardiovascular?: Maybe<PatientStateEnum>;
  cardiovascularAbnormalStateComments?: Maybe<Scalars["String"]>;
  ears?: Maybe<PatientStateEnum>;
  earsAbnormalStateComments?: Maybe<Scalars["String"]>;
  eyes?: Maybe<PatientStateEnum>;
  eyesAbnormalStateComments?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  gastrointestinal?: Maybe<PatientStateEnum>;
  gastrointestinalAbnormalStateComments?: Maybe<Scalars["String"]>;
  generalAppearance?: Maybe<PatientStateEnum>;
  generalAppearanceAbnormalStateComments?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  integumentary?: Maybe<PatientStateEnum>;
  integumentaryAbnormalStateComments?: Maybe<Scalars["String"]>;
  lymphNodes?: Maybe<PatientStateEnum>;
  lymphNodesAbnormalStateComments?: Maybe<Scalars["String"]>;
  mucousMembranes?: Maybe<PatientStateEnum>;
  mucousMembranesAbnormalStateComments?: Maybe<Scalars["String"]>;
  musculosceletal?: Maybe<PatientStateEnum>;
  musculosceletalAbnormalStateComments?: Maybe<Scalars["String"]>;
  nervousSystem?: Maybe<PatientStateEnum>;
  nervousSystemAbnormalStateComments?: Maybe<Scalars["String"]>;
  oralCavity?: Maybe<PatientStateEnum>;
  oralCavityAbnormalStateComments?: Maybe<Scalars["String"]>;
  organization: Organization;
  patient?: Maybe<Patient>;
  respiratory?: Maybe<PatientStateEnum>;
  respiratoryAbnormalStateComments?: Maybe<Scalars["String"]>;
  urogenital?: Maybe<PatientStateEnum>;
  urogenitalAbnormalStateComments?: Maybe<Scalars["String"]>;
};

export type PhysicalExamEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type PhysicalExamExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type PhysicalExamFilter = {
  OR?: InputMaybe<Array<InputMaybe<PhysicalExamFilter>>>;
  concat?: InputMaybe<PhysicalExamFilterConcat>;
  equal?: InputMaybe<PhysicalExamEqualFilter>;
  exists?: InputMaybe<PhysicalExamExistsFilter>;
  in?: InputMaybe<PhysicalExamInFilter>;
  range?: InputMaybe<PhysicalExamRangeFilter>;
};

export type PhysicalExamFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PhysicalExamFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PhysicalExamFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PhysicalExamInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for PhysicalExam. */
export type PhysicalExamPageConnection = {
  collection: Array<PhysicalExam>;
  paginationInfo: PhysicalExamPaginationInfo;
};

/** Information about the pagination. */
export type PhysicalExamPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PhysicalExamRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type PinAuthentication = Node & {
  correctPin: Scalars["Boolean"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type PinLogin = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export enum PlaqueIndexEnum {
  PlaqueIndex_0 = "plaque_index_0",
  PlaqueIndex_1 = "plaque_index_1",
  PlaqueIndex_2 = "plaque_index_2",
  PlaqueIndex_3 = "plaque_index_3"
}

export type PostAnestheticVital = Node & {
  _id: Scalars["Int"];
  comment?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  fluidRate?: Maybe<Scalars["Float"]>;
  heartRate?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  initials?: Maybe<Scalars["String"]>;
  meanBloodPressure?: Maybe<Scalars["Float"]>;
  organization: Organization;
  painScore?: Maybe<Scalars["Float"]>;
  patient: Patient;
  respiratoryRate?: Maybe<Scalars["Int"]>;
  temperature?: Maybe<Scalars["Float"]>;
  timeMonitoring: Scalars["DateTime"];
};

export type PostAnestheticVitalComment = Node & {
  _id: Scalars["Int"];
  comment?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient: Patient;
  surgeryReport?: Maybe<Scalars["String"]>;
};

export type PostAnestheticVitalCommentEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type PostAnestheticVitalCommentExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type PostAnestheticVitalCommentFilter = {
  OR?: InputMaybe<Array<InputMaybe<PostAnestheticVitalCommentFilter>>>;
  concat?: InputMaybe<PostAnestheticVitalCommentFilterConcat>;
  equal?: InputMaybe<PostAnestheticVitalCommentEqualFilter>;
  exists?: InputMaybe<PostAnestheticVitalCommentExistsFilter>;
  in?: InputMaybe<PostAnestheticVitalCommentInFilter>;
  range?: InputMaybe<PostAnestheticVitalCommentRangeFilter>;
};

export type PostAnestheticVitalCommentFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PostAnestheticVitalCommentFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PostAnestheticVitalCommentFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PostAnestheticVitalCommentInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for PostAnestheticVitalComment. */
export type PostAnestheticVitalCommentPageConnection = {
  collection: Array<PostAnestheticVitalComment>;
  paginationInfo: PostAnestheticVitalCommentPaginationInfo;
};

/** Information about the pagination. */
export type PostAnestheticVitalCommentPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PostAnestheticVitalCommentRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type PostAnestheticVitalEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type PostAnestheticVitalExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type PostAnestheticVitalFilter = {
  OR?: InputMaybe<Array<InputMaybe<PostAnestheticVitalFilter>>>;
  concat?: InputMaybe<PostAnestheticVitalFilterConcat>;
  equal?: InputMaybe<PostAnestheticVitalEqualFilter>;
  exists?: InputMaybe<PostAnestheticVitalExistsFilter>;
  in?: InputMaybe<PostAnestheticVitalInFilter>;
  range?: InputMaybe<PostAnestheticVitalRangeFilter>;
};

export type PostAnestheticVitalFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PostAnestheticVitalFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PostAnestheticVitalFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PostAnestheticVitalInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for PostAnestheticVital. */
export type PostAnestheticVitalPageConnection = {
  collection: Array<PostAnestheticVital>;
  paginationInfo: PostAnestheticVitalPaginationInfo;
};

/** Information about the pagination. */
export type PostAnestheticVitalPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PostAnestheticVitalRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type PreAnestheticExam = Node & {
  _id: Scalars["Int"];
  bodyConditionScore?: Maybe<Scalars["Int"]>;
  dentalScore?: Maybe<Scalars["Int"]>;
  fakeId?: Maybe<Scalars["String"]>;
  heartRate?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  organization: Organization;
  painScore?: Maybe<Scalars["Int"]>;
  patient?: Maybe<Patient>;
  physicalStatus?: Maybe<PatientPhysicalStatus>;
  respiratoryRate?: Maybe<Scalars["Int"]>;
  temperature?: Maybe<Scalars["Float"]>;
};

export type PreAnestheticExamEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type PreAnestheticExamExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type PreAnestheticExamFilter = {
  OR?: InputMaybe<Array<InputMaybe<PreAnestheticExamFilter>>>;
  concat?: InputMaybe<PreAnestheticExamFilterConcat>;
  equal?: InputMaybe<PreAnestheticExamEqualFilter>;
  exists?: InputMaybe<PreAnestheticExamExistsFilter>;
  in?: InputMaybe<PreAnestheticExamInFilter>;
  range?: InputMaybe<PreAnestheticExamRangeFilter>;
};

export type PreAnestheticExamFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PreAnestheticExamFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PreAnestheticExamFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PreAnestheticExamInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for PreAnestheticExam. */
export type PreAnestheticExamPageConnection = {
  collection: Array<PreAnestheticExam>;
  paginationInfo: PreAnestheticExamPaginationInfo;
};

/** Information about the pagination. */
export type PreAnestheticExamPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PreAnestheticExamRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type PreoperativeTibialPlateauAngle = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  angle: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  sawRadius: Scalars["Int"];
  value: Scalars["Float"];
};

export type PreoperativeTibialPlateauAngleEqualFilter = {
  angle?: InputMaybe<Scalars["Int"]>;
  sawRadius?: InputMaybe<Scalars["Int"]>;
};

export type PreoperativeTibialPlateauAngleExistsFilter = {
  angle?: InputMaybe<Scalars["Boolean"]>;
  sawRadius?: InputMaybe<Scalars["Boolean"]>;
};

export type PreoperativeTibialPlateauAngleFilter = {
  OR?: InputMaybe<Array<InputMaybe<PreoperativeTibialPlateauAngleFilter>>>;
  concat?: InputMaybe<PreoperativeTibialPlateauAngleFilterConcat>;
  equal?: InputMaybe<PreoperativeTibialPlateauAngleEqualFilter>;
  exists?: InputMaybe<PreoperativeTibialPlateauAngleExistsFilter>;
  in?: InputMaybe<PreoperativeTibialPlateauAngleInFilter>;
  range?: InputMaybe<PreoperativeTibialPlateauAngleRangeFilter>;
};

export type PreoperativeTibialPlateauAngleFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: PreoperativeTibialPlateauAngleFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum PreoperativeTibialPlateauAngleFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type PreoperativeTibialPlateauAngleInFilter = {
  angle?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  sawRadius?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for PreoperativeTibialPlateauAngle. */
export type PreoperativeTibialPlateauAnglePageConnection = {
  collection: Array<PreoperativeTibialPlateauAngle>;
  paginationInfo: PreoperativeTibialPlateauAnglePaginationInfo;
};

/** Information about the pagination. */
export type PreoperativeTibialPlateauAnglePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type PreoperativeTibialPlateauAngleRangeFilter = {
  angle?: InputMaybe<RangeFilter>;
  sawRadius?: InputMaybe<RangeFilter>;
};

export type Procedure = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type ProcedureEndFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type ProcedureEqualFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type ProcedureExistsFilter = {
  id?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
};

export type ProcedureFilter = {
  OR?: InputMaybe<Array<InputMaybe<ProcedureFilter>>>;
  concat?: InputMaybe<ProcedureFilterConcat>;
  end?: InputMaybe<ProcedureEndFilter>;
  equal?: InputMaybe<ProcedureEqualFilter>;
  exists?: InputMaybe<ProcedureExistsFilter>;
  in?: InputMaybe<ProcedureInFilter>;
  like?: InputMaybe<ProcedureLikeFilter>;
  start?: InputMaybe<ProcedureStartFilter>;
};

export type ProcedureFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: ProcedureFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum ProcedureFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type ProcedureInFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type ProcedureLikeFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

/** Page connection for Procedure. */
export type ProcedurePageConnection = {
  collection: Array<Procedure>;
  paginationInfo: ProcedurePaginationInfo;
};

/** Information about the pagination. */
export type ProcedurePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type ProcedureStartFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type ProphylacticDentalProcedure = Node & {
  _id: Scalars["Int"];
  additionalComments?: Maybe<Scalars["String"]>;
  dontAuthorizeAnyAdditionalDentalWorkBeforeContact: Scalars["Boolean"];
  dontAuthorizeAnyRadiographs: Scalars["Boolean"];
  fakeId?: Maybe<Scalars["String"]>;
  fullMouthRadiographs: Scalars["Boolean"];
  gumWorkOrExtraction: Scalars["Boolean"];
  id: Scalars["ID"];
  onlyRadiographsDeemedNecessary: Scalars["Boolean"];
  organization: Organization;
  patient?: Maybe<Patient>;
};

export enum QualityOfSedationEnum {
  Mild = "mild",
  Moderate = "moderate",
  Profound = "profound"
}

export enum QualityRecoveryEnum {
  Dysphoric = "dysphoric",
  Excellent = "excellent",
  Fair = "fair",
  Poor = "poor",
  Slow = "slow"
}

export type Query = {
  accessLog?: Maybe<AccessLog>;
  accessLogs?: Maybe<AccessLogPageConnection>;
  additionalDiagnosticTest?: Maybe<AdditionalDiagnosticTest>;
  additionalDiagnosticTests?: Maybe<AdditionalDiagnosticTestPageConnection>;
  anestheticGas?: Maybe<AnestheticGasPageConnection>;
  anestheticProtocol?: Maybe<AnestheticProtocol>;
  anestheticProtocolMedicationCalculation?: Maybe<
    AnestheticProtocolMedicationCalculation
  >;
  anestheticProtocolMedicationCalculations?: Maybe<
    AnestheticProtocolMedicationCalculationPageConnection
  >;
  anestheticProtocolRegionalBlock?: Maybe<AnestheticProtocolRegionalBlock>;
  anestheticProtocolRegionalBlocks?: Maybe<
    AnestheticProtocolRegionalBlockPageConnection
  >;
  anestheticProtocols?: Maybe<AnestheticProtocolPageConnection>;
  applicationSettings?: Maybe<ApplicationSettings>;
  authorization?: Maybe<Authorization>;
  authorizationSetting?: Maybe<AuthorizationSetting>;
  authorizationSettings?: Maybe<AuthorizationSettingPageConnection>;
  authorizations?: Maybe<AuthorizationPageConnection>;
  bodyConditionScoreDescription?: Maybe<BodyConditionScoreDescription>;
  bodyConditionScoreDescriptions?: Maybe<
    BodyConditionScoreDescriptionPageConnection
  >;
  breed?: Maybe<Breed>;
  breeds?: Maybe<BreedPageConnection>;
  calculationAgreement?: Maybe<CalculationAgreement>;
  calculationAgreements?: Maybe<CalculationAgreementPageConnection>;
  catheterSizeOption?: Maybe<CatheterSizeOption>;
  catheterSizeOptions?: Maybe<CatheterSizeOptionPageConnection>;
  cities?: Maybe<CityPageConnection>;
  city?: Maybe<City>;
  client?: Maybe<Client>;
  clients?: Maybe<ClientPageConnection>;
  currentMedication?: Maybe<CurrentMedication>;
  currentMedications?: Maybe<CurrentMedicationPageConnection>;
  defibMedication?: Maybe<DefibMedication>;
  defibMedications?: Maybe<DefibMedicationPageConnection>;
  dentalCharting?: Maybe<DentalCharting>;
  dentalChartings?: Maybe<DentalChartingPageConnection>;
  dentalScoreDescription?: Maybe<DentalScoreDescription>;
  dentalScoreDescriptions?: Maybe<DentalScoreDescriptionPageConnection>;
  dentalSketchComments?: Maybe<DentalSketchCommentPageConnection>;
  diagnosticTesting?: Maybe<DiagnosticTesting>;
  diagnosticTestings?: Maybe<DiagnosticTestingPageConnection>;
  dictionary?: Maybe<Dictionary>;
  disclaimer?: Maybe<Disclaimer>;
  disclaimerProcedure?: Maybe<DisclaimerProcedure>;
  disclaimerProcedureSetting?: Maybe<DisclaimerProcedureSetting>;
  disclaimerProcedureSettings?: Maybe<DisclaimerProcedureSettingPageConnection>;
  disclaimerProcedures?: Maybe<DisclaimerProcedurePageConnection>;
  dropOff?: Maybe<DropOff>;
  emailLogs?: Maybe<EmailLogPageConnection>;
  examNote?: Maybe<ExamNote>;
  examNotes?: Maybe<ExamNotePageConnection>;
  file?: Maybe<File>;
  files?: Maybe<FilePageConnection>;
  fluidBolus?: Maybe<FluidBolus>;
  fluidBoluses?: Maybe<FluidBolusPageConnection>;
  fluidRateOption?: Maybe<FluidRateOption>;
  fluidRateOptions?: Maybe<FluidRateOptionPageConnection>;
  fluidTemperature?: Maybe<FluidTemperature>;
  fluidTemperatures?: Maybe<FluidTemperaturePageConnection>;
  fluidTypeOption?: Maybe<FluidTypeOption>;
  fluidTypeOptions?: Maybe<FluidTypeOptionPageConnection>;
  generalAssessment?: Maybe<GeneralAssessment>;
  generalAssessments?: Maybe<GeneralAssessmentPageConnection>;
  legend?: Maybe<Legend>;
  legends?: Maybe<LegendPageConnection>;
  license?: Maybe<License>;
  licenses?: Maybe<LicensePageConnection>;
  medicalCase?: Maybe<MedicalCase>;
  medicalCases?: Maybe<MedicalCasePageConnection>;
  medication?: Maybe<Medication>;
  medicationCalculation?: Maybe<MedicationCalculation>;
  medicationCalculations?: Maybe<MedicationCalculationPageConnection>;
  medications?: Maybe<MedicationPageConnection>;
  miscellaneousGroup?: Maybe<MiscellaneousGroup>;
  miscellaneousGroups?: Maybe<MiscellaneousGroupPageConnection>;
  monitoring?: Maybe<Monitoring>;
  monitorings?: Maybe<MonitoringPageConnection>;
  node?: Maybe<Node>;
  order?: Maybe<Order>;
  orders?: Maybe<OrderPageConnection>;
  organization?: Maybe<Organization>;
  organizationAdminUser?: Maybe<User>;
  organizationSetting?: Maybe<OrganizationSetting>;
  organizations?: Maybe<OrganizationPageConnection>;
  passwordRecoveryToken?: Maybe<PasswordRecoveryToken>;
  patient?: Maybe<Patient>;
  patientProcedure?: Maybe<PatientProcedure>;
  patientProcedures?: Maybe<PatientProcedurePageConnection>;
  patientTest?: Maybe<PatientTest>;
  patientTests?: Maybe<PatientTestPageConnection>;
  patients?: Maybe<PatientPageConnection>;
  physicalExam?: Maybe<PhysicalExam>;
  physicalExams?: Maybe<PhysicalExamPageConnection>;
  postAnestheticVital?: Maybe<PostAnestheticVital>;
  postAnestheticVitalComment?: Maybe<PostAnestheticVitalComment>;
  postAnestheticVitalComments?: Maybe<PostAnestheticVitalCommentPageConnection>;
  postAnestheticVitals?: Maybe<PostAnestheticVitalPageConnection>;
  preAnestheticExam?: Maybe<PreAnestheticExam>;
  preAnestheticExams?: Maybe<PreAnestheticExamPageConnection>;
  preoperativeTibialPlateauAngle?: Maybe<PreoperativeTibialPlateauAngle>;
  preoperativeTibialPlateauAngles?: Maybe<
    PreoperativeTibialPlateauAnglePageConnection
  >;
  procedure?: Maybe<Procedure>;
  procedures?: Maybe<ProcedurePageConnection>;
  prophylacticDentalProcedure?: Maybe<ProphylacticDentalProcedure>;
  queryVetspireClients?: Maybe<VetspireClientPageConnection>;
  queryVetspirePatients?: Maybe<VetspirePatientPageConnection>;
  regionalBlock?: Maybe<RegionalBlock>;
  regionalBlocks?: Maybe<RegionalBlockPageConnection>;
  registrationToken?: Maybe<RegistrationToken>;
  reportOrganizationCounter?: Maybe<OrganizationCounter>;
  reportOrganizationUserMedicalCaseCounters?: Maybe<
    OrganizationUserMedicalCaseCounterPageConnection
  >;
  state?: Maybe<State>;
  states?: Maybe<StatePageConnection>;
  suspension?: Maybe<Suspension>;
  suspensions?: Maybe<SuspensionPageConnection>;
  tablet?: Maybe<Tablet>;
  tablets?: Maybe<TabletPageConnection>;
  teeth?: Maybe<ToothPageConnection>;
  tibialPlateauLevelingOsteotomyPlanning?: Maybe<
    TibialPlateauLevelingOsteotomyPlanning
  >;
  tibialPlateauLevelingOsteotomyPlannings?: Maybe<
    TibialPlateauLevelingOsteotomyPlanningPageConnection
  >;
  tooth?: Maybe<Tooth>;
  treatment?: Maybe<Treatment>;
  treatments?: Maybe<TreatmentPageConnection>;
  user?: Maybe<User>;
  users?: Maybe<UserPageConnection>;
  vaccine?: Maybe<Vaccine>;
  vaccines?: Maybe<VaccinePageConnection>;
  vital?: Maybe<Vital>;
  vitalComment?: Maybe<VitalComment>;
  vitalComments?: Maybe<VitalCommentPageConnection>;
  vitals?: Maybe<VitalPageConnection>;
  zipCode?: Maybe<ZipCode>;
  zipCodes?: Maybe<ZipCodePageConnection>;
};

export type QueryAccessLogArgs = {
  _id: Scalars["Int"];
};

export type QueryAccessLogsArgs = {
  filter?: InputMaybe<AccessLogFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<Array<InputMaybe<AccessLogFilter_Order>>>;
  page?: InputMaybe<Scalars["Int"]>;
  username?: InputMaybe<Scalars["String"]>;
};

export type QueryAdditionalDiagnosticTestArgs = {
  _id: Scalars["Int"];
};

export type QueryAdditionalDiagnosticTestsArgs = {
  filter?: InputMaybe<AdditionalDiagnosticTestFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryAnestheticGasArgs = {
  filter?: InputMaybe<AnestheticGasFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryAnestheticProtocolArgs = {
  _id: Scalars["Int"];
};

export type QueryAnestheticProtocolMedicationCalculationArgs = {
  _id: Scalars["Int"];
};

export type QueryAnestheticProtocolMedicationCalculationsArgs = {
  filter?: InputMaybe<AnestheticProtocolMedicationCalculationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryAnestheticProtocolRegionalBlockArgs = {
  _id: Scalars["Int"];
};

export type QueryAnestheticProtocolRegionalBlocksArgs = {
  filter?: InputMaybe<AnestheticProtocolRegionalBlockFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryAnestheticProtocolsArgs = {
  filter?: InputMaybe<AnestheticProtocolFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryApplicationSettingsArgs = {
  id: Scalars["ID"];
};

export type QueryAuthorizationArgs = {
  _id: Scalars["Int"];
};

export type QueryAuthorizationSettingArgs = {
  _id: Scalars["Int"];
};

export type QueryAuthorizationSettingsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryAuthorizationsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryBodyConditionScoreDescriptionArgs = {
  _id: Scalars["Int"];
};

export type QueryBodyConditionScoreDescriptionsArgs = {
  filter?: InputMaybe<BodyConditionScoreDescriptionFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryBreedArgs = {
  _id: Scalars["String"];
};

export type QueryBreedsArgs = {
  filter?: InputMaybe<BreedFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryCalculationAgreementArgs = {
  _id: Scalars["Int"];
};

export type QueryCalculationAgreementsArgs = {
  filter?: InputMaybe<CalculationAgreementFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryCatheterSizeOptionArgs = {
  _id: Scalars["Int"];
};

export type QueryCatheterSizeOptionsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryCitiesArgs = {
  filter?: InputMaybe<CityFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryCityArgs = {
  _id: Scalars["String"];
};

export type QueryClientArgs = {
  _id: Scalars["Int"];
};

export type QueryClientsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryCurrentMedicationArgs = {
  _id: Scalars["Int"];
};

export type QueryCurrentMedicationsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDefibMedicationArgs = {
  _id: Scalars["Int"];
};

export type QueryDefibMedicationsArgs = {
  filter?: InputMaybe<DefibMedicationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDentalChartingArgs = {
  _id: Scalars["Int"];
};

export type QueryDentalChartingsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDentalScoreDescriptionArgs = {
  _id: Scalars["Int"];
};

export type QueryDentalScoreDescriptionsArgs = {
  filter?: InputMaybe<DentalScoreDescriptionFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDentalSketchCommentsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDiagnosticTestingArgs = {
  _id: Scalars["Int"];
};

export type QueryDiagnosticTestingsArgs = {
  filter?: InputMaybe<DiagnosticTestingFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDictionaryArgs = {
  id: Scalars["ID"];
};

export type QueryDisclaimerArgs = {
  _id: Scalars["Int"];
};

export type QueryDisclaimerProcedureArgs = {
  _id: Scalars["Int"];
};

export type QueryDisclaimerProcedureSettingArgs = {
  _id: Scalars["Int"];
};

export type QueryDisclaimerProcedureSettingsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDisclaimerProceduresArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryDropOffArgs = {
  _id: Scalars["Int"];
};

export type QueryEmailLogsArgs = {
  filter?: InputMaybe<EmailLogFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryExamNoteArgs = {
  _id: Scalars["Int"];
};

export type QueryExamNotesArgs = {
  filter?: InputMaybe<ExamNoteFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryFileArgs = {
  _id: Scalars["Int"];
};

export type QueryFilesArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryFluidBolusArgs = {
  _id: Scalars["Int"];
};

export type QueryFluidBolusesArgs = {
  filter?: InputMaybe<FluidBolusFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryFluidRateOptionArgs = {
  _id: Scalars["Int"];
};

export type QueryFluidRateOptionsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryFluidTemperatureArgs = {
  _id: Scalars["Int"];
};

export type QueryFluidTemperaturesArgs = {
  filter?: InputMaybe<FluidTemperatureFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryFluidTypeOptionArgs = {
  _id: Scalars["Int"];
};

export type QueryFluidTypeOptionsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryGeneralAssessmentArgs = {
  _id: Scalars["Int"];
};

export type QueryGeneralAssessmentsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryLegendArgs = {
  _id: Scalars["Int"];
};

export type QueryLegendsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryLicenseArgs = {
  _id: Scalars["Int"];
};

export type QueryLicensesArgs = {
  filter?: InputMaybe<LicenseFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryMedicalCaseArgs = {
  _id: Scalars["Int"];
};

export type QueryMedicalCasesArgs = {
  filter?: InputMaybe<MedicalCaseFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<Array<InputMaybe<MedicalCaseFilter_Order>>>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryMedicationArgs = {
  _id: Scalars["String"];
};

export type QueryMedicationCalculationArgs = {
  _id: Scalars["Int"];
};

export type QueryMedicationCalculationsArgs = {
  filter?: InputMaybe<MedicationCalculationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryMedicationsArgs = {
  filter?: InputMaybe<MedicationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type QueryMiscellaneousGroupArgs = {
  _id: Scalars["Int"];
};

export type QueryMiscellaneousGroupsArgs = {
  filter?: InputMaybe<MiscellaneousGroupFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryMonitoringArgs = {
  _id: Scalars["Int"];
};

export type QueryMonitoringsArgs = {
  filter?: InputMaybe<MonitoringFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryNodeArgs = {
  id: Scalars["ID"];
};

export type QueryOrderArgs = {
  _id: Scalars["Int"];
};

export type QueryOrdersArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryOrganizationArgs = {
  _id: Scalars["Int"];
};

export type QueryOrganizationAdminUserArgs = {
  organization: Scalars["Int"];
};

export type QueryOrganizationSettingArgs = {
  _id: Scalars["Int"];
};

export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPasswordRecoveryTokenArgs = {
  _id: Scalars["String"];
};

export type QueryPatientArgs = {
  _id: Scalars["Int"];
};

export type QueryPatientProcedureArgs = {
  _id: Scalars["Int"];
};

export type QueryPatientProceduresArgs = {
  filter?: InputMaybe<PatientProcedureFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPatientTestArgs = {
  _id: Scalars["Int"];
};

export type QueryPatientTestsArgs = {
  filter?: InputMaybe<PatientTestFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPatientsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPhysicalExamArgs = {
  _id: Scalars["Int"];
};

export type QueryPhysicalExamsArgs = {
  filter?: InputMaybe<PhysicalExamFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPostAnestheticVitalArgs = {
  _id: Scalars["Int"];
};

export type QueryPostAnestheticVitalCommentArgs = {
  _id: Scalars["Int"];
};

export type QueryPostAnestheticVitalCommentsArgs = {
  filter?: InputMaybe<PostAnestheticVitalCommentFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPostAnestheticVitalsArgs = {
  filter?: InputMaybe<PostAnestheticVitalFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPreAnestheticExamArgs = {
  _id: Scalars["Int"];
};

export type QueryPreAnestheticExamsArgs = {
  filter?: InputMaybe<PreAnestheticExamFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryPreoperativeTibialPlateauAngleArgs = {
  _id: Scalars["String"];
};

export type QueryPreoperativeTibialPlateauAnglesArgs = {
  filter?: InputMaybe<PreoperativeTibialPlateauAngleFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryProcedureArgs = {
  _id: Scalars["String"];
};

export type QueryProceduresArgs = {
  filter?: InputMaybe<ProcedureFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryProphylacticDentalProcedureArgs = {
  _id: Scalars["Int"];
};

export type QueryQueryVetspireClientsArgs = {
  fullName?: InputMaybe<Scalars["String"]>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryQueryVetspirePatientsArgs = {
  vetspireClientId: Scalars["String"];
};

export type QueryRegionalBlockArgs = {
  _id: Scalars["Int"];
};

export type QueryRegionalBlocksArgs = {
  filter?: InputMaybe<RegionalBlockFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryRegistrationTokenArgs = {
  _id: Scalars["String"];
};

export type QueryReportOrganizationCounterArgs = {
  dateFilter?: InputMaybe<Scalars["DateTime"]>;
};

export type QueryReportOrganizationUserMedicalCaseCountersArgs = {
  dateFilter?: InputMaybe<Scalars["DateTime"]>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryStateArgs = {
  _id: Scalars["String"];
};

export type QueryStatesArgs = {
  filter?: InputMaybe<StateFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QuerySuspensionArgs = {
  _id: Scalars["Int"];
};

export type QuerySuspensionsArgs = {
  filter?: InputMaybe<SuspensionFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryTabletArgs = {
  _id: Scalars["Int"];
};

export type QueryTabletsArgs = {
  filter?: InputMaybe<TabletFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryTeethArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryTibialPlateauLevelingOsteotomyPlanningArgs = {
  _id: Scalars["Int"];
};

export type QueryTibialPlateauLevelingOsteotomyPlanningsArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryToothArgs = {
  _id: Scalars["Int"];
};

export type QueryTreatmentArgs = {
  _id: Scalars["Int"];
};

export type QueryTreatmentsArgs = {
  filter?: InputMaybe<TreatmentFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryUserArgs = {
  _id: Scalars["Int"];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryVaccineArgs = {
  _id: Scalars["Int"];
};

export type QueryVaccinesArgs = {
  filter?: InputMaybe<VaccineFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryVitalArgs = {
  _id: Scalars["Int"];
};

export type QueryVitalCommentArgs = {
  _id: Scalars["Int"];
};

export type QueryVitalCommentsArgs = {
  filter?: InputMaybe<VitalCommentFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryVitalsArgs = {
  filter?: InputMaybe<VitalFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type QueryZipCodeArgs = {
  _id: Scalars["String"];
};

export type QueryZipCodesArgs = {
  filter?: InputMaybe<ZipCodeFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type ReferralDocumentExport = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type ReferralDocumentPrint = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
  id: Scalars["ID"];
};

export type RefreshToken = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  refreshToken: Scalars["String"];
  sessionId: Scalars["String"];
};

export type RegionalBlock = Node & {
  _id: Scalars["Int"];
  concentration: Scalars["Float"];
  dosageMax?: Maybe<Scalars["Float"]>;
  dosageMin?: Maybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  initials?: Maybe<Scalars["String"]>;
  medication: Scalars["String"];
  organization: Organization;
  patient: Patient;
  type: RegionalBlockTypeEnum;
  volumeRangeMax?: Maybe<Scalars["Float"]>;
  volumeRangeMin?: Maybe<Scalars["Float"]>;
  volumeToBeInfused?: Maybe<Scalars["Float"]>;
};

export type RegionalBlockEndFilter = {
  type?: InputMaybe<Scalars["String"]>;
};

export type RegionalBlockEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
  type?: InputMaybe<RegionalBlockTypeEnum>;
};

export type RegionalBlockExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
  type?: InputMaybe<Scalars["Boolean"]>;
};

export type RegionalBlockFilter = {
  OR?: InputMaybe<Array<InputMaybe<RegionalBlockFilter>>>;
  concat?: InputMaybe<RegionalBlockFilterConcat>;
  end?: InputMaybe<RegionalBlockEndFilter>;
  equal?: InputMaybe<RegionalBlockEqualFilter>;
  exists?: InputMaybe<RegionalBlockExistsFilter>;
  in?: InputMaybe<RegionalBlockInFilter>;
  like?: InputMaybe<RegionalBlockLikeFilter>;
  range?: InputMaybe<RegionalBlockRangeFilter>;
  start?: InputMaybe<RegionalBlockStartFilter>;
};

export type RegionalBlockFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: RegionalBlockFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum RegionalBlockFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type RegionalBlockInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  type?: InputMaybe<Array<InputMaybe<RegionalBlockTypeEnum>>>;
};

export type RegionalBlockLikeFilter = {
  type?: InputMaybe<Scalars["String"]>;
};

/** Page connection for RegionalBlock. */
export type RegionalBlockPageConnection = {
  collection: Array<RegionalBlock>;
  paginationInfo: RegionalBlockPaginationInfo;
};

/** Information about the pagination. */
export type RegionalBlockPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type RegionalBlockRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type RegionalBlockStartFilter = {
  type?: InputMaybe<Scalars["String"]>;
};

export enum RegionalBlockTypeEnum {
  EpiduralCalculations = "epidural_calculations",
  RegionalOralBlocks = "regional_oral_blocks"
}

export type RegistrationCompletion = Node & {
  applicationSettings: ApplicationSettings;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  sessionId: Scalars["String"];
};

export type RegistrationToken = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  valid: Scalars["Boolean"];
};

export enum ResorptionEnum {
  Tr1 = "tr1",
  Tr2 = "tr2",
  Tr3 = "tr3",
  Tr4 = "tr4",
  Tr5 = "tr5"
}

export enum RootPlaningAndSubgingivalCurettageEnum {
  Closed = "closed",
  Open = "open"
}

export enum RouteEnum {
  Im = "im",
  Iv = "iv",
  Po = "po",
  Sc = "sc",
  Td = "td"
}

export enum SkullTypeEnum {
  Brachycephalic = "brachycephalic",
  Dolichocephalic = "dolichocephalic",
  Mesocephalic = "mesocephalic"
}

export enum SpeciesEnum {
  Amphibian = "amphibian",
  Bird = "bird",
  Cat = "cat",
  Chinchilla = "chinchilla",
  Dog = "dog",
  Ferret = "ferret",
  Fish = "fish",
  GuineaPig = "guinea_pig",
  Hamster = "hamster",
  Hedgehog = "hedgehog",
  Mouse = "mouse",
  Rabbit = "rabbit",
  Rat = "rat",
  Reptile = "reptile",
  Rodent = "rodent",
  Snake = "snake",
  SugarGlider = "sugar_glider",
  Tortoise = "tortoise",
  Turtle = "turtle"
}

export type State = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  cities?: Maybe<CityPageConnection>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type StateCitiesArgs = {
  filter?: InputMaybe<CityFilter>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
};

export type StateEndFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type StateEqualFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type StateExistsFilter = {
  id?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["Boolean"]>;
};

export type StateFilter = {
  OR?: InputMaybe<Array<InputMaybe<StateFilter>>>;
  concat?: InputMaybe<StateFilterConcat>;
  end?: InputMaybe<StateEndFilter>;
  equal?: InputMaybe<StateEqualFilter>;
  exists?: InputMaybe<StateExistsFilter>;
  in?: InputMaybe<StateInFilter>;
  like?: InputMaybe<StateLikeFilter>;
  start?: InputMaybe<StateStartFilter>;
};

export type StateFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: StateFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum StateFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type StateInFilter = {
  id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type StateLikeFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

/** Page connection for State. */
export type StatePageConnection = {
  collection: Array<State>;
  paginationInfo: StatePaginationInfo;
};

/** Information about the pagination. */
export type StatePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type StateStartFilter = {
  id?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type Subscription = {
  /** Subscribes to the update event of a MedicalCase. */
  updateMedicalCaseSubscribe?: Maybe<UpdateMedicalCaseSubscriptionPayload>;
};

export type SubscriptionUpdateMedicalCaseSubscribeArgs = {
  input: UpdateMedicalCaseSubscriptionInput;
};

export type Suspension = Node & {
  _id: Scalars["Int"];
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  labelInstructions?: Maybe<Scalars["String"]>;
  medication: Scalars["String"];
  organization: Organization;
  patient: Patient;
  totalVolume?: Maybe<Scalars["Float"]>;
  volume: Scalars["Float"];
};

export type SuspensionEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type SuspensionExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type SuspensionFilter = {
  OR?: InputMaybe<Array<InputMaybe<SuspensionFilter>>>;
  concat?: InputMaybe<SuspensionFilterConcat>;
  equal?: InputMaybe<SuspensionEqualFilter>;
  exists?: InputMaybe<SuspensionExistsFilter>;
  in?: InputMaybe<SuspensionInFilter>;
  range?: InputMaybe<SuspensionRangeFilter>;
};

export type SuspensionFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: SuspensionFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum SuspensionFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type SuspensionInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for Suspension. */
export type SuspensionPageConnection = {
  collection: Array<Suspension>;
  paginationInfo: SuspensionPaginationInfo;
};

/** Information about the pagination. */
export type SuspensionPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type SuspensionRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type Tablet = Node & {
  _id: Scalars["Int"];
  dosage: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  labelInstructions?: Maybe<Scalars["String"]>;
  medication: Scalars["String"];
  numberOfTablets?: Maybe<Scalars["Float"]>;
  organization: Organization;
  patient: Patient;
  tabletSize?: Maybe<Scalars["Float"]>;
};

export type TabletEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type TabletExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type TabletFilter = {
  OR?: InputMaybe<Array<InputMaybe<TabletFilter>>>;
  concat?: InputMaybe<TabletFilterConcat>;
  equal?: InputMaybe<TabletEqualFilter>;
  exists?: InputMaybe<TabletExistsFilter>;
  in?: InputMaybe<TabletInFilter>;
  range?: InputMaybe<TabletRangeFilter>;
};

export type TabletFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: TabletFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum TabletFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type TabletInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for Tablet. */
export type TabletPageConnection = {
  collection: Array<Tablet>;
  paginationInfo: TabletPaginationInfo;
};

/** Information about the pagination. */
export type TabletPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type TabletRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export enum TemperatureUnitEnum {
  Celsius = "celsius",
  Fahrenheit = "fahrenheit"
}

export type TibialPlateauLevelingOsteotomyPlanning = Node & {
  _id: Scalars["Int"];
  d1?: Maybe<Scalars["String"]>;
  d2?: Maybe<Scalars["String"]>;
  d3?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  initialTpa?: Maybe<Scalars["String"]>;
  organization: Organization;
  patient?: Maybe<Patient>;
  postOpTpa?: Maybe<Scalars["String"]>;
  rotationNeeded?: Maybe<Scalars["String"]>;
  tploBladeSize?: Maybe<Scalars["String"]>;
  tploPlateSizeAndModel?: Maybe<Scalars["String"]>;
};

/** Page connection for TibialPlateauLevelingOsteotomyPlanning. */
export type TibialPlateauLevelingOsteotomyPlanningPageConnection = {
  collection: Array<TibialPlateauLevelingOsteotomyPlanning>;
  paginationInfo: TibialPlateauLevelingOsteotomyPlanningPaginationInfo;
};

/** Information about the pagination. */
export type TibialPlateauLevelingOsteotomyPlanningPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type Tooth = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  toothName: Scalars["String"];
};

export enum ToothEndodonticsEnum {
  PulpCapIndirect = "pulp_cap_indirect",
  StandardRootCanal = "standard_root_canal",
  SurgicalRootCanal = "surgical_root_canal",
  VitalPulpotomy = "vital_pulpotomy"
}

export enum ToothOralSurgeryEnum {
  Extraction = "extraction",
  SubgingivalCrownAmputation = "subgingival_crown_amputation",
  SutureMaterial = "suture_material"
}

/** Page connection for Tooth. */
export type ToothPageConnection = {
  collection: Array<Tooth>;
  paginationInfo: ToothPaginationInfo;
};

/** Information about the pagination. */
export type ToothPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export enum ToothRestorationEnum {
  CrCementation = "cr_cementation",
  CrownPrep = "crown_prep",
  Restoratives = "restoratives"
}

export enum ToothStateEnum {
  Abnormal = "abnormal",
  Extracted = "extracted",
  Missing = "missing",
  Treated = "treated",
  Unerupted = "unerupted",
  Untreated = "untreated"
}

export type Treatment = Node & {
  _id: Scalars["Int"];
  cereniaInjection: Scalars["Boolean"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  laserTherapy: Scalars["Boolean"];
  microchip: Scalars["Boolean"];
  organization: Organization;
  patient?: Maybe<Patient>;
};

export type TreatmentEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type TreatmentExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type TreatmentFilter = {
  OR?: InputMaybe<Array<InputMaybe<TreatmentFilter>>>;
  concat?: InputMaybe<TreatmentFilterConcat>;
  equal?: InputMaybe<TreatmentEqualFilter>;
  exists?: InputMaybe<TreatmentExistsFilter>;
  in?: InputMaybe<TreatmentInFilter>;
  range?: InputMaybe<TreatmentRangeFilter>;
};

export type TreatmentFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: TreatmentFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum TreatmentFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type TreatmentInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for Treatment. */
export type TreatmentPageConnection = {
  collection: Array<Treatment>;
  paginationInfo: TreatmentPaginationInfo;
};

/** Information about the pagination. */
export type TreatmentPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type TreatmentRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export enum TreatmentRegionalBlockEnum {
  InferiorAlveolar = "inferior_alveolar",
  Infraorbital = "infraorbital",
  Maxillary = "maxillary",
  RostralMandibular = "rostral_mandibular"
}

export type User = Node & {
  _id: Scalars["Int"];
  active: Scalars["Boolean"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  email: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  firstName: Scalars["String"];
  id: Scalars["ID"];
  image?: Maybe<File>;
  lastName: Scalars["String"];
  organization?: Maybe<Organization>;
  pin?: Maybe<Scalars["String"]>;
  userRole: UserRoleEnum;
  username: Scalars["String"];
};

export type UserEndFilter = {
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  userRole?: InputMaybe<Scalars["String"]>;
};

export type UserEqualFilter = {
  firstName?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  userRole?: InputMaybe<UserRoleEnum>;
};

export type UserExistsFilter = {
  firstName?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["Boolean"]>;
  lastName?: InputMaybe<Scalars["Boolean"]>;
  userRole?: InputMaybe<Scalars["Boolean"]>;
};

export type UserFilter = {
  OR?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  concat?: InputMaybe<UserFilterConcat>;
  end?: InputMaybe<UserEndFilter>;
  equal?: InputMaybe<UserEqualFilter>;
  exists?: InputMaybe<UserExistsFilter>;
  in?: InputMaybe<UserInFilter>;
  like?: InputMaybe<UserLikeFilter>;
  range?: InputMaybe<UserRangeFilter>;
  start?: InputMaybe<UserStartFilter>;
};

export type UserFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: UserFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum UserFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type UserInFilter = {
  firstName?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  userRole?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
};

export type UserLikeFilter = {
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  userRole?: InputMaybe<Scalars["String"]>;
};

/** Page connection for User. */
export type UserPageConnection = {
  collection: Array<User>;
  paginationInfo: UserPaginationInfo;
};

/** Information about the pagination. */
export type UserPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type UserRangeFilter = {
  id?: InputMaybe<RangeFilter>;
};

export enum UserRoleEnum {
  RoleAnesthesiologist = "ROLE_ANESTHESIOLOGIST",
  RoleAnesthetist = "ROLE_ANESTHETIST",
  RoleAssistant = "ROLE_ASSISTANT",
  RoleCvt = "ROLE_CVT",
  RoleDoctor = "ROLE_DOCTOR",
  RoleDvm = "ROLE_DVM",
  RoleDvmDavdc = "ROLE_DVM_DAVDC",
  RoleLvt = "ROLE_LVT",
  RoleNurse = "ROLE_NURSE",
  RoleOrganizationAdmin = "ROLE_ORGANIZATION_ADMIN",
  RoleRvt = "ROLE_RVT",
  RoleSuperAdmin = "ROLE_SUPER_ADMIN",
  RoleSurgeon = "ROLE_SURGEON",
  RoleTechnician = "ROLE_TECHNICIAN",
  RoleVeterinaryTechnician = "ROLE_VETERINARY_TECHNICIAN"
}

export type UserStartFilter = {
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  userRole?: InputMaybe<Scalars["String"]>;
};

export type Vaccine = Node & {
  _id: Scalars["Int"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient: Patient;
  toPerform: Scalars["Boolean"];
  vaccine: VaccineEnum;
};

export type VaccineEndFilter = {
  vaccine?: InputMaybe<Scalars["String"]>;
};

export enum VaccineEnum {
  Bordatella = "bordatella",
  CanineInfluenza = "canine_influenza",
  Da2pp = "da2pp",
  FelineLeukemia = "feline_leukemia",
  Fvrcp = "fvrcp",
  Leptospirosis = "leptospirosis",
  Rabies = "rabies"
}

export type VaccineEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
  vaccine?: InputMaybe<VaccineEnum>;
};

export type VaccineExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
  vaccine?: InputMaybe<Scalars["Boolean"]>;
};

export type VaccineFilter = {
  OR?: InputMaybe<Array<InputMaybe<VaccineFilter>>>;
  concat?: InputMaybe<VaccineFilterConcat>;
  end?: InputMaybe<VaccineEndFilter>;
  equal?: InputMaybe<VaccineEqualFilter>;
  exists?: InputMaybe<VaccineExistsFilter>;
  in?: InputMaybe<VaccineInFilter>;
  like?: InputMaybe<VaccineLikeFilter>;
  range?: InputMaybe<VaccineRangeFilter>;
  start?: InputMaybe<VaccineStartFilter>;
};

export type VaccineFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: VaccineFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum VaccineFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type VaccineInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  vaccine?: InputMaybe<Array<InputMaybe<VaccineEnum>>>;
};

export type VaccineLikeFilter = {
  vaccine?: InputMaybe<Scalars["String"]>;
};

/** Page connection for Vaccine. */
export type VaccinePageConnection = {
  collection: Array<Vaccine>;
  paginationInfo: VaccinePaginationInfo;
};

/** Information about the pagination. */
export type VaccinePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type VaccineRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type VaccineStartFilter = {
  vaccine?: InputMaybe<Scalars["String"]>;
};

export type VetspireClient = Node & {
  _id: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  firstName: Scalars["String"];
  id: Scalars["ID"];
  lastName: Scalars["String"];
};

/** Page connection for VetspireClient. */
export type VetspireClientPageConnection = {
  collection: Array<VetspireClient>;
  paginationInfo: VetspireClientPaginationInfo;
};

/** Information about the pagination. */
export type VetspireClientPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type VetspireMedicalCase = Node & {
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  medicalCase: MedicalCase;
};

export type VetspirePatient = Node & {
  _id: Scalars["String"];
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
};

/** Page connection for VetspirePatient. */
export type VetspirePatientPageConnection = {
  collection: Array<VetspirePatient>;
  paginationInfo: VetspirePatientPaginationInfo;
};

/** Information about the pagination. */
export type VetspirePatientPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type Vital = Node & {
  _id: Scalars["Int"];
  diastolicBloodPressure?: Maybe<Scalars["Float"]>;
  endTidal?: Maybe<Scalars["Float"]>;
  fakeId?: Maybe<Scalars["String"]>;
  heartRate?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  meanBloodPressure?: Maybe<Scalars["Float"]>;
  organization: Organization;
  patient: Patient;
  pulseOximetry?: Maybe<Scalars["Float"]>;
  respiratoryRate?: Maybe<Scalars["Int"]>;
  systolicBloodPressure?: Maybe<Scalars["Float"]>;
  timeMonitoring?: Maybe<Scalars["DateTime"]>;
};

export type VitalComment = Node & {
  _id: Scalars["Int"];
  comment?: Maybe<Scalars["String"]>;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  organization: Organization;
  patient: Patient;
  qualityRecovery?: Maybe<QualityRecoveryEnum>;
  timeExtubation?: Maybe<Scalars["DateTime"]>;
};

export type VitalCommentEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type VitalCommentExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type VitalCommentFilter = {
  OR?: InputMaybe<Array<InputMaybe<VitalCommentFilter>>>;
  concat?: InputMaybe<VitalCommentFilterConcat>;
  equal?: InputMaybe<VitalCommentEqualFilter>;
  exists?: InputMaybe<VitalCommentExistsFilter>;
  in?: InputMaybe<VitalCommentInFilter>;
  range?: InputMaybe<VitalCommentRangeFilter>;
};

export type VitalCommentFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: VitalCommentFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum VitalCommentFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type VitalCommentInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for VitalComment. */
export type VitalCommentPageConnection = {
  collection: Array<VitalComment>;
  paginationInfo: VitalCommentPaginationInfo;
};

/** Information about the pagination. */
export type VitalCommentPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type VitalCommentRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export type VitalEqualFilter = {
  patient_id?: InputMaybe<Scalars["Int"]>;
};

export type VitalExistsFilter = {
  patient_id?: InputMaybe<Scalars["Boolean"]>;
};

export type VitalFilter = {
  OR?: InputMaybe<Array<InputMaybe<VitalFilter>>>;
  concat?: InputMaybe<VitalFilterConcat>;
  equal?: InputMaybe<VitalEqualFilter>;
  exists?: InputMaybe<VitalExistsFilter>;
  in?: InputMaybe<VitalInFilter>;
  range?: InputMaybe<VitalRangeFilter>;
};

export type VitalFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: VitalFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum VitalFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type VitalInFilter = {
  patient_id?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

/** Page connection for Vital. */
export type VitalPageConnection = {
  collection: Array<Vital>;
  paginationInfo: VitalPaginationInfo;
};

/** Information about the pagination. */
export type VitalPaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type VitalRangeFilter = {
  patient_id?: InputMaybe<RangeFilter>;
};

export enum WeightMeasureEnum {
  G = "g",
  Kg = "kg",
  Lbs = "lbs"
}

export type ZipCode = Node & {
  /** fix graphql schema generate */
  _id: Scalars["String"];
  city: City;
  fakeId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  zipCode: Scalars["String"];
};

export type ZipCodeEndFilter = {
  city_id?: InputMaybe<Scalars["String"]>;
  city_name?: InputMaybe<Scalars["String"]>;
  city_state_id?: InputMaybe<Scalars["String"]>;
  city_state_name?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type ZipCodeEqualFilter = {
  city_id?: InputMaybe<Scalars["String"]>;
  city_name?: InputMaybe<Scalars["String"]>;
  city_state_id?: InputMaybe<Scalars["String"]>;
  city_state_name?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type ZipCodeExistsFilter = {
  city_id?: InputMaybe<Scalars["Boolean"]>;
  city_name?: InputMaybe<Scalars["Boolean"]>;
  city_state_id?: InputMaybe<Scalars["Boolean"]>;
  city_state_name?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["Boolean"]>;
  zipCode?: InputMaybe<Scalars["Boolean"]>;
};

export type ZipCodeFilter = {
  OR?: InputMaybe<Array<InputMaybe<ZipCodeFilter>>>;
  concat?: InputMaybe<ZipCodeFilterConcat>;
  end?: InputMaybe<ZipCodeEndFilter>;
  equal?: InputMaybe<ZipCodeEqualFilter>;
  exists?: InputMaybe<ZipCodeExistsFilter>;
  in?: InputMaybe<ZipCodeInFilter>;
  like?: InputMaybe<ZipCodeLikeFilter>;
  start?: InputMaybe<ZipCodeStartFilter>;
};

export type ZipCodeFilterConcat = {
  data: Array<InputMaybe<Scalars["String"]>>;
  delimiters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterType: ZipCodeFilterConcatType;
  value?: InputMaybe<Scalars["String"]>;
};

export enum ZipCodeFilterConcatType {
  End = "end",
  Equal = "equal",
  Like = "like",
  Start = "start"
}

export type ZipCodeInFilter = {
  city_id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  city_name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  city_state_id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  city_state_name?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  zipCode?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type ZipCodeLikeFilter = {
  city_id?: InputMaybe<Scalars["String"]>;
  city_name?: InputMaybe<Scalars["String"]>;
  city_state_id?: InputMaybe<Scalars["String"]>;
  city_state_name?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

/** Page connection for ZipCode. */
export type ZipCodePageConnection = {
  collection: Array<ZipCode>;
  paginationInfo: ZipCodePaginationInfo;
};

/** Information about the pagination. */
export type ZipCodePaginationInfo = {
  itemsPerPage: Scalars["Int"];
  lastPage: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type ZipCodeStartFilter = {
  city_id?: InputMaybe<Scalars["String"]>;
  city_name?: InputMaybe<Scalars["String"]>;
  city_state_id?: InputMaybe<Scalars["String"]>;
  city_state_name?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type CopyMedicalCaseInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
};

export type CopyMedicalCasePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicalCase?: Maybe<MedicalCase>;
};

export type CreateAdditionalDiagnosticTestInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diagnosticTesting: Scalars["Int"];
  fakeId?: InputMaybe<Scalars["String"]>;
  test: Scalars["String"];
  toPerform?: Scalars["Boolean"];
};

export type CreateAdditionalDiagnosticTestNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diagnosticTesting?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  test: Scalars["String"];
  toPerform?: Scalars["Boolean"];
};

export type CreateAdditionalDiagnosticTestPayload = {
  additionalDiagnosticTest?: Maybe<AdditionalDiagnosticTest>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAnestheticGasInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  inhalantAnestheticAgent?: InputMaybe<Scalars["Float"]>;
  oxygen?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type CreateAnestheticGasNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  inhalantAnestheticAgent?: InputMaybe<Scalars["Float"]>;
  oxygen?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type CreateAnestheticGasPayload = {
  anestheticGas?: Maybe<AnestheticGas>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAnestheticProtocolInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicationCalculations?: InputMaybe<
    Array<InputMaybe<CreateAnestheticProtocolMedicationCalculationNestedInput>>
  >;
  name: Scalars["String"];
  regionalBlocks?: InputMaybe<
    Array<InputMaybe<CreateAnestheticProtocolRegionalBlockNestedInput>>
  >;
};

export type CreateAnestheticProtocolMedicationCalculationInput = {
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  anestheticProtocol: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  route: RouteEnum;
  type: MedicationCalculationTypeEnum;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type CreateAnestheticProtocolMedicationCalculationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  anestheticProtocol?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  route: RouteEnum;
  type: MedicationCalculationTypeEnum;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type CreateAnestheticProtocolMedicationCalculationPayload = {
  anestheticProtocolMedicationCalculation?: Maybe<
    AnestheticProtocolMedicationCalculation
  >;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAnestheticProtocolPayload = {
  anestheticProtocol?: Maybe<AnestheticProtocol>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAnestheticProtocolRegionalBlockInput = {
  anestheticProtocol: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  type: RegionalBlockTypeEnum;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type CreateAnestheticProtocolRegionalBlockNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  anestheticProtocol?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  type: RegionalBlockTypeEnum;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type CreateAnestheticProtocolRegionalBlockPayload = {
  anestheticProtocolRegionalBlock?: Maybe<AnestheticProtocolRegionalBlock>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAuthenticationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  password: Scalars["String"];
  username: Scalars["String"];
};

export type CreateAuthenticationPayload = {
  authentication?: Maybe<Authentication>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAuthorizationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  condition: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  selected?: Scalars["Boolean"];
};

export type CreateAuthorizationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  condition: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase?: InputMaybe<Scalars["Int"]>;
  selected?: Scalars["Boolean"];
};

export type CreateAuthorizationPayload = {
  authorization?: Maybe<Authorization>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateAuthorizationSettingInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  condition: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  organizationSetting: Scalars["Int"];
};

export type CreateAuthorizationSettingPayload = {
  authorizationSetting?: Maybe<AuthorizationSetting>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateBulkAdditionalDiagnosticTestInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diagnosticTesting: Scalars["Int"];
  tests: Array<Scalars["String"]>;
};

export type CreateBulkAdditionalDiagnosticTestPayload = {
  bulkAdditionalDiagnosticTest?: Maybe<BulkAdditionalDiagnosticTest>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type CreateCalculationAgreementNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  agreed?: Scalars["Boolean"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  file?: InputMaybe<CreateFileNestedInput>;
  signedAt?: InputMaybe<Scalars["DateTime"]>;
};

export type CreateClientNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  accountNumber?: InputMaybe<Scalars["String"]>;
  apartments?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  disclaimer?: InputMaybe<CreateDisclaimerNestedInput>;
  email?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  notAvailableTime?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<CreatePatientNestedInput>;
  phoneFirst?: InputMaybe<Scalars["String"]>;
  phoneSecond?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  streetAddress?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type CreateClientReportExportInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  recipientEmail: Scalars["String"];
  userTimezone: Scalars["String"];
};

export type CreateClientReportExportPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  clientReportExport?: Maybe<ClientReportExport>;
};

export type CreateClientReportPrintInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  userTimezone: Scalars["String"];
};

export type CreateClientReportPrintPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  clientReportPrint?: Maybe<ClientReportPrint>;
};

export type CreateContactRequestInput = {
  billingType?: InputMaybe<BillingTypeEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  contactFormType: ContactFormTypeEnum;
  email: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  numberOfUsers?: InputMaybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  practiceName: Scalars["String"];
  practiceSize: Scalars["String"];
  price?: InputMaybe<Scalars["Float"]>;
  roleName: Scalars["String"];
};

export type CreateContactRequestPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  contactRequest?: Maybe<ContactRequest>;
};

export type CreateCurrentMedicationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dose: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  frequency: MedicationFrequencyEnum;
  lastGivenAt: Scalars["DateTime"];
  medication?: InputMaybe<Scalars["String"]>;
  patient: Scalars["Int"];
};

export type CreateCurrentMedicationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dose: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  frequency: MedicationFrequencyEnum;
  lastGivenAt: Scalars["DateTime"];
  medication?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
};

export type CreateCurrentMedicationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  currentMedication?: Maybe<CurrentMedication>;
};

export type CreateDefibMedicationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient: Scalars["Int"];
  timeAdministered?: InputMaybe<Scalars["Time"]>;
};

export type CreateDefibMedicationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient?: InputMaybe<Scalars["Int"]>;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
};

export type CreateDefibMedicationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  defibMedication?: Maybe<DefibMedication>;
};

export type CreateDentalChartingInput = {
  calculus?: InputMaybe<CalculusEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  crCementation?: InputMaybe<Scalars["String"]>;
  distalMarFile?: InputMaybe<Scalars["Float"]>;
  distalWorkingLength?: InputMaybe<Scalars["Float"]>;
  enamel?: InputMaybe<EnamelEnum>;
  endodontics?: InputMaybe<Array<ToothEndodonticsEnum>>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fracture?: InputMaybe<FractureEnum>;
  furcation?: InputMaybe<FurcationEnum>;
  gingivalRecessionBuccal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMLingPal?: InputMaybe<Scalars["Float"]>;
  gingivitis?: InputMaybe<GingivitisEnum>;
  mesialMarFile?: InputMaybe<Scalars["Float"]>;
  mesialWorkingLength?: InputMaybe<Scalars["Float"]>;
  mobility?: InputMaybe<MobilityEnum>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  obturation?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<ToothOralSurgeryEnum>>;
  other?: InputMaybe<Array<OtherEnum>>;
  palatalMarFile?: InputMaybe<Scalars["Float"]>;
  palatalWorkingLength?: InputMaybe<Scalars["Float"]>;
  periodontal?: InputMaybe<PeriodontalEnum>;
  periodontalPocketBuccal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMLingPal?: InputMaybe<Scalars["Float"]>;
  resorption?: InputMaybe<ResorptionEnum>;
  restorations?: InputMaybe<Array<ToothRestorationEnum>>;
  restoratives?: InputMaybe<Scalars["String"]>;
  sutureMaterial?: InputMaybe<Scalars["String"]>;
  technique?: InputMaybe<Scalars["String"]>;
  timerDurationSec?: InputMaybe<Scalars["Int"]>;
  tooth: Scalars["Int"];
  toothState?: InputMaybe<ToothStateEnum>;
  treatmentComment?: InputMaybe<Scalars["String"]>;
};

export type CreateDentalChartingNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  calculus?: InputMaybe<CalculusEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  crCementation?: InputMaybe<Scalars["String"]>;
  distalMarFile?: InputMaybe<Scalars["Float"]>;
  distalWorkingLength?: InputMaybe<Scalars["Float"]>;
  enamel?: InputMaybe<EnamelEnum>;
  endodontics?: InputMaybe<Array<ToothEndodonticsEnum>>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fracture?: InputMaybe<FractureEnum>;
  furcation?: InputMaybe<FurcationEnum>;
  gingivalRecessionBuccal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMLingPal?: InputMaybe<Scalars["Float"]>;
  gingivitis?: InputMaybe<GingivitisEnum>;
  mesialMarFile?: InputMaybe<Scalars["Float"]>;
  mesialWorkingLength?: InputMaybe<Scalars["Float"]>;
  mobility?: InputMaybe<MobilityEnum>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  obturation?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<ToothOralSurgeryEnum>>;
  other?: InputMaybe<Array<OtherEnum>>;
  palatalMarFile?: InputMaybe<Scalars["Float"]>;
  palatalWorkingLength?: InputMaybe<Scalars["Float"]>;
  periodontal?: InputMaybe<PeriodontalEnum>;
  periodontalPocketBuccal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMLingPal?: InputMaybe<Scalars["Float"]>;
  resorption?: InputMaybe<ResorptionEnum>;
  restorations?: InputMaybe<Array<ToothRestorationEnum>>;
  restoratives?: InputMaybe<Scalars["String"]>;
  sutureMaterial?: InputMaybe<Scalars["String"]>;
  technique?: InputMaybe<Scalars["String"]>;
  timerDurationSec?: InputMaybe<Scalars["Int"]>;
  tooth: Scalars["Int"];
  toothState?: InputMaybe<ToothStateEnum>;
  treatmentComment?: InputMaybe<Scalars["String"]>;
};

export type CreateDentalChartingPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalCharting?: Maybe<DentalCharting>;
};

export type CreateDentalReportExportInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  recipientEmail: Scalars["String"];
  userTimezone: Scalars["String"];
};

export type CreateDentalReportExportPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalReportExport?: Maybe<DentalReportExport>;
};

export type CreateDentalReportPrintInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  userTimezone: Scalars["String"];
};

export type CreateDentalReportPrintPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalReportPrint?: Maybe<DentalReportPrint>;
};

export type CreateDentalSketchCommentInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  locationX: Scalars["Float"];
  locationY: Scalars["Float"];
  patient: Scalars["Int"];
  text: Scalars["String"];
};

export type CreateDentalSketchCommentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  locationX: Scalars["Float"];
  locationY: Scalars["Float"];
  patient?: InputMaybe<Scalars["Int"]>;
  text: Scalars["String"];
};

export type CreateDentalSketchCommentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalSketchComment?: Maybe<DentalSketchComment>;
};

export type CreateDiagnosticTestingNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  abnormalitiesAndNotes?: InputMaybe<Scalars["String"]>;
  additionalTests?: InputMaybe<
    Array<InputMaybe<CreateAdditionalDiagnosticTestNestedInput>>
  >;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  reviewedByDvm?: InputMaybe<Scalars["Boolean"]>;
};

export type CreateDisclaimerNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  agreeWithTerms?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["Date"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<CreateFileNestedInput>;
};

export type CreateDisclaimerProcedureInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  description: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  selected?: Scalars["Boolean"];
  title: Scalars["String"];
};

export type CreateDisclaimerProcedureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  description: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase?: InputMaybe<Scalars["Int"]>;
  selected?: Scalars["Boolean"];
  title: Scalars["String"];
};

export type CreateDisclaimerProcedurePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  disclaimerProcedure?: Maybe<DisclaimerProcedure>;
};

export type CreateDisclaimerProcedureSettingInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  description: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  organizationSetting: Scalars["Int"];
  title: Scalars["String"];
};

export type CreateDisclaimerProcedureSettingPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  disclaimerProcedureSetting?: Maybe<DisclaimerProcedureSetting>;
};

export type CreateDropOffNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  admittingConcern?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor?: InputMaybe<Scalars["Int"]>;
  evaluateTestAndTreat?: Scalars["Boolean"];
  fakeId?: InputMaybe<Scalars["String"]>;
  performInitialEvaluation?: Scalars["Boolean"];
};

export type CreateExamNoteNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalNotes?: InputMaybe<Scalars["String"]>;
  allergies?: InputMaybe<Scalars["String"]>;
  bloodwork?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  lastMealAt?: InputMaybe<Scalars["DateTime"]>;
  patientPersonalItems?: InputMaybe<Scalars["String"]>;
  previousSurgery?: InputMaybe<Scalars["String"]>;
  treatmentPlan?: InputMaybe<Scalars["String"]>;
  vaccines?: InputMaybe<Scalars["String"]>;
};

export type CreateFileInput = {
  base64Format?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  reference?: InputMaybe<Scalars["String"]>;
};

export type CreateFileNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  base64Format?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  reference?: InputMaybe<Scalars["String"]>;
};

export type CreateFilePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
};

export type CreateFluidBolusInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
};

export type CreateFluidBolusNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
};

export type CreateFluidBolusPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  fluidBolus?: Maybe<FluidBolus>;
};

export type CreateFluidTemperatureInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
  volumeInfused?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type CreateFluidTemperatureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
  volumeInfused?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type CreateFluidTemperaturePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  fluidTemperature?: Maybe<FluidTemperature>;
};

export type CreateGeneralAssessmentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalCommentsAndNotes?: InputMaybe<Scalars["String"]>;
  additionalPhotos?: InputMaybe<Array<InputMaybe<CreateFileNestedInput>>>;
  afterPhotoFront?: InputMaybe<CreateFileNestedInput>;
  afterPhotoLeft?: InputMaybe<CreateFileNestedInput>;
  afterPhotoRight?: InputMaybe<CreateFileNestedInput>;
  beforePhotoFront?: InputMaybe<CreateFileNestedInput>;
  beforePhotoLeft?: InputMaybe<CreateFileNestedInput>;
  beforePhotoRight?: InputMaybe<CreateFileNestedInput>;
  between25And50PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  boneAugmentation?: Scalars["Boolean"];
  boneAugmentationDetails?: InputMaybe<Scalars["String"]>;
  buccalMucosa?: InputMaybe<OralStateEnum>;
  calculusIndex?: InputMaybe<CalculusIndexEnum>;
  caudalOralMucosa?: InputMaybe<OralStateEnum>;
  cbctComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dentalChart?: InputMaybe<DentalChartEnum>;
  externalCervicalToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalInflammatoryToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalReplacementRootResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalSurfaceRootResorption?: InputMaybe<Array<Scalars["String"]>>;
  extraoral?: InputMaybe<OralStateEnum>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fistula?: InputMaybe<Scalars["Boolean"]>;
  gingivalIndex?: InputMaybe<GingivalIndexEnum>;
  greaterThan50PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  hardPalate?: InputMaybe<OralStateEnum>;
  internalToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  intraoralRadiographicComments?: InputMaybe<Scalars["String"]>;
  leftInferiorAlveolar?: InputMaybe<Scalars["Float"]>;
  leftInfraorbital?: InputMaybe<Scalars["Float"]>;
  leftMaxillary?: InputMaybe<Scalars["Float"]>;
  leftRegionalBlocks?: InputMaybe<Array<TreatmentRegionalBlockEnum>>;
  leftRostralMandibular?: InputMaybe<Scalars["Float"]>;
  lessThan25PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  lymphNodes?: InputMaybe<OralStateEnum>;
  missingTeeth?: InputMaybe<Array<Scalars["String"]>>;
  notesForClientDentalReport?: InputMaybe<Scalars["String"]>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  occlusion?: InputMaybe<OcclusionEnum>;
  occlusionDescription?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<OralSurgeryEnum>>;
  orthodontics?: InputMaybe<Array<OrthodonticsEnum>>;
  parulisSinusTract?: InputMaybe<Scalars["Boolean"]>;
  periapicalLucency?: InputMaybe<Array<Scalars["String"]>>;
  periapicalRarefaction?: InputMaybe<Array<Scalars["String"]>>;
  periodontalDisease?: InputMaybe<PeriodontalDiseaseEnum>;
  periodontics?: InputMaybe<Array<PeriodonticsEnum>>;
  planingAndSubgingivalCurettage?: InputMaybe<
    RootPlaningAndSubgingivalCurettageEnum
  >;
  plaqueIndex?: InputMaybe<PlaqueIndexEnum>;
  radiographicFindingsPhotos?: InputMaybe<
    Array<InputMaybe<CreateFileNestedInput>>
  >;
  referralNotesAndComments?: InputMaybe<Scalars["String"]>;
  retainedToothRoots?: InputMaybe<Array<Scalars["String"]>>;
  rightInferiorAlveolar?: InputMaybe<Scalars["Float"]>;
  rightInfraorbital?: InputMaybe<Scalars["Float"]>;
  rightMaxillary?: InputMaybe<Scalars["Float"]>;
  rightRegionalBlocks?: InputMaybe<Array<TreatmentRegionalBlockEnum>>;
  rightRostralMandibular?: InputMaybe<Scalars["Float"]>;
  skullType?: InputMaybe<SkullTypeEnum>;
  softPalate?: InputMaybe<OralStateEnum>;
  tongue?: InputMaybe<OralStateEnum>;
  tonsils?: InputMaybe<OralStateEnum>;
  toothResorptionType1?: InputMaybe<Array<Scalars["String"]>>;
  toothResorptionType2?: InputMaybe<Array<Scalars["String"]>>;
  toothResorptionType3?: InputMaybe<Array<Scalars["String"]>>;
  treatmentAdditionalFindingsCommentsAndNotes?: InputMaybe<Scalars["String"]>;
  uneruptedTeeth?: InputMaybe<Array<Scalars["String"]>>;
  widenedPulpCanal?: InputMaybe<Array<Scalars["String"]>>;
};

export type CreateLicenseInput = {
  active?: Scalars["Boolean"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  maxNumberOfUsers: Scalars["Int"];
  name: Scalars["String"];
  period: LicensePeriodEnum;
  price: Scalars["Float"];
};

export type CreateLicensePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  license?: Maybe<License>;
};

export type CreateLogoutInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type CreateLogoutPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  logout?: Maybe<Logout>;
};

export type CreateMedicalCaseInput = {
  authorizations?: InputMaybe<
    Array<InputMaybe<CreateAuthorizationNestedInput>>
  >;
  client?: InputMaybe<CreateClientNestedInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  disclaimerProcedures?: InputMaybe<
    Array<InputMaybe<CreateDisclaimerProcedureNestedInput>>
  >;
  disclaimerText?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  offline?: InputMaybe<Scalars["Boolean"]>;
  status?: CaseStatusEnum;
  temperatureUnit?: InputMaybe<TemperatureUnitEnum>;
};

export type CreateMedicalCasePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicalCase?: Maybe<MedicalCase>;
};

export type CreateMedicalRecordExportInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  recipientEmail: Scalars["String"];
  userTimezone: Scalars["String"];
};

export type CreateMedicalRecordExportPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicalRecordExport?: Maybe<MedicalRecordExport>;
};

export type CreateMedicalRecordPrintInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  userTimezone: Scalars["String"];
};

export type CreateMedicalRecordPrintPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicalRecordPrint?: Maybe<MedicalRecordPrint>;
};

export type CreateMedicationCalculationInput = {
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  calculationType: MedicationCalculationTypeEnum;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient: Scalars["Int"];
  route: RouteEnum;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type CreateMedicationCalculationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  calculationType: MedicationCalculationTypeEnum;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient?: InputMaybe<Scalars["Int"]>;
  route: RouteEnum;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type CreateMedicationCalculationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicationCalculation?: Maybe<MedicationCalculation>;
};

export type CreateMiscellaneousGroupNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  anesthesiaSystem?: InputMaybe<AnesthesiaSystemEnum>;
  bagSize?: InputMaybe<Scalars["Float"]>;
  bloodPressureMonitoring?: InputMaybe<BloodPressureMonitoringEnum>;
  catheterLocation?: InputMaybe<CatheterLocationEnum>;
  catheterSize?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endotrachealTubeSize?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Int"]>;
  fluidRateValue?: InputMaybe<Scalars["Float"]>;
  fluidType?: InputMaybe<Scalars["String"]>;
  intubated?: InputMaybe<Scalars["Boolean"]>;
  oxygenFlowRate?: InputMaybe<Scalars["Float"]>;
  qualityOfSedation?: InputMaybe<QualityOfSedationEnum>;
};

export type CreateMonitoringNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  monitoringBy?: InputMaybe<Scalars["Int"]>;
  patient?: InputMaybe<Scalars["Int"]>;
};

export type CreateOrderInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  expirationDate: Scalars["Date"];
  fakeId?: InputMaybe<Scalars["String"]>;
  license: Scalars["Int"];
  organization: Scalars["Int"];
  price: Scalars["Float"];
  startDate: Scalars["Date"];
};

export type CreateOrderPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  order?: Maybe<Order>;
};

export type CreateOrganizationRegistrationInput = {
  adminEmail: Scalars["String"];
  adminFirstName: Scalars["String"];
  adminLastName: Scalars["String"];
  adminPicture?: InputMaybe<CreateFileNestedInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  organizationContactEmail?: InputMaybe<Scalars["String"]>;
  organizationDescription?: InputMaybe<Scalars["String"]>;
  organizationLogo?: InputMaybe<CreateFileNestedInput>;
  organizationName: Scalars["String"];
};

export type CreateOrganizationRegistrationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  organizationRegistration?: Maybe<OrganizationRegistration>;
};

export type CreatePasswordChangeInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  newPassword: Scalars["String"];
  passwordRecoveryToken: Scalars["String"];
};

export type CreatePasswordChangePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  passwordChange?: Maybe<PasswordChange>;
};

export type CreatePasswordRecoveryRequestInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type CreatePasswordRecoveryRequestPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  passwordRecoveryRequest?: Maybe<PasswordRecoveryRequest>;
};

export type CreatePatientNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  alerts?: InputMaybe<Scalars["String"]>;
  anestheticGasMedication?: AnestheticGasMedicationEnum;
  anestheticGases?: InputMaybe<
    Array<InputMaybe<CreateAnestheticGasNestedInput>>
  >;
  breed?: InputMaybe<Scalars["String"]>;
  calculationAgreement?: InputMaybe<CreateCalculationAgreementNestedInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  currentMedications?: InputMaybe<
    Array<InputMaybe<CreateCurrentMedicationNestedInput>>
  >;
  dateOfBirth?: InputMaybe<Scalars["Date"]>;
  defibMedications?: InputMaybe<
    Array<InputMaybe<CreateDefibMedicationNestedInput>>
  >;
  dentalChartings?: InputMaybe<
    Array<InputMaybe<CreateDentalChartingNestedInput>>
  >;
  dentalSketch?: InputMaybe<CreateFileNestedInput>;
  dentalSketchComments?: InputMaybe<
    Array<InputMaybe<CreateDentalSketchCommentNestedInput>>
  >;
  diagnosticTesting?: InputMaybe<CreateDiagnosticTestingNestedInput>;
  dropOff?: InputMaybe<CreateDropOffNestedInput>;
  examNote?: InputMaybe<CreateExamNoteNestedInput>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidBolus?: InputMaybe<CreateFluidBolusNestedInput>;
  fluidTemperatures?: InputMaybe<
    Array<InputMaybe<CreateFluidTemperatureNestedInput>>
  >;
  generalAssessment?: InputMaybe<CreateGeneralAssessmentNestedInput>;
  image?: InputMaybe<CreateFileNestedInput>;
  medicationCalculations?: InputMaybe<
    Array<InputMaybe<CreateMedicationCalculationNestedInput>>
  >;
  miscellaneousGroup?: InputMaybe<CreateMiscellaneousGroupNestedInput>;
  monitoring?: InputMaybe<CreateMonitoringNestedInput>;
  name?: InputMaybe<Scalars["String"]>;
  patientProcedures?: InputMaybe<
    Array<InputMaybe<CreatePatientProcedureNestedInput>>
  >;
  patientTests?: InputMaybe<Array<InputMaybe<CreatePatientTestNestedInput>>>;
  physicalExam?: InputMaybe<CreatePhysicalExamNestedInput>;
  postAnestheticVitalComment?: InputMaybe<
    CreatePostAnestheticVitalCommentNestedInput
  >;
  postAnestheticVitals?: InputMaybe<
    Array<InputMaybe<CreatePostAnestheticVitalNestedInput>>
  >;
  preAnestheticExam?: InputMaybe<CreatePreAnestheticExamNestedInput>;
  procedureDate?: InputMaybe<Scalars["Date"]>;
  procedures?: InputMaybe<Array<Scalars["String"]>>;
  prophylacticDentalProcedure?: InputMaybe<
    CreateProphylacticDentalProcedureNestedInput
  >;
  regionalBlocks?: InputMaybe<
    Array<InputMaybe<CreateRegionalBlockNestedInput>>
  >;
  sex?: InputMaybe<PatientSexEnum>;
  species?: InputMaybe<SpeciesEnum>;
  suspensions?: InputMaybe<Array<InputMaybe<CreateSuspensionNestedInput>>>;
  tablets?: InputMaybe<Array<InputMaybe<CreateTabletNestedInput>>>;
  tibialPlateauLevelingOsteotomyPlanning?: InputMaybe<
    CreateTibialPlateauLevelingOsteotomyPlanningNestedInput
  >;
  treatment?: InputMaybe<CreateTreatmentNestedInput>;
  vaccines?: InputMaybe<Array<InputMaybe<CreateVaccineNestedInput>>>;
  vitalComment?: InputMaybe<CreateVitalCommentNestedInput>;
  vitals?: InputMaybe<Array<InputMaybe<CreateVitalNestedInput>>>;
  weight?: InputMaybe<Scalars["Float"]>;
  weightMeasure?: WeightMeasureEnum;
};

export type CreatePatientProcedureInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  patient: Scalars["Int"];
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type CreatePatientProcedureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type CreatePatientProcedurePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  patientProcedure?: Maybe<PatientProcedure>;
};

export type CreatePatientTestNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  test: PatientTestEnum;
  toPerform?: Scalars["Boolean"];
};

export type CreatePhysicalExamNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  cardiovascular?: InputMaybe<PatientStateEnum>;
  cardiovascularAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ears?: InputMaybe<PatientStateEnum>;
  earsAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  eyes?: InputMaybe<PatientStateEnum>;
  eyesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  gastrointestinal?: InputMaybe<PatientStateEnum>;
  gastrointestinalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  generalAppearance?: InputMaybe<PatientStateEnum>;
  generalAppearanceAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  integumentary?: InputMaybe<PatientStateEnum>;
  integumentaryAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  lymphNodes?: InputMaybe<PatientStateEnum>;
  lymphNodesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  mucousMembranes?: InputMaybe<PatientStateEnum>;
  mucousMembranesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  musculosceletal?: InputMaybe<PatientStateEnum>;
  musculosceletalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  nervousSystem?: InputMaybe<PatientStateEnum>;
  nervousSystemAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  oralCavity?: InputMaybe<PatientStateEnum>;
  oralCavityAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  respiratory?: InputMaybe<PatientStateEnum>;
  respiratoryAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  urogenital?: InputMaybe<PatientStateEnum>;
  urogenitalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
};

export type CreatePinAuthenticationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  plainPin: Scalars["Int"];
};

export type CreatePinAuthenticationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  pinAuthentication?: Maybe<PinAuthentication>;
};

export type CreatePostAnestheticVitalCommentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  surgeryReport?: InputMaybe<Scalars["String"]>;
};

export type CreatePostAnestheticVitalInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  initials?: InputMaybe<Scalars["String"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  painScore?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring: Scalars["DateTime"];
};

export type CreatePostAnestheticVitalNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  initials?: InputMaybe<Scalars["String"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  painScore?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring: Scalars["DateTime"];
};

export type CreatePostAnestheticVitalPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  postAnestheticVital?: Maybe<PostAnestheticVital>;
};

export type CreatePreAnestheticExamNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  bodyConditionScore?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dentalScore?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  painScore?: InputMaybe<Scalars["Int"]>;
  physicalStatus?: InputMaybe<PatientPhysicalStatus>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
};

export type CreateProphylacticDentalProcedureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dontAuthorizeAnyAdditionalDentalWorkBeforeContact?: Scalars["Boolean"];
  dontAuthorizeAnyRadiographs?: Scalars["Boolean"];
  fakeId?: InputMaybe<Scalars["String"]>;
  fullMouthRadiographs?: Scalars["Boolean"];
  gumWorkOrExtraction?: Scalars["Boolean"];
  onlyRadiographsDeemedNecessary?: Scalars["Boolean"];
};

export type CreateReferralDocumentExportInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  recipientEmail: Scalars["String"];
  userTimezone: Scalars["String"];
};

export type CreateReferralDocumentExportPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  referralDocumentExport?: Maybe<ReferralDocumentExport>;
};

export type CreateReferralDocumentPrintInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  userTimezone: Scalars["String"];
};

export type CreateReferralDocumentPrintPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  referralDocumentPrint?: Maybe<ReferralDocumentPrint>;
};

export type CreateRefreshTokenInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  refreshToken: Scalars["String"];
};

export type CreateRefreshTokenPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  refreshToken?: Maybe<RefreshToken>;
};

export type CreateRegionalBlockInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient: Scalars["Int"];
  type: RegionalBlockTypeEnum;
  volumeRangeMax?: InputMaybe<Scalars["Float"]>;
  volumeRangeMin?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type CreateRegionalBlockNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient?: InputMaybe<Scalars["Int"]>;
  type: RegionalBlockTypeEnum;
  volumeRangeMax?: InputMaybe<Scalars["Float"]>;
  volumeRangeMin?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type CreateRegionalBlockPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  regionalBlock?: Maybe<RegionalBlock>;
};

export type CreateRegistrationCompletionInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  plainPassword: Scalars["String"];
  plainPin: Scalars["Int"];
  registrationToken: Scalars["String"];
};

export type CreateRegistrationCompletionPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  registrationCompletion?: Maybe<RegistrationCompletion>;
};

export type CreateSuspensionInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient: Scalars["Int"];
  totalVolume?: InputMaybe<Scalars["Float"]>;
  volume: Scalars["Float"];
};

export type CreateSuspensionNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient?: InputMaybe<Scalars["Int"]>;
  totalVolume?: InputMaybe<Scalars["Float"]>;
  volume: Scalars["Float"];
};

export type CreateSuspensionPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  suspension?: Maybe<Suspension>;
};

export type CreateTabletInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosage: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  numberOfTablets?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  tabletSize?: InputMaybe<Scalars["Float"]>;
};

export type CreateTabletNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosage: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  numberOfTablets?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  tabletSize?: InputMaybe<Scalars["Float"]>;
};

export type CreateTabletPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  tablet?: Maybe<Tablet>;
};

export type CreateTibialPlateauLevelingOsteotomyPlanningNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  d1?: InputMaybe<Scalars["String"]>;
  d2?: InputMaybe<Scalars["String"]>;
  d3?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initialTpa?: InputMaybe<Scalars["String"]>;
  postOpTpa?: InputMaybe<Scalars["String"]>;
  rotationNeeded?: InputMaybe<Scalars["String"]>;
  tploBladeSize?: InputMaybe<Scalars["String"]>;
  tploPlateSizeAndModel?: InputMaybe<Scalars["String"]>;
};

export type CreateTreatmentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  cereniaInjection?: Scalars["Boolean"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  laserTherapy?: Scalars["Boolean"];
  microchip?: Scalars["Boolean"];
};

export type CreateUserInput = {
  active?: Scalars["Boolean"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  image?: InputMaybe<CreateFileNestedInput>;
  lastName: Scalars["String"];
  plainPassword?: InputMaybe<Scalars["String"]>;
  plainPin?: InputMaybe<Scalars["Int"]>;
  userRole: UserRoleEnum;
};

export type CreateUserPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
};

export type CreateVaccineNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  toPerform?: Scalars["Boolean"];
  vaccine: VaccineEnum;
};

export type CreateVitalCommentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  qualityRecovery?: InputMaybe<QualityRecoveryEnum>;
  timeExtubation?: InputMaybe<Scalars["DateTime"]>;
};

export type CreateVitalInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diastolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  endTidal?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  pulseOximetry?: InputMaybe<Scalars["Float"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  systolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type CreateVitalNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diastolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  endTidal?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  pulseOximetry?: InputMaybe<Scalars["Float"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  systolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type CreateVitalPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vital?: Maybe<Vital>;
};

export type DeleteAdditionalDiagnosticTestInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteAdditionalDiagnosticTestPayload = {
  additionalDiagnosticTest?: Maybe<AdditionalDiagnosticTest>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteAnestheticProtocolInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteAnestheticProtocolMedicationCalculationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteAnestheticProtocolMedicationCalculationPayload = {
  anestheticProtocolMedicationCalculation?: Maybe<
    AnestheticProtocolMedicationCalculation
  >;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteAnestheticProtocolPayload = {
  anestheticProtocol?: Maybe<AnestheticProtocol>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteAnestheticProtocolRegionalBlockInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteAnestheticProtocolRegionalBlockPayload = {
  anestheticProtocolRegionalBlock?: Maybe<AnestheticProtocolRegionalBlock>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type DeleteCurrentMedicationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteCurrentMedicationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  currentMedication?: Maybe<CurrentMedication>;
};

export type DeleteDefibMedicationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteDefibMedicationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  defibMedication?: Maybe<DefibMedication>;
};

export type DeleteDentalSketchCommentInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteDentalSketchCommentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalSketchComment?: Maybe<DentalSketchComment>;
};

export type DeleteFileInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteFilePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
};

export type DeleteFluidBolusInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteFluidBolusPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  fluidBolus?: Maybe<FluidBolus>;
};

export type DeleteLicenseInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteLicensePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  license?: Maybe<License>;
};

export type DeleteMedicalCaseInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteMedicalCasePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicalCase?: Maybe<MedicalCase>;
};

export type DeleteMedicationCalculationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteMedicationCalculationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicationCalculation?: Maybe<MedicationCalculation>;
};

export type DeleteOrderInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteOrderPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  order?: Maybe<Order>;
};

export type DeleteRegionalBlockInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteRegionalBlockPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  regionalBlock?: Maybe<RegionalBlock>;
};

export type DeleteSuspensionInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteSuspensionPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  suspension?: Maybe<Suspension>;
};

export type DeleteTabletInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteTabletPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  tablet?: Maybe<Tablet>;
};

export type DeleteUserInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type DeleteUserPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
};

export type ExportPdfToVetspireMedicalCaseInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  medicalCase: Scalars["Int"];
  userTimezone: Scalars["String"];
};

export type ExportPdfToVetspireMedicalCasePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vetspireMedicalCase?: Maybe<VetspireMedicalCase>;
};

export type ImportVetspireMedicalCaseInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor: Scalars["Int"];
  name: Scalars["String"];
  vetspirePatientId: Scalars["String"];
};

export type ImportVetspireMedicalCasePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vetspireMedicalCase?: Maybe<VetspireMedicalCase>;
};

export type LogBulkPinAuthenticationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  pinLogins: Array<LogPinLoginNestedInput>;
};

export type LogBulkPinAuthenticationPayload = {
  bulkPinAuthentication?: Maybe<BulkPinAuthentication>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type LogPinLoginInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  status: AccessStatusEnum;
  time: Scalars["DateTime"];
};

export type LogPinLoginNestedInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  status: AccessStatusEnum;
  time: Scalars["DateTime"];
};

export type LogPinLoginPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  pinLogin?: Maybe<PinLogin>;
};

export type Mutation_Collection_QueryAdditionalDiagnosticTestInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diagnosticTesting: Scalars["Int"];
  fakeId?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  test: Scalars["String"];
  toPerform?: Scalars["Boolean"];
};

export type Mutation_Collection_QueryAdditionalDiagnosticTestPayload = {
  additionalDiagnosticTest?: Maybe<AdditionalDiagnosticTest>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type Mutation_Collection_QueryMedicationCalculationInput = {
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  calculationType: MedicationCalculationTypeEnum;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dose: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient: Scalars["Int"];
  route: RouteEnum;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type Mutation_Collection_QueryMedicationCalculationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicationCalculation?: Maybe<MedicationCalculation>;
};

export type Mutation_Collection_QueryPatientTestInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  test: PatientTestEnum;
  toPerform?: Scalars["Boolean"];
};

export type Mutation_Collection_QueryPatientTestPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  patientTest?: Maybe<PatientTest>;
};

export type Mutation_Collection_QueryRegionalBlockInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration: Scalars["Float"];
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax: Scalars["Float"];
  doseMin: Scalars["Float"];
  fakeId?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  initials?: InputMaybe<Scalars["String"]>;
  medication: Scalars["String"];
  patient: Scalars["Int"];
  type: RegionalBlockTypeEnum;
  volumeRangeMax?: InputMaybe<Scalars["Float"]>;
  volumeRangeMin?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type Mutation_Collection_QueryRegionalBlockPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  regionalBlock?: Maybe<RegionalBlock>;
};

export type Mutation_Collection_QueryVaccineInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  toPerform?: Scalars["Boolean"];
  vaccine: VaccineEnum;
};

export type Mutation_Collection_QueryVaccinePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vaccine?: Maybe<Vaccine>;
};

export type RangeFilter = {
  gt?: InputMaybe<Scalars["String"]>;
  gte?: InputMaybe<Scalars["String"]>;
  lt?: InputMaybe<Scalars["String"]>;
  lte?: InputMaybe<Scalars["String"]>;
};

export type RemoveBulkAnestheticProtocolInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkAnestheticProtocolMedicationCalculationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkAnestheticProtocolMedicationCalculationPayload = {
  bulkAnestheticProtocolMedicationCalculation?: Maybe<
    BulkAnestheticProtocolMedicationCalculation
  >;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkAnestheticProtocolPayload = {
  bulkAnestheticProtocol?: Maybe<BulkAnestheticProtocol>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkAnestheticProtocolRegionalBlockInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkAnestheticProtocolRegionalBlockPayload = {
  bulkAnestheticProtocolRegionalBlock?: Maybe<
    BulkAnestheticProtocolRegionalBlock
  >;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkAuthorizationSettingInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkAuthorizationSettingPayload = {
  bulkAuthorizationSetting?: Maybe<BulkAuthorizationSetting>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkCurrentMedicationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkCurrentMedicationPayload = {
  bulkCurrentMedication?: Maybe<BulkCurrentMedication>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkDefibMedicationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkDefibMedicationPayload = {
  bulkDefibMedication?: Maybe<BulkDefibMedication>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkDentalSketchCommentInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkDentalSketchCommentPayload = {
  bulkDentalSketchComment?: Maybe<BulkDentalSketchComment>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkDisclaimerProcedureSettingInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkDisclaimerProcedureSettingPayload = {
  bulkDisclaimerProcedureSetting?: Maybe<BulkDisclaimerProcedureSetting>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkMedicalCaseInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkMedicalCasePayload = {
  bulkMedicalCase?: Maybe<BulkMedicalCase>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkMedicationCalculationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkMedicationCalculationPayload = {
  bulkMedicationCalculation?: Maybe<BulkMedicationCalculation>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkRegionalBlockInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkRegionalBlockPayload = {
  bulkRegionalBlock?: Maybe<BulkRegionalBlock>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkSuspensionInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkSuspensionPayload = {
  bulkSuspension?: Maybe<BulkSuspension>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type RemoveBulkTabletInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
};

export type RemoveBulkTabletPayload = {
  bulkTablet?: Maybe<BulkTablet>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type ResendOrganizationInviteInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  organization: Scalars["Int"];
};

export type ResendOrganizationInvitePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  organizationInvite?: Maybe<OrganizationInvite>;
};

export type SetFullMonitoringInformationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diastolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  endTidal?: InputMaybe<Scalars["Float"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  inhalantAnestheticAgent?: InputMaybe<Scalars["Float"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  oxygen?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  pulseOximetry?: InputMaybe<Scalars["Float"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  systolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring: Scalars["DateTime"];
  volumeInfused?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type SetFullMonitoringInformationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  fullMonitoringInformation?: Maybe<FullMonitoringInformation>;
};

export type SetLightMonitoringInformationInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diastolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  endTidal?: InputMaybe<Scalars["Float"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  inhalantAnestheticAgent?: InputMaybe<Scalars["Float"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  oxygen?: InputMaybe<Scalars["Float"]>;
  patient: Scalars["Int"];
  pulseOximetry?: InputMaybe<Scalars["Float"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  systolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  timeMonitoring: Scalars["DateTime"];
};

export type SetLightMonitoringInformationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  lightMonitoringInformation?: Maybe<LightMonitoringInformation>;
};

export type UpdateAdditionalDiagnosticTestInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diagnosticTesting?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  test?: InputMaybe<Scalars["String"]>;
  toPerform?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateAdditionalDiagnosticTestNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diagnosticTesting?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  test?: InputMaybe<Scalars["String"]>;
  toPerform?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateAdditionalDiagnosticTestPayload = {
  additionalDiagnosticTest?: Maybe<AdditionalDiagnosticTest>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateAnestheticGasInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  inhalantAnestheticAgent?: InputMaybe<Scalars["Float"]>;
  oxygen?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateAnestheticGasNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  inhalantAnestheticAgent?: InputMaybe<Scalars["Float"]>;
  oxygen?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateAnestheticGasPayload = {
  anestheticGas?: Maybe<AnestheticGas>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateAnestheticProtocolInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medicationCalculations?: InputMaybe<
    Array<InputMaybe<UpdateAnestheticProtocolMedicationCalculationNestedInput>>
  >;
  name?: InputMaybe<Scalars["String"]>;
  regionalBlocks?: InputMaybe<
    Array<InputMaybe<UpdateAnestheticProtocolRegionalBlockNestedInput>>
  >;
};

export type UpdateAnestheticProtocolMedicationCalculationInput = {
  _id: Scalars["Int"];
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  anestheticProtocol?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  route?: InputMaybe<RouteEnum>;
  type?: InputMaybe<MedicationCalculationTypeEnum>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type UpdateAnestheticProtocolMedicationCalculationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  anestheticProtocol?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  route?: InputMaybe<RouteEnum>;
  type?: InputMaybe<MedicationCalculationTypeEnum>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type UpdateAnestheticProtocolMedicationCalculationPayload = {
  anestheticProtocolMedicationCalculation?: Maybe<
    AnestheticProtocolMedicationCalculation
  >;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateAnestheticProtocolPayload = {
  anestheticProtocol?: Maybe<AnestheticProtocol>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateAnestheticProtocolRegionalBlockInput = {
  _id: Scalars["Int"];
  anestheticProtocol?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  doseMax?: InputMaybe<Scalars["Float"]>;
  doseMin?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<RegionalBlockTypeEnum>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type UpdateAnestheticProtocolRegionalBlockNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  anestheticProtocol?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  doseMax?: InputMaybe<Scalars["Float"]>;
  doseMin?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<RegionalBlockTypeEnum>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type UpdateAnestheticProtocolRegionalBlockPayload = {
  anestheticProtocolRegionalBlock?: Maybe<AnestheticProtocolRegionalBlock>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateAuthorizationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  selected?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateAuthorizationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  selected?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateAuthorizationPayload = {
  authorization?: Maybe<Authorization>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateAuthorizationSettingInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  condition?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type UpdateAuthorizationSettingNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  condition?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
};

export type UpdateAuthorizationSettingPayload = {
  authorizationSetting?: Maybe<AuthorizationSetting>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateCalculationAgreementInput = {
  _id: Scalars["Int"];
  agreed?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  file?: InputMaybe<UpdateFileNestedInput>;
  signedAt?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateCalculationAgreementNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  agreed?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  file?: InputMaybe<UpdateFileNestedInput>;
  signedAt?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateCalculationAgreementPayload = {
  calculationAgreement?: Maybe<CalculationAgreement>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateClientInput = {
  _id: Scalars["Int"];
  accountNumber?: InputMaybe<Scalars["String"]>;
  apartments?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  disclaimer?: InputMaybe<UpdateDisclaimerNestedInput>;
  email?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  notAvailableTime?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<UpdatePatientNestedInput>;
  phoneFirst?: InputMaybe<Scalars["String"]>;
  phoneSecond?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  streetAddress?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type UpdateClientNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  accountNumber?: InputMaybe<Scalars["String"]>;
  apartments?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  disclaimer?: InputMaybe<UpdateDisclaimerNestedInput>;
  email?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  notAvailableTime?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<UpdatePatientNestedInput>;
  phoneFirst?: InputMaybe<Scalars["String"]>;
  phoneSecond?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  streetAddress?: InputMaybe<Scalars["String"]>;
  zipCode?: InputMaybe<Scalars["String"]>;
};

export type UpdateClientPayload = {
  client?: Maybe<Client>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateCurrentMedicationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dose?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  frequency?: InputMaybe<MedicationFrequencyEnum>;
  lastGivenAt?: InputMaybe<Scalars["DateTime"]>;
  medication?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
};

export type UpdateCurrentMedicationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dose?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  frequency?: InputMaybe<MedicationFrequencyEnum>;
  lastGivenAt?: InputMaybe<Scalars["DateTime"]>;
  medication?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
};

export type UpdateCurrentMedicationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  currentMedication?: Maybe<CurrentMedication>;
};

export type UpdateDefibMedicationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax?: InputMaybe<Scalars["Float"]>;
  doseMin?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
};

export type UpdateDefibMedicationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax?: InputMaybe<Scalars["Float"]>;
  doseMin?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
};

export type UpdateDefibMedicationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  defibMedication?: Maybe<DefibMedication>;
};

export type UpdateDentalChartingInput = {
  _id: Scalars["Int"];
  calculus?: InputMaybe<CalculusEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  crCementation?: InputMaybe<Scalars["String"]>;
  distalMarFile?: InputMaybe<Scalars["Float"]>;
  distalWorkingLength?: InputMaybe<Scalars["Float"]>;
  enamel?: InputMaybe<EnamelEnum>;
  endodontics?: InputMaybe<Array<ToothEndodonticsEnum>>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fracture?: InputMaybe<FractureEnum>;
  furcation?: InputMaybe<FurcationEnum>;
  gingivalRecessionBuccal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMLingPal?: InputMaybe<Scalars["Float"]>;
  gingivitis?: InputMaybe<GingivitisEnum>;
  mesialMarFile?: InputMaybe<Scalars["Float"]>;
  mesialWorkingLength?: InputMaybe<Scalars["Float"]>;
  mobility?: InputMaybe<MobilityEnum>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  obturation?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<ToothOralSurgeryEnum>>;
  other?: InputMaybe<Array<OtherEnum>>;
  palatalMarFile?: InputMaybe<Scalars["Float"]>;
  palatalWorkingLength?: InputMaybe<Scalars["Float"]>;
  periodontal?: InputMaybe<PeriodontalEnum>;
  periodontalPocketBuccal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMLingPal?: InputMaybe<Scalars["Float"]>;
  resorption?: InputMaybe<ResorptionEnum>;
  restorations?: InputMaybe<Array<ToothRestorationEnum>>;
  restoratives?: InputMaybe<Scalars["String"]>;
  sutureMaterial?: InputMaybe<Scalars["String"]>;
  technique?: InputMaybe<Scalars["String"]>;
  timerDurationSec?: InputMaybe<Scalars["Int"]>;
  tooth?: InputMaybe<Scalars["Int"]>;
  toothState?: InputMaybe<ToothStateEnum>;
  treatmentComment?: InputMaybe<Scalars["String"]>;
};

export type UpdateDentalChartingNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  calculus?: InputMaybe<CalculusEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  crCementation?: InputMaybe<Scalars["String"]>;
  distalMarFile?: InputMaybe<Scalars["Float"]>;
  distalWorkingLength?: InputMaybe<Scalars["Float"]>;
  enamel?: InputMaybe<EnamelEnum>;
  endodontics?: InputMaybe<Array<ToothEndodonticsEnum>>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fracture?: InputMaybe<FractureEnum>;
  furcation?: InputMaybe<FurcationEnum>;
  gingivalRecessionBuccal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMLingPal?: InputMaybe<Scalars["Float"]>;
  gingivitis?: InputMaybe<GingivitisEnum>;
  mesialMarFile?: InputMaybe<Scalars["Float"]>;
  mesialWorkingLength?: InputMaybe<Scalars["Float"]>;
  mobility?: InputMaybe<MobilityEnum>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  obturation?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<ToothOralSurgeryEnum>>;
  other?: InputMaybe<Array<OtherEnum>>;
  palatalMarFile?: InputMaybe<Scalars["Float"]>;
  palatalWorkingLength?: InputMaybe<Scalars["Float"]>;
  periodontal?: InputMaybe<PeriodontalEnum>;
  periodontalPocketBuccal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMLingPal?: InputMaybe<Scalars["Float"]>;
  resorption?: InputMaybe<ResorptionEnum>;
  restorations?: InputMaybe<Array<ToothRestorationEnum>>;
  restoratives?: InputMaybe<Scalars["String"]>;
  sutureMaterial?: InputMaybe<Scalars["String"]>;
  technique?: InputMaybe<Scalars["String"]>;
  timerDurationSec?: InputMaybe<Scalars["Int"]>;
  tooth?: InputMaybe<Scalars["Int"]>;
  toothState?: InputMaybe<ToothStateEnum>;
  treatmentComment?: InputMaybe<Scalars["String"]>;
};

export type UpdateDentalChartingPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalCharting?: Maybe<DentalCharting>;
};

export type UpdateDentalSketchCommentInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  locationX?: InputMaybe<Scalars["Float"]>;
  locationY?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  text?: InputMaybe<Scalars["String"]>;
};

export type UpdateDentalSketchCommentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  locationX?: InputMaybe<Scalars["Float"]>;
  locationY?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  text?: InputMaybe<Scalars["String"]>;
};

export type UpdateDentalSketchCommentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dentalSketchComment?: Maybe<DentalSketchComment>;
};

export type UpdateDiagnosticTestingInput = {
  _id: Scalars["Int"];
  abnormalitiesAndNotes?: InputMaybe<Scalars["String"]>;
  additionalTests?: InputMaybe<
    Array<InputMaybe<UpdateAdditionalDiagnosticTestNestedInput>>
  >;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  reviewedByDvm?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateDiagnosticTestingNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  abnormalitiesAndNotes?: InputMaybe<Scalars["String"]>;
  additionalTests?: InputMaybe<
    Array<InputMaybe<UpdateAdditionalDiagnosticTestNestedInput>>
  >;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  reviewedByDvm?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateDiagnosticTestingPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  diagnosticTesting?: Maybe<DiagnosticTesting>;
};

export type UpdateDisclaimerInput = {
  _id: Scalars["Int"];
  agreeWithTerms?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["Date"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<UpdateFileNestedInput>;
};

export type UpdateDisclaimerNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  agreeWithTerms?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  createdAt?: InputMaybe<Scalars["Date"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  signature?: InputMaybe<UpdateFileNestedInput>;
};

export type UpdateDisclaimerPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  disclaimer?: Maybe<Disclaimer>;
};

export type UpdateDisclaimerProcedureInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  selected?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateDisclaimerProcedureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  selected?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateDisclaimerProcedurePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  disclaimerProcedure?: Maybe<DisclaimerProcedure>;
};

export type UpdateDisclaimerProcedureSettingInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type UpdateDisclaimerProcedureSettingNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
};

export type UpdateDisclaimerProcedureSettingPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  disclaimerProcedureSetting?: Maybe<DisclaimerProcedureSetting>;
};

export type UpdateDropOffInput = {
  _id: Scalars["Int"];
  admittingConcern?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor?: InputMaybe<Scalars["Int"]>;
  evaluateTestAndTreat?: InputMaybe<Scalars["Boolean"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  performInitialEvaluation?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateDropOffNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  admittingConcern?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  doctor?: InputMaybe<Scalars["Int"]>;
  evaluateTestAndTreat?: InputMaybe<Scalars["Boolean"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  performInitialEvaluation?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateDropOffPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  dropOff?: Maybe<DropOff>;
};

export type UpdateExamNoteInput = {
  _id: Scalars["Int"];
  additionalNotes?: InputMaybe<Scalars["String"]>;
  allergies?: InputMaybe<Scalars["String"]>;
  bloodwork?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  lastMealAt?: InputMaybe<Scalars["DateTime"]>;
  patientPersonalItems?: InputMaybe<Scalars["String"]>;
  previousSurgery?: InputMaybe<Scalars["String"]>;
  treatmentPlan?: InputMaybe<Scalars["String"]>;
  vaccines?: InputMaybe<Scalars["String"]>;
};

export type UpdateExamNoteNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalNotes?: InputMaybe<Scalars["String"]>;
  allergies?: InputMaybe<Scalars["String"]>;
  bloodwork?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  lastMealAt?: InputMaybe<Scalars["DateTime"]>;
  patientPersonalItems?: InputMaybe<Scalars["String"]>;
  previousSurgery?: InputMaybe<Scalars["String"]>;
  treatmentPlan?: InputMaybe<Scalars["String"]>;
  vaccines?: InputMaybe<Scalars["String"]>;
};

export type UpdateExamNotePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  examNote?: Maybe<ExamNote>;
};

export type UpdateFileInput = {
  _id: Scalars["Int"];
  base64Format?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  reference?: InputMaybe<Scalars["String"]>;
};

export type UpdateFileNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  base64Format?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  reference?: InputMaybe<Scalars["String"]>;
};

export type UpdateFilePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  file?: Maybe<File>;
};

export type UpdateFluidBolusInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
};

export type UpdateFluidBolusNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
};

export type UpdateFluidBolusPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  fluidBolus?: Maybe<FluidBolus>;
};

export type UpdateFluidTemperatureInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
  volumeInfused?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type UpdateFluidTemperatureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
  volumeInfused?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type UpdateFluidTemperaturePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  fluidTemperature?: Maybe<FluidTemperature>;
};

export type UpdateGeneralAssessmentInput = {
  _id: Scalars["Int"];
  additionalCommentsAndNotes?: InputMaybe<Scalars["String"]>;
  additionalPhotos?: InputMaybe<Array<InputMaybe<UpdateFileNestedInput>>>;
  afterPhotoFront?: InputMaybe<UpdateFileNestedInput>;
  afterPhotoLeft?: InputMaybe<UpdateFileNestedInput>;
  afterPhotoRight?: InputMaybe<UpdateFileNestedInput>;
  beforePhotoFront?: InputMaybe<UpdateFileNestedInput>;
  beforePhotoLeft?: InputMaybe<UpdateFileNestedInput>;
  beforePhotoRight?: InputMaybe<UpdateFileNestedInput>;
  between25And50PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  boneAugmentation?: InputMaybe<Scalars["Boolean"]>;
  boneAugmentationDetails?: InputMaybe<Scalars["String"]>;
  buccalMucosa?: InputMaybe<OralStateEnum>;
  calculusIndex?: InputMaybe<CalculusIndexEnum>;
  caudalOralMucosa?: InputMaybe<OralStateEnum>;
  cbctComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dentalChart?: InputMaybe<DentalChartEnum>;
  externalCervicalToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalInflammatoryToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalReplacementRootResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalSurfaceRootResorption?: InputMaybe<Array<Scalars["String"]>>;
  extraoral?: InputMaybe<OralStateEnum>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fistula?: InputMaybe<Scalars["Boolean"]>;
  gingivalIndex?: InputMaybe<GingivalIndexEnum>;
  greaterThan50PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  hardPalate?: InputMaybe<OralStateEnum>;
  internalToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  intraoralRadiographicComments?: InputMaybe<Scalars["String"]>;
  leftInferiorAlveolar?: InputMaybe<Scalars["Float"]>;
  leftInfraorbital?: InputMaybe<Scalars["Float"]>;
  leftMaxillary?: InputMaybe<Scalars["Float"]>;
  leftRegionalBlocks?: InputMaybe<Array<TreatmentRegionalBlockEnum>>;
  leftRostralMandibular?: InputMaybe<Scalars["Float"]>;
  lessThan25PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  lymphNodes?: InputMaybe<OralStateEnum>;
  missingTeeth?: InputMaybe<Array<Scalars["String"]>>;
  notesForClientDentalReport?: InputMaybe<Scalars["String"]>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  occlusion?: InputMaybe<OcclusionEnum>;
  occlusionDescription?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<OralSurgeryEnum>>;
  orthodontics?: InputMaybe<Array<OrthodonticsEnum>>;
  parulisSinusTract?: InputMaybe<Scalars["Boolean"]>;
  periapicalLucency?: InputMaybe<Array<Scalars["String"]>>;
  periapicalRarefaction?: InputMaybe<Array<Scalars["String"]>>;
  periodontalDisease?: InputMaybe<PeriodontalDiseaseEnum>;
  periodontics?: InputMaybe<Array<PeriodonticsEnum>>;
  planingAndSubgingivalCurettage?: InputMaybe<
    RootPlaningAndSubgingivalCurettageEnum
  >;
  plaqueIndex?: InputMaybe<PlaqueIndexEnum>;
  radiographicFindingsPhotos?: InputMaybe<
    Array<InputMaybe<UpdateFileNestedInput>>
  >;
  referralNotesAndComments?: InputMaybe<Scalars["String"]>;
  retainedToothRoots?: InputMaybe<Array<Scalars["String"]>>;
  rightInferiorAlveolar?: InputMaybe<Scalars["Float"]>;
  rightInfraorbital?: InputMaybe<Scalars["Float"]>;
  rightMaxillary?: InputMaybe<Scalars["Float"]>;
  rightRegionalBlocks?: InputMaybe<Array<TreatmentRegionalBlockEnum>>;
  rightRostralMandibular?: InputMaybe<Scalars["Float"]>;
  skullType?: InputMaybe<SkullTypeEnum>;
  softPalate?: InputMaybe<OralStateEnum>;
  tongue?: InputMaybe<OralStateEnum>;
  tonsils?: InputMaybe<OralStateEnum>;
  toothResorptionType1?: InputMaybe<Array<Scalars["String"]>>;
  toothResorptionType2?: InputMaybe<Array<Scalars["String"]>>;
  toothResorptionType3?: InputMaybe<Array<Scalars["String"]>>;
  treatmentAdditionalFindingsCommentsAndNotes?: InputMaybe<Scalars["String"]>;
  uneruptedTeeth?: InputMaybe<Array<Scalars["String"]>>;
  widenedPulpCanal?: InputMaybe<Array<Scalars["String"]>>;
};

export type UpdateGeneralAssessmentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalCommentsAndNotes?: InputMaybe<Scalars["String"]>;
  additionalPhotos?: InputMaybe<Array<InputMaybe<UpdateFileNestedInput>>>;
  afterPhotoFront?: InputMaybe<UpdateFileNestedInput>;
  afterPhotoLeft?: InputMaybe<UpdateFileNestedInput>;
  afterPhotoRight?: InputMaybe<UpdateFileNestedInput>;
  beforePhotoFront?: InputMaybe<UpdateFileNestedInput>;
  beforePhotoLeft?: InputMaybe<UpdateFileNestedInput>;
  beforePhotoRight?: InputMaybe<UpdateFileNestedInput>;
  between25And50PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  boneAugmentation?: InputMaybe<Scalars["Boolean"]>;
  boneAugmentationDetails?: InputMaybe<Scalars["String"]>;
  buccalMucosa?: InputMaybe<OralStateEnum>;
  calculusIndex?: InputMaybe<CalculusIndexEnum>;
  caudalOralMucosa?: InputMaybe<OralStateEnum>;
  cbctComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dentalChart?: InputMaybe<DentalChartEnum>;
  externalCervicalToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalInflammatoryToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalReplacementRootResorption?: InputMaybe<Array<Scalars["String"]>>;
  externalSurfaceRootResorption?: InputMaybe<Array<Scalars["String"]>>;
  extraoral?: InputMaybe<OralStateEnum>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fistula?: InputMaybe<Scalars["Boolean"]>;
  gingivalIndex?: InputMaybe<GingivalIndexEnum>;
  greaterThan50PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  hardPalate?: InputMaybe<OralStateEnum>;
  internalToothResorption?: InputMaybe<Array<Scalars["String"]>>;
  intraoralRadiographicComments?: InputMaybe<Scalars["String"]>;
  leftInferiorAlveolar?: InputMaybe<Scalars["Float"]>;
  leftInfraorbital?: InputMaybe<Scalars["Float"]>;
  leftMaxillary?: InputMaybe<Scalars["Float"]>;
  leftRegionalBlocks?: InputMaybe<Array<TreatmentRegionalBlockEnum>>;
  leftRostralMandibular?: InputMaybe<Scalars["Float"]>;
  lessThan25PerCentBoneLoss?: InputMaybe<Array<Scalars["String"]>>;
  lymphNodes?: InputMaybe<OralStateEnum>;
  missingTeeth?: InputMaybe<Array<Scalars["String"]>>;
  notesForClientDentalReport?: InputMaybe<Scalars["String"]>;
  notesTimer?: InputMaybe<Scalars["String"]>;
  occlusion?: InputMaybe<OcclusionEnum>;
  occlusionDescription?: InputMaybe<Scalars["String"]>;
  oralSurgeries?: InputMaybe<Array<OralSurgeryEnum>>;
  orthodontics?: InputMaybe<Array<OrthodonticsEnum>>;
  parulisSinusTract?: InputMaybe<Scalars["Boolean"]>;
  periapicalLucency?: InputMaybe<Array<Scalars["String"]>>;
  periapicalRarefaction?: InputMaybe<Array<Scalars["String"]>>;
  periodontalDisease?: InputMaybe<PeriodontalDiseaseEnum>;
  periodontics?: InputMaybe<Array<PeriodonticsEnum>>;
  planingAndSubgingivalCurettage?: InputMaybe<
    RootPlaningAndSubgingivalCurettageEnum
  >;
  plaqueIndex?: InputMaybe<PlaqueIndexEnum>;
  radiographicFindingsPhotos?: InputMaybe<
    Array<InputMaybe<UpdateFileNestedInput>>
  >;
  referralNotesAndComments?: InputMaybe<Scalars["String"]>;
  retainedToothRoots?: InputMaybe<Array<Scalars["String"]>>;
  rightInferiorAlveolar?: InputMaybe<Scalars["Float"]>;
  rightInfraorbital?: InputMaybe<Scalars["Float"]>;
  rightMaxillary?: InputMaybe<Scalars["Float"]>;
  rightRegionalBlocks?: InputMaybe<Array<TreatmentRegionalBlockEnum>>;
  rightRostralMandibular?: InputMaybe<Scalars["Float"]>;
  skullType?: InputMaybe<SkullTypeEnum>;
  softPalate?: InputMaybe<OralStateEnum>;
  tongue?: InputMaybe<OralStateEnum>;
  tonsils?: InputMaybe<OralStateEnum>;
  toothResorptionType1?: InputMaybe<Array<Scalars["String"]>>;
  toothResorptionType2?: InputMaybe<Array<Scalars["String"]>>;
  toothResorptionType3?: InputMaybe<Array<Scalars["String"]>>;
  treatmentAdditionalFindingsCommentsAndNotes?: InputMaybe<Scalars["String"]>;
  uneruptedTeeth?: InputMaybe<Array<Scalars["String"]>>;
  widenedPulpCanal?: InputMaybe<Array<Scalars["String"]>>;
};

export type UpdateGeneralAssessmentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  generalAssessment?: Maybe<GeneralAssessment>;
};

export type UpdateLicenseInput = {
  _id: Scalars["Int"];
  active?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  maxNumberOfUsers?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  period?: InputMaybe<LicensePeriodEnum>;
  price?: InputMaybe<Scalars["Float"]>;
};

export type UpdateLicensePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  license?: Maybe<License>;
};

export type UpdateMedicalCaseInput = {
  _id: Scalars["Int"];
  authorizations?: InputMaybe<
    Array<InputMaybe<UpdateAuthorizationNestedInput>>
  >;
  client?: InputMaybe<UpdateClientNestedInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  disclaimerProcedures?: InputMaybe<
    Array<InputMaybe<UpdateDisclaimerProcedureNestedInput>>
  >;
  disclaimerText?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  offline?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<CaseStatusEnum>;
  temperatureUnit?: InputMaybe<TemperatureUnitEnum>;
};

export type UpdateMedicalCasePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicalCase?: Maybe<MedicalCase>;
};

export type UpdateMedicalCaseSubscriptionInput = {
  clientSubscriptionId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
};

export type UpdateMedicalCaseSubscriptionPayload = {
  clientSubscriptionId?: Maybe<Scalars["String"]>;
  medicalCase?: Maybe<MedicalCase>;
  mercureUrl?: Maybe<Scalars["String"]>;
};

export type UpdateMedicationCalculationInput = {
  _id: Scalars["Int"];
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  calculationType?: InputMaybe<MedicationCalculationTypeEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  route?: InputMaybe<RouteEnum>;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type UpdateMedicationCalculationNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalVolumeAdministered?: InputMaybe<Scalars["Float"]>;
  additionalVolumeDrawn?: InputMaybe<Scalars["Float"]>;
  calculationType?: InputMaybe<MedicationCalculationTypeEnum>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  route?: InputMaybe<RouteEnum>;
  timeAdministered?: InputMaybe<Scalars["Time"]>;
  totalAmount?: InputMaybe<Scalars["Float"]>;
  volumeAdministered?: InputMaybe<Scalars["Float"]>;
};

export type UpdateMedicationCalculationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  medicationCalculation?: Maybe<MedicationCalculation>;
};

export type UpdateMiscellaneousGroupInput = {
  _id: Scalars["Int"];
  anesthesiaSystem?: InputMaybe<AnesthesiaSystemEnum>;
  bagSize?: InputMaybe<Scalars["Float"]>;
  bloodPressureMonitoring?: InputMaybe<BloodPressureMonitoringEnum>;
  catheterLocation?: InputMaybe<CatheterLocationEnum>;
  catheterSize?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endotrachealTubeSize?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Int"]>;
  fluidRateValue?: InputMaybe<Scalars["Float"]>;
  fluidType?: InputMaybe<Scalars["String"]>;
  intubated?: InputMaybe<Scalars["Boolean"]>;
  oxygenFlowRate?: InputMaybe<Scalars["Float"]>;
  qualityOfSedation?: InputMaybe<QualityOfSedationEnum>;
};

export type UpdateMiscellaneousGroupNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  anesthesiaSystem?: InputMaybe<AnesthesiaSystemEnum>;
  bagSize?: InputMaybe<Scalars["Float"]>;
  bloodPressureMonitoring?: InputMaybe<BloodPressureMonitoringEnum>;
  catheterLocation?: InputMaybe<CatheterLocationEnum>;
  catheterSize?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endotrachealTubeSize?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Int"]>;
  fluidRateValue?: InputMaybe<Scalars["Float"]>;
  fluidType?: InputMaybe<Scalars["String"]>;
  intubated?: InputMaybe<Scalars["Boolean"]>;
  oxygenFlowRate?: InputMaybe<Scalars["Float"]>;
  qualityOfSedation?: InputMaybe<QualityOfSedationEnum>;
};

export type UpdateMiscellaneousGroupPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  miscellaneousGroup?: Maybe<MiscellaneousGroup>;
};

export type UpdateMonitoringInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  monitoringBy?: InputMaybe<Scalars["Int"]>;
  patient?: InputMaybe<Scalars["Int"]>;
};

export type UpdateMonitoringNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  monitoringBy?: InputMaybe<Scalars["Int"]>;
  patient?: InputMaybe<Scalars["Int"]>;
};

export type UpdateMonitoringPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  monitoring?: Maybe<Monitoring>;
};

export type UpdateOrderInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  expirationDate?: InputMaybe<Scalars["Date"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  license?: InputMaybe<Scalars["Int"]>;
  organization?: InputMaybe<Scalars["Int"]>;
  price?: InputMaybe<Scalars["Float"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
};

export type UpdateOrderPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  order?: Maybe<Order>;
};

export type UpdateOrganizationInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  contactEmail?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  logo?: InputMaybe<UpdateFileNestedInput>;
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<OrganizationStatusEnum>;
  users?: InputMaybe<Array<InputMaybe<UpdateUserNestedInput>>>;
  vetspireApiKey?: InputMaybe<Scalars["String"]>;
};

export type UpdateOrganizationPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  organization?: Maybe<Organization>;
};

export type UpdateOrganizationSettingInput = {
  _id: Scalars["Int"];
  authorizationSettings?: InputMaybe<
    Array<InputMaybe<UpdateAuthorizationSettingNestedInput>>
  >;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dateFormat?: InputMaybe<DateFormatEnum>;
  disclaimerProcedureSettings?: InputMaybe<
    Array<InputMaybe<UpdateDisclaimerProcedureSettingNestedInput>>
  >;
  disclaimerText?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  temperatureUnit?: InputMaybe<TemperatureUnitEnum>;
};

export type UpdateOrganizationSettingPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  organizationSetting?: Maybe<OrganizationSetting>;
};

export type UpdatePatientInput = {
  _id: Scalars["Int"];
  alerts?: InputMaybe<Scalars["String"]>;
  anestheticGasMedication?: InputMaybe<AnestheticGasMedicationEnum>;
  anestheticGases?: InputMaybe<
    Array<InputMaybe<UpdateAnestheticGasNestedInput>>
  >;
  breed?: InputMaybe<Scalars["String"]>;
  calculationAgreement?: InputMaybe<UpdateCalculationAgreementNestedInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  currentMedications?: InputMaybe<
    Array<InputMaybe<UpdateCurrentMedicationNestedInput>>
  >;
  dateOfBirth?: InputMaybe<Scalars["Date"]>;
  defibMedications?: InputMaybe<
    Array<InputMaybe<UpdateDefibMedicationNestedInput>>
  >;
  dentalChartings?: InputMaybe<
    Array<InputMaybe<UpdateDentalChartingNestedInput>>
  >;
  dentalSketch?: InputMaybe<UpdateFileNestedInput>;
  dentalSketchComments?: InputMaybe<
    Array<InputMaybe<UpdateDentalSketchCommentNestedInput>>
  >;
  diagnosticTesting?: InputMaybe<UpdateDiagnosticTestingNestedInput>;
  dropOff?: InputMaybe<UpdateDropOffNestedInput>;
  examNote?: InputMaybe<UpdateExamNoteNestedInput>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidBolus?: InputMaybe<UpdateFluidBolusNestedInput>;
  fluidTemperatures?: InputMaybe<
    Array<InputMaybe<UpdateFluidTemperatureNestedInput>>
  >;
  generalAssessment?: InputMaybe<UpdateGeneralAssessmentNestedInput>;
  image?: InputMaybe<UpdateFileNestedInput>;
  medicationCalculations?: InputMaybe<
    Array<InputMaybe<UpdateMedicationCalculationNestedInput>>
  >;
  miscellaneousGroup?: InputMaybe<UpdateMiscellaneousGroupNestedInput>;
  monitoring?: InputMaybe<UpdateMonitoringNestedInput>;
  name?: InputMaybe<Scalars["String"]>;
  patientProcedures?: InputMaybe<
    Array<InputMaybe<UpdatePatientProcedureNestedInput>>
  >;
  patientTests?: InputMaybe<Array<InputMaybe<UpdatePatientTestNestedInput>>>;
  physicalExam?: InputMaybe<UpdatePhysicalExamNestedInput>;
  postAnestheticVitalComment?: InputMaybe<
    UpdatePostAnestheticVitalCommentNestedInput
  >;
  postAnestheticVitals?: InputMaybe<
    Array<InputMaybe<UpdatePostAnestheticVitalNestedInput>>
  >;
  preAnestheticExam?: InputMaybe<UpdatePreAnestheticExamNestedInput>;
  procedureDate?: InputMaybe<Scalars["Date"]>;
  procedures?: InputMaybe<Array<Scalars["String"]>>;
  prophylacticDentalProcedure?: InputMaybe<
    UpdateProphylacticDentalProcedureNestedInput
  >;
  regionalBlocks?: InputMaybe<
    Array<InputMaybe<UpdateRegionalBlockNestedInput>>
  >;
  sex?: InputMaybe<PatientSexEnum>;
  species?: InputMaybe<SpeciesEnum>;
  suspensions?: InputMaybe<Array<InputMaybe<UpdateSuspensionNestedInput>>>;
  tablets?: InputMaybe<Array<InputMaybe<UpdateTabletNestedInput>>>;
  tibialPlateauLevelingOsteotomyPlanning?: InputMaybe<
    UpdateTibialPlateauLevelingOsteotomyPlanningNestedInput
  >;
  treatment?: InputMaybe<UpdateTreatmentNestedInput>;
  vaccines?: InputMaybe<Array<InputMaybe<UpdateVaccineNestedInput>>>;
  vitalComment?: InputMaybe<UpdateVitalCommentNestedInput>;
  vitals?: InputMaybe<Array<InputMaybe<UpdateVitalNestedInput>>>;
  weight?: InputMaybe<Scalars["Float"]>;
  weightMeasure?: InputMaybe<WeightMeasureEnum>;
};

export type UpdatePatientNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  alerts?: InputMaybe<Scalars["String"]>;
  anestheticGasMedication?: InputMaybe<AnestheticGasMedicationEnum>;
  anestheticGases?: InputMaybe<
    Array<InputMaybe<UpdateAnestheticGasNestedInput>>
  >;
  breed?: InputMaybe<Scalars["String"]>;
  calculationAgreement?: InputMaybe<UpdateCalculationAgreementNestedInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  currentMedications?: InputMaybe<
    Array<InputMaybe<UpdateCurrentMedicationNestedInput>>
  >;
  dateOfBirth?: InputMaybe<Scalars["Date"]>;
  defibMedications?: InputMaybe<
    Array<InputMaybe<UpdateDefibMedicationNestedInput>>
  >;
  dentalChartings?: InputMaybe<
    Array<InputMaybe<UpdateDentalChartingNestedInput>>
  >;
  dentalSketch?: InputMaybe<UpdateFileNestedInput>;
  dentalSketchComments?: InputMaybe<
    Array<InputMaybe<UpdateDentalSketchCommentNestedInput>>
  >;
  diagnosticTesting?: InputMaybe<UpdateDiagnosticTestingNestedInput>;
  dropOff?: InputMaybe<UpdateDropOffNestedInput>;
  examNote?: InputMaybe<UpdateExamNoteNestedInput>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidBolus?: InputMaybe<UpdateFluidBolusNestedInput>;
  fluidTemperatures?: InputMaybe<
    Array<InputMaybe<UpdateFluidTemperatureNestedInput>>
  >;
  generalAssessment?: InputMaybe<UpdateGeneralAssessmentNestedInput>;
  image?: InputMaybe<UpdateFileNestedInput>;
  medicationCalculations?: InputMaybe<
    Array<InputMaybe<UpdateMedicationCalculationNestedInput>>
  >;
  miscellaneousGroup?: InputMaybe<UpdateMiscellaneousGroupNestedInput>;
  monitoring?: InputMaybe<UpdateMonitoringNestedInput>;
  name?: InputMaybe<Scalars["String"]>;
  patientProcedures?: InputMaybe<
    Array<InputMaybe<UpdatePatientProcedureNestedInput>>
  >;
  patientTests?: InputMaybe<Array<InputMaybe<UpdatePatientTestNestedInput>>>;
  physicalExam?: InputMaybe<UpdatePhysicalExamNestedInput>;
  postAnestheticVitalComment?: InputMaybe<
    UpdatePostAnestheticVitalCommentNestedInput
  >;
  postAnestheticVitals?: InputMaybe<
    Array<InputMaybe<UpdatePostAnestheticVitalNestedInput>>
  >;
  preAnestheticExam?: InputMaybe<UpdatePreAnestheticExamNestedInput>;
  procedureDate?: InputMaybe<Scalars["Date"]>;
  procedures?: InputMaybe<Array<Scalars["String"]>>;
  prophylacticDentalProcedure?: InputMaybe<
    UpdateProphylacticDentalProcedureNestedInput
  >;
  regionalBlocks?: InputMaybe<
    Array<InputMaybe<UpdateRegionalBlockNestedInput>>
  >;
  sex?: InputMaybe<PatientSexEnum>;
  species?: InputMaybe<SpeciesEnum>;
  suspensions?: InputMaybe<Array<InputMaybe<UpdateSuspensionNestedInput>>>;
  tablets?: InputMaybe<Array<InputMaybe<UpdateTabletNestedInput>>>;
  tibialPlateauLevelingOsteotomyPlanning?: InputMaybe<
    UpdateTibialPlateauLevelingOsteotomyPlanningNestedInput
  >;
  treatment?: InputMaybe<UpdateTreatmentNestedInput>;
  vaccines?: InputMaybe<Array<InputMaybe<UpdateVaccineNestedInput>>>;
  vitalComment?: InputMaybe<UpdateVitalCommentNestedInput>;
  vitals?: InputMaybe<Array<InputMaybe<UpdateVitalNestedInput>>>;
  weight?: InputMaybe<Scalars["Float"]>;
  weightMeasure?: InputMaybe<WeightMeasureEnum>;
};

export type UpdatePatientPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  patient?: Maybe<Patient>;
};

export type UpdatePatientProcedureInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdatePatientProcedureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["DateTime"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  startTime?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdatePatientProcedurePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  patientProcedure?: Maybe<PatientProcedure>;
};

export type UpdatePatientTestInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  test?: InputMaybe<PatientTestEnum>;
  toPerform?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdatePatientTestNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  test?: InputMaybe<PatientTestEnum>;
  toPerform?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdatePatientTestPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  patientTest?: Maybe<PatientTest>;
};

export type UpdatePhysicalExamInput = {
  _id: Scalars["Int"];
  cardiovascular?: InputMaybe<PatientStateEnum>;
  cardiovascularAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ears?: InputMaybe<PatientStateEnum>;
  earsAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  eyes?: InputMaybe<PatientStateEnum>;
  eyesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  gastrointestinal?: InputMaybe<PatientStateEnum>;
  gastrointestinalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  generalAppearance?: InputMaybe<PatientStateEnum>;
  generalAppearanceAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  integumentary?: InputMaybe<PatientStateEnum>;
  integumentaryAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  lymphNodes?: InputMaybe<PatientStateEnum>;
  lymphNodesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  mucousMembranes?: InputMaybe<PatientStateEnum>;
  mucousMembranesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  musculosceletal?: InputMaybe<PatientStateEnum>;
  musculosceletalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  nervousSystem?: InputMaybe<PatientStateEnum>;
  nervousSystemAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  oralCavity?: InputMaybe<PatientStateEnum>;
  oralCavityAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  respiratory?: InputMaybe<PatientStateEnum>;
  respiratoryAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  urogenital?: InputMaybe<PatientStateEnum>;
  urogenitalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
};

export type UpdatePhysicalExamNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  cardiovascular?: InputMaybe<PatientStateEnum>;
  cardiovascularAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ears?: InputMaybe<PatientStateEnum>;
  earsAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  eyes?: InputMaybe<PatientStateEnum>;
  eyesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  gastrointestinal?: InputMaybe<PatientStateEnum>;
  gastrointestinalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  generalAppearance?: InputMaybe<PatientStateEnum>;
  generalAppearanceAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  integumentary?: InputMaybe<PatientStateEnum>;
  integumentaryAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  lymphNodes?: InputMaybe<PatientStateEnum>;
  lymphNodesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  mucousMembranes?: InputMaybe<PatientStateEnum>;
  mucousMembranesAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  musculosceletal?: InputMaybe<PatientStateEnum>;
  musculosceletalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  nervousSystem?: InputMaybe<PatientStateEnum>;
  nervousSystemAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  oralCavity?: InputMaybe<PatientStateEnum>;
  oralCavityAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  respiratory?: InputMaybe<PatientStateEnum>;
  respiratoryAbnormalStateComments?: InputMaybe<Scalars["String"]>;
  urogenital?: InputMaybe<PatientStateEnum>;
  urogenitalAbnormalStateComments?: InputMaybe<Scalars["String"]>;
};

export type UpdatePhysicalExamPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  physicalExam?: Maybe<PhysicalExam>;
};

export type UpdatePostAnestheticVitalCommentInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  surgeryReport?: InputMaybe<Scalars["String"]>;
};

export type UpdatePostAnestheticVitalCommentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  surgeryReport?: InputMaybe<Scalars["String"]>;
};

export type UpdatePostAnestheticVitalCommentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  postAnestheticVitalComment?: Maybe<PostAnestheticVitalComment>;
};

export type UpdatePostAnestheticVitalInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  initials?: InputMaybe<Scalars["String"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  painScore?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdatePostAnestheticVitalNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fluidRate?: InputMaybe<Scalars["Float"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  initials?: InputMaybe<Scalars["String"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  painScore?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdatePostAnestheticVitalPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  postAnestheticVital?: Maybe<PostAnestheticVital>;
};

export type UpdatePreAnestheticExamInput = {
  _id: Scalars["Int"];
  bodyConditionScore?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dentalScore?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  painScore?: InputMaybe<Scalars["Int"]>;
  physicalStatus?: InputMaybe<PatientPhysicalStatus>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
};

export type UpdatePreAnestheticExamNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  bodyConditionScore?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dentalScore?: InputMaybe<Scalars["Int"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  painScore?: InputMaybe<Scalars["Int"]>;
  physicalStatus?: InputMaybe<PatientPhysicalStatus>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  temperature?: InputMaybe<Scalars["Float"]>;
};

export type UpdatePreAnestheticExamPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  preAnestheticExam?: Maybe<PreAnestheticExam>;
};

export type UpdateProphylacticDentalProcedureInput = {
  _id: Scalars["Int"];
  additionalComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dontAuthorizeAnyAdditionalDentalWorkBeforeContact?: InputMaybe<
    Scalars["Boolean"]
  >;
  dontAuthorizeAnyRadiographs?: InputMaybe<Scalars["Boolean"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fullMouthRadiographs?: InputMaybe<Scalars["Boolean"]>;
  gumWorkOrExtraction?: InputMaybe<Scalars["Boolean"]>;
  onlyRadiographsDeemedNecessary?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateProphylacticDentalProcedureNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  additionalComments?: InputMaybe<Scalars["String"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dontAuthorizeAnyAdditionalDentalWorkBeforeContact?: InputMaybe<
    Scalars["Boolean"]
  >;
  dontAuthorizeAnyRadiographs?: InputMaybe<Scalars["Boolean"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  fullMouthRadiographs?: InputMaybe<Scalars["Boolean"]>;
  gumWorkOrExtraction?: InputMaybe<Scalars["Boolean"]>;
  onlyRadiographsDeemedNecessary?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateProphylacticDentalProcedurePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  prophylacticDentalProcedure?: Maybe<ProphylacticDentalProcedure>;
};

export type UpdateQuickChartBulkDentalChartingInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fracture?: InputMaybe<FractureEnum>;
  furcation?: InputMaybe<FurcationEnum>;
  gingivalRecessionBuccal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionDLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionLingPal?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMBuc?: InputMaybe<Scalars["Float"]>;
  gingivalRecessionMLingPal?: InputMaybe<Scalars["Float"]>;
  ids: Array<Scalars["Int"]>;
  mobility?: InputMaybe<MobilityEnum>;
  other?: InputMaybe<Array<OtherEnum>>;
  periodontalPocketBuccal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketDLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketLingPal?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMBuc?: InputMaybe<Scalars["Float"]>;
  periodontalPocketMLingPal?: InputMaybe<Scalars["Float"]>;
  resorption?: InputMaybe<ResorptionEnum>;
  toothState?: InputMaybe<ToothStateEnum>;
};

export type UpdateQuickChartBulkDentalChartingPayload = {
  bulkDentalCharting?: Maybe<BulkDentalCharting>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateRegionalBlockInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax?: InputMaybe<Scalars["Float"]>;
  doseMin?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<RegionalBlockTypeEnum>;
  volumeRangeMax?: InputMaybe<Scalars["Float"]>;
  volumeRangeMin?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type UpdateRegionalBlockNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dosageMax?: InputMaybe<Scalars["Float"]>;
  dosageMin?: InputMaybe<Scalars["Float"]>;
  doseMax?: InputMaybe<Scalars["Float"]>;
  doseMin?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initials?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<RegionalBlockTypeEnum>;
  volumeRangeMax?: InputMaybe<Scalars["Float"]>;
  volumeRangeMin?: InputMaybe<Scalars["Float"]>;
  volumeToBeInfused?: InputMaybe<Scalars["Float"]>;
};

export type UpdateRegionalBlockPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  regionalBlock?: Maybe<RegionalBlock>;
};

export type UpdateStatusBulkDentalChartingInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
  toothState: ToothStateEnum;
};

export type UpdateStatusBulkDentalChartingPayload = {
  bulkDentalCharting?: Maybe<BulkDentalCharting>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateStatusBulkMedicalCaseInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
  status: CaseStatusEnum;
};

export type UpdateStatusBulkMedicalCasePayload = {
  bulkMedicalCase?: Maybe<BulkMedicalCase>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateStatusBulkPatientTestInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
  toPerform: Scalars["Boolean"];
};

export type UpdateStatusBulkPatientTestPayload = {
  bulkPatientTest?: Maybe<BulkPatientTest>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateStatusBulkVaccineInput = {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  ids: Array<Scalars["Int"]>;
  toPerform: Scalars["Boolean"];
};

export type UpdateStatusBulkVaccinePayload = {
  bulkVaccine?: Maybe<BulkVaccine>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type UpdateSuspensionInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  totalVolume?: InputMaybe<Scalars["Float"]>;
  volume?: InputMaybe<Scalars["Float"]>;
};

export type UpdateSuspensionNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  concentration?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  totalVolume?: InputMaybe<Scalars["Float"]>;
  volume?: InputMaybe<Scalars["Float"]>;
};

export type UpdateSuspensionPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  suspension?: Maybe<Suspension>;
};

export type UpdateTabletInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosage?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  numberOfTablets?: InputMaybe<Scalars["Float"]>;
  tabletSize?: InputMaybe<Scalars["Float"]>;
};

export type UpdateTabletNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  dosage?: InputMaybe<Scalars["Float"]>;
  dose?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  labelInstructions?: InputMaybe<Scalars["String"]>;
  medication?: InputMaybe<Scalars["String"]>;
  numberOfTablets?: InputMaybe<Scalars["Float"]>;
  tabletSize?: InputMaybe<Scalars["Float"]>;
};

export type UpdateTabletPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  tablet?: Maybe<Tablet>;
};

export type UpdateTibialPlateauLevelingOsteotomyPlanningInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  d1?: InputMaybe<Scalars["String"]>;
  d2?: InputMaybe<Scalars["String"]>;
  d3?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initialTpa?: InputMaybe<Scalars["String"]>;
  postOpTpa?: InputMaybe<Scalars["String"]>;
  rotationNeeded?: InputMaybe<Scalars["String"]>;
  tploBladeSize?: InputMaybe<Scalars["String"]>;
  tploPlateSizeAndModel?: InputMaybe<Scalars["String"]>;
};

export type UpdateTibialPlateauLevelingOsteotomyPlanningNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  d1?: InputMaybe<Scalars["String"]>;
  d2?: InputMaybe<Scalars["String"]>;
  d3?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  initialTpa?: InputMaybe<Scalars["String"]>;
  postOpTpa?: InputMaybe<Scalars["String"]>;
  rotationNeeded?: InputMaybe<Scalars["String"]>;
  tploBladeSize?: InputMaybe<Scalars["String"]>;
  tploPlateSizeAndModel?: InputMaybe<Scalars["String"]>;
};

export type UpdateTibialPlateauLevelingOsteotomyPlanningPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  tibialPlateauLevelingOsteotomyPlanning?: Maybe<
    TibialPlateauLevelingOsteotomyPlanning
  >;
};

export type UpdateTreatmentInput = {
  _id: Scalars["Int"];
  cereniaInjection?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  laserTherapy?: InputMaybe<Scalars["Boolean"]>;
  microchip?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateTreatmentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  cereniaInjection?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  laserTherapy?: InputMaybe<Scalars["Boolean"]>;
  microchip?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateTreatmentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  treatment?: Maybe<Treatment>;
};

export type UpdateUserInput = {
  _id: Scalars["Int"];
  active?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  image?: InputMaybe<UpdateFileNestedInput>;
  lastName?: InputMaybe<Scalars["String"]>;
  plainPassword?: InputMaybe<Scalars["String"]>;
  plainPin?: InputMaybe<Scalars["Int"]>;
  userRole?: InputMaybe<UserRoleEnum>;
};

export type UpdateUserNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  active?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  image?: InputMaybe<UpdateFileNestedInput>;
  lastName?: InputMaybe<Scalars["String"]>;
  plainPassword?: InputMaybe<Scalars["String"]>;
  plainPin?: InputMaybe<Scalars["Int"]>;
  userRole?: InputMaybe<UserRoleEnum>;
};

export type UpdateUserPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
};

export type UpdateVaccineInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  toPerform?: InputMaybe<Scalars["Boolean"]>;
  vaccine?: InputMaybe<VaccineEnum>;
};

export type UpdateVaccineNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  toPerform?: InputMaybe<Scalars["Boolean"]>;
  vaccine?: InputMaybe<VaccineEnum>;
};

export type UpdateVaccinePayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vaccine?: Maybe<Vaccine>;
};

export type UpdateVitalCommentInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  qualityRecovery?: InputMaybe<QualityRecoveryEnum>;
  timeExtubation?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateVitalCommentNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  comment?: InputMaybe<Scalars["String"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  qualityRecovery?: InputMaybe<QualityRecoveryEnum>;
  timeExtubation?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateVitalCommentPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vitalComment?: Maybe<VitalComment>;
};

export type UpdateVitalInput = {
  _id: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diastolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  endTidal?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  pulseOximetry?: InputMaybe<Scalars["Float"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  systolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateVitalNestedInput = {
  _id?: InputMaybe<Scalars["Int"]>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  diastolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  endTidal?: InputMaybe<Scalars["Float"]>;
  fakeId?: InputMaybe<Scalars["String"]>;
  heartRate?: InputMaybe<Scalars["Int"]>;
  meanBloodPressure?: InputMaybe<Scalars["Float"]>;
  patient?: InputMaybe<Scalars["Int"]>;
  pulseOximetry?: InputMaybe<Scalars["Float"]>;
  respiratoryRate?: InputMaybe<Scalars["Int"]>;
  systolicBloodPressure?: InputMaybe<Scalars["Float"]>;
  timeMonitoring?: InputMaybe<Scalars["DateTime"]>;
};

export type UpdateVitalPayload = {
  clientMutationId?: Maybe<Scalars["String"]>;
  vital?: Maybe<Vital>;
};

export type UseCalculationsAnestheticProtocolInput = {
  anestheticProtocol: Scalars["Int"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
  patient: Scalars["Int"];
};

export type UseCalculationsAnestheticProtocolPayload = {
  calculationsAnestheticProtocol?: Maybe<CalculationsAnestheticProtocol>;
  clientMutationId?: Maybe<Scalars["String"]>;
};

export type GetAccessLogsQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
  filter?: InputMaybe<AccessLogFilter>;
  username?: InputMaybe<Scalars["String"]>;
}>;

export type GetAccessLogsQuery = {
  accessLogs?:
    | {
        collection: Array<{
          id: string;
          _id: number;
          accessStatus: AccessStatusEnum;
          accessTypeEnum: AccessTypeEnum;
          createdAt: any;
          ip: string;
          browser: string;
          user: {
            id: string;
            _id: number;
            firstName: string;
            lastName: string;
          };
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type LogPinLoginsMutationVariables = Exact<{
  input: LogBulkPinAuthenticationInput;
}>;

export type LogPinLoginsMutation = {
  logBulkPinAuthentication?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type GetEmailLogsQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
  filter?: InputMaybe<EmailLogFilter>;
}>;

export type GetEmailLogsQuery = {
  emailLogs?:
    | {
        collection: Array<{
          emailSubject: string;
          recipientsUsername?: string | null | undefined;
          recipientsEmail: string;
          sentAt: any;
          _id: number;
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type CreateLicenseMutationVariables = Exact<{
  input: CreateLicenseInput;
}>;

export type CreateLicenseMutation = {
  createLicense?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdateLicenseMutationVariables = Exact<{
  input: UpdateLicenseInput;
}>;

export type UpdateLicenseMutation = {
  updateLicense?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type DeleteLicenseMutationVariables = Exact<{
  id: Scalars["Int"];
}>;

export type DeleteLicenseMutation = {
  deleteLicense?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type GetLicenseQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type GetLicenseQuery = {
  license?:
    | {
        _id: number;
        name: string;
        period: LicensePeriodEnum;
        price: number;
        maxNumberOfUsers: number;
        active: boolean;
      }
    | null
    | undefined;
};

export type GetLicensesQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
  filter?: InputMaybe<LicenseFilter>;
}>;

export type GetLicensesQuery = {
  licenses?:
    | {
        collection: Array<{
          _id: number;
          name: string;
          period: LicensePeriodEnum;
          price: number;
          maxNumberOfUsers: number;
          active: boolean;
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;

export type CreateOrderMutation = {
  createOrder?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;

export type UpdateOrderMutation = {
  updateOrder?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars["Int"];
}>;

export type DeleteOrderMutation = {
  deleteOrder?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type GetOrderQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type GetOrderQuery = {
  order?:
    | {
        _id: number;
        startDate: any;
        expirationDate: any;
        price: number;
        license: { _id: number; price: number; period: LicensePeriodEnum };
        organization: { _id: number };
      }
    | null
    | undefined;
};

export type GetOrdersQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
}>;

export type GetOrdersQuery = {
  orders?:
    | {
        collection: Array<{
          _id: number;
          price: number;
          startDate: any;
          expirationDate: any;
          license: { _id: number; name: string };
          organization: { _id: number; name: string };
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type AdminOrganizationFragment = {
  _id: number;
  contactEmail?: string | null | undefined;
  description?: string | null | undefined;
  name: string;
  status: OrganizationStatusEnum;
  adminRegistrationCompleted: boolean;
  logo?: { _id: number } | null | undefined;
};

export type GetAdminOrganizationQueryVariables = Exact<{
  _id: Scalars["Int"];
  filter?: InputMaybe<UserFilter>;
  page?: InputMaybe<Scalars["Int"]>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
}>;

export type GetAdminOrganizationQuery = {
  organization?:
    | {
        _id: number;
        contactEmail?: string | null | undefined;
        description?: string | null | undefined;
        name: string;
        status: OrganizationStatusEnum;
        adminRegistrationCompleted: boolean;
        users?:
          | {
              collection: Array<{
                id: string;
                _id: number;
                firstName: string;
                lastName: string;
                email: string;
                userRole: UserRoleEnum;
                image?: { _id: number } | null | undefined;
              }>;
              paginationInfo: { totalCount: number };
            }
          | null
          | undefined;
        logo?: { _id: number } | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateAdminOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;

export type UpdateAdminOrganizationMutation = {
  updateOrganization?:
    | {
        organization?:
          | {
              _id: number;
              contactEmail?: string | null | undefined;
              description?: string | null | undefined;
              name: string;
              status: OrganizationStatusEnum;
              adminRegistrationCompleted: boolean;
              logo?: { _id: number } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetOrganizationsQueryVariables = Exact<{
  perPage: Scalars["Int"];
  page: Scalars["Int"];
  filter?: InputMaybe<OrganizationFilter>;
}>;

export type GetOrganizationsQuery = {
  organizations?:
    | {
        collection: Array<{
          _id: number;
          contactEmail?: string | null | undefined;
          description?: string | null | undefined;
          name: string;
          status: OrganizationStatusEnum;
          adminRegistrationCompleted: boolean;
          logo?: { _id: number } | null | undefined;
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationRegistrationInput;
}>;

export type CreateOrganizationMutation = {
  createOrganizationRegistration?:
    | {
        organizationRegistration?:
          | { id: string; fakeId?: string | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetOrganizationAdminUserQueryVariables = Exact<{
  organization: Scalars["Int"];
}>;

export type GetOrganizationAdminUserQuery = {
  organizationAdminUser?:
    | {
        _id: number;
        firstName: string;
        lastName: string;
        email: string;
        image?: { _id: number } | null | undefined;
      }
    | null
    | undefined;
};

export type ResendOrganizationInviteMutationVariables = Exact<{
  input: ResendOrganizationInviteInput;
}>;

export type ResendOrganizationInviteMutation = {
  resendOrganizationInvite?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type GetReportQueryVariables = Exact<{
  dateFilter?: InputMaybe<Scalars["DateTime"]>;
}>;

export type GetReportQuery = {
  reportOrganizationCounter?:
    | {
        _id: string;
        activeOrganizationsCount: number;
        archivedOrganizationsCount: number;
        usersCount: number;
      }
    | null
    | undefined;
};

export type GetOrganizationsReportQueryVariables = Exact<{
  dateFilter?: InputMaybe<Scalars["DateTime"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
}>;

export type GetOrganizationsReportQuery = {
  reportOrganizationUserMedicalCaseCounters?:
    | {
        collection: Array<{
          id: string;
          medicalCaseCount: number;
          organizationName: string;
          userCount: number;
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type GetAnestheticProtocolQueryVariables = Exact<{
  _id: Scalars["Int"];
}>;

export type GetAnestheticProtocolQuery = {
  anestheticProtocol?:
    | {
        defaultProtocol: boolean;
        name: string;
        _id: number;
        createdBy: { _id: number };
        medicationCalculations?:
          | {
              collection: Array<{
                type: MedicationCalculationTypeEnum;
                concentration: number;
                dose: number;
                route: RouteEnum;
                medication: string;
                additionalVolumeAdministered?: number | null | undefined;
                additionalVolumeDrawn?: number | null | undefined;
                volumeAdministered?: number | null | undefined;
                _id: number;
              }>;
            }
          | null
          | undefined;
        regionalBlocks?:
          | {
              collection: Array<{
                _id: number;
                type: RegionalBlockTypeEnum;
                concentration: number;
                doseMax: number;
                doseMin: number;
                volumeToBeInfused?: number | null | undefined;
                medication: string;
              }>;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateAnestheticProtocolMedicationCalculationMutationVariables = Exact<{
  input: CreateAnestheticProtocolMedicationCalculationInput;
}>;

export type CreateAnestheticProtocolMedicationCalculationMutation = {
  createAnestheticProtocolMedicationCalculation?:
    | {
        anestheticProtocolMedicationCalculation?:
          | {
              type: MedicationCalculationTypeEnum;
              concentration: number;
              dose: number;
              route: RouteEnum;
              medication: string;
              additionalVolumeAdministered?: number | null | undefined;
              additionalVolumeDrawn?: number | null | undefined;
              volumeAdministered?: number | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateAnestheticProtocolMedicationCalculationMutationVariables = Exact<{
  input: UpdateAnestheticProtocolMedicationCalculationInput;
}>;

export type UpdateAnestheticProtocolMedicationCalculationMutation = {
  updateAnestheticProtocolMedicationCalculation?:
    | {
        anestheticProtocolMedicationCalculation?:
          | {
              type: MedicationCalculationTypeEnum;
              concentration: number;
              dose: number;
              route: RouteEnum;
              medication: string;
              additionalVolumeAdministered?: number | null | undefined;
              additionalVolumeDrawn?: number | null | undefined;
              volumeAdministered?: number | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteAnestheticProtocolMedicationCalculationsMutationVariables = Exact<{
  input: RemoveBulkAnestheticProtocolMedicationCalculationInput;
}>;

export type DeleteAnestheticProtocolMedicationCalculationsMutation = {
  removeBulkAnestheticProtocolMedicationCalculation?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type CreateAnestheticProtocolRegionalBlockMutationVariables = Exact<{
  input: CreateAnestheticProtocolRegionalBlockInput;
}>;

export type CreateAnestheticProtocolRegionalBlockMutation = {
  createAnestheticProtocolRegionalBlock?:
    | {
        anestheticProtocolRegionalBlock?:
          | {
              _id: number;
              type: RegionalBlockTypeEnum;
              concentration: number;
              doseMax: number;
              doseMin: number;
              volumeToBeInfused?: number | null | undefined;
              medication: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateAnestheticProtocolRegionalBlockMutationVariables = Exact<{
  input: UpdateAnestheticProtocolRegionalBlockInput;
}>;

export type UpdateAnestheticProtocolRegionalBlockMutation = {
  updateAnestheticProtocolRegionalBlock?:
    | {
        anestheticProtocolRegionalBlock?:
          | {
              _id: number;
              type: RegionalBlockTypeEnum;
              concentration: number;
              doseMax: number;
              doseMin: number;
              volumeToBeInfused?: number | null | undefined;
              medication: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteAnestheticProtocolRegionalBlocksMutationVariables = Exact<{
  input: RemoveBulkAnestheticProtocolRegionalBlockInput;
}>;

export type DeleteAnestheticProtocolRegionalBlocksMutation = {
  removeBulkAnestheticProtocolRegionalBlock?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UseCalculationsAnestheticProtocolMutationVariables = Exact<{
  input: UseCalculationsAnestheticProtocolInput;
}>;

export type UseCalculationsAnestheticProtocolMutation = {
  useCalculationsAnestheticProtocol?:
    | {
        calculationsAnestheticProtocol?:
          | {
              medicationCalculations: Array<{
                _id: number;
                calculationType: MedicationCalculationTypeEnum;
                medication: string;
                dose: number;
                concentration: number;
                route: RouteEnum;
                initials?: string | null | undefined;
                timeAdministered?: any | null | undefined;
                totalAmount?: number | null | undefined;
                volumeAdministered?: number | null | undefined;
                totalVolume?: number | null | undefined;
                additionalVolumeAdministered?: number | null | undefined;
                additionalVolumeDrawn?: number | null | undefined;
              }>;
              regionalBlocks: Array<{
                concentration: number;
                dosageMax?: number | null | undefined;
                dosageMin?: number | null | undefined;
                doseMax: number;
                doseMin: number;
                type: RegionalBlockTypeEnum;
                volumeRangeMax?: number | null | undefined;
                volumeRangeMin?: number | null | undefined;
                volumeToBeInfused?: number | null | undefined;
                medication: string;
                initials?: string | null | undefined;
                _id: number;
              }>;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type AnestheticProtocolMedicationCalculationFragment = {
  type: MedicationCalculationTypeEnum;
  concentration: number;
  dose: number;
  route: RouteEnum;
  medication: string;
  additionalVolumeAdministered?: number | null | undefined;
  additionalVolumeDrawn?: number | null | undefined;
  volumeAdministered?: number | null | undefined;
  _id: number;
};

export type AnestheticProtocolRegionalBlockFragment = {
  _id: number;
  type: RegionalBlockTypeEnum;
  concentration: number;
  doseMax: number;
  doseMin: number;
  volumeToBeInfused?: number | null | undefined;
  medication: string;
};

export type AnestheticProtocolFragment = {
  defaultProtocol: boolean;
  name: string;
  _id: number;
  createdBy: { _id: number };
  medicationCalculations?:
    | {
        collection: Array<{
          type: MedicationCalculationTypeEnum;
          concentration: number;
          dose: number;
          route: RouteEnum;
          medication: string;
          additionalVolumeAdministered?: number | null | undefined;
          additionalVolumeDrawn?: number | null | undefined;
          volumeAdministered?: number | null | undefined;
          _id: number;
        }>;
      }
    | null
    | undefined;
  regionalBlocks?:
    | {
        collection: Array<{
          _id: number;
          type: RegionalBlockTypeEnum;
          concentration: number;
          doseMax: number;
          doseMin: number;
          volumeToBeInfused?: number | null | undefined;
          medication: string;
        }>;
      }
    | null
    | undefined;
};

export type AnestheticProtocolsQueryVariables = Exact<{
  filter?: InputMaybe<AnestheticProtocolFilter>;
  search?: InputMaybe<Scalars["String"]>;
}>;

export type AnestheticProtocolsQuery = {
  defaultProtocols?:
    | {
        collection: Array<{
          defaultProtocol: boolean;
          name: string;
          _id: number;
          createdBy: { _id: number };
          medicationCalculations?:
            | {
                collection: Array<{
                  type: MedicationCalculationTypeEnum;
                  concentration: number;
                  dose: number;
                  route: RouteEnum;
                  medication: string;
                  additionalVolumeAdministered?: number | null | undefined;
                  additionalVolumeDrawn?: number | null | undefined;
                  volumeAdministered?: number | null | undefined;
                  _id: number;
                }>;
              }
            | null
            | undefined;
          regionalBlocks?:
            | {
                collection: Array<{
                  _id: number;
                  type: RegionalBlockTypeEnum;
                  concentration: number;
                  doseMax: number;
                  doseMin: number;
                  volumeToBeInfused?: number | null | undefined;
                  medication: string;
                }>;
              }
            | null
            | undefined;
        }>;
      }
    | null
    | undefined;
  anestheticProtocols?:
    | {
        collection: Array<{
          defaultProtocol: boolean;
          name: string;
          _id: number;
          createdBy: { _id: number };
          medicationCalculations?:
            | {
                collection: Array<{
                  type: MedicationCalculationTypeEnum;
                  concentration: number;
                  dose: number;
                  route: RouteEnum;
                  medication: string;
                  additionalVolumeAdministered?: number | null | undefined;
                  additionalVolumeDrawn?: number | null | undefined;
                  volumeAdministered?: number | null | undefined;
                  _id: number;
                }>;
              }
            | null
            | undefined;
          regionalBlocks?:
            | {
                collection: Array<{
                  _id: number;
                  type: RegionalBlockTypeEnum;
                  concentration: number;
                  doseMax: number;
                  doseMin: number;
                  volumeToBeInfused?: number | null | undefined;
                  medication: string;
                }>;
              }
            | null
            | undefined;
        }>;
      }
    | null
    | undefined;
};

export type CreateAnestheticProtocolMutationVariables = Exact<{
  input: CreateAnestheticProtocolInput;
}>;

export type CreateAnestheticProtocolMutation = {
  createAnestheticProtocol?:
    | {
        anestheticProtocol?:
          | {
              defaultProtocol: boolean;
              name: string;
              _id: number;
              createdBy: { _id: number };
              medicationCalculations?:
                | {
                    collection: Array<{
                      type: MedicationCalculationTypeEnum;
                      concentration: number;
                      dose: number;
                      route: RouteEnum;
                      medication: string;
                      additionalVolumeAdministered?: number | null | undefined;
                      additionalVolumeDrawn?: number | null | undefined;
                      volumeAdministered?: number | null | undefined;
                      _id: number;
                    }>;
                  }
                | null
                | undefined;
              regionalBlocks?:
                | {
                    collection: Array<{
                      _id: number;
                      type: RegionalBlockTypeEnum;
                      concentration: number;
                      doseMax: number;
                      doseMin: number;
                      volumeToBeInfused?: number | null | undefined;
                      medication: string;
                    }>;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateAnestheticProtocolMutationVariables = Exact<{
  input: UpdateAnestheticProtocolInput;
}>;

export type UpdateAnestheticProtocolMutation = {
  updateAnestheticProtocol?:
    | {
        anestheticProtocol?:
          | {
              defaultProtocol: boolean;
              name: string;
              _id: number;
              createdBy: { _id: number };
              medicationCalculations?:
                | {
                    collection: Array<{
                      type: MedicationCalculationTypeEnum;
                      concentration: number;
                      dose: number;
                      route: RouteEnum;
                      medication: string;
                      additionalVolumeAdministered?: number | null | undefined;
                      additionalVolumeDrawn?: number | null | undefined;
                      volumeAdministered?: number | null | undefined;
                      _id: number;
                    }>;
                  }
                | null
                | undefined;
              regionalBlocks?:
                | {
                    collection: Array<{
                      _id: number;
                      type: RegionalBlockTypeEnum;
                      concentration: number;
                      doseMax: number;
                      doseMin: number;
                      volumeToBeInfused?: number | null | undefined;
                      medication: string;
                    }>;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteAnestheticProtocolsMutationVariables = Exact<{
  input: RemoveBulkAnestheticProtocolInput;
}>;

export type DeleteAnestheticProtocolsMutation = {
  removeBulkAnestheticProtocol?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type SettingsFragment = {
  id: string;
  user: {
    _id: number;
    pin?: string | null | undefined;
    firstName: string;
    lastName: string;
    userRole: UserRoleEnum;
    email: string;
    organization?:
      | {
          name: string;
          _id: number;
          organizationSetting?:
            | {
                _id: number;
                dateFormat: DateFormatEnum;
                temperatureUnit: TemperatureUnitEnum;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    image?: { _id: number; path: string } | null | undefined;
  };
};

export type LoginMutationVariables = Exact<{
  username: Scalars["String"];
  password: Scalars["String"];
}>;

export type LoginMutation = {
  createAuthentication?:
    | {
        authentication?:
          | {
              id: string;
              sessionId: string;
              applicationSettings: {
                id: string;
                user: {
                  _id: number;
                  pin?: string | null | undefined;
                  firstName: string;
                  lastName: string;
                  userRole: UserRoleEnum;
                  email: string;
                  organization?:
                    | {
                        name: string;
                        _id: number;
                        organizationSetting?:
                          | {
                              _id: number;
                              dateFormat: DateFormatEnum;
                              temperatureUnit: TemperatureUnitEnum;
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                  image?: { _id: number; path: string } | null | undefined;
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetApplicationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetApplicationSettingsQuery = {
  applicationSettings?:
    | {
        id: string;
        user: {
          _id: number;
          pin?: string | null | undefined;
          firstName: string;
          lastName: string;
          userRole: UserRoleEnum;
          email: string;
          organization?:
            | {
                name: string;
                _id: number;
                organizationSetting?:
                  | {
                      _id: number;
                      dateFormat: DateFormatEnum;
                      temperatureUnit: TemperatureUnitEnum;
                    }
                  | null
                  | undefined;
              }
            | null
            | undefined;
          image?: { _id: number; path: string } | null | undefined;
        };
      }
    | null
    | undefined;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  createLogout?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type ResetPasswordMutation = {
  createPasswordRecoveryRequest?:
    | { passwordRecoveryRequest?: { id: string } | null | undefined }
    | null
    | undefined;
};

export type PasswordChangeMutationVariables = Exact<{
  password: Scalars["String"];
  token: Scalars["String"];
}>;

export type PasswordChangeMutation = {
  createPasswordChange?:
    | {
        passwordChange?:
          | {
              id: string;
              sessionId: string;
              applicationSettings: {
                id: string;
                user: {
                  _id: number;
                  pin?: string | null | undefined;
                  firstName: string;
                  lastName: string;
                  userRole: UserRoleEnum;
                  email: string;
                  organization?:
                    | {
                        name: string;
                        _id: number;
                        organizationSetting?:
                          | {
                              _id: number;
                              dateFormat: DateFormatEnum;
                              temperatureUnit: TemperatureUnitEnum;
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                  image?: { _id: number; path: string } | null | undefined;
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CompleteRegistrationMutationVariables = Exact<{
  input: CreateRegistrationCompletionInput;
}>;

export type CompleteRegistrationMutation = {
  createRegistrationCompletion?:
    | {
        registrationCompletion?:
          | {
              id: string;
              sessionId: string;
              applicationSettings: {
                id: string;
                user: {
                  _id: number;
                  pin?: string | null | undefined;
                  firstName: string;
                  lastName: string;
                  userRole: UserRoleEnum;
                  email: string;
                  organization?:
                    | {
                        name: string;
                        _id: number;
                        organizationSetting?:
                          | {
                              _id: number;
                              dateFormat: DateFormatEnum;
                              temperatureUnit: TemperatureUnitEnum;
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                  image?: { _id: number; path: string } | null | undefined;
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetStatesQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
  ids?: InputMaybe<
    Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>
  >;
  search?: InputMaybe<Scalars["String"]>;
}>;

export type GetStatesQuery = {
  states?:
    | {
        collection: Array<{ _id: string; name: string }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type GetCitiesQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
  ids?: InputMaybe<
    Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>
  >;
  search?: InputMaybe<Scalars["String"]>;
  stateId?: InputMaybe<Scalars["String"]>;
}>;

export type GetCitiesQuery = {
  cities?:
    | {
        collection: Array<{
          _id: string;
          name: string;
          state: { _id: string; name: string };
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type GetZipCodesQueryVariables = Exact<{
  page: Scalars["Int"];
  perPage: Scalars["Int"];
  ids?: InputMaybe<
    Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>
  >;
  cityId?: InputMaybe<Scalars["String"]>;
  stateId?: InputMaybe<Scalars["String"]>;
  search?: InputMaybe<Scalars["String"]>;
}>;

export type GetZipCodesQuery = {
  zipCodes?:
    | {
        collection: Array<{
          _id: string;
          zipCode: string;
          city: {
            _id: string;
            name: string;
            state: { _id: string; name: string };
          };
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type GetMercuryUrlQueryVariables = Exact<{
  caseId: Scalars["Int"];
}>;

export type GetMercuryUrlQuery = {
  medicalCase?:
    | {
        mercureUrl?: string | null | undefined;
        _id: number;
        name: string;
        createdAt: any;
        status: CaseStatusEnum;
        fromVetspire: boolean;
        disclaimerText: string;
        createdFrom?: { _id: number; name: string } | null | undefined;
        authorizations?:
          | {
              collection: Array<{
                _id: number;
                selected: boolean;
                condition: string;
              }>;
            }
          | null
          | undefined;
        disclaimerProcedures?:
          | {
              collection: Array<{
                _id: number;
                description: string;
                selected: boolean;
                title: string;
              }>;
            }
          | null
          | undefined;
        client: {
          _id: number;
          accountNumber?: string | null | undefined;
          email?: string | null | undefined;
          firstName?: string | null | undefined;
          lastName?: string | null | undefined;
          phoneFirst?: string | null | undefined;
          phoneSecond?: string | null | undefined;
          notAvailableTime?: string | null | undefined;
          streetAddress?: string | null | undefined;
          apartments?: string | null | undefined;
          zipCode?: string | null | undefined;
          patient: {
            anestheticGasMedication: AnestheticGasMedicationEnum;
            _id: number;
            name?: string | null | undefined;
            sex?: PatientSexEnum | null | undefined;
            species?: SpeciesEnum | null | undefined;
            breed?: string | null | undefined;
            dateOfBirth?: any | null | undefined;
            weight?: number | null | undefined;
            weightMeasure: WeightMeasureEnum;
            procedureDate: any;
            alerts?: string | null | undefined;
            procedures: Array<string>;
            image?: { _id: number } | null | undefined;
            dropOff: {
              _id: number;
              admittingConcern?: string | null | undefined;
              evaluateTestAndTreat: boolean;
              performInitialEvaluation: boolean;
              doctor?:
                | { _id: number; firstName: string; lastName: string }
                | null
                | undefined;
            };
            vaccines?:
              | {
                  collection: Array<{
                    vaccine: VaccineEnum;
                    _id: number;
                    toPerform: boolean;
                  }>;
                }
              | null
              | undefined;
            patientTests?:
              | {
                  collection: Array<{
                    test: PatientTestEnum;
                    _id: number;
                    toPerform: boolean;
                  }>;
                }
              | null
              | undefined;
            treatment?:
              | {
                  cereniaInjection: boolean;
                  laserTherapy: boolean;
                  microchip: boolean;
                  _id: number;
                }
              | null
              | undefined;
            examNote: {
              _id: number;
              additionalNotes?: string | null | undefined;
              allergies?: string | null | undefined;
              bloodwork?: string | null | undefined;
              lastMealAt?: any | null | undefined;
              patientPersonalItems?: string | null | undefined;
              previousSurgery?: string | null | undefined;
              treatmentPlan?: string | null | undefined;
              vaccines?: string | null | undefined;
            };
            currentMedications?:
              | {
                  collection: Array<{
                    _id: number;
                    medication?: string | null | undefined;
                    dose: string;
                    frequency: MedicationFrequencyEnum;
                    lastGivenAt: any;
                  }>;
                }
              | null
              | undefined;
            preAnestheticExam: {
              _id: number;
              temperature?: number | null | undefined;
              heartRate?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              painScore?: number | null | undefined;
              bodyConditionScore?: number | null | undefined;
              dentalScore?: number | null | undefined;
              physicalStatus?: PatientPhysicalStatus | null | undefined;
            };
            physicalExam: {
              _id: number;
              generalAppearance?: PatientStateEnum | null | undefined;
              generalAppearanceAbnormalStateComments?:
                | string
                | null
                | undefined;
              gastrointestinal?: PatientStateEnum | null | undefined;
              gastrointestinalAbnormalStateComments?: string | null | undefined;
              oralCavity?: PatientStateEnum | null | undefined;
              oralCavityAbnormalStateComments?: string | null | undefined;
              musculosceletal?: PatientStateEnum | null | undefined;
              musculosceletalAbnormalStateComments?: string | null | undefined;
              mucousMembranes?: PatientStateEnum | null | undefined;
              mucousMembranesAbnormalStateComments?: string | null | undefined;
              lymphNodes?: PatientStateEnum | null | undefined;
              lymphNodesAbnormalStateComments?: string | null | undefined;
              eyes?: PatientStateEnum | null | undefined;
              eyesAbnormalStateComments?: string | null | undefined;
              urogenital?: PatientStateEnum | null | undefined;
              urogenitalAbnormalStateComments?: string | null | undefined;
              ears?: PatientStateEnum | null | undefined;
              earsAbnormalStateComments?: string | null | undefined;
              integumentary?: PatientStateEnum | null | undefined;
              integumentaryAbnormalStateComments?: string | null | undefined;
              cardiovascular?: PatientStateEnum | null | undefined;
              cardiovascularAbnormalStateComments?: string | null | undefined;
              nervousSystem?: PatientStateEnum | null | undefined;
              nervousSystemAbnormalStateComments?: string | null | undefined;
              respiratory?: PatientStateEnum | null | undefined;
              respiratoryAbnormalStateComments?: string | null | undefined;
            };
            diagnosticTesting: {
              _id: number;
              abnormalitiesAndNotes?: string | null | undefined;
              reviewedByDvm?: boolean | null | undefined;
              additionalTests?:
                | {
                    collection: Array<{
                      _id: number;
                      toPerform: boolean;
                      test: string;
                    }>;
                  }
                | null
                | undefined;
              doctor?:
                | { _id: number; firstName: string; lastName: string }
                | null
                | undefined;
            };
            patientProcedures?:
              | {
                  collection: Array<{
                    endTime?: any | null | undefined;
                    name?: string | null | undefined;
                    startTime?: any | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            fluidTemperatures?:
              | {
                  collection: Array<{
                    _id: number;
                    fluidRate?: number | null | undefined;
                    temperature?: number | null | undefined;
                    timeMonitoring?: any | null | undefined;
                    volumeInfused?: number | null | undefined;
                    volumeToBeInfused?: number | null | undefined;
                  }>;
                }
              | null
              | undefined;
            anestheticGases?:
              | {
                  collection: Array<{
                    inhalantAnestheticAgent?: number | null | undefined;
                    oxygen?: number | null | undefined;
                    timeMonitoring?: any | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            vitals?:
              | {
                  collection: Array<{
                    diastolicBloodPressure?: number | null | undefined;
                    endTidal?: number | null | undefined;
                    heartRate?: number | null | undefined;
                    meanBloodPressure?: number | null | undefined;
                    pulseOximetry?: number | null | undefined;
                    respiratoryRate?: number | null | undefined;
                    systolicBloodPressure?: number | null | undefined;
                    timeMonitoring?: any | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            medicationCalculations?:
              | {
                  collection: Array<{
                    _id: number;
                    calculationType: MedicationCalculationTypeEnum;
                    medication: string;
                    dose: number;
                    concentration: number;
                    route: RouteEnum;
                    initials?: string | null | undefined;
                    timeAdministered?: any | null | undefined;
                    totalAmount?: number | null | undefined;
                    volumeAdministered?: number | null | undefined;
                    totalVolume?: number | null | undefined;
                    additionalVolumeAdministered?: number | null | undefined;
                    additionalVolumeDrawn?: number | null | undefined;
                  }>;
                }
              | null
              | undefined;
            miscellaneousGroup?:
              | {
                  _id: number;
                  catheterSize?: number | null | undefined;
                  catheterLocation?: CatheterLocationEnum | null | undefined;
                  fluidType?: string | null | undefined;
                  bloodPressureMonitoring?:
                    | BloodPressureMonitoringEnum
                    | null
                    | undefined;
                  fluidRate?: number | null | undefined;
                  fluidRateValue?: number | null | undefined;
                  qualityOfSedation?: QualityOfSedationEnum | null | undefined;
                  anesthesiaSystem?: AnesthesiaSystemEnum | null | undefined;
                  bagSize?: number | null | undefined;
                  oxygenFlowRate?: number | null | undefined;
                  intubated?: boolean | null | undefined;
                  endotrachealTubeSize?: string | null | undefined;
                }
              | null
              | undefined;
            defibMedications?:
              | {
                  collection: Array<{
                    _id: number;
                    doseMax: number;
                    doseMin: number;
                    timeAdministered?: any | null | undefined;
                    medication: string;
                    dosageMax?: number | null | undefined;
                    dosageMin?: number | null | undefined;
                    initials?: string | null | undefined;
                  }>;
                }
              | null
              | undefined;
            fluidBolus?:
              | { _id: number; totalAmount?: number | null | undefined }
              | null
              | undefined;
            monitoring: {
              _id: number;
              monitoringBy?: { _id: number } | null | undefined;
            };
            vitalComment?:
              | {
                  _id: number;
                  comment?: string | null | undefined;
                  qualityRecovery?: QualityRecoveryEnum | null | undefined;
                  timeExtubation?: any | null | undefined;
                }
              | null
              | undefined;
            regionalBlocks?:
              | {
                  collection: Array<{
                    concentration: number;
                    dosageMax?: number | null | undefined;
                    dosageMin?: number | null | undefined;
                    doseMax: number;
                    doseMin: number;
                    type: RegionalBlockTypeEnum;
                    volumeRangeMax?: number | null | undefined;
                    volumeRangeMin?: number | null | undefined;
                    volumeToBeInfused?: number | null | undefined;
                    medication: string;
                    initials?: string | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            tablets?:
              | {
                  collection: Array<{
                    _id: number;
                    dosage: number;
                    dose: number;
                    labelInstructions?: string | null | undefined;
                    numberOfTablets?: number | null | undefined;
                    tabletSize?: number | null | undefined;
                    medication: string;
                  }>;
                }
              | null
              | undefined;
            suspensions?:
              | {
                  collection: Array<{
                    _id: number;
                    dose: number;
                    labelInstructions?: string | null | undefined;
                    totalVolume?: number | null | undefined;
                    volume: number;
                    medication: string;
                    concentration: number;
                  }>;
                }
              | null
              | undefined;
            tibialPlateauLevelingOsteotomyPlanning?:
              | {
                  _id: number;
                  d1?: string | null | undefined;
                  d2?: string | null | undefined;
                  d3?: string | null | undefined;
                  rotationNeeded?: string | null | undefined;
                  initialTpa?: string | null | undefined;
                  postOpTpa?: string | null | undefined;
                  tploBladeSize?: string | null | undefined;
                  tploPlateSizeAndModel?: string | null | undefined;
                }
              | null
              | undefined;
            postAnestheticVitals?:
              | {
                  collection: Array<{
                    comment?: string | null | undefined;
                    fluidRate?: number | null | undefined;
                    heartRate?: number | null | undefined;
                    initials?: string | null | undefined;
                    meanBloodPressure?: number | null | undefined;
                    painScore?: number | null | undefined;
                    respiratoryRate?: number | null | undefined;
                    temperature?: number | null | undefined;
                    timeMonitoring: any;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            postAnestheticVitalComment?:
              | {
                  _id: number;
                  comment?: string | null | undefined;
                  surgeryReport?: string | null | undefined;
                }
              | null
              | undefined;
            generalAssessment?:
              | {
                  _id: number;
                  notesTimer?: string | null | undefined;
                  periodontalDisease?:
                    | PeriodontalDiseaseEnum
                    | null
                    | undefined;
                  plaqueIndex?: PlaqueIndexEnum | null | undefined;
                  calculusIndex?: CalculusIndexEnum | null | undefined;
                  gingivalIndex?: GingivalIndexEnum | null | undefined;
                  additionalCommentsAndNotes?: string | null | undefined;
                  buccalMucosa?: OralStateEnum | null | undefined;
                  caudalOralMucosa?: OralStateEnum | null | undefined;
                  dentalChart?: DentalChartEnum | null | undefined;
                  extraoral?: OralStateEnum | null | undefined;
                  fistula?: boolean | null | undefined;
                  hardPalate?: OralStateEnum | null | undefined;
                  lymphNodes?: OralStateEnum | null | undefined;
                  occlusion?: OcclusionEnum | null | undefined;
                  occlusionDescription?: string | null | undefined;
                  parulisSinusTract?: boolean | null | undefined;
                  skullType?: SkullTypeEnum | null | undefined;
                  softPalate?: OralStateEnum | null | undefined;
                  tongue?: OralStateEnum | null | undefined;
                  tonsils?: OralStateEnum | null | undefined;
                  intraoralRadiographicComments?: string | null | undefined;
                  cbctComments?: string | null | undefined;
                  referralNotesAndComments?: string | null | undefined;
                  notesForClientDentalReport?: string | null | undefined;
                  rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                  rightInfraorbital?: number | null | undefined;
                  rightMaxillary?: number | null | undefined;
                  rightRostralMandibular?: number | null | undefined;
                  rightInferiorAlveolar?: number | null | undefined;
                  leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                  leftInfraorbital?: number | null | undefined;
                  leftMaxillary?: number | null | undefined;
                  leftRostralMandibular?: number | null | undefined;
                  leftInferiorAlveolar?: number | null | undefined;
                  oralSurgeries: Array<OralSurgeryEnum>;
                  orthodontics: Array<OrthodonticsEnum>;
                  periodontics: Array<PeriodonticsEnum>;
                  planingAndSubgingivalCurettage?:
                    | RootPlaningAndSubgingivalCurettageEnum
                    | null
                    | undefined;
                  boneAugmentation: boolean;
                  boneAugmentationDetails?: string | null | undefined;
                  treatmentAdditionalFindingsCommentsAndNotes?:
                    | string
                    | null
                    | undefined;
                  between25And50PerCentBoneLoss: Array<string>;
                  externalCervicalToothResorption: Array<string>;
                  externalInflammatoryToothResorption: Array<string>;
                  externalReplacementRootResorption: Array<string>;
                  externalSurfaceRootResorption: Array<string>;
                  greaterThan50PerCentBoneLoss: Array<string>;
                  internalToothResorption: Array<string>;
                  lessThan25PerCentBoneLoss: Array<string>;
                  missingTeeth: Array<string>;
                  periapicalLucency: Array<string>;
                  periapicalRarefaction: Array<string>;
                  retainedToothRoots: Array<string>;
                  toothResorptionType1: Array<string>;
                  toothResorptionType2: Array<string>;
                  toothResorptionType3: Array<string>;
                  uneruptedTeeth: Array<string>;
                  widenedPulpCanal: Array<string>;
                  beforePhotoFront?: { _id: number } | null | undefined;
                  beforePhotoLeft?: { _id: number } | null | undefined;
                  beforePhotoRight?: { _id: number } | null | undefined;
                  afterPhotoFront?: { _id: number } | null | undefined;
                  afterPhotoLeft?: { _id: number } | null | undefined;
                  afterPhotoRight?: { _id: number } | null | undefined;
                  additionalPhotos?:
                    | { collection: Array<{ _id: number }> }
                    | null
                    | undefined;
                  radiographicFindingsPhotos?:
                    | { collection: Array<{ _id: number }> }
                    | null
                    | undefined;
                }
              | null
              | undefined;
            dentalChartings?:
              | {
                  collection: Array<{
                    _id: number;
                    notesTimer?: string | null | undefined;
                    timerDurationSec: number;
                    toothState?: ToothStateEnum | null | undefined;
                    periodontal?: PeriodontalEnum | null | undefined;
                    furcation?: FurcationEnum | null | undefined;
                    mobility?: MobilityEnum | null | undefined;
                    gingivitis?: GingivitisEnum | null | undefined;
                    calculus?: CalculusEnum | null | undefined;
                    enamel?: EnamelEnum | null | undefined;
                    fracture?: FractureEnum | null | undefined;
                    resorption?: ResorptionEnum | null | undefined;
                    other: Array<OtherEnum>;
                    periodontalPocketMBuc?: number | null | undefined;
                    periodontalPocketBuccal?: number | null | undefined;
                    periodontalPocketDBuc?: number | null | undefined;
                    periodontalPocketMLingPal?: number | null | undefined;
                    periodontalPocketLingPal?: number | null | undefined;
                    periodontalPocketDLingPal?: number | null | undefined;
                    gingivalRecessionMBuc?: number | null | undefined;
                    gingivalRecessionBuccal?: number | null | undefined;
                    gingivalRecessionDBuc?: number | null | undefined;
                    gingivalRecessionMLingPal?: number | null | undefined;
                    gingivalRecessionLingPal?: number | null | undefined;
                    gingivalRecessionDLingPal?: number | null | undefined;
                    oralSurgeries: Array<ToothOralSurgeryEnum>;
                    sutureMaterial?: string | null | undefined;
                    restorations: Array<ToothRestorationEnum>;
                    restoratives?: string | null | undefined;
                    crCementation?: string | null | undefined;
                    endodontics: Array<ToothEndodonticsEnum>;
                    obturation?: string | null | undefined;
                    distalWorkingLength?: number | null | undefined;
                    mesialWorkingLength?: number | null | undefined;
                    palatalWorkingLength?: number | null | undefined;
                    distalMarFile?: number | null | undefined;
                    mesialMarFile?: number | null | undefined;
                    palatalMarFile?: number | null | undefined;
                    technique?: string | null | undefined;
                    treatmentComment?: string | null | undefined;
                    tooth: { _id: number; toothName: string };
                  }>;
                }
              | null
              | undefined;
            dentalSketch?: { _id: number; name: string } | null | undefined;
            dentalSketchComments?:
              | {
                  collection: Array<{
                    locationX: number;
                    locationY: number;
                    createdAt?: any | null | undefined;
                    text: string;
                    _id: number;
                    createdBy: {
                      _id: number;
                      firstName: string;
                      lastName: string;
                      image?: { _id: number } | null | undefined;
                    };
                  }>;
                }
              | null
              | undefined;
            calculationAgreement?:
              | {
                  _id: number;
                  signedAt?: any | null | undefined;
                  file?: { _id: number; name: string } | null | undefined;
                }
              | null
              | undefined;
          };
          disclaimer: {
            id: string;
            _id: number;
            createdAt: any;
            signature?:
              | { id: string; _id: number; name: string }
              | null
              | undefined;
          };
          city?:
            | {
                _id: string;
                name: string;
                state: { _id: string; name: string };
              }
            | null
            | undefined;
          state?: { _id: string; name: string } | null | undefined;
        };
      }
    | null
    | undefined;
};

export type GetFullMedicalCaseQueryVariables = Exact<{
  caseId: Scalars["Int"];
}>;

export type GetFullMedicalCaseQuery = {
  medicalCase?:
    | {
        _id: number;
        name: string;
        createdAt: any;
        status: CaseStatusEnum;
        fromVetspire: boolean;
        disclaimerText: string;
        createdFrom?: { _id: number; name: string } | null | undefined;
        authorizations?:
          | {
              collection: Array<{
                _id: number;
                selected: boolean;
                condition: string;
              }>;
            }
          | null
          | undefined;
        disclaimerProcedures?:
          | {
              collection: Array<{
                _id: number;
                description: string;
                selected: boolean;
                title: string;
              }>;
            }
          | null
          | undefined;
        client: {
          _id: number;
          accountNumber?: string | null | undefined;
          email?: string | null | undefined;
          firstName?: string | null | undefined;
          lastName?: string | null | undefined;
          phoneFirst?: string | null | undefined;
          phoneSecond?: string | null | undefined;
          notAvailableTime?: string | null | undefined;
          streetAddress?: string | null | undefined;
          apartments?: string | null | undefined;
          zipCode?: string | null | undefined;
          patient: {
            anestheticGasMedication: AnestheticGasMedicationEnum;
            _id: number;
            name?: string | null | undefined;
            sex?: PatientSexEnum | null | undefined;
            species?: SpeciesEnum | null | undefined;
            breed?: string | null | undefined;
            dateOfBirth?: any | null | undefined;
            weight?: number | null | undefined;
            weightMeasure: WeightMeasureEnum;
            procedureDate: any;
            alerts?: string | null | undefined;
            procedures: Array<string>;
            image?: { _id: number } | null | undefined;
            dropOff: {
              _id: number;
              admittingConcern?: string | null | undefined;
              evaluateTestAndTreat: boolean;
              performInitialEvaluation: boolean;
              doctor?:
                | { _id: number; firstName: string; lastName: string }
                | null
                | undefined;
            };
            vaccines?:
              | {
                  collection: Array<{
                    vaccine: VaccineEnum;
                    _id: number;
                    toPerform: boolean;
                  }>;
                }
              | null
              | undefined;
            patientTests?:
              | {
                  collection: Array<{
                    test: PatientTestEnum;
                    _id: number;
                    toPerform: boolean;
                  }>;
                }
              | null
              | undefined;
            treatment?:
              | {
                  cereniaInjection: boolean;
                  laserTherapy: boolean;
                  microchip: boolean;
                  _id: number;
                }
              | null
              | undefined;
            examNote: {
              _id: number;
              additionalNotes?: string | null | undefined;
              allergies?: string | null | undefined;
              bloodwork?: string | null | undefined;
              lastMealAt?: any | null | undefined;
              patientPersonalItems?: string | null | undefined;
              previousSurgery?: string | null | undefined;
              treatmentPlan?: string | null | undefined;
              vaccines?: string | null | undefined;
            };
            currentMedications?:
              | {
                  collection: Array<{
                    _id: number;
                    medication?: string | null | undefined;
                    dose: string;
                    frequency: MedicationFrequencyEnum;
                    lastGivenAt: any;
                  }>;
                }
              | null
              | undefined;
            preAnestheticExam: {
              _id: number;
              temperature?: number | null | undefined;
              heartRate?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              painScore?: number | null | undefined;
              bodyConditionScore?: number | null | undefined;
              dentalScore?: number | null | undefined;
              physicalStatus?: PatientPhysicalStatus | null | undefined;
            };
            physicalExam: {
              _id: number;
              generalAppearance?: PatientStateEnum | null | undefined;
              generalAppearanceAbnormalStateComments?:
                | string
                | null
                | undefined;
              gastrointestinal?: PatientStateEnum | null | undefined;
              gastrointestinalAbnormalStateComments?: string | null | undefined;
              oralCavity?: PatientStateEnum | null | undefined;
              oralCavityAbnormalStateComments?: string | null | undefined;
              musculosceletal?: PatientStateEnum | null | undefined;
              musculosceletalAbnormalStateComments?: string | null | undefined;
              mucousMembranes?: PatientStateEnum | null | undefined;
              mucousMembranesAbnormalStateComments?: string | null | undefined;
              lymphNodes?: PatientStateEnum | null | undefined;
              lymphNodesAbnormalStateComments?: string | null | undefined;
              eyes?: PatientStateEnum | null | undefined;
              eyesAbnormalStateComments?: string | null | undefined;
              urogenital?: PatientStateEnum | null | undefined;
              urogenitalAbnormalStateComments?: string | null | undefined;
              ears?: PatientStateEnum | null | undefined;
              earsAbnormalStateComments?: string | null | undefined;
              integumentary?: PatientStateEnum | null | undefined;
              integumentaryAbnormalStateComments?: string | null | undefined;
              cardiovascular?: PatientStateEnum | null | undefined;
              cardiovascularAbnormalStateComments?: string | null | undefined;
              nervousSystem?: PatientStateEnum | null | undefined;
              nervousSystemAbnormalStateComments?: string | null | undefined;
              respiratory?: PatientStateEnum | null | undefined;
              respiratoryAbnormalStateComments?: string | null | undefined;
            };
            diagnosticTesting: {
              _id: number;
              abnormalitiesAndNotes?: string | null | undefined;
              reviewedByDvm?: boolean | null | undefined;
              additionalTests?:
                | {
                    collection: Array<{
                      _id: number;
                      toPerform: boolean;
                      test: string;
                    }>;
                  }
                | null
                | undefined;
              doctor?:
                | { _id: number; firstName: string; lastName: string }
                | null
                | undefined;
            };
            patientProcedures?:
              | {
                  collection: Array<{
                    endTime?: any | null | undefined;
                    name?: string | null | undefined;
                    startTime?: any | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            fluidTemperatures?:
              | {
                  collection: Array<{
                    _id: number;
                    fluidRate?: number | null | undefined;
                    temperature?: number | null | undefined;
                    timeMonitoring?: any | null | undefined;
                    volumeInfused?: number | null | undefined;
                    volumeToBeInfused?: number | null | undefined;
                  }>;
                }
              | null
              | undefined;
            anestheticGases?:
              | {
                  collection: Array<{
                    inhalantAnestheticAgent?: number | null | undefined;
                    oxygen?: number | null | undefined;
                    timeMonitoring?: any | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            vitals?:
              | {
                  collection: Array<{
                    diastolicBloodPressure?: number | null | undefined;
                    endTidal?: number | null | undefined;
                    heartRate?: number | null | undefined;
                    meanBloodPressure?: number | null | undefined;
                    pulseOximetry?: number | null | undefined;
                    respiratoryRate?: number | null | undefined;
                    systolicBloodPressure?: number | null | undefined;
                    timeMonitoring?: any | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            medicationCalculations?:
              | {
                  collection: Array<{
                    _id: number;
                    calculationType: MedicationCalculationTypeEnum;
                    medication: string;
                    dose: number;
                    concentration: number;
                    route: RouteEnum;
                    initials?: string | null | undefined;
                    timeAdministered?: any | null | undefined;
                    totalAmount?: number | null | undefined;
                    volumeAdministered?: number | null | undefined;
                    totalVolume?: number | null | undefined;
                    additionalVolumeAdministered?: number | null | undefined;
                    additionalVolumeDrawn?: number | null | undefined;
                  }>;
                }
              | null
              | undefined;
            miscellaneousGroup?:
              | {
                  _id: number;
                  catheterSize?: number | null | undefined;
                  catheterLocation?: CatheterLocationEnum | null | undefined;
                  fluidType?: string | null | undefined;
                  bloodPressureMonitoring?:
                    | BloodPressureMonitoringEnum
                    | null
                    | undefined;
                  fluidRate?: number | null | undefined;
                  fluidRateValue?: number | null | undefined;
                  qualityOfSedation?: QualityOfSedationEnum | null | undefined;
                  anesthesiaSystem?: AnesthesiaSystemEnum | null | undefined;
                  bagSize?: number | null | undefined;
                  oxygenFlowRate?: number | null | undefined;
                  intubated?: boolean | null | undefined;
                  endotrachealTubeSize?: string | null | undefined;
                }
              | null
              | undefined;
            defibMedications?:
              | {
                  collection: Array<{
                    _id: number;
                    doseMax: number;
                    doseMin: number;
                    timeAdministered?: any | null | undefined;
                    medication: string;
                    dosageMax?: number | null | undefined;
                    dosageMin?: number | null | undefined;
                    initials?: string | null | undefined;
                  }>;
                }
              | null
              | undefined;
            fluidBolus?:
              | { _id: number; totalAmount?: number | null | undefined }
              | null
              | undefined;
            monitoring: {
              _id: number;
              monitoringBy?: { _id: number } | null | undefined;
            };
            vitalComment?:
              | {
                  _id: number;
                  comment?: string | null | undefined;
                  qualityRecovery?: QualityRecoveryEnum | null | undefined;
                  timeExtubation?: any | null | undefined;
                }
              | null
              | undefined;
            regionalBlocks?:
              | {
                  collection: Array<{
                    concentration: number;
                    dosageMax?: number | null | undefined;
                    dosageMin?: number | null | undefined;
                    doseMax: number;
                    doseMin: number;
                    type: RegionalBlockTypeEnum;
                    volumeRangeMax?: number | null | undefined;
                    volumeRangeMin?: number | null | undefined;
                    volumeToBeInfused?: number | null | undefined;
                    medication: string;
                    initials?: string | null | undefined;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            tablets?:
              | {
                  collection: Array<{
                    _id: number;
                    dosage: number;
                    dose: number;
                    labelInstructions?: string | null | undefined;
                    numberOfTablets?: number | null | undefined;
                    tabletSize?: number | null | undefined;
                    medication: string;
                  }>;
                }
              | null
              | undefined;
            suspensions?:
              | {
                  collection: Array<{
                    _id: number;
                    dose: number;
                    labelInstructions?: string | null | undefined;
                    totalVolume?: number | null | undefined;
                    volume: number;
                    medication: string;
                    concentration: number;
                  }>;
                }
              | null
              | undefined;
            tibialPlateauLevelingOsteotomyPlanning?:
              | {
                  _id: number;
                  d1?: string | null | undefined;
                  d2?: string | null | undefined;
                  d3?: string | null | undefined;
                  rotationNeeded?: string | null | undefined;
                  initialTpa?: string | null | undefined;
                  postOpTpa?: string | null | undefined;
                  tploBladeSize?: string | null | undefined;
                  tploPlateSizeAndModel?: string | null | undefined;
                }
              | null
              | undefined;
            postAnestheticVitals?:
              | {
                  collection: Array<{
                    comment?: string | null | undefined;
                    fluidRate?: number | null | undefined;
                    heartRate?: number | null | undefined;
                    initials?: string | null | undefined;
                    meanBloodPressure?: number | null | undefined;
                    painScore?: number | null | undefined;
                    respiratoryRate?: number | null | undefined;
                    temperature?: number | null | undefined;
                    timeMonitoring: any;
                    _id: number;
                  }>;
                }
              | null
              | undefined;
            postAnestheticVitalComment?:
              | {
                  _id: number;
                  comment?: string | null | undefined;
                  surgeryReport?: string | null | undefined;
                }
              | null
              | undefined;
            generalAssessment?:
              | {
                  _id: number;
                  notesTimer?: string | null | undefined;
                  periodontalDisease?:
                    | PeriodontalDiseaseEnum
                    | null
                    | undefined;
                  plaqueIndex?: PlaqueIndexEnum | null | undefined;
                  calculusIndex?: CalculusIndexEnum | null | undefined;
                  gingivalIndex?: GingivalIndexEnum | null | undefined;
                  additionalCommentsAndNotes?: string | null | undefined;
                  buccalMucosa?: OralStateEnum | null | undefined;
                  caudalOralMucosa?: OralStateEnum | null | undefined;
                  dentalChart?: DentalChartEnum | null | undefined;
                  extraoral?: OralStateEnum | null | undefined;
                  fistula?: boolean | null | undefined;
                  hardPalate?: OralStateEnum | null | undefined;
                  lymphNodes?: OralStateEnum | null | undefined;
                  occlusion?: OcclusionEnum | null | undefined;
                  occlusionDescription?: string | null | undefined;
                  parulisSinusTract?: boolean | null | undefined;
                  skullType?: SkullTypeEnum | null | undefined;
                  softPalate?: OralStateEnum | null | undefined;
                  tongue?: OralStateEnum | null | undefined;
                  tonsils?: OralStateEnum | null | undefined;
                  intraoralRadiographicComments?: string | null | undefined;
                  cbctComments?: string | null | undefined;
                  referralNotesAndComments?: string | null | undefined;
                  notesForClientDentalReport?: string | null | undefined;
                  rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                  rightInfraorbital?: number | null | undefined;
                  rightMaxillary?: number | null | undefined;
                  rightRostralMandibular?: number | null | undefined;
                  rightInferiorAlveolar?: number | null | undefined;
                  leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                  leftInfraorbital?: number | null | undefined;
                  leftMaxillary?: number | null | undefined;
                  leftRostralMandibular?: number | null | undefined;
                  leftInferiorAlveolar?: number | null | undefined;
                  oralSurgeries: Array<OralSurgeryEnum>;
                  orthodontics: Array<OrthodonticsEnum>;
                  periodontics: Array<PeriodonticsEnum>;
                  planingAndSubgingivalCurettage?:
                    | RootPlaningAndSubgingivalCurettageEnum
                    | null
                    | undefined;
                  boneAugmentation: boolean;
                  boneAugmentationDetails?: string | null | undefined;
                  treatmentAdditionalFindingsCommentsAndNotes?:
                    | string
                    | null
                    | undefined;
                  between25And50PerCentBoneLoss: Array<string>;
                  externalCervicalToothResorption: Array<string>;
                  externalInflammatoryToothResorption: Array<string>;
                  externalReplacementRootResorption: Array<string>;
                  externalSurfaceRootResorption: Array<string>;
                  greaterThan50PerCentBoneLoss: Array<string>;
                  internalToothResorption: Array<string>;
                  lessThan25PerCentBoneLoss: Array<string>;
                  missingTeeth: Array<string>;
                  periapicalLucency: Array<string>;
                  periapicalRarefaction: Array<string>;
                  retainedToothRoots: Array<string>;
                  toothResorptionType1: Array<string>;
                  toothResorptionType2: Array<string>;
                  toothResorptionType3: Array<string>;
                  uneruptedTeeth: Array<string>;
                  widenedPulpCanal: Array<string>;
                  beforePhotoFront?: { _id: number } | null | undefined;
                  beforePhotoLeft?: { _id: number } | null | undefined;
                  beforePhotoRight?: { _id: number } | null | undefined;
                  afterPhotoFront?: { _id: number } | null | undefined;
                  afterPhotoLeft?: { _id: number } | null | undefined;
                  afterPhotoRight?: { _id: number } | null | undefined;
                  additionalPhotos?:
                    | { collection: Array<{ _id: number }> }
                    | null
                    | undefined;
                  radiographicFindingsPhotos?:
                    | { collection: Array<{ _id: number }> }
                    | null
                    | undefined;
                }
              | null
              | undefined;
            dentalChartings?:
              | {
                  collection: Array<{
                    _id: number;
                    notesTimer?: string | null | undefined;
                    timerDurationSec: number;
                    toothState?: ToothStateEnum | null | undefined;
                    periodontal?: PeriodontalEnum | null | undefined;
                    furcation?: FurcationEnum | null | undefined;
                    mobility?: MobilityEnum | null | undefined;
                    gingivitis?: GingivitisEnum | null | undefined;
                    calculus?: CalculusEnum | null | undefined;
                    enamel?: EnamelEnum | null | undefined;
                    fracture?: FractureEnum | null | undefined;
                    resorption?: ResorptionEnum | null | undefined;
                    other: Array<OtherEnum>;
                    periodontalPocketMBuc?: number | null | undefined;
                    periodontalPocketBuccal?: number | null | undefined;
                    periodontalPocketDBuc?: number | null | undefined;
                    periodontalPocketMLingPal?: number | null | undefined;
                    periodontalPocketLingPal?: number | null | undefined;
                    periodontalPocketDLingPal?: number | null | undefined;
                    gingivalRecessionMBuc?: number | null | undefined;
                    gingivalRecessionBuccal?: number | null | undefined;
                    gingivalRecessionDBuc?: number | null | undefined;
                    gingivalRecessionMLingPal?: number | null | undefined;
                    gingivalRecessionLingPal?: number | null | undefined;
                    gingivalRecessionDLingPal?: number | null | undefined;
                    oralSurgeries: Array<ToothOralSurgeryEnum>;
                    sutureMaterial?: string | null | undefined;
                    restorations: Array<ToothRestorationEnum>;
                    restoratives?: string | null | undefined;
                    crCementation?: string | null | undefined;
                    endodontics: Array<ToothEndodonticsEnum>;
                    obturation?: string | null | undefined;
                    distalWorkingLength?: number | null | undefined;
                    mesialWorkingLength?: number | null | undefined;
                    palatalWorkingLength?: number | null | undefined;
                    distalMarFile?: number | null | undefined;
                    mesialMarFile?: number | null | undefined;
                    palatalMarFile?: number | null | undefined;
                    technique?: string | null | undefined;
                    treatmentComment?: string | null | undefined;
                    tooth: { _id: number; toothName: string };
                  }>;
                }
              | null
              | undefined;
            dentalSketch?: { _id: number; name: string } | null | undefined;
            dentalSketchComments?:
              | {
                  collection: Array<{
                    locationX: number;
                    locationY: number;
                    createdAt?: any | null | undefined;
                    text: string;
                    _id: number;
                    createdBy: {
                      _id: number;
                      firstName: string;
                      lastName: string;
                      image?: { _id: number } | null | undefined;
                    };
                  }>;
                }
              | null
              | undefined;
            calculationAgreement?:
              | {
                  _id: number;
                  signedAt?: any | null | undefined;
                  file?: { _id: number; name: string } | null | undefined;
                }
              | null
              | undefined;
          };
          disclaimer: {
            id: string;
            _id: number;
            createdAt: any;
            signature?:
              | { id: string; _id: number; name: string }
              | null
              | undefined;
          };
          city?:
            | {
                _id: string;
                name: string;
                state: { _id: string; name: string };
              }
            | null
            | undefined;
          state?: { _id: string; name: string } | null | undefined;
        };
      }
    | null
    | undefined;
};

export type AllCaseDataFragment = {
  _id: number;
  name: string;
  createdAt: any;
  status: CaseStatusEnum;
  fromVetspire: boolean;
  disclaimerText: string;
  createdFrom?: { _id: number; name: string } | null | undefined;
  authorizations?:
    | {
        collection: Array<{
          _id: number;
          selected: boolean;
          condition: string;
        }>;
      }
    | null
    | undefined;
  disclaimerProcedures?:
    | {
        collection: Array<{
          _id: number;
          description: string;
          selected: boolean;
          title: string;
        }>;
      }
    | null
    | undefined;
  client: {
    _id: number;
    accountNumber?: string | null | undefined;
    email?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    phoneFirst?: string | null | undefined;
    phoneSecond?: string | null | undefined;
    notAvailableTime?: string | null | undefined;
    streetAddress?: string | null | undefined;
    apartments?: string | null | undefined;
    zipCode?: string | null | undefined;
    patient: {
      anestheticGasMedication: AnestheticGasMedicationEnum;
      _id: number;
      name?: string | null | undefined;
      sex?: PatientSexEnum | null | undefined;
      species?: SpeciesEnum | null | undefined;
      breed?: string | null | undefined;
      dateOfBirth?: any | null | undefined;
      weight?: number | null | undefined;
      weightMeasure: WeightMeasureEnum;
      procedureDate: any;
      alerts?: string | null | undefined;
      procedures: Array<string>;
      image?: { _id: number } | null | undefined;
      dropOff: {
        _id: number;
        admittingConcern?: string | null | undefined;
        evaluateTestAndTreat: boolean;
        performInitialEvaluation: boolean;
        doctor?:
          | { _id: number; firstName: string; lastName: string }
          | null
          | undefined;
      };
      vaccines?:
        | {
            collection: Array<{
              vaccine: VaccineEnum;
              _id: number;
              toPerform: boolean;
            }>;
          }
        | null
        | undefined;
      patientTests?:
        | {
            collection: Array<{
              test: PatientTestEnum;
              _id: number;
              toPerform: boolean;
            }>;
          }
        | null
        | undefined;
      treatment?:
        | {
            cereniaInjection: boolean;
            laserTherapy: boolean;
            microchip: boolean;
            _id: number;
          }
        | null
        | undefined;
      examNote: {
        _id: number;
        additionalNotes?: string | null | undefined;
        allergies?: string | null | undefined;
        bloodwork?: string | null | undefined;
        lastMealAt?: any | null | undefined;
        patientPersonalItems?: string | null | undefined;
        previousSurgery?: string | null | undefined;
        treatmentPlan?: string | null | undefined;
        vaccines?: string | null | undefined;
      };
      currentMedications?:
        | {
            collection: Array<{
              _id: number;
              medication?: string | null | undefined;
              dose: string;
              frequency: MedicationFrequencyEnum;
              lastGivenAt: any;
            }>;
          }
        | null
        | undefined;
      preAnestheticExam: {
        _id: number;
        temperature?: number | null | undefined;
        heartRate?: number | null | undefined;
        respiratoryRate?: number | null | undefined;
        painScore?: number | null | undefined;
        bodyConditionScore?: number | null | undefined;
        dentalScore?: number | null | undefined;
        physicalStatus?: PatientPhysicalStatus | null | undefined;
      };
      physicalExam: {
        _id: number;
        generalAppearance?: PatientStateEnum | null | undefined;
        generalAppearanceAbnormalStateComments?: string | null | undefined;
        gastrointestinal?: PatientStateEnum | null | undefined;
        gastrointestinalAbnormalStateComments?: string | null | undefined;
        oralCavity?: PatientStateEnum | null | undefined;
        oralCavityAbnormalStateComments?: string | null | undefined;
        musculosceletal?: PatientStateEnum | null | undefined;
        musculosceletalAbnormalStateComments?: string | null | undefined;
        mucousMembranes?: PatientStateEnum | null | undefined;
        mucousMembranesAbnormalStateComments?: string | null | undefined;
        lymphNodes?: PatientStateEnum | null | undefined;
        lymphNodesAbnormalStateComments?: string | null | undefined;
        eyes?: PatientStateEnum | null | undefined;
        eyesAbnormalStateComments?: string | null | undefined;
        urogenital?: PatientStateEnum | null | undefined;
        urogenitalAbnormalStateComments?: string | null | undefined;
        ears?: PatientStateEnum | null | undefined;
        earsAbnormalStateComments?: string | null | undefined;
        integumentary?: PatientStateEnum | null | undefined;
        integumentaryAbnormalStateComments?: string | null | undefined;
        cardiovascular?: PatientStateEnum | null | undefined;
        cardiovascularAbnormalStateComments?: string | null | undefined;
        nervousSystem?: PatientStateEnum | null | undefined;
        nervousSystemAbnormalStateComments?: string | null | undefined;
        respiratory?: PatientStateEnum | null | undefined;
        respiratoryAbnormalStateComments?: string | null | undefined;
      };
      diagnosticTesting: {
        _id: number;
        abnormalitiesAndNotes?: string | null | undefined;
        reviewedByDvm?: boolean | null | undefined;
        additionalTests?:
          | {
              collection: Array<{
                _id: number;
                toPerform: boolean;
                test: string;
              }>;
            }
          | null
          | undefined;
        doctor?:
          | { _id: number; firstName: string; lastName: string }
          | null
          | undefined;
      };
      patientProcedures?:
        | {
            collection: Array<{
              endTime?: any | null | undefined;
              name?: string | null | undefined;
              startTime?: any | null | undefined;
              _id: number;
            }>;
          }
        | null
        | undefined;
      fluidTemperatures?:
        | {
            collection: Array<{
              _id: number;
              fluidRate?: number | null | undefined;
              temperature?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              volumeInfused?: number | null | undefined;
              volumeToBeInfused?: number | null | undefined;
            }>;
          }
        | null
        | undefined;
      anestheticGases?:
        | {
            collection: Array<{
              inhalantAnestheticAgent?: number | null | undefined;
              oxygen?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              _id: number;
            }>;
          }
        | null
        | undefined;
      vitals?:
        | {
            collection: Array<{
              diastolicBloodPressure?: number | null | undefined;
              endTidal?: number | null | undefined;
              heartRate?: number | null | undefined;
              meanBloodPressure?: number | null | undefined;
              pulseOximetry?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              systolicBloodPressure?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              _id: number;
            }>;
          }
        | null
        | undefined;
      medicationCalculations?:
        | {
            collection: Array<{
              _id: number;
              calculationType: MedicationCalculationTypeEnum;
              medication: string;
              dose: number;
              concentration: number;
              route: RouteEnum;
              initials?: string | null | undefined;
              timeAdministered?: any | null | undefined;
              totalAmount?: number | null | undefined;
              volumeAdministered?: number | null | undefined;
              totalVolume?: number | null | undefined;
              additionalVolumeAdministered?: number | null | undefined;
              additionalVolumeDrawn?: number | null | undefined;
            }>;
          }
        | null
        | undefined;
      miscellaneousGroup?:
        | {
            _id: number;
            catheterSize?: number | null | undefined;
            catheterLocation?: CatheterLocationEnum | null | undefined;
            fluidType?: string | null | undefined;
            bloodPressureMonitoring?:
              | BloodPressureMonitoringEnum
              | null
              | undefined;
            fluidRate?: number | null | undefined;
            fluidRateValue?: number | null | undefined;
            qualityOfSedation?: QualityOfSedationEnum | null | undefined;
            anesthesiaSystem?: AnesthesiaSystemEnum | null | undefined;
            bagSize?: number | null | undefined;
            oxygenFlowRate?: number | null | undefined;
            intubated?: boolean | null | undefined;
            endotrachealTubeSize?: string | null | undefined;
          }
        | null
        | undefined;
      defibMedications?:
        | {
            collection: Array<{
              _id: number;
              doseMax: number;
              doseMin: number;
              timeAdministered?: any | null | undefined;
              medication: string;
              dosageMax?: number | null | undefined;
              dosageMin?: number | null | undefined;
              initials?: string | null | undefined;
            }>;
          }
        | null
        | undefined;
      fluidBolus?:
        | { _id: number; totalAmount?: number | null | undefined }
        | null
        | undefined;
      monitoring: {
        _id: number;
        monitoringBy?: { _id: number } | null | undefined;
      };
      vitalComment?:
        | {
            _id: number;
            comment?: string | null | undefined;
            qualityRecovery?: QualityRecoveryEnum | null | undefined;
            timeExtubation?: any | null | undefined;
          }
        | null
        | undefined;
      regionalBlocks?:
        | {
            collection: Array<{
              concentration: number;
              dosageMax?: number | null | undefined;
              dosageMin?: number | null | undefined;
              doseMax: number;
              doseMin: number;
              type: RegionalBlockTypeEnum;
              volumeRangeMax?: number | null | undefined;
              volumeRangeMin?: number | null | undefined;
              volumeToBeInfused?: number | null | undefined;
              medication: string;
              initials?: string | null | undefined;
              _id: number;
            }>;
          }
        | null
        | undefined;
      tablets?:
        | {
            collection: Array<{
              _id: number;
              dosage: number;
              dose: number;
              labelInstructions?: string | null | undefined;
              numberOfTablets?: number | null | undefined;
              tabletSize?: number | null | undefined;
              medication: string;
            }>;
          }
        | null
        | undefined;
      suspensions?:
        | {
            collection: Array<{
              _id: number;
              dose: number;
              labelInstructions?: string | null | undefined;
              totalVolume?: number | null | undefined;
              volume: number;
              medication: string;
              concentration: number;
            }>;
          }
        | null
        | undefined;
      tibialPlateauLevelingOsteotomyPlanning?:
        | {
            _id: number;
            d1?: string | null | undefined;
            d2?: string | null | undefined;
            d3?: string | null | undefined;
            rotationNeeded?: string | null | undefined;
            initialTpa?: string | null | undefined;
            postOpTpa?: string | null | undefined;
            tploBladeSize?: string | null | undefined;
            tploPlateSizeAndModel?: string | null | undefined;
          }
        | null
        | undefined;
      postAnestheticVitals?:
        | {
            collection: Array<{
              comment?: string | null | undefined;
              fluidRate?: number | null | undefined;
              heartRate?: number | null | undefined;
              initials?: string | null | undefined;
              meanBloodPressure?: number | null | undefined;
              painScore?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              temperature?: number | null | undefined;
              timeMonitoring: any;
              _id: number;
            }>;
          }
        | null
        | undefined;
      postAnestheticVitalComment?:
        | {
            _id: number;
            comment?: string | null | undefined;
            surgeryReport?: string | null | undefined;
          }
        | null
        | undefined;
      generalAssessment?:
        | {
            _id: number;
            notesTimer?: string | null | undefined;
            periodontalDisease?: PeriodontalDiseaseEnum | null | undefined;
            plaqueIndex?: PlaqueIndexEnum | null | undefined;
            calculusIndex?: CalculusIndexEnum | null | undefined;
            gingivalIndex?: GingivalIndexEnum | null | undefined;
            additionalCommentsAndNotes?: string | null | undefined;
            buccalMucosa?: OralStateEnum | null | undefined;
            caudalOralMucosa?: OralStateEnum | null | undefined;
            dentalChart?: DentalChartEnum | null | undefined;
            extraoral?: OralStateEnum | null | undefined;
            fistula?: boolean | null | undefined;
            hardPalate?: OralStateEnum | null | undefined;
            lymphNodes?: OralStateEnum | null | undefined;
            occlusion?: OcclusionEnum | null | undefined;
            occlusionDescription?: string | null | undefined;
            parulisSinusTract?: boolean | null | undefined;
            skullType?: SkullTypeEnum | null | undefined;
            softPalate?: OralStateEnum | null | undefined;
            tongue?: OralStateEnum | null | undefined;
            tonsils?: OralStateEnum | null | undefined;
            intraoralRadiographicComments?: string | null | undefined;
            cbctComments?: string | null | undefined;
            referralNotesAndComments?: string | null | undefined;
            notesForClientDentalReport?: string | null | undefined;
            rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
            rightInfraorbital?: number | null | undefined;
            rightMaxillary?: number | null | undefined;
            rightRostralMandibular?: number | null | undefined;
            rightInferiorAlveolar?: number | null | undefined;
            leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
            leftInfraorbital?: number | null | undefined;
            leftMaxillary?: number | null | undefined;
            leftRostralMandibular?: number | null | undefined;
            leftInferiorAlveolar?: number | null | undefined;
            oralSurgeries: Array<OralSurgeryEnum>;
            orthodontics: Array<OrthodonticsEnum>;
            periodontics: Array<PeriodonticsEnum>;
            planingAndSubgingivalCurettage?:
              | RootPlaningAndSubgingivalCurettageEnum
              | null
              | undefined;
            boneAugmentation: boolean;
            boneAugmentationDetails?: string | null | undefined;
            treatmentAdditionalFindingsCommentsAndNotes?:
              | string
              | null
              | undefined;
            between25And50PerCentBoneLoss: Array<string>;
            externalCervicalToothResorption: Array<string>;
            externalInflammatoryToothResorption: Array<string>;
            externalReplacementRootResorption: Array<string>;
            externalSurfaceRootResorption: Array<string>;
            greaterThan50PerCentBoneLoss: Array<string>;
            internalToothResorption: Array<string>;
            lessThan25PerCentBoneLoss: Array<string>;
            missingTeeth: Array<string>;
            periapicalLucency: Array<string>;
            periapicalRarefaction: Array<string>;
            retainedToothRoots: Array<string>;
            toothResorptionType1: Array<string>;
            toothResorptionType2: Array<string>;
            toothResorptionType3: Array<string>;
            uneruptedTeeth: Array<string>;
            widenedPulpCanal: Array<string>;
            beforePhotoFront?: { _id: number } | null | undefined;
            beforePhotoLeft?: { _id: number } | null | undefined;
            beforePhotoRight?: { _id: number } | null | undefined;
            afterPhotoFront?: { _id: number } | null | undefined;
            afterPhotoLeft?: { _id: number } | null | undefined;
            afterPhotoRight?: { _id: number } | null | undefined;
            additionalPhotos?:
              | { collection: Array<{ _id: number }> }
              | null
              | undefined;
            radiographicFindingsPhotos?:
              | { collection: Array<{ _id: number }> }
              | null
              | undefined;
          }
        | null
        | undefined;
      dentalChartings?:
        | {
            collection: Array<{
              _id: number;
              notesTimer?: string | null | undefined;
              timerDurationSec: number;
              toothState?: ToothStateEnum | null | undefined;
              periodontal?: PeriodontalEnum | null | undefined;
              furcation?: FurcationEnum | null | undefined;
              mobility?: MobilityEnum | null | undefined;
              gingivitis?: GingivitisEnum | null | undefined;
              calculus?: CalculusEnum | null | undefined;
              enamel?: EnamelEnum | null | undefined;
              fracture?: FractureEnum | null | undefined;
              resorption?: ResorptionEnum | null | undefined;
              other: Array<OtherEnum>;
              periodontalPocketMBuc?: number | null | undefined;
              periodontalPocketBuccal?: number | null | undefined;
              periodontalPocketDBuc?: number | null | undefined;
              periodontalPocketMLingPal?: number | null | undefined;
              periodontalPocketLingPal?: number | null | undefined;
              periodontalPocketDLingPal?: number | null | undefined;
              gingivalRecessionMBuc?: number | null | undefined;
              gingivalRecessionBuccal?: number | null | undefined;
              gingivalRecessionDBuc?: number | null | undefined;
              gingivalRecessionMLingPal?: number | null | undefined;
              gingivalRecessionLingPal?: number | null | undefined;
              gingivalRecessionDLingPal?: number | null | undefined;
              oralSurgeries: Array<ToothOralSurgeryEnum>;
              sutureMaterial?: string | null | undefined;
              restorations: Array<ToothRestorationEnum>;
              restoratives?: string | null | undefined;
              crCementation?: string | null | undefined;
              endodontics: Array<ToothEndodonticsEnum>;
              obturation?: string | null | undefined;
              distalWorkingLength?: number | null | undefined;
              mesialWorkingLength?: number | null | undefined;
              palatalWorkingLength?: number | null | undefined;
              distalMarFile?: number | null | undefined;
              mesialMarFile?: number | null | undefined;
              palatalMarFile?: number | null | undefined;
              technique?: string | null | undefined;
              treatmentComment?: string | null | undefined;
              tooth: { _id: number; toothName: string };
            }>;
          }
        | null
        | undefined;
      dentalSketch?: { _id: number; name: string } | null | undefined;
      dentalSketchComments?:
        | {
            collection: Array<{
              locationX: number;
              locationY: number;
              createdAt?: any | null | undefined;
              text: string;
              _id: number;
              createdBy: {
                _id: number;
                firstName: string;
                lastName: string;
                image?: { _id: number } | null | undefined;
              };
            }>;
          }
        | null
        | undefined;
      calculationAgreement?:
        | {
            _id: number;
            signedAt?: any | null | undefined;
            file?: { _id: number; name: string } | null | undefined;
          }
        | null
        | undefined;
    };
    disclaimer: {
      id: string;
      _id: number;
      createdAt: any;
      signature?: { id: string; _id: number; name: string } | null | undefined;
    };
    city?:
      | { _id: string; name: string; state: { _id: string; name: string } }
      | null
      | undefined;
    state?: { _id: string; name: string } | null | undefined;
  };
};

export type MedicationCalculationFragment = {
  _id: number;
  calculationType: MedicationCalculationTypeEnum;
  medication: string;
  dose: number;
  concentration: number;
  route: RouteEnum;
  initials?: string | null | undefined;
  timeAdministered?: any | null | undefined;
  totalAmount?: number | null | undefined;
  volumeAdministered?: number | null | undefined;
  totalVolume?: number | null | undefined;
  additionalVolumeAdministered?: number | null | undefined;
  additionalVolumeDrawn?: number | null | undefined;
};

export type UpdateMedicationCalculationsMutationVariables = Exact<{
  input: UpdateMedicationCalculationInput;
}>;

export type UpdateMedicationCalculationsMutation = {
  updateMedicationCalculation?:
    | {
        medicationCalculation?:
          | {
              _id: number;
              calculationType: MedicationCalculationTypeEnum;
              medication: string;
              dose: number;
              concentration: number;
              route: RouteEnum;
              initials?: string | null | undefined;
              timeAdministered?: any | null | undefined;
              totalAmount?: number | null | undefined;
              volumeAdministered?: number | null | undefined;
              totalVolume?: number | null | undefined;
              additionalVolumeAdministered?: number | null | undefined;
              additionalVolumeDrawn?: number | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateMedicationCalculationsMutationVariables = Exact<{
  input: CreateMedicationCalculationInput;
}>;

export type CreateMedicationCalculationsMutation = {
  createMedicationCalculation?:
    | {
        medicationCalculation?:
          | {
              _id: number;
              calculationType: MedicationCalculationTypeEnum;
              medication: string;
              dose: number;
              concentration: number;
              route: RouteEnum;
              initials?: string | null | undefined;
              timeAdministered?: any | null | undefined;
              totalAmount?: number | null | undefined;
              volumeAdministered?: number | null | undefined;
              totalVolume?: number | null | undefined;
              additionalVolumeAdministered?: number | null | undefined;
              additionalVolumeDrawn?: number | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateCalculationAgreementMutationVariables = Exact<{
  input: UpdateCalculationAgreementInput;
}>;

export type UpdateCalculationAgreementMutation = {
  updateCalculationAgreement?:
    | {
        calculationAgreement?:
          | {
              _id: number;
              signedAt?: any | null | undefined;
              file?: { _id: number; name: string } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteMedicationCalculationsMutationVariables = Exact<{
  input: RemoveBulkMedicationCalculationInput;
}>;

export type DeleteMedicationCalculationsMutation = {
  removeBulkMedicationCalculation?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type DefibMedicationFragment = {
  _id: number;
  doseMax: number;
  doseMin: number;
  timeAdministered?: any | null | undefined;
  medication: string;
  dosageMax?: number | null | undefined;
  dosageMin?: number | null | undefined;
  initials?: string | null | undefined;
};

export type UpdateDefibMedicationMutationVariables = Exact<{
  input: UpdateDefibMedicationInput;
}>;

export type UpdateDefibMedicationMutation = {
  updateDefibMedication?:
    | {
        defibMedication?:
          | {
              _id: number;
              doseMax: number;
              doseMin: number;
              timeAdministered?: any | null | undefined;
              medication: string;
              dosageMax?: number | null | undefined;
              dosageMin?: number | null | undefined;
              initials?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateDefibMedicationMutationVariables = Exact<{
  input: CreateDefibMedicationInput;
}>;

export type CreateDefibMedicationMutation = {
  createDefibMedication?:
    | {
        defibMedication?:
          | {
              _id: number;
              doseMax: number;
              doseMin: number;
              timeAdministered?: any | null | undefined;
              medication: string;
              dosageMax?: number | null | undefined;
              dosageMin?: number | null | undefined;
              initials?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteDefibMedicationsMutationVariables = Exact<{
  input: RemoveBulkDefibMedicationInput;
}>;

export type DeleteDefibMedicationsMutation = {
  removeBulkDefibMedication?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdateFluidBolusMutationVariables = Exact<{
  input: UpdateFluidBolusInput;
}>;

export type UpdateFluidBolusMutation = {
  updateFluidBolus?:
    | {
        fluidBolus?:
          | { _id: number; totalAmount?: number | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteFluidBolusMutationVariables = Exact<{
  input: DeleteFluidBolusInput;
}>;

export type DeleteFluidBolusMutation = {
  deleteFluidBolus?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type CreateFluidBolusMutationVariables = Exact<{
  input: CreateFluidBolusInput;
}>;

export type CreateFluidBolusMutation = {
  createFluidBolus?:
    | {
        fluidBolus?:
          | { _id: number; totalAmount?: number | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RegionalBlockFragment = {
  concentration: number;
  dosageMax?: number | null | undefined;
  dosageMin?: number | null | undefined;
  doseMax: number;
  doseMin: number;
  type: RegionalBlockTypeEnum;
  volumeRangeMax?: number | null | undefined;
  volumeRangeMin?: number | null | undefined;
  volumeToBeInfused?: number | null | undefined;
  medication: string;
  initials?: string | null | undefined;
  _id: number;
};

export type UpdateRegionalBlockMutationVariables = Exact<{
  input: UpdateRegionalBlockInput;
}>;

export type UpdateRegionalBlockMutation = {
  updateRegionalBlock?:
    | {
        regionalBlock?:
          | {
              concentration: number;
              dosageMax?: number | null | undefined;
              dosageMin?: number | null | undefined;
              doseMax: number;
              doseMin: number;
              type: RegionalBlockTypeEnum;
              volumeRangeMax?: number | null | undefined;
              volumeRangeMin?: number | null | undefined;
              volumeToBeInfused?: number | null | undefined;
              medication: string;
              initials?: string | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateRegionalBlockMutationVariables = Exact<{
  input: CreateRegionalBlockInput;
}>;

export type CreateRegionalBlockMutation = {
  createRegionalBlock?:
    | {
        regionalBlock?:
          | {
              concentration: number;
              dosageMax?: number | null | undefined;
              dosageMin?: number | null | undefined;
              doseMax: number;
              doseMin: number;
              type: RegionalBlockTypeEnum;
              volumeRangeMax?: number | null | undefined;
              volumeRangeMin?: number | null | undefined;
              volumeToBeInfused?: number | null | undefined;
              medication: string;
              initials?: string | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteRegionalBlocksMutationVariables = Exact<{
  input: RemoveBulkRegionalBlockInput;
}>;

export type DeleteRegionalBlocksMutation = {
  removeBulkRegionalBlock?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type MiscellaneousGroupFragment = {
  _id: number;
  catheterSize?: number | null | undefined;
  catheterLocation?: CatheterLocationEnum | null | undefined;
  fluidType?: string | null | undefined;
  bloodPressureMonitoring?: BloodPressureMonitoringEnum | null | undefined;
  fluidRate?: number | null | undefined;
  fluidRateValue?: number | null | undefined;
  qualityOfSedation?: QualityOfSedationEnum | null | undefined;
  anesthesiaSystem?: AnesthesiaSystemEnum | null | undefined;
  bagSize?: number | null | undefined;
  oxygenFlowRate?: number | null | undefined;
  intubated?: boolean | null | undefined;
  endotrachealTubeSize?: string | null | undefined;
};

export type UpdatePatientMiscellaneousMutationVariables = Exact<{
  input: UpdateMiscellaneousGroupInput;
}>;

export type UpdatePatientMiscellaneousMutation = {
  updateMiscellaneousGroup?:
    | {
        miscellaneousGroup?:
          | {
              _id: number;
              catheterSize?: number | null | undefined;
              catheterLocation?: CatheterLocationEnum | null | undefined;
              fluidType?: string | null | undefined;
              bloodPressureMonitoring?:
                | BloodPressureMonitoringEnum
                | null
                | undefined;
              fluidRate?: number | null | undefined;
              fluidRateValue?: number | null | undefined;
              qualityOfSedation?: QualityOfSedationEnum | null | undefined;
              anesthesiaSystem?: AnesthesiaSystemEnum | null | undefined;
              bagSize?: number | null | undefined;
              oxygenFlowRate?: number | null | undefined;
              intubated?: boolean | null | undefined;
              endotrachealTubeSize?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PatientInformationFragment = {
  _id: number;
  name?: string | null | undefined;
  sex?: PatientSexEnum | null | undefined;
  species?: SpeciesEnum | null | undefined;
  breed?: string | null | undefined;
  dateOfBirth?: any | null | undefined;
  weight?: number | null | undefined;
  weightMeasure: WeightMeasureEnum;
  procedureDate: any;
  alerts?: string | null | undefined;
  procedures: Array<string>;
  calculationAgreement?:
    | {
        _id: number;
        signedAt?: any | null | undefined;
        file?: { _id: number; name: string } | null | undefined;
      }
    | null
    | undefined;
};

export type UpdatePatientInformationMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;

export type UpdatePatientInformationMutation = {
  updatePatient?:
    | {
        patient?:
          | {
              _id: number;
              name?: string | null | undefined;
              sex?: PatientSexEnum | null | undefined;
              species?: SpeciesEnum | null | undefined;
              breed?: string | null | undefined;
              dateOfBirth?: any | null | undefined;
              weight?: number | null | undefined;
              weightMeasure: WeightMeasureEnum;
              procedureDate: any;
              alerts?: string | null | undefined;
              procedures: Array<string>;
              vaccines?:
                | {
                    collection: Array<{
                      vaccine: VaccineEnum;
                      _id: number;
                      toPerform: boolean;
                    }>;
                  }
                | null
                | undefined;
              generalAssessment?:
                | {
                    _id: number;
                    notesTimer?: string | null | undefined;
                    periodontalDisease?:
                      | PeriodontalDiseaseEnum
                      | null
                      | undefined;
                    plaqueIndex?: PlaqueIndexEnum | null | undefined;
                    calculusIndex?: CalculusIndexEnum | null | undefined;
                    gingivalIndex?: GingivalIndexEnum | null | undefined;
                    additionalCommentsAndNotes?: string | null | undefined;
                    buccalMucosa?: OralStateEnum | null | undefined;
                    caudalOralMucosa?: OralStateEnum | null | undefined;
                    dentalChart?: DentalChartEnum | null | undefined;
                    extraoral?: OralStateEnum | null | undefined;
                    fistula?: boolean | null | undefined;
                    hardPalate?: OralStateEnum | null | undefined;
                    lymphNodes?: OralStateEnum | null | undefined;
                    occlusion?: OcclusionEnum | null | undefined;
                    occlusionDescription?: string | null | undefined;
                    parulisSinusTract?: boolean | null | undefined;
                    skullType?: SkullTypeEnum | null | undefined;
                    softPalate?: OralStateEnum | null | undefined;
                    tongue?: OralStateEnum | null | undefined;
                    tonsils?: OralStateEnum | null | undefined;
                    intraoralRadiographicComments?: string | null | undefined;
                    cbctComments?: string | null | undefined;
                    referralNotesAndComments?: string | null | undefined;
                    notesForClientDentalReport?: string | null | undefined;
                    rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                    rightInfraorbital?: number | null | undefined;
                    rightMaxillary?: number | null | undefined;
                    rightRostralMandibular?: number | null | undefined;
                    rightInferiorAlveolar?: number | null | undefined;
                    leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                    leftInfraorbital?: number | null | undefined;
                    leftMaxillary?: number | null | undefined;
                    leftRostralMandibular?: number | null | undefined;
                    leftInferiorAlveolar?: number | null | undefined;
                    oralSurgeries: Array<OralSurgeryEnum>;
                    orthodontics: Array<OrthodonticsEnum>;
                    periodontics: Array<PeriodonticsEnum>;
                    planingAndSubgingivalCurettage?:
                      | RootPlaningAndSubgingivalCurettageEnum
                      | null
                      | undefined;
                    boneAugmentation: boolean;
                    boneAugmentationDetails?: string | null | undefined;
                    treatmentAdditionalFindingsCommentsAndNotes?:
                      | string
                      | null
                      | undefined;
                    between25And50PerCentBoneLoss: Array<string>;
                    externalCervicalToothResorption: Array<string>;
                    externalInflammatoryToothResorption: Array<string>;
                    externalReplacementRootResorption: Array<string>;
                    externalSurfaceRootResorption: Array<string>;
                    greaterThan50PerCentBoneLoss: Array<string>;
                    internalToothResorption: Array<string>;
                    lessThan25PerCentBoneLoss: Array<string>;
                    missingTeeth: Array<string>;
                    periapicalLucency: Array<string>;
                    periapicalRarefaction: Array<string>;
                    retainedToothRoots: Array<string>;
                    toothResorptionType1: Array<string>;
                    toothResorptionType2: Array<string>;
                    toothResorptionType3: Array<string>;
                    uneruptedTeeth: Array<string>;
                    widenedPulpCanal: Array<string>;
                    beforePhotoFront?: { _id: number } | null | undefined;
                    beforePhotoLeft?: { _id: number } | null | undefined;
                    beforePhotoRight?: { _id: number } | null | undefined;
                    afterPhotoFront?: { _id: number } | null | undefined;
                    afterPhotoLeft?: { _id: number } | null | undefined;
                    afterPhotoRight?: { _id: number } | null | undefined;
                    additionalPhotos?:
                      | { collection: Array<{ _id: number }> }
                      | null
                      | undefined;
                    radiographicFindingsPhotos?:
                      | { collection: Array<{ _id: number }> }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
              tibialPlateauLevelingOsteotomyPlanning?:
                | {
                    _id: number;
                    d1?: string | null | undefined;
                    d2?: string | null | undefined;
                    d3?: string | null | undefined;
                    rotationNeeded?: string | null | undefined;
                    initialTpa?: string | null | undefined;
                    postOpTpa?: string | null | undefined;
                    tploBladeSize?: string | null | undefined;
                    tploPlateSizeAndModel?: string | null | undefined;
                  }
                | null
                | undefined;
              patientTests?:
                | {
                    collection: Array<{
                      test: PatientTestEnum;
                      _id: number;
                      toPerform: boolean;
                    }>;
                  }
                | null
                | undefined;
              treatment?:
                | {
                    cereniaInjection: boolean;
                    laserTherapy: boolean;
                    microchip: boolean;
                    _id: number;
                  }
                | null
                | undefined;
              dentalChartings?:
                | {
                    collection: Array<{
                      _id: number;
                      notesTimer?: string | null | undefined;
                      timerDurationSec: number;
                      toothState?: ToothStateEnum | null | undefined;
                      periodontal?: PeriodontalEnum | null | undefined;
                      furcation?: FurcationEnum | null | undefined;
                      mobility?: MobilityEnum | null | undefined;
                      gingivitis?: GingivitisEnum | null | undefined;
                      calculus?: CalculusEnum | null | undefined;
                      enamel?: EnamelEnum | null | undefined;
                      fracture?: FractureEnum | null | undefined;
                      resorption?: ResorptionEnum | null | undefined;
                      other: Array<OtherEnum>;
                      periodontalPocketMBuc?: number | null | undefined;
                      periodontalPocketBuccal?: number | null | undefined;
                      periodontalPocketDBuc?: number | null | undefined;
                      periodontalPocketMLingPal?: number | null | undefined;
                      periodontalPocketLingPal?: number | null | undefined;
                      periodontalPocketDLingPal?: number | null | undefined;
                      gingivalRecessionMBuc?: number | null | undefined;
                      gingivalRecessionBuccal?: number | null | undefined;
                      gingivalRecessionDBuc?: number | null | undefined;
                      gingivalRecessionMLingPal?: number | null | undefined;
                      gingivalRecessionLingPal?: number | null | undefined;
                      gingivalRecessionDLingPal?: number | null | undefined;
                      oralSurgeries: Array<ToothOralSurgeryEnum>;
                      sutureMaterial?: string | null | undefined;
                      restorations: Array<ToothRestorationEnum>;
                      restoratives?: string | null | undefined;
                      crCementation?: string | null | undefined;
                      endodontics: Array<ToothEndodonticsEnum>;
                      obturation?: string | null | undefined;
                      distalWorkingLength?: number | null | undefined;
                      mesialWorkingLength?: number | null | undefined;
                      palatalWorkingLength?: number | null | undefined;
                      distalMarFile?: number | null | undefined;
                      mesialMarFile?: number | null | undefined;
                      palatalMarFile?: number | null | undefined;
                      technique?: string | null | undefined;
                      treatmentComment?: string | null | undefined;
                      tooth: { _id: number; toothName: string };
                    }>;
                  }
                | null
                | undefined;
              dentalSketch?: { _id: number; name: string } | null | undefined;
              dentalSketchComments?:
                | {
                    collection: Array<{
                      locationX: number;
                      locationY: number;
                      createdAt?: any | null | undefined;
                      text: string;
                      _id: number;
                      createdBy: {
                        _id: number;
                        firstName: string;
                        lastName: string;
                        image?: { _id: number } | null | undefined;
                      };
                    }>;
                  }
                | null
                | undefined;
              calculationAgreement?:
                | {
                    _id: number;
                    signedAt?: any | null | undefined;
                    file?: { _id: number; name: string } | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ClientInformationFragment = {
  _id: number;
  accountNumber?: string | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  phoneFirst?: string | null | undefined;
  phoneSecond?: string | null | undefined;
  notAvailableTime?: string | null | undefined;
  streetAddress?: string | null | undefined;
  apartments?: string | null | undefined;
  zipCode?: string | null | undefined;
  disclaimer: {
    id: string;
    _id: number;
    createdAt: any;
    signature?: { id: string; _id: number; name: string } | null | undefined;
  };
  city?:
    | { _id: string; name: string; state: { _id: string; name: string } }
    | null
    | undefined;
  state?: { _id: string; name: string } | null | undefined;
};

export type UpdateClientInformationMutationVariables = Exact<{
  input: UpdateClientInput;
}>;

export type UpdateClientInformationMutation = {
  updateClient?:
    | {
        client?:
          | {
              _id: number;
              accountNumber?: string | null | undefined;
              email?: string | null | undefined;
              firstName?: string | null | undefined;
              lastName?: string | null | undefined;
              phoneFirst?: string | null | undefined;
              phoneSecond?: string | null | undefined;
              notAvailableTime?: string | null | undefined;
              streetAddress?: string | null | undefined;
              apartments?: string | null | undefined;
              zipCode?: string | null | undefined;
              disclaimer: {
                id: string;
                _id: number;
                createdAt: any;
                signature?:
                  | { id: string; _id: number; name: string }
                  | null
                  | undefined;
              };
              city?:
                | {
                    _id: string;
                    name: string;
                    state: { _id: string; name: string };
                  }
                | null
                | undefined;
              state?: { _id: string; name: string } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateDisclaimerMutationVariables = Exact<{
  input: UpdateDisclaimerInput;
}>;

export type UpdateDisclaimerMutation = {
  updateDisclaimer?:
    | {
        disclaimer?:
          | {
              _id: number;
              signature?: { _id: number; name: string } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DropOffFragment = {
  _id: number;
  admittingConcern?: string | null | undefined;
  evaluateTestAndTreat: boolean;
  performInitialEvaluation: boolean;
  doctor?:
    | { _id: number; firstName: string; lastName: string }
    | null
    | undefined;
};

export type UpdatePatientDropOffMutationVariables = Exact<{
  input: UpdateDropOffInput;
}>;

export type UpdatePatientDropOffMutation = {
  updateDropOff?:
    | {
        dropOff?:
          | {
              _id: number;
              admittingConcern?: string | null | undefined;
              evaluateTestAndTreat: boolean;
              performInitialEvaluation: boolean;
              doctor?:
                | { _id: number; firstName: string; lastName: string }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateAuthorizationMutationVariables = Exact<{
  input: UpdateAuthorizationInput;
}>;

export type UpdateAuthorizationMutation = {
  updateAuthorization?:
    | { authorization?: { _id: number; selected: boolean } | null | undefined }
    | null
    | undefined;
};

export type UpdateDisclaimerProcedureMutationVariables = Exact<{
  input: UpdateDisclaimerProcedureInput;
}>;

export type UpdateDisclaimerProcedureMutation = {
  updateDisclaimerProcedure?:
    | {
        disclaimerProcedure?:
          | { _id: number; selected: boolean }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GeneralAssessmentFragment = {
  _id: number;
  notesTimer?: string | null | undefined;
  periodontalDisease?: PeriodontalDiseaseEnum | null | undefined;
  plaqueIndex?: PlaqueIndexEnum | null | undefined;
  calculusIndex?: CalculusIndexEnum | null | undefined;
  gingivalIndex?: GingivalIndexEnum | null | undefined;
  additionalCommentsAndNotes?: string | null | undefined;
  buccalMucosa?: OralStateEnum | null | undefined;
  caudalOralMucosa?: OralStateEnum | null | undefined;
  dentalChart?: DentalChartEnum | null | undefined;
  extraoral?: OralStateEnum | null | undefined;
  fistula?: boolean | null | undefined;
  hardPalate?: OralStateEnum | null | undefined;
  lymphNodes?: OralStateEnum | null | undefined;
  occlusion?: OcclusionEnum | null | undefined;
  occlusionDescription?: string | null | undefined;
  parulisSinusTract?: boolean | null | undefined;
  skullType?: SkullTypeEnum | null | undefined;
  softPalate?: OralStateEnum | null | undefined;
  tongue?: OralStateEnum | null | undefined;
  tonsils?: OralStateEnum | null | undefined;
  intraoralRadiographicComments?: string | null | undefined;
  cbctComments?: string | null | undefined;
  referralNotesAndComments?: string | null | undefined;
  notesForClientDentalReport?: string | null | undefined;
  rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
  rightInfraorbital?: number | null | undefined;
  rightMaxillary?: number | null | undefined;
  rightRostralMandibular?: number | null | undefined;
  rightInferiorAlveolar?: number | null | undefined;
  leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
  leftInfraorbital?: number | null | undefined;
  leftMaxillary?: number | null | undefined;
  leftRostralMandibular?: number | null | undefined;
  leftInferiorAlveolar?: number | null | undefined;
  oralSurgeries: Array<OralSurgeryEnum>;
  orthodontics: Array<OrthodonticsEnum>;
  periodontics: Array<PeriodonticsEnum>;
  planingAndSubgingivalCurettage?:
    | RootPlaningAndSubgingivalCurettageEnum
    | null
    | undefined;
  boneAugmentation: boolean;
  boneAugmentationDetails?: string | null | undefined;
  treatmentAdditionalFindingsCommentsAndNotes?: string | null | undefined;
  between25And50PerCentBoneLoss: Array<string>;
  externalCervicalToothResorption: Array<string>;
  externalInflammatoryToothResorption: Array<string>;
  externalReplacementRootResorption: Array<string>;
  externalSurfaceRootResorption: Array<string>;
  greaterThan50PerCentBoneLoss: Array<string>;
  internalToothResorption: Array<string>;
  lessThan25PerCentBoneLoss: Array<string>;
  missingTeeth: Array<string>;
  periapicalLucency: Array<string>;
  periapicalRarefaction: Array<string>;
  retainedToothRoots: Array<string>;
  toothResorptionType1: Array<string>;
  toothResorptionType2: Array<string>;
  toothResorptionType3: Array<string>;
  uneruptedTeeth: Array<string>;
  widenedPulpCanal: Array<string>;
  beforePhotoFront?: { _id: number } | null | undefined;
  beforePhotoLeft?: { _id: number } | null | undefined;
  beforePhotoRight?: { _id: number } | null | undefined;
  afterPhotoFront?: { _id: number } | null | undefined;
  afterPhotoLeft?: { _id: number } | null | undefined;
  afterPhotoRight?: { _id: number } | null | undefined;
  additionalPhotos?: { collection: Array<{ _id: number }> } | null | undefined;
  radiographicFindingsPhotos?:
    | { collection: Array<{ _id: number }> }
    | null
    | undefined;
};

export type UpdateGeneralAssessmentMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;

export type UpdateGeneralAssessmentMutation = {
  updatePatient?:
    | {
        patient?:
          | {
              generalAssessment?:
                | {
                    _id: number;
                    notesTimer?: string | null | undefined;
                    periodontalDisease?:
                      | PeriodontalDiseaseEnum
                      | null
                      | undefined;
                    plaqueIndex?: PlaqueIndexEnum | null | undefined;
                    calculusIndex?: CalculusIndexEnum | null | undefined;
                    gingivalIndex?: GingivalIndexEnum | null | undefined;
                    additionalCommentsAndNotes?: string | null | undefined;
                    buccalMucosa?: OralStateEnum | null | undefined;
                    caudalOralMucosa?: OralStateEnum | null | undefined;
                    dentalChart?: DentalChartEnum | null | undefined;
                    extraoral?: OralStateEnum | null | undefined;
                    fistula?: boolean | null | undefined;
                    hardPalate?: OralStateEnum | null | undefined;
                    lymphNodes?: OralStateEnum | null | undefined;
                    occlusion?: OcclusionEnum | null | undefined;
                    occlusionDescription?: string | null | undefined;
                    parulisSinusTract?: boolean | null | undefined;
                    skullType?: SkullTypeEnum | null | undefined;
                    softPalate?: OralStateEnum | null | undefined;
                    tongue?: OralStateEnum | null | undefined;
                    tonsils?: OralStateEnum | null | undefined;
                    intraoralRadiographicComments?: string | null | undefined;
                    cbctComments?: string | null | undefined;
                    referralNotesAndComments?: string | null | undefined;
                    notesForClientDentalReport?: string | null | undefined;
                    rightRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                    rightInfraorbital?: number | null | undefined;
                    rightMaxillary?: number | null | undefined;
                    rightRostralMandibular?: number | null | undefined;
                    rightInferiorAlveolar?: number | null | undefined;
                    leftRegionalBlocks: Array<TreatmentRegionalBlockEnum>;
                    leftInfraorbital?: number | null | undefined;
                    leftMaxillary?: number | null | undefined;
                    leftRostralMandibular?: number | null | undefined;
                    leftInferiorAlveolar?: number | null | undefined;
                    oralSurgeries: Array<OralSurgeryEnum>;
                    orthodontics: Array<OrthodonticsEnum>;
                    periodontics: Array<PeriodonticsEnum>;
                    planingAndSubgingivalCurettage?:
                      | RootPlaningAndSubgingivalCurettageEnum
                      | null
                      | undefined;
                    boneAugmentation: boolean;
                    boneAugmentationDetails?: string | null | undefined;
                    treatmentAdditionalFindingsCommentsAndNotes?:
                      | string
                      | null
                      | undefined;
                    between25And50PerCentBoneLoss: Array<string>;
                    externalCervicalToothResorption: Array<string>;
                    externalInflammatoryToothResorption: Array<string>;
                    externalReplacementRootResorption: Array<string>;
                    externalSurfaceRootResorption: Array<string>;
                    greaterThan50PerCentBoneLoss: Array<string>;
                    internalToothResorption: Array<string>;
                    lessThan25PerCentBoneLoss: Array<string>;
                    missingTeeth: Array<string>;
                    periapicalLucency: Array<string>;
                    periapicalRarefaction: Array<string>;
                    retainedToothRoots: Array<string>;
                    toothResorptionType1: Array<string>;
                    toothResorptionType2: Array<string>;
                    toothResorptionType3: Array<string>;
                    uneruptedTeeth: Array<string>;
                    widenedPulpCanal: Array<string>;
                    beforePhotoFront?: { _id: number } | null | undefined;
                    beforePhotoLeft?: { _id: number } | null | undefined;
                    beforePhotoRight?: { _id: number } | null | undefined;
                    afterPhotoFront?: { _id: number } | null | undefined;
                    afterPhotoLeft?: { _id: number } | null | undefined;
                    afterPhotoRight?: { _id: number } | null | undefined;
                    additionalPhotos?:
                      | { collection: Array<{ _id: number }> }
                      | null
                      | undefined;
                    radiographicFindingsPhotos?:
                      | { collection: Array<{ _id: number }> }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
              dentalChartings?:
                | {
                    collection: Array<{
                      _id: number;
                      notesTimer?: string | null | undefined;
                      timerDurationSec: number;
                      toothState?: ToothStateEnum | null | undefined;
                      periodontal?: PeriodontalEnum | null | undefined;
                      furcation?: FurcationEnum | null | undefined;
                      mobility?: MobilityEnum | null | undefined;
                      gingivitis?: GingivitisEnum | null | undefined;
                      calculus?: CalculusEnum | null | undefined;
                      enamel?: EnamelEnum | null | undefined;
                      fracture?: FractureEnum | null | undefined;
                      resorption?: ResorptionEnum | null | undefined;
                      other: Array<OtherEnum>;
                      periodontalPocketMBuc?: number | null | undefined;
                      periodontalPocketBuccal?: number | null | undefined;
                      periodontalPocketDBuc?: number | null | undefined;
                      periodontalPocketMLingPal?: number | null | undefined;
                      periodontalPocketLingPal?: number | null | undefined;
                      periodontalPocketDLingPal?: number | null | undefined;
                      gingivalRecessionMBuc?: number | null | undefined;
                      gingivalRecessionBuccal?: number | null | undefined;
                      gingivalRecessionDBuc?: number | null | undefined;
                      gingivalRecessionMLingPal?: number | null | undefined;
                      gingivalRecessionLingPal?: number | null | undefined;
                      gingivalRecessionDLingPal?: number | null | undefined;
                      oralSurgeries: Array<ToothOralSurgeryEnum>;
                      sutureMaterial?: string | null | undefined;
                      restorations: Array<ToothRestorationEnum>;
                      restoratives?: string | null | undefined;
                      crCementation?: string | null | undefined;
                      endodontics: Array<ToothEndodonticsEnum>;
                      obturation?: string | null | undefined;
                      distalWorkingLength?: number | null | undefined;
                      mesialWorkingLength?: number | null | undefined;
                      palatalWorkingLength?: number | null | undefined;
                      distalMarFile?: number | null | undefined;
                      mesialMarFile?: number | null | undefined;
                      palatalMarFile?: number | null | undefined;
                      technique?: string | null | undefined;
                      treatmentComment?: string | null | undefined;
                      tooth: { _id: number; toothName: string };
                    }>;
                  }
                | null
                | undefined;
              dentalSketchComments?:
                | {
                    collection: Array<{
                      locationX: number;
                      locationY: number;
                      createdAt?: any | null | undefined;
                      text: string;
                      _id: number;
                      createdBy: {
                        _id: number;
                        firstName: string;
                        lastName: string;
                        image?: { _id: number } | null | undefined;
                      };
                    }>;
                  }
                | null
                | undefined;
              dentalSketch?: { _id: number } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DentalChartingFragment = {
  _id: number;
  notesTimer?: string | null | undefined;
  timerDurationSec: number;
  toothState?: ToothStateEnum | null | undefined;
  periodontal?: PeriodontalEnum | null | undefined;
  furcation?: FurcationEnum | null | undefined;
  mobility?: MobilityEnum | null | undefined;
  gingivitis?: GingivitisEnum | null | undefined;
  calculus?: CalculusEnum | null | undefined;
  enamel?: EnamelEnum | null | undefined;
  fracture?: FractureEnum | null | undefined;
  resorption?: ResorptionEnum | null | undefined;
  other: Array<OtherEnum>;
  periodontalPocketMBuc?: number | null | undefined;
  periodontalPocketBuccal?: number | null | undefined;
  periodontalPocketDBuc?: number | null | undefined;
  periodontalPocketMLingPal?: number | null | undefined;
  periodontalPocketLingPal?: number | null | undefined;
  periodontalPocketDLingPal?: number | null | undefined;
  gingivalRecessionMBuc?: number | null | undefined;
  gingivalRecessionBuccal?: number | null | undefined;
  gingivalRecessionDBuc?: number | null | undefined;
  gingivalRecessionMLingPal?: number | null | undefined;
  gingivalRecessionLingPal?: number | null | undefined;
  gingivalRecessionDLingPal?: number | null | undefined;
  oralSurgeries: Array<ToothOralSurgeryEnum>;
  sutureMaterial?: string | null | undefined;
  restorations: Array<ToothRestorationEnum>;
  restoratives?: string | null | undefined;
  crCementation?: string | null | undefined;
  endodontics: Array<ToothEndodonticsEnum>;
  obturation?: string | null | undefined;
  distalWorkingLength?: number | null | undefined;
  mesialWorkingLength?: number | null | undefined;
  palatalWorkingLength?: number | null | undefined;
  distalMarFile?: number | null | undefined;
  mesialMarFile?: number | null | undefined;
  palatalMarFile?: number | null | undefined;
  technique?: string | null | undefined;
  treatmentComment?: string | null | undefined;
  tooth: { _id: number; toothName: string };
};

export type UpdateTeethStateMutationVariables = Exact<{
  input: UpdateStatusBulkDentalChartingInput;
}>;

export type UpdateTeethStateMutation = {
  updateStatusBulkDentalCharting?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdateDentalChartingMutationVariables = Exact<{
  input: UpdateDentalChartingInput;
}>;

export type UpdateDentalChartingMutation = {
  updateDentalCharting?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdateQuickChartMutationVariables = Exact<{
  input: UpdateQuickChartBulkDentalChartingInput;
}>;

export type UpdateQuickChartMutation = {
  updateQuickChartBulkDentalCharting?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type PrintDentalReportMutationVariables = Exact<{
  input: CreateDentalReportPrintInput;
}>;

export type PrintDentalReportMutation = {
  createDentalReportPrint?:
    | {
        dentalReportPrint?:
          | { id: string; file?: { _id: number } | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ExportDentalReportMutationVariables = Exact<{
  input: CreateDentalReportExportInput;
}>;

export type ExportDentalReportMutation = {
  createDentalReportExport?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type DentalSketchCommentFragment = {
  locationX: number;
  locationY: number;
  createdAt?: any | null | undefined;
  text: string;
  _id: number;
  createdBy: {
    _id: number;
    firstName: string;
    lastName: string;
    image?: { _id: number } | null | undefined;
  };
};

export type UpdateDentalSketchCommentMutationVariables = Exact<{
  input: UpdateDentalSketchCommentInput;
}>;

export type UpdateDentalSketchCommentMutation = {
  updateDentalSketchComment?:
    | {
        dentalSketchComment?:
          | {
              locationX: number;
              locationY: number;
              createdAt?: any | null | undefined;
              text: string;
              _id: number;
              createdBy: {
                _id: number;
                firstName: string;
                lastName: string;
                image?: { _id: number } | null | undefined;
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateDentalSketchCommentMutationVariables = Exact<{
  input: CreateDentalSketchCommentInput;
}>;

export type CreateDentalSketchCommentMutation = {
  createDentalSketchComment?:
    | {
        dentalSketchComment?:
          | {
              locationX: number;
              locationY: number;
              createdAt?: any | null | undefined;
              text: string;
              _id: number;
              createdBy: {
                _id: number;
                firstName: string;
                lastName: string;
                image?: { _id: number } | null | undefined;
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteDentalSketchCommentsMutationVariables = Exact<{
  input: RemoveBulkDentalSketchCommentInput;
}>;

export type DeleteDentalSketchCommentsMutation = {
  removeBulkDentalSketchComment?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type PatientVaccineFragment = {
  vaccine: VaccineEnum;
  _id: number;
  toPerform: boolean;
};

export type UpdateVaccineMutationVariables = Exact<{
  input: UpdateVaccineInput;
}>;

export type UpdateVaccineMutation = {
  updateVaccine?:
    | {
        vaccine?:
          | { vaccine: VaccineEnum; _id: number; toPerform: boolean }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type TestFragment = {
  test: PatientTestEnum;
  _id: number;
  toPerform: boolean;
};

export type UpdatePatientTestMutationVariables = Exact<{
  input: UpdatePatientTestInput;
}>;

export type UpdatePatientTestMutation = {
  updatePatientTest?:
    | {
        patientTest?:
          | { test: PatientTestEnum; _id: number; toPerform: boolean }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PatientTreatmentFragment = {
  cereniaInjection: boolean;
  laserTherapy: boolean;
  microchip: boolean;
  _id: number;
};

export type UpdateTreatmentsMutationVariables = Exact<{
  input: UpdateTreatmentInput;
}>;

export type UpdateTreatmentsMutation = {
  updateTreatment?:
    | {
        treatment?:
          | {
              cereniaInjection: boolean;
              laserTherapy: boolean;
              microchip: boolean;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PatientExamNoteFragment = {
  _id: number;
  additionalNotes?: string | null | undefined;
  allergies?: string | null | undefined;
  bloodwork?: string | null | undefined;
  lastMealAt?: any | null | undefined;
  patientPersonalItems?: string | null | undefined;
  previousSurgery?: string | null | undefined;
  treatmentPlan?: string | null | undefined;
  vaccines?: string | null | undefined;
};

export type UpdateExamNotesMutationVariables = Exact<{
  input: UpdateExamNoteInput;
}>;

export type UpdateExamNotesMutation = {
  updateExamNote?:
    | {
        examNote?:
          | {
              _id: number;
              additionalNotes?: string | null | undefined;
              allergies?: string | null | undefined;
              bloodwork?: string | null | undefined;
              lastMealAt?: any | null | undefined;
              patientPersonalItems?: string | null | undefined;
              previousSurgery?: string | null | undefined;
              treatmentPlan?: string | null | undefined;
              vaccines?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PreAnestheticExamFragment = {
  _id: number;
  temperature?: number | null | undefined;
  heartRate?: number | null | undefined;
  respiratoryRate?: number | null | undefined;
  painScore?: number | null | undefined;
  bodyConditionScore?: number | null | undefined;
  dentalScore?: number | null | undefined;
  physicalStatus?: PatientPhysicalStatus | null | undefined;
};

export type UpdatePreAnestheticExamMutationVariables = Exact<{
  input: UpdatePreAnestheticExamInput;
}>;

export type UpdatePreAnestheticExamMutation = {
  updatePreAnestheticExam?:
    | {
        preAnestheticExam?:
          | {
              _id: number;
              temperature?: number | null | undefined;
              heartRate?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              painScore?: number | null | undefined;
              bodyConditionScore?: number | null | undefined;
              dentalScore?: number | null | undefined;
              physicalStatus?: PatientPhysicalStatus | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PhysicalExamFragment = {
  _id: number;
  generalAppearance?: PatientStateEnum | null | undefined;
  generalAppearanceAbnormalStateComments?: string | null | undefined;
  gastrointestinal?: PatientStateEnum | null | undefined;
  gastrointestinalAbnormalStateComments?: string | null | undefined;
  oralCavity?: PatientStateEnum | null | undefined;
  oralCavityAbnormalStateComments?: string | null | undefined;
  musculosceletal?: PatientStateEnum | null | undefined;
  musculosceletalAbnormalStateComments?: string | null | undefined;
  mucousMembranes?: PatientStateEnum | null | undefined;
  mucousMembranesAbnormalStateComments?: string | null | undefined;
  lymphNodes?: PatientStateEnum | null | undefined;
  lymphNodesAbnormalStateComments?: string | null | undefined;
  eyes?: PatientStateEnum | null | undefined;
  eyesAbnormalStateComments?: string | null | undefined;
  urogenital?: PatientStateEnum | null | undefined;
  urogenitalAbnormalStateComments?: string | null | undefined;
  ears?: PatientStateEnum | null | undefined;
  earsAbnormalStateComments?: string | null | undefined;
  integumentary?: PatientStateEnum | null | undefined;
  integumentaryAbnormalStateComments?: string | null | undefined;
  cardiovascular?: PatientStateEnum | null | undefined;
  cardiovascularAbnormalStateComments?: string | null | undefined;
  nervousSystem?: PatientStateEnum | null | undefined;
  nervousSystemAbnormalStateComments?: string | null | undefined;
  respiratory?: PatientStateEnum | null | undefined;
  respiratoryAbnormalStateComments?: string | null | undefined;
};

export type UpdatePatientPhysicalExamMutationVariables = Exact<{
  input: UpdatePhysicalExamInput;
}>;

export type UpdatePatientPhysicalExamMutation = {
  updatePhysicalExam?:
    | {
        physicalExam?:
          | {
              _id: number;
              generalAppearance?: PatientStateEnum | null | undefined;
              generalAppearanceAbnormalStateComments?:
                | string
                | null
                | undefined;
              gastrointestinal?: PatientStateEnum | null | undefined;
              gastrointestinalAbnormalStateComments?: string | null | undefined;
              oralCavity?: PatientStateEnum | null | undefined;
              oralCavityAbnormalStateComments?: string | null | undefined;
              musculosceletal?: PatientStateEnum | null | undefined;
              musculosceletalAbnormalStateComments?: string | null | undefined;
              mucousMembranes?: PatientStateEnum | null | undefined;
              mucousMembranesAbnormalStateComments?: string | null | undefined;
              lymphNodes?: PatientStateEnum | null | undefined;
              lymphNodesAbnormalStateComments?: string | null | undefined;
              eyes?: PatientStateEnum | null | undefined;
              eyesAbnormalStateComments?: string | null | undefined;
              urogenital?: PatientStateEnum | null | undefined;
              urogenitalAbnormalStateComments?: string | null | undefined;
              ears?: PatientStateEnum | null | undefined;
              earsAbnormalStateComments?: string | null | undefined;
              integumentary?: PatientStateEnum | null | undefined;
              integumentaryAbnormalStateComments?: string | null | undefined;
              cardiovascular?: PatientStateEnum | null | undefined;
              cardiovascularAbnormalStateComments?: string | null | undefined;
              nervousSystem?: PatientStateEnum | null | undefined;
              nervousSystemAbnormalStateComments?: string | null | undefined;
              respiratory?: PatientStateEnum | null | undefined;
              respiratoryAbnormalStateComments?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DiagnosticTestingFragment = {
  _id: number;
  abnormalitiesAndNotes?: string | null | undefined;
  reviewedByDvm?: boolean | null | undefined;
  doctor?:
    | { _id: number; firstName: string; lastName: string }
    | null
    | undefined;
};

export type UpdateDiagnosticTestingMutationVariables = Exact<{
  input: UpdateDiagnosticTestingInput;
}>;

export type UpdateDiagnosticTestingMutation = {
  updateDiagnosticTesting?:
    | {
        diagnosticTesting?:
          | {
              _id: number;
              abnormalitiesAndNotes?: string | null | undefined;
              reviewedByDvm?: boolean | null | undefined;
              doctor?:
                | { _id: number; firstName: string; lastName: string }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type AdditionalDiagnosticTestFragment = {
  _id: number;
  toPerform: boolean;
  test: string;
};

export type UpdateAdditionalDiagnosticTestMutationVariables = Exact<{
  input: UpdateAdditionalDiagnosticTestInput;
}>;

export type UpdateAdditionalDiagnosticTestMutation = {
  updateAdditionalDiagnosticTest?:
    | {
        additionalDiagnosticTest?:
          | { _id: number; toPerform: boolean; test: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateAdditionalDiagnosticTestMutationVariables = Exact<{
  input: CreateAdditionalDiagnosticTestInput;
}>;

export type CreateAdditionalDiagnosticTestMutation = {
  createAdditionalDiagnosticTest?:
    | {
        additionalDiagnosticTest?:
          | { _id: number; toPerform: boolean; test: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CurrentMedicationFragment = {
  _id: number;
  medication?: string | null | undefined;
  dose: string;
  frequency: MedicationFrequencyEnum;
  lastGivenAt: any;
};

export type CreateCurrentMedicationMutationVariables = Exact<{
  input: CreateCurrentMedicationInput;
}>;

export type CreateCurrentMedicationMutation = {
  createCurrentMedication?:
    | {
        currentMedication?:
          | {
              _id: number;
              medication?: string | null | undefined;
              dose: string;
              frequency: MedicationFrequencyEnum;
              lastGivenAt: any;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateCurrentMedicationMutationVariables = Exact<{
  input: UpdateCurrentMedicationInput;
}>;

export type UpdateCurrentMedicationMutation = {
  updateCurrentMedication?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type RemoveBulkCurrentMedicationMutationVariables = Exact<{
  input: RemoveBulkCurrentMedicationInput;
}>;

export type RemoveBulkCurrentMedicationMutation = {
  removeBulkCurrentMedication?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdatePatientAvatarMutationVariables = Exact<{
  id: Scalars["Int"];
  image?: InputMaybe<UpdateFileNestedInput>;
}>;

export type UpdatePatientAvatarMutation = {
  updatePatient?:
    | {
        patient?:
          | { _id: number; image?: { _id: number } | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type FluidAndTemperatureFragment = {
  _id: number;
  fluidRate?: number | null | undefined;
  temperature?: number | null | undefined;
  timeMonitoring?: any | null | undefined;
  volumeInfused?: number | null | undefined;
  volumeToBeInfused?: number | null | undefined;
};

export type CreateFluidAndTemperatureMutationVariables = Exact<{
  input: CreateFluidTemperatureInput;
}>;

export type CreateFluidAndTemperatureMutation = {
  createFluidTemperature?:
    | {
        fluidTemperature?:
          | {
              _id: number;
              fluidRate?: number | null | undefined;
              temperature?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              volumeInfused?: number | null | undefined;
              volumeToBeInfused?: number | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateFluidAndTemperatureMutationVariables = Exact<{
  input: UpdateFluidTemperatureInput;
}>;

export type UpdateFluidAndTemperatureMutation = {
  updateFluidTemperature?:
    | {
        fluidTemperature?:
          | {
              _id: number;
              fluidRate?: number | null | undefined;
              temperature?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              volumeInfused?: number | null | undefined;
              volumeToBeInfused?: number | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type AnestheticGasAndOxygenFragment = {
  inhalantAnestheticAgent?: number | null | undefined;
  oxygen?: number | null | undefined;
  timeMonitoring?: any | null | undefined;
  _id: number;
};

export type CreateAnestheticGasAndOxygenMutationVariables = Exact<{
  input: CreateAnestheticGasInput;
}>;

export type CreateAnestheticGasAndOxygenMutation = {
  createAnestheticGas?:
    | {
        anestheticGas?:
          | {
              inhalantAnestheticAgent?: number | null | undefined;
              oxygen?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateAnestheticGasAndOxygenMutationVariables = Exact<{
  input: UpdateAnestheticGasInput;
}>;

export type UpdateAnestheticGasAndOxygenMutation = {
  updateAnestheticGas?:
    | {
        anestheticGas?:
          | {
              inhalantAnestheticAgent?: number | null | undefined;
              oxygen?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type VitalFragment = {
  diastolicBloodPressure?: number | null | undefined;
  endTidal?: number | null | undefined;
  heartRate?: number | null | undefined;
  meanBloodPressure?: number | null | undefined;
  pulseOximetry?: number | null | undefined;
  respiratoryRate?: number | null | undefined;
  systolicBloodPressure?: number | null | undefined;
  timeMonitoring?: any | null | undefined;
  _id: number;
};

export type CreateVitalMutationVariables = Exact<{
  input: CreateVitalInput;
}>;

export type CreateVitalMutation = {
  createVital?:
    | {
        vital?:
          | {
              diastolicBloodPressure?: number | null | undefined;
              endTidal?: number | null | undefined;
              heartRate?: number | null | undefined;
              meanBloodPressure?: number | null | undefined;
              pulseOximetry?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              systolicBloodPressure?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateVitalMutationVariables = Exact<{
  input: UpdateVitalInput;
}>;

export type UpdateVitalMutation = {
  updateVital?:
    | {
        vital?:
          | {
              diastolicBloodPressure?: number | null | undefined;
              endTidal?: number | null | undefined;
              heartRate?: number | null | undefined;
              meanBloodPressure?: number | null | undefined;
              pulseOximetry?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              systolicBloodPressure?: number | null | undefined;
              timeMonitoring?: any | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PostAnestheticVitalFragment = {
  comment?: string | null | undefined;
  fluidRate?: number | null | undefined;
  heartRate?: number | null | undefined;
  initials?: string | null | undefined;
  meanBloodPressure?: number | null | undefined;
  painScore?: number | null | undefined;
  respiratoryRate?: number | null | undefined;
  temperature?: number | null | undefined;
  timeMonitoring: any;
  _id: number;
};

export type CreatePostAnestheticVitalMutationVariables = Exact<{
  input: CreatePostAnestheticVitalInput;
}>;

export type CreatePostAnestheticVitalMutation = {
  createPostAnestheticVital?:
    | {
        postAnestheticVital?:
          | {
              comment?: string | null | undefined;
              fluidRate?: number | null | undefined;
              heartRate?: number | null | undefined;
              initials?: string | null | undefined;
              meanBloodPressure?: number | null | undefined;
              painScore?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              temperature?: number | null | undefined;
              timeMonitoring: any;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdatePostAnestheticVitalMutationVariables = Exact<{
  input: UpdatePostAnestheticVitalInput;
}>;

export type UpdatePostAnestheticVitalMutation = {
  updatePostAnestheticVital?:
    | {
        postAnestheticVital?:
          | {
              comment?: string | null | undefined;
              fluidRate?: number | null | undefined;
              heartRate?: number | null | undefined;
              initials?: string | null | undefined;
              meanBloodPressure?: number | null | undefined;
              painScore?: number | null | undefined;
              respiratoryRate?: number | null | undefined;
              temperature?: number | null | undefined;
              timeMonitoring: any;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PatientProcedureFragment = {
  endTime?: any | null | undefined;
  name?: string | null | undefined;
  startTime?: any | null | undefined;
  _id: number;
};

export type CreatePatientProcedureMutationVariables = Exact<{
  input: CreatePatientProcedureInput;
}>;

export type CreatePatientProcedureMutation = {
  createPatientProcedure?:
    | {
        patientProcedure?:
          | {
              endTime?: any | null | undefined;
              name?: string | null | undefined;
              startTime?: any | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdatePatientProcedureMutationVariables = Exact<{
  input: UpdatePatientProcedureInput;
}>;

export type UpdatePatientProcedureMutation = {
  updatePatientProcedure?:
    | {
        patientProcedure?:
          | {
              endTime?: any | null | undefined;
              name?: string | null | undefined;
              startTime?: any | null | undefined;
              _id: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateMonitoringMutationVariables = Exact<{
  input: UpdateMonitoringInput;
}>;

export type UpdateMonitoringMutation = {
  updateMonitoring?:
    | {
        monitoring?:
          | { _id: number; monitoringBy?: { _id: number } | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PostAnestheticVitalCommentFragment = {
  _id: number;
  comment?: string | null | undefined;
  surgeryReport?: string | null | undefined;
};

export type UpdatePostAnestheticVitalCommentMutationVariables = Exact<{
  input: UpdatePostAnestheticVitalCommentInput;
}>;

export type UpdatePostAnestheticVitalCommentMutation = {
  updatePostAnestheticVitalComment?:
    | {
        postAnestheticVitalComment?:
          | {
              _id: number;
              comment?: string | null | undefined;
              surgeryReport?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateVitalCommentMutationVariables = Exact<{
  input: UpdateVitalCommentInput;
}>;

export type UpdateVitalCommentMutation = {
  updateVitalComment?:
    | {
        vitalComment?:
          | {
              _id: number;
              comment?: string | null | undefined;
              qualityRecovery?: QualityRecoveryEnum | null | undefined;
              timeExtubation?: any | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type SetLightMonitoringInformationMutationVariables = Exact<{
  input: SetLightMonitoringInformationInput;
}>;

export type SetLightMonitoringInformationMutation = {
  setLightMonitoringInformation?:
    | {
        lightMonitoringInformation?:
          | {
              vital: {
                diastolicBloodPressure?: number | null | undefined;
                endTidal?: number | null | undefined;
                heartRate?: number | null | undefined;
                meanBloodPressure?: number | null | undefined;
                pulseOximetry?: number | null | undefined;
                respiratoryRate?: number | null | undefined;
                systolicBloodPressure?: number | null | undefined;
                timeMonitoring?: any | null | undefined;
                _id: number;
              };
              anestheticGas: {
                inhalantAnestheticAgent?: number | null | undefined;
                oxygen?: number | null | undefined;
                timeMonitoring?: any | null | undefined;
                _id: number;
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type SetFullMonitoringInformationMutationVariables = Exact<{
  input: SetFullMonitoringInformationInput;
}>;

export type SetFullMonitoringInformationMutation = {
  setFullMonitoringInformation?:
    | {
        fullMonitoringInformation?:
          | {
              fluidTemperature: {
                _id: number;
                fluidRate?: number | null | undefined;
                temperature?: number | null | undefined;
                timeMonitoring?: any | null | undefined;
                volumeInfused?: number | null | undefined;
                volumeToBeInfused?: number | null | undefined;
              };
              vital: {
                diastolicBloodPressure?: number | null | undefined;
                endTidal?: number | null | undefined;
                heartRate?: number | null | undefined;
                meanBloodPressure?: number | null | undefined;
                pulseOximetry?: number | null | undefined;
                respiratoryRate?: number | null | undefined;
                systolicBloodPressure?: number | null | undefined;
                timeMonitoring?: any | null | undefined;
                _id: number;
              };
              anestheticGas: {
                inhalantAnestheticAgent?: number | null | undefined;
                oxygen?: number | null | undefined;
                timeMonitoring?: any | null | undefined;
                _id: number;
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type TabletFragment = {
  _id: number;
  dosage: number;
  dose: number;
  labelInstructions?: string | null | undefined;
  numberOfTablets?: number | null | undefined;
  tabletSize?: number | null | undefined;
  medication: string;
};

export type UpdateTabletMutationVariables = Exact<{
  input: UpdateTabletInput;
}>;

export type UpdateTabletMutation = {
  updateTablet?:
    | {
        tablet?:
          | {
              _id: number;
              dosage: number;
              dose: number;
              labelInstructions?: string | null | undefined;
              numberOfTablets?: number | null | undefined;
              tabletSize?: number | null | undefined;
              medication: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateTabletMutationVariables = Exact<{
  input: CreateTabletInput;
}>;

export type CreateTabletMutation = {
  createTablet?:
    | {
        tablet?:
          | {
              _id: number;
              dosage: number;
              dose: number;
              labelInstructions?: string | null | undefined;
              numberOfTablets?: number | null | undefined;
              tabletSize?: number | null | undefined;
              medication: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteTabletsMutationVariables = Exact<{
  input: RemoveBulkTabletInput;
}>;

export type DeleteTabletsMutation = {
  removeBulkTablet?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type SuspensionFragment = {
  _id: number;
  dose: number;
  labelInstructions?: string | null | undefined;
  totalVolume?: number | null | undefined;
  volume: number;
  medication: string;
  concentration: number;
};

export type UpdateSuspensionMutationVariables = Exact<{
  input: UpdateSuspensionInput;
}>;

export type UpdateSuspensionMutation = {
  updateSuspension?:
    | {
        suspension?:
          | {
              _id: number;
              dose: number;
              labelInstructions?: string | null | undefined;
              totalVolume?: number | null | undefined;
              volume: number;
              medication: string;
              concentration: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateSuspensionMutationVariables = Exact<{
  input: CreateSuspensionInput;
}>;

export type CreateSuspensionMutation = {
  createSuspension?:
    | {
        suspension?:
          | {
              _id: number;
              dose: number;
              labelInstructions?: string | null | undefined;
              totalVolume?: number | null | undefined;
              volume: number;
              medication: string;
              concentration: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteSuspensionsMutationVariables = Exact<{
  input: RemoveBulkSuspensionInput;
}>;

export type DeleteSuspensionsMutation = {
  removeBulkSuspension?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type TploFragment = {
  _id: number;
  d1?: string | null | undefined;
  d2?: string | null | undefined;
  d3?: string | null | undefined;
  rotationNeeded?: string | null | undefined;
  initialTpa?: string | null | undefined;
  postOpTpa?: string | null | undefined;
  tploBladeSize?: string | null | undefined;
  tploPlateSizeAndModel?: string | null | undefined;
};

export type UpdateTploMutationVariables = Exact<{
  input: UpdateTibialPlateauLevelingOsteotomyPlanningInput;
}>;

export type UpdateTploMutation = {
  updateTibialPlateauLevelingOsteotomyPlanning?:
    | {
        tibialPlateauLevelingOsteotomyPlanning?:
          | {
              _id: number;
              d1?: string | null | undefined;
              d2?: string | null | undefined;
              d3?: string | null | undefined;
              rotationNeeded?: string | null | undefined;
              initialTpa?: string | null | undefined;
              postOpTpa?: string | null | undefined;
              tploBladeSize?: string | null | undefined;
              tploPlateSizeAndModel?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CaseFragment = {
  id: string;
  _id: number;
  name: string;
  status: CaseStatusEnum;
  fromVetspire: boolean;
  createdAt: any;
  updatedAt?: any | null | undefined;
  createdFrom?: { _id: number; name: string } | null | undefined;
  organization: { id: string; _id: number; name: string };
  client: {
    _id: number;
    disclaimer: {
      id: string;
      _id: number;
      signature?: { id: string; _id: number; name: string } | null | undefined;
    };
    patient: {
      _id: number;
      procedureDate: any;
      image?: { _id: number } | null | undefined;
    };
  };
};

export type MedicalCasesQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  filter?: InputMaybe<MedicalCaseFilter>;
  order?: InputMaybe<
    | Array<InputMaybe<MedicalCaseFilter_Order>>
    | InputMaybe<MedicalCaseFilter_Order>
  >;
}>;

export type MedicalCasesQuery = {
  medicalCases?:
    | {
        collection: Array<{
          id: string;
          _id: number;
          name: string;
          status: CaseStatusEnum;
          fromVetspire: boolean;
          createdAt: any;
          updatedAt?: any | null | undefined;
          createdFrom?: { _id: number; name: string } | null | undefined;
          organization: { id: string; _id: number; name: string };
          client: {
            _id: number;
            disclaimer: {
              id: string;
              _id: number;
              signature?:
                | { id: string; _id: number; name: string }
                | null
                | undefined;
            };
            patient: {
              _id: number;
              procedureDate: any;
              image?: { _id: number } | null | undefined;
            };
          };
        }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type CreateMedicalCaseMutationVariables = Exact<{
  input: CreateMedicalCaseInput;
}>;

export type CreateMedicalCaseMutation = {
  createMedicalCase?:
    | {
        medicalCase?:
          | {
              id: string;
              _id: number;
              name: string;
              status: CaseStatusEnum;
              fromVetspire: boolean;
              createdAt: any;
              updatedAt?: any | null | undefined;
              createdFrom?: { _id: number; name: string } | null | undefined;
              organization: { id: string; _id: number; name: string };
              client: {
                _id: number;
                disclaimer: {
                  id: string;
                  _id: number;
                  signature?:
                    | { id: string; _id: number; name: string }
                    | null
                    | undefined;
                };
                patient: {
                  _id: number;
                  procedureDate: any;
                  image?: { _id: number } | null | undefined;
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateMedicalCaseMutationVariables = Exact<{
  input: UpdateMedicalCaseInput;
}>;

export type UpdateMedicalCaseMutation = {
  updateMedicalCase?:
    | {
        medicalCase?:
          | {
              id: string;
              _id: number;
              name: string;
              status: CaseStatusEnum;
              fromVetspire: boolean;
              createdAt: any;
              updatedAt?: any | null | undefined;
              createdFrom?: { _id: number; name: string } | null | undefined;
              organization: { id: string; _id: number; name: string };
              client: {
                _id: number;
                disclaimer: {
                  id: string;
                  _id: number;
                  signature?:
                    | { id: string; _id: number; name: string }
                    | null
                    | undefined;
                };
                patient: {
                  _id: number;
                  procedureDate: any;
                  image?: { _id: number } | null | undefined;
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CopyMedicalCaseMutationVariables = Exact<{
  input: CopyMedicalCaseInput;
}>;

export type CopyMedicalCaseMutation = {
  copyMedicalCase?:
    | {
        medicalCase?:
          | {
              id: string;
              _id: number;
              name: string;
              status: CaseStatusEnum;
              fromVetspire: boolean;
              createdAt: any;
              updatedAt?: any | null | undefined;
              createdFrom?: { _id: number; name: string } | null | undefined;
              organization: { id: string; _id: number; name: string };
              client: {
                _id: number;
                disclaimer: {
                  id: string;
                  _id: number;
                  signature?:
                    | { id: string; _id: number; name: string }
                    | null
                    | undefined;
                };
                patient: {
                  _id: number;
                  procedureDate: any;
                  image?: { _id: number } | null | undefined;
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteMedicalCasesMutationVariables = Exact<{
  input: RemoveBulkMedicalCaseInput;
}>;

export type DeleteMedicalCasesMutation = {
  removeBulkMedicalCase?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type UpdateMedicalCasesStatusMutationVariables = Exact<{
  input: UpdateStatusBulkMedicalCaseInput;
}>;

export type UpdateMedicalCasesStatusMutation = {
  updateStatusBulkMedicalCase?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type ExportMedicalRecordMutationVariables = Exact<{
  input: CreateMedicalRecordExportInput;
}>;

export type ExportMedicalRecordMutation = {
  createMedicalRecordExport?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type ExportClientReportMutationVariables = Exact<{
  input: CreateClientReportExportInput;
}>;

export type ExportClientReportMutation = {
  createClientReportExport?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type ExportReferralRecordMutationVariables = Exact<{
  input: CreateReferralDocumentExportInput;
}>;

export type ExportReferralRecordMutation = {
  createReferralDocumentExport?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type PrintMedicalRecordMutationVariables = Exact<{
  input: CreateMedicalRecordPrintInput;
}>;

export type PrintMedicalRecordMutation = {
  createMedicalRecordPrint?:
    | {
        medicalRecordPrint?:
          | { id: string; file?: { _id: number } | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PrintClientReportMutationVariables = Exact<{
  input: CreateClientReportPrintInput;
}>;

export type PrintClientReportMutation = {
  createClientReportPrint?:
    | {
        clientReportPrint?:
          | { id: string; file?: { _id: number } | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PrintReferralRecordMutationVariables = Exact<{
  input: CreateReferralDocumentPrintInput;
}>;

export type PrintReferralRecordMutation = {
  createReferralDocumentPrint?:
    | {
        referralDocumentPrint?:
          | { id: string; file?: { _id: number } | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetVetspireClientsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
}>;

export type GetVetspireClientsQuery = {
  queryVetspireClients?:
    | {
        collection: Array<{ _id: string; firstName: string; lastName: string }>;
        paginationInfo: { totalCount: number };
      }
    | null
    | undefined;
};

export type GetVetspirePatientsQueryVariables = Exact<{
  clientId: Scalars["String"];
}>;

export type GetVetspirePatientsQuery = {
  queryVetspirePatients?:
    | { collection: Array<{ _id: string; name: string }> }
    | null
    | undefined;
};

export type ImportVetspireMedicalCaseMutationVariables = Exact<{
  input: ImportVetspireMedicalCaseInput;
}>;

export type ImportVetspireMedicalCaseMutation = {
  importVetspireMedicalCase?:
    | {
        vetspireMedicalCase?:
          | {
              medicalCase: {
                id: string;
                _id: number;
                name: string;
                status: CaseStatusEnum;
                fromVetspire: boolean;
                createdAt: any;
                updatedAt?: any | null | undefined;
                createdFrom?: { _id: number; name: string } | null | undefined;
                organization: { id: string; _id: number; name: string };
                client: {
                  _id: number;
                  disclaimer: {
                    id: string;
                    _id: number;
                    signature?:
                      | { id: string; _id: number; name: string }
                      | null
                      | undefined;
                  };
                  patient: {
                    _id: number;
                    procedureDate: any;
                    image?: { _id: number } | null | undefined;
                  };
                };
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ExportMedicalCaseToVetspireMutationVariables = Exact<{
  input: ExportPdfToVetspireMedicalCaseInput;
}>;

export type ExportMedicalCaseToVetspireMutation = {
  exportPdfToVetspireMedicalCase?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type CreateFileMutationVariables = Exact<{
  input: CreateFileInput;
}>;

export type CreateFileMutation = {
  createFile?:
    | {
        file?:
          | {
              _id: number;
              id: string;
              name: string;
              mimeType: string;
              path: string;
              size: number;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetAllProceduresQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllProceduresQuery = {
  procedures?:
    | { collection: Array<{ _id: string; name: string }> }
    | null
    | undefined;
};

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUsersQuery = {
  users?:
    | {
        collection: Array<{
          _id: number;
          firstName: string;
          lastName: string;
          userRole: UserRoleEnum;
        }>;
      }
    | null
    | undefined;
};

export type GetAllBreedsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllBreedsQuery = {
  breeds?:
    | { collection: Array<{ _id: string; name: string; species: SpeciesEnum }> }
    | null
    | undefined;
};

export type GetAllMedicationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllMedicationsQuery = {
  medications?:
    | {
        collection: Array<{
          _id: string;
          name: string;
          concentration?: number | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type GetAllProtocolsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllProtocolsQuery = {
  anestheticProtocols?:
    | {
        collection: Array<{
          defaultProtocol: boolean;
          name: string;
          _id: number;
          createdBy: { _id: number };
          medicationCalculations?:
            | {
                collection: Array<{
                  type: MedicationCalculationTypeEnum;
                  concentration: number;
                  dose: number;
                  route: RouteEnum;
                  medication: string;
                  additionalVolumeAdministered?: number | null | undefined;
                  additionalVolumeDrawn?: number | null | undefined;
                  volumeAdministered?: number | null | undefined;
                  _id: number;
                }>;
              }
            | null
            | undefined;
          regionalBlocks?:
            | {
                collection: Array<{
                  _id: number;
                  type: RegionalBlockTypeEnum;
                  concentration: number;
                  doseMax: number;
                  doseMin: number;
                  volumeToBeInfused?: number | null | undefined;
                  medication: string;
                }>;
              }
            | null
            | undefined;
        }>;
      }
    | null
    | undefined;
};

export type GetAllDisclaimersQueryVariables = Exact<{
  organizationId: Scalars["Int"];
}>;

export type GetAllDisclaimersQuery = {
  organization?:
    | {
        _id: number;
        organizationSetting?:
          | {
              _id: number;
              disclaimerText: string;
              disclaimerProcedureSettings?:
                | {
                    collection: Array<{
                      _id: number;
                      description: string;
                      title: string;
                    }>;
                  }
                | null
                | undefined;
              authorizationSettings?:
                | { collection: Array<{ _id: number; condition: string }> }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type OrganizationFragment = {
  _id: number;
  contactEmail?: string | null | undefined;
  description?: string | null | undefined;
  name: string;
  vetspireApiKey?: string | null | undefined;
  logo?: { _id: number } | null | undefined;
};

export type OrganizationQueryVariables = Exact<{
  _id: Scalars["Int"];
}>;

export type OrganizationQuery = {
  organization?:
    | {
        _id: number;
        contactEmail?: string | null | undefined;
        description?: string | null | undefined;
        name: string;
        vetspireApiKey?: string | null | undefined;
        users?:
          | {
              collection: Array<{
                id: string;
                _id: number;
                firstName: string;
                lastName: string;
                email: string;
                userRole: UserRoleEnum;
              }>;
            }
          | null
          | undefined;
        logo?: { _id: number } | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;

export type UpdateOrganizationMutation = {
  updateOrganization?:
    | {
        organization?:
          | {
              _id: number;
              contactEmail?: string | null | undefined;
              description?: string | null | undefined;
              name: string;
              vetspireApiKey?: string | null | undefined;
              logo?: { _id: number } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetOrganizationAdminQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganizationAdminQuery = {
  users?:
    | {
        collection: Array<{
          id: string;
          _id: number;
          firstName: string;
          lastName: string;
          email: string;
          image?: { _id: number; id: string } | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type UpdateOrganizationAdminMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateOrganizationAdminMutation = {
  updateUser?:
    | {
        user?:
          | {
              _id: number;
              firstName: string;
              lastName: string;
              email: string;
              image?: { _id: number; path: string } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetUsersQueryVariables = Exact<{
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<Scalars["Int"]>;
}>;

export type GetUsersQuery = {
  users?:
    | {
        collection: Array<{
          id: string;
          _id: number;
          active: boolean;
          email: string;
          firstName: string;
          lastName: string;
          userRole: UserRoleEnum;
          username: string;
        }>;
        paginationInfo: {
          itemsPerPage: number;
          lastPage: number;
          totalCount: number;
        };
      }
    | null
    | undefined;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type GetUserQuery = {
  user?:
    | {
        id: string;
        _id: number;
        active: boolean;
        email: string;
        firstName: string;
        lastName: string;
        userRole: UserRoleEnum;
        username: string;
        image?: { _id: number } | null | undefined;
      }
    | null
    | undefined;
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  createUser?:
    | {
        user?: { id: string; _id: number; username: string } | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  updateUser?:
    | {
        user?:
          | {
              _id: number;
              firstName: string;
              lastName: string;
              email: string;
              image?: { _id: number; path: string } | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;

export type DeleteUserMutation = {
  deleteUser?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type GetAllowedUsersCountQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type GetAllowedUsersCountQuery = {
  user?:
    | {
        organization?:
          | {
              order?:
                | { license: { maxNumberOfUsers: number } }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
  users?: { paginationInfo: { totalCount: number } } | null | undefined;
};

export type AuthorizationSettingFragment = { _id: number; condition: string };

export type DisclaimerProcedureSettingFragment = {
  _id: number;
  description: string;
  title: string;
};

export type GetOrganizationSettingsQueryVariables = Exact<{
  _id: Scalars["Int"];
}>;

export type GetOrganizationSettingsQuery = {
  organization?:
    | {
        _id: number;
        organizationSetting?:
          | {
              _id: number;
              disclaimerText: string;
              dateFormat: DateFormatEnum;
              temperatureUnit: TemperatureUnitEnum;
              authorizationSettings?:
                | { collection: Array<{ _id: number; condition: string }> }
                | null
                | undefined;
              disclaimerProcedureSettings?:
                | {
                    collection: Array<{
                      _id: number;
                      description: string;
                      title: string;
                    }>;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateAuthorizationSettingMutationVariables = Exact<{
  input: UpdateAuthorizationSettingInput;
}>;

export type UpdateAuthorizationSettingMutation = {
  updateAuthorizationSetting?:
    | {
        authorizationSetting?:
          | { _id: number; condition: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateDisclaimerProcedureSettingMutationVariables = Exact<{
  input: UpdateDisclaimerProcedureSettingInput;
}>;

export type UpdateDisclaimerProcedureSettingMutation = {
  updateDisclaimerProcedureSetting?:
    | {
        disclaimerProcedureSetting?:
          | { _id: number; description: string; title: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RemoveAuthorizationSettingsMutationVariables = Exact<{
  input: RemoveBulkAuthorizationSettingInput;
}>;

export type RemoveAuthorizationSettingsMutation = {
  removeBulkAuthorizationSetting?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type RemoveDisclaimerProcedureSettingsMutationVariables = Exact<{
  input: RemoveBulkDisclaimerProcedureSettingInput;
}>;

export type RemoveDisclaimerProcedureSettingsMutation = {
  removeBulkDisclaimerProcedureSetting?:
    | { clientMutationId?: string | null | undefined }
    | null
    | undefined;
};

export type CreateAuthorizationSettingMutationVariables = Exact<{
  input: CreateAuthorizationSettingInput;
}>;

export type CreateAuthorizationSettingMutation = {
  createAuthorizationSetting?:
    | {
        authorizationSetting?:
          | { _id: number; condition: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateDisclaimerProcedureSettingMutationVariables = Exact<{
  input: CreateDisclaimerProcedureSettingInput;
}>;

export type CreateDisclaimerProcedureSettingMutation = {
  createDisclaimerProcedureSetting?:
    | {
        disclaimerProcedureSetting?:
          | { _id: number; description: string; title: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateOrganizationSettingMutationVariables = Exact<{
  input: UpdateOrganizationSettingInput;
}>;

export type UpdateOrganizationSettingMutation = {
  updateOrganizationSetting?:
    | {
        organizationSetting?:
          | {
              _id: number;
              disclaimerText: string;
              temperatureUnit: TemperatureUnitEnum;
              dateFormat: DateFormatEnum;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export const AdminOrganizationFragmentDoc = gql`
  fragment AdminOrganization on Organization {
    _id
    contactEmail
    description
    logo {
      _id
    }
    name
    status
    adminRegistrationCompleted
  }
`;
export const AnestheticProtocolMedicationCalculationFragmentDoc = gql`
  fragment AnestheticProtocolMedicationCalculation on AnestheticProtocolMedicationCalculation {
    type
    concentration
    dose
    route
    medication
    additionalVolumeAdministered
    additionalVolumeDrawn
    volumeAdministered
    _id
  }
`;
export const AnestheticProtocolRegionalBlockFragmentDoc = gql`
  fragment AnestheticProtocolRegionalBlock on AnestheticProtocolRegionalBlock {
    _id
    type
    concentration
    doseMax
    doseMin
    volumeToBeInfused
    medication
  }
`;
export const AnestheticProtocolFragmentDoc = gql`
  fragment AnestheticProtocol on AnestheticProtocol {
    defaultProtocol
    name
    _id
    createdBy {
      _id
    }
    medicationCalculations {
      collection {
        ...AnestheticProtocolMedicationCalculation
      }
    }
    regionalBlocks {
      collection {
        ...AnestheticProtocolRegionalBlock
      }
    }
  }
  ${AnestheticProtocolMedicationCalculationFragmentDoc}
  ${AnestheticProtocolRegionalBlockFragmentDoc}
`;
export const SettingsFragmentDoc = gql`
  fragment Settings on ApplicationSettings {
    id
    user {
      _id
      pin
      firstName
      lastName
      userRole
      email
      organization {
        name
        _id
        organizationSetting {
          _id
          dateFormat
          temperatureUnit
        }
      }
      image {
        _id
        path
      }
    }
  }
`;
export const ClientInformationFragmentDoc = gql`
  fragment ClientInformation on Client {
    _id
    accountNumber
    email
    firstName
    lastName
    phoneFirst
    phoneSecond
    notAvailableTime
    streetAddress
    apartments
    disclaimer {
      id
      _id
      signature {
        id
        _id
        name
      }
      createdAt
    }
    city {
      _id
      name
      state {
        _id
        name
      }
    }
    state {
      _id
      name
    }
    zipCode
  }
`;
export const PatientInformationFragmentDoc = gql`
  fragment PatientInformation on Patient {
    _id
    name
    sex
    species
    breed
    dateOfBirth
    calculationAgreement {
      _id
      signedAt
      file {
        _id
        name
      }
    }
    weight
    weightMeasure
    procedureDate
    alerts
    procedures
  }
`;
export const DropOffFragmentDoc = gql`
  fragment DropOff on DropOff {
    _id
    admittingConcern
    evaluateTestAndTreat
    doctor {
      _id
      firstName
      lastName
    }
    performInitialEvaluation
  }
`;
export const PatientVaccineFragmentDoc = gql`
  fragment PatientVaccine on Vaccine {
    vaccine
    _id
    toPerform
  }
`;
export const TestFragmentDoc = gql`
  fragment Test on PatientTest {
    test
    _id
    toPerform
  }
`;
export const PatientTreatmentFragmentDoc = gql`
  fragment PatientTreatment on Treatment {
    cereniaInjection
    laserTherapy
    microchip
    _id
  }
`;
export const PatientExamNoteFragmentDoc = gql`
  fragment PatientExamNote on ExamNote {
    _id
    additionalNotes
    allergies
    bloodwork
    lastMealAt
    patientPersonalItems
    previousSurgery
    treatmentPlan
    vaccines
  }
`;
export const CurrentMedicationFragmentDoc = gql`
  fragment CurrentMedication on CurrentMedication {
    _id
    medication
    dose
    frequency
    lastGivenAt
  }
`;
export const PreAnestheticExamFragmentDoc = gql`
  fragment PreAnestheticExam on PreAnestheticExam {
    _id
    temperature
    heartRate
    respiratoryRate
    painScore
    bodyConditionScore
    dentalScore
    physicalStatus
  }
`;
export const PhysicalExamFragmentDoc = gql`
  fragment PhysicalExam on PhysicalExam {
    _id
    generalAppearance
    generalAppearanceAbnormalStateComments
    gastrointestinal
    gastrointestinalAbnormalStateComments
    oralCavity
    oralCavityAbnormalStateComments
    musculosceletal
    musculosceletalAbnormalStateComments
    mucousMembranes
    mucousMembranesAbnormalStateComments
    lymphNodes
    lymphNodesAbnormalStateComments
    eyes
    eyesAbnormalStateComments
    urogenital
    urogenitalAbnormalStateComments
    ears
    earsAbnormalStateComments
    integumentary
    integumentaryAbnormalStateComments
    cardiovascular
    cardiovascularAbnormalStateComments
    nervousSystem
    nervousSystemAbnormalStateComments
    respiratory
    respiratoryAbnormalStateComments
  }
`;
export const DiagnosticTestingFragmentDoc = gql`
  fragment DiagnosticTesting on DiagnosticTesting {
    _id
    abnormalitiesAndNotes
    doctor {
      _id
      firstName
      lastName
    }
    reviewedByDvm
  }
`;
export const AdditionalDiagnosticTestFragmentDoc = gql`
  fragment AdditionalDiagnosticTest on AdditionalDiagnosticTest {
    _id
    toPerform
    test
  }
`;
export const PatientProcedureFragmentDoc = gql`
  fragment PatientProcedure on PatientProcedure {
    endTime
    name
    startTime
    _id
  }
`;
export const FluidAndTemperatureFragmentDoc = gql`
  fragment FluidAndTemperature on FluidTemperature {
    _id
    fluidRate
    temperature
    timeMonitoring
    volumeInfused
    volumeToBeInfused
  }
`;
export const AnestheticGasAndOxygenFragmentDoc = gql`
  fragment AnestheticGasAndOxygen on AnestheticGas {
    inhalantAnestheticAgent
    oxygen
    timeMonitoring
    _id
  }
`;
export const VitalFragmentDoc = gql`
  fragment Vital on Vital {
    diastolicBloodPressure
    endTidal
    heartRate
    meanBloodPressure
    pulseOximetry
    respiratoryRate
    systolicBloodPressure
    timeMonitoring
    _id
  }
`;
export const MedicationCalculationFragmentDoc = gql`
  fragment MedicationCalculation on MedicationCalculation {
    _id
    calculationType
    medication
    dose
    concentration
    route
    initials
    timeAdministered
    totalAmount
    volumeAdministered
    totalVolume
    additionalVolumeAdministered
    additionalVolumeDrawn
  }
`;
export const MiscellaneousGroupFragmentDoc = gql`
  fragment MiscellaneousGroup on MiscellaneousGroup {
    _id
    catheterSize
    catheterLocation
    fluidType
    bloodPressureMonitoring
    fluidRate
    fluidRateValue
    qualityOfSedation
    anesthesiaSystem
    bagSize
    oxygenFlowRate
    intubated
    endotrachealTubeSize
  }
`;
export const DefibMedicationFragmentDoc = gql`
  fragment DefibMedication on DefibMedication {
    _id
    doseMax
    doseMin
    timeAdministered
    medication
    dosageMax
    dosageMin
    initials
  }
`;
export const RegionalBlockFragmentDoc = gql`
  fragment RegionalBlock on RegionalBlock {
    concentration
    dosageMax
    dosageMin
    doseMax
    doseMin
    type
    volumeRangeMax
    volumeRangeMin
    volumeToBeInfused
    medication
    initials
    _id
  }
`;
export const TabletFragmentDoc = gql`
  fragment Tablet on Tablet {
    _id
    dosage
    dose
    labelInstructions
    numberOfTablets
    tabletSize
    medication
  }
`;
export const SuspensionFragmentDoc = gql`
  fragment Suspension on Suspension {
    _id
    dose
    labelInstructions
    totalVolume
    volume
    medication
    concentration
  }
`;
export const TploFragmentDoc = gql`
  fragment TPLO on TibialPlateauLevelingOsteotomyPlanning {
    _id
    d1
    d2
    d3
    rotationNeeded
    initialTpa
    postOpTpa
    tploBladeSize
    tploPlateSizeAndModel
  }
`;
export const PostAnestheticVitalFragmentDoc = gql`
  fragment PostAnestheticVital on PostAnestheticVital {
    comment
    fluidRate
    heartRate
    initials
    meanBloodPressure
    painScore
    respiratoryRate
    temperature
    timeMonitoring
    _id
  }
`;
export const PostAnestheticVitalCommentFragmentDoc = gql`
  fragment PostAnestheticVitalComment on PostAnestheticVitalComment {
    _id
    comment
    surgeryReport
  }
`;
export const GeneralAssessmentFragmentDoc = gql`
  fragment GeneralAssessment on GeneralAssessment {
    _id
    notesTimer
    periodontalDisease
    plaqueIndex
    calculusIndex
    gingivalIndex
    additionalCommentsAndNotes
    beforePhotoFront {
      _id
    }
    beforePhotoLeft {
      _id
    }
    beforePhotoRight {
      _id
    }
    afterPhotoFront {
      _id
    }
    afterPhotoLeft {
      _id
    }
    afterPhotoRight {
      _id
    }
    additionalPhotos {
      collection {
        _id
      }
    }
    radiographicFindingsPhotos {
      collection {
        _id
      }
    }
    buccalMucosa
    caudalOralMucosa
    dentalChart
    extraoral
    fistula
    hardPalate
    lymphNodes
    occlusion
    occlusionDescription
    parulisSinusTract
    skullType
    softPalate
    tongue
    tonsils
    intraoralRadiographicComments
    cbctComments
    referralNotesAndComments
    notesForClientDentalReport
    rightRegionalBlocks
    rightInfraorbital
    rightMaxillary
    rightRostralMandibular
    rightInferiorAlveolar
    leftRegionalBlocks
    leftInfraorbital
    leftMaxillary
    leftRostralMandibular
    leftInferiorAlveolar
    oralSurgeries
    orthodontics
    periodontics
    planingAndSubgingivalCurettage
    boneAugmentation
    boneAugmentationDetails
    treatmentAdditionalFindingsCommentsAndNotes
    between25And50PerCentBoneLoss
    externalCervicalToothResorption
    externalInflammatoryToothResorption
    externalReplacementRootResorption
    externalSurfaceRootResorption
    greaterThan50PerCentBoneLoss
    internalToothResorption
    lessThan25PerCentBoneLoss
    missingTeeth
    periapicalLucency
    periapicalRarefaction
    retainedToothRoots
    toothResorptionType1
    toothResorptionType2
    toothResorptionType3
    uneruptedTeeth
    widenedPulpCanal
  }
`;
export const DentalChartingFragmentDoc = gql`
  fragment DentalCharting on DentalCharting {
    _id
    tooth {
      _id
      toothName
    }
    notesTimer
    timerDurationSec
    toothState
    periodontal
    furcation
    mobility
    gingivitis
    calculus
    enamel
    fracture
    resorption
    other
    periodontalPocketMBuc
    periodontalPocketBuccal
    periodontalPocketDBuc
    periodontalPocketMLingPal
    periodontalPocketLingPal
    periodontalPocketDLingPal
    gingivalRecessionMBuc
    gingivalRecessionBuccal
    gingivalRecessionDBuc
    gingivalRecessionMLingPal
    gingivalRecessionLingPal
    gingivalRecessionDLingPal
    oralSurgeries
    sutureMaterial
    restorations
    restoratives
    crCementation
    endodontics
    obturation
    distalWorkingLength
    mesialWorkingLength
    palatalWorkingLength
    distalMarFile
    mesialMarFile
    palatalMarFile
    technique
    treatmentComment
  }
`;
export const DentalSketchCommentFragmentDoc = gql`
  fragment DentalSketchComment on DentalSketchComment {
    locationX
    locationY
    createdBy {
      _id
      firstName
      lastName
      image {
        _id
      }
    }
    createdAt
    text
    _id
  }
`;
export const AllCaseDataFragmentDoc = gql`
  fragment AllCaseData on MedicalCase {
    _id
    name
    createdAt
    status
    fromVetspire
    createdFrom {
      _id
      name
    }
    authorizations {
      collection {
        _id
        selected
        condition
      }
    }
    disclaimerProcedures {
      collection {
        _id
        description
        selected
        title
      }
    }
    disclaimerText
    client {
      _id
      ...ClientInformation
      patient {
        anestheticGasMedication
        image {
          _id
        }
        ...PatientInformation
        dropOff {
          ...DropOff
        }
        vaccines {
          collection {
            ...PatientVaccine
          }
        }
        patientTests {
          collection {
            ...Test
          }
        }
        treatment {
          ...PatientTreatment
        }
        examNote {
          ...PatientExamNote
        }
        currentMedications {
          collection {
            ...CurrentMedication
          }
        }
        preAnestheticExam {
          ...PreAnestheticExam
        }
        physicalExam {
          ...PhysicalExam
        }
        diagnosticTesting {
          ...DiagnosticTesting
          additionalTests {
            collection {
              ...AdditionalDiagnosticTest
            }
          }
        }
        patientProcedures {
          collection {
            ...PatientProcedure
          }
        }
        fluidTemperatures {
          collection {
            ...FluidAndTemperature
          }
        }
        anestheticGases {
          collection {
            ...AnestheticGasAndOxygen
          }
        }
        vitals {
          collection {
            ...Vital
          }
        }
        medicationCalculations {
          collection {
            ...MedicationCalculation
          }
        }
        miscellaneousGroup {
          ...MiscellaneousGroup
        }
        defibMedications {
          collection {
            ...DefibMedication
          }
        }
        fluidBolus {
          _id
          totalAmount
        }
        monitoring {
          _id
          monitoringBy {
            _id
          }
        }
        vitalComment {
          _id
          comment
          qualityRecovery
          timeExtubation
        }
        regionalBlocks {
          collection {
            ...RegionalBlock
          }
        }
        tablets {
          collection {
            ...Tablet
          }
        }
        suspensions {
          collection {
            ...Suspension
          }
        }
        tibialPlateauLevelingOsteotomyPlanning {
          ...TPLO
        }
        postAnestheticVitals {
          collection {
            ...PostAnestheticVital
          }
        }
        postAnestheticVitalComment {
          ...PostAnestheticVitalComment
        }
        generalAssessment {
          ...GeneralAssessment
        }
        dentalChartings {
          collection {
            ...DentalCharting
          }
        }
        dentalSketch {
          _id
          name
        }
        dentalSketchComments {
          collection {
            ...DentalSketchComment
          }
        }
      }
    }
  }
  ${ClientInformationFragmentDoc}
  ${PatientInformationFragmentDoc}
  ${DropOffFragmentDoc}
  ${PatientVaccineFragmentDoc}
  ${TestFragmentDoc}
  ${PatientTreatmentFragmentDoc}
  ${PatientExamNoteFragmentDoc}
  ${CurrentMedicationFragmentDoc}
  ${PreAnestheticExamFragmentDoc}
  ${PhysicalExamFragmentDoc}
  ${DiagnosticTestingFragmentDoc}
  ${AdditionalDiagnosticTestFragmentDoc}
  ${PatientProcedureFragmentDoc}
  ${FluidAndTemperatureFragmentDoc}
  ${AnestheticGasAndOxygenFragmentDoc}
  ${VitalFragmentDoc}
  ${MedicationCalculationFragmentDoc}
  ${MiscellaneousGroupFragmentDoc}
  ${DefibMedicationFragmentDoc}
  ${RegionalBlockFragmentDoc}
  ${TabletFragmentDoc}
  ${SuspensionFragmentDoc}
  ${TploFragmentDoc}
  ${PostAnestheticVitalFragmentDoc}
  ${PostAnestheticVitalCommentFragmentDoc}
  ${GeneralAssessmentFragmentDoc}
  ${DentalChartingFragmentDoc}
  ${DentalSketchCommentFragmentDoc}
`;
export const CaseFragmentDoc = gql`
  fragment Case on MedicalCase {
    id
    _id
    name
    status
    fromVetspire
    createdFrom {
      _id
      name
    }
    organization {
      id
      _id
      name
    }
    client {
      _id
      disclaimer {
        id
        _id
        signature {
          id
          _id
          name
        }
      }
      patient {
        _id
        image {
          _id
        }
        procedureDate
      }
    }
    createdAt
    updatedAt
  }
`;
export const OrganizationFragmentDoc = gql`
  fragment Organization on Organization {
    _id
    contactEmail
    description
    logo {
      _id
    }
    name
    vetspireApiKey
  }
`;
export const AuthorizationSettingFragmentDoc = gql`
  fragment AuthorizationSetting on AuthorizationSetting {
    _id
    condition
  }
`;
export const DisclaimerProcedureSettingFragmentDoc = gql`
  fragment DisclaimerProcedureSetting on DisclaimerProcedureSetting {
    _id
    description
    title
  }
`;
export const GetAccessLogsDocument = gql`
  query getAccessLogs(
    $page: Int!
    $perPage: Int!
    $filter: AccessLogFilter
    $username: String
  ) {
    accessLogs(
      itemsPerPage: $perPage
      page: $page
      filter: $filter
      username: $username
    ) {
      collection {
        id
        _id
        accessStatus
        accessTypeEnum
        createdAt
        ip
        user {
          id
          _id
          firstName
          lastName
        }
        browser
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetAccessLogsQuery__
 *
 * To run a query within a React component, call `useGetAccessLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessLogsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetAccessLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccessLogsQuery,
    GetAccessLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccessLogsQuery, GetAccessLogsQueryVariables>(
    GetAccessLogsDocument,
    options
  );
}
export function useGetAccessLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessLogsQuery,
    GetAccessLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccessLogsQuery, GetAccessLogsQueryVariables>(
    GetAccessLogsDocument,
    options
  );
}
export type GetAccessLogsQueryHookResult = ReturnType<
  typeof useGetAccessLogsQuery
>;
export type GetAccessLogsLazyQueryHookResult = ReturnType<
  typeof useGetAccessLogsLazyQuery
>;
export type GetAccessLogsQueryResult = Apollo.QueryResult<
  GetAccessLogsQuery,
  GetAccessLogsQueryVariables
>;
export const LogPinLoginsDocument = gql`
  mutation logPinLogins($input: logBulkPinAuthenticationInput!) {
    logBulkPinAuthentication(input: $input) {
      clientMutationId
    }
  }
`;
export type LogPinLoginsMutationFn = Apollo.MutationFunction<
  LogPinLoginsMutation,
  LogPinLoginsMutationVariables
>;

/**
 * __useLogPinLoginsMutation__
 *
 * To run a mutation, you first call `useLogPinLoginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogPinLoginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logPinLoginsMutation, { data, loading, error }] = useLogPinLoginsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogPinLoginsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogPinLoginsMutation,
    LogPinLoginsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LogPinLoginsMutation,
    LogPinLoginsMutationVariables
  >(LogPinLoginsDocument, options);
}
export type LogPinLoginsMutationHookResult = ReturnType<
  typeof useLogPinLoginsMutation
>;
export type LogPinLoginsMutationResult = Apollo.MutationResult<
  LogPinLoginsMutation
>;
export type LogPinLoginsMutationOptions = Apollo.BaseMutationOptions<
  LogPinLoginsMutation,
  LogPinLoginsMutationVariables
>;
export const GetEmailLogsDocument = gql`
  query getEmailLogs($page: Int!, $perPage: Int!, $filter: EmailLogFilter) {
    emailLogs(itemsPerPage: $perPage, page: $page, filter: $filter) {
      collection {
        emailSubject
        recipientsUsername
        recipientsEmail
        sentAt
        _id
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetEmailLogsQuery__
 *
 * To run a query within a React component, call `useGetEmailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailLogsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmailLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmailLogsQuery,
    GetEmailLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmailLogsQuery, GetEmailLogsQueryVariables>(
    GetEmailLogsDocument,
    options
  );
}
export function useGetEmailLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailLogsQuery,
    GetEmailLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmailLogsQuery, GetEmailLogsQueryVariables>(
    GetEmailLogsDocument,
    options
  );
}
export type GetEmailLogsQueryHookResult = ReturnType<
  typeof useGetEmailLogsQuery
>;
export type GetEmailLogsLazyQueryHookResult = ReturnType<
  typeof useGetEmailLogsLazyQuery
>;
export type GetEmailLogsQueryResult = Apollo.QueryResult<
  GetEmailLogsQuery,
  GetEmailLogsQueryVariables
>;
export const CreateLicenseDocument = gql`
  mutation createLicense($input: createLicenseInput!) {
    createLicense(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateLicenseMutationFn = Apollo.MutationFunction<
  CreateLicenseMutation,
  CreateLicenseMutationVariables
>;

/**
 * __useCreateLicenseMutation__
 *
 * To run a mutation, you first call `useCreateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLicenseMutation, { data, loading, error }] = useCreateLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLicenseMutation,
    CreateLicenseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLicenseMutation,
    CreateLicenseMutationVariables
  >(CreateLicenseDocument, options);
}
export type CreateLicenseMutationHookResult = ReturnType<
  typeof useCreateLicenseMutation
>;
export type CreateLicenseMutationResult = Apollo.MutationResult<
  CreateLicenseMutation
>;
export type CreateLicenseMutationOptions = Apollo.BaseMutationOptions<
  CreateLicenseMutation,
  CreateLicenseMutationVariables
>;
export const UpdateLicenseDocument = gql`
  mutation updateLicense($input: updateLicenseInput!) {
    updateLicense(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateLicenseMutationFn = Apollo.MutationFunction<
  UpdateLicenseMutation,
  UpdateLicenseMutationVariables
>;

/**
 * __useUpdateLicenseMutation__
 *
 * To run a mutation, you first call `useUpdateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLicenseMutation, { data, loading, error }] = useUpdateLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLicenseMutation,
    UpdateLicenseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLicenseMutation,
    UpdateLicenseMutationVariables
  >(UpdateLicenseDocument, options);
}
export type UpdateLicenseMutationHookResult = ReturnType<
  typeof useUpdateLicenseMutation
>;
export type UpdateLicenseMutationResult = Apollo.MutationResult<
  UpdateLicenseMutation
>;
export type UpdateLicenseMutationOptions = Apollo.BaseMutationOptions<
  UpdateLicenseMutation,
  UpdateLicenseMutationVariables
>;
export const DeleteLicenseDocument = gql`
  mutation deleteLicense($id: Int!) {
    deleteLicense(input: { _id: $id }) {
      clientMutationId
    }
  }
`;
export type DeleteLicenseMutationFn = Apollo.MutationFunction<
  DeleteLicenseMutation,
  DeleteLicenseMutationVariables
>;

/**
 * __useDeleteLicenseMutation__
 *
 * To run a mutation, you first call `useDeleteLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLicenseMutation, { data, loading, error }] = useDeleteLicenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLicenseMutation,
    DeleteLicenseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteLicenseMutation,
    DeleteLicenseMutationVariables
  >(DeleteLicenseDocument, options);
}
export type DeleteLicenseMutationHookResult = ReturnType<
  typeof useDeleteLicenseMutation
>;
export type DeleteLicenseMutationResult = Apollo.MutationResult<
  DeleteLicenseMutation
>;
export type DeleteLicenseMutationOptions = Apollo.BaseMutationOptions<
  DeleteLicenseMutation,
  DeleteLicenseMutationVariables
>;
export const GetLicenseDocument = gql`
  query getLicense($id: Int!) {
    license(_id: $id) {
      _id
      name
      period
      price
      maxNumberOfUsers
      active
    }
  }
`;

/**
 * __useGetLicenseQuery__
 *
 * To run a query within a React component, call `useGetLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLicenseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLicenseQuery,
    GetLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLicenseQuery, GetLicenseQueryVariables>(
    GetLicenseDocument,
    options
  );
}
export function useGetLicenseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLicenseQuery,
    GetLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLicenseQuery, GetLicenseQueryVariables>(
    GetLicenseDocument,
    options
  );
}
export type GetLicenseQueryHookResult = ReturnType<typeof useGetLicenseQuery>;
export type GetLicenseLazyQueryHookResult = ReturnType<
  typeof useGetLicenseLazyQuery
>;
export type GetLicenseQueryResult = Apollo.QueryResult<
  GetLicenseQuery,
  GetLicenseQueryVariables
>;
export const GetLicensesDocument = gql`
  query getLicenses($page: Int!, $perPage: Int!, $filter: LicenseFilter) {
    licenses(itemsPerPage: $perPage, page: $page, filter: $filter) {
      collection {
        _id
        name
        period
        price
        maxNumberOfUsers
        active
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetLicensesQuery__
 *
 * To run a query within a React component, call `useGetLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicensesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLicensesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLicensesQuery,
    GetLicensesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLicensesQuery, GetLicensesQueryVariables>(
    GetLicensesDocument,
    options
  );
}
export function useGetLicensesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLicensesQuery,
    GetLicensesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLicensesQuery, GetLicensesQueryVariables>(
    GetLicensesDocument,
    options
  );
}
export type GetLicensesQueryHookResult = ReturnType<typeof useGetLicensesQuery>;
export type GetLicensesLazyQueryHookResult = ReturnType<
  typeof useGetLicensesLazyQuery
>;
export type GetLicensesQueryResult = Apollo.QueryResult<
  GetLicensesQuery,
  GetLicensesQueryVariables
>;
export const CreateOrderDocument = gql`
  mutation createOrder($input: createOrderInput!) {
    createOrder(input: $input) {
      clientMutationId
    }
  }
`;
export type CreateOrderMutationFn = Apollo.MutationFunction<
  CreateOrderMutation,
  CreateOrderMutationVariables
>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrderMutation,
    CreateOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(
    CreateOrderDocument,
    options
  );
}
export type CreateOrderMutationHookResult = ReturnType<
  typeof useCreateOrderMutation
>;
export type CreateOrderMutationResult = Apollo.MutationResult<
  CreateOrderMutation
>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateOrderMutation,
  CreateOrderMutationVariables
>;
export const UpdateOrderDocument = gql`
  mutation updateOrder($input: updateOrderInput!) {
    updateOrder(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<
  UpdateOrderMutation,
  UpdateOrderMutationVariables
>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrderMutation,
    UpdateOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(
    UpdateOrderDocument,
    options
  );
}
export type UpdateOrderMutationHookResult = ReturnType<
  typeof useUpdateOrderMutation
>;
export type UpdateOrderMutationResult = Apollo.MutationResult<
  UpdateOrderMutation
>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrderMutation,
  UpdateOrderMutationVariables
>;
export const DeleteOrderDocument = gql`
  mutation deleteOrder($id: Int!) {
    deleteOrder(input: { _id: $id }) {
      clientMutationId
    }
  }
`;
export type DeleteOrderMutationFn = Apollo.MutationFunction<
  DeleteOrderMutation,
  DeleteOrderMutationVariables
>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOrderMutation,
    DeleteOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(
    DeleteOrderDocument,
    options
  );
}
export type DeleteOrderMutationHookResult = ReturnType<
  typeof useDeleteOrderMutation
>;
export type DeleteOrderMutationResult = Apollo.MutationResult<
  DeleteOrderMutation
>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<
  DeleteOrderMutation,
  DeleteOrderMutationVariables
>;
export const GetOrderDocument = gql`
  query getOrder($id: Int!) {
    order(_id: $id) {
      _id
      license {
        _id
        price
        period
      }
      organization {
        _id
      }
      startDate
      expirationDate
      price
    }
  }
`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(
    GetOrderDocument,
    options
  );
}
export function useGetOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrderQuery,
    GetOrderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(
    GetOrderDocument,
    options
  );
}
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<
  typeof useGetOrderLazyQuery
>;
export type GetOrderQueryResult = Apollo.QueryResult<
  GetOrderQuery,
  GetOrderQueryVariables
>;
export const GetOrdersDocument = gql`
  query getOrders($page: Int!, $perPage: Int!) {
    orders(page: $page, itemsPerPage: $perPage) {
      collection {
        _id
        license {
          _id
          name
        }
        organization {
          _id
          name
        }
        price
        startDate
        expirationDate
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(
    GetOrdersDocument,
    options
  );
}
export function useGetOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrdersQuery,
    GetOrdersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(
    GetOrdersDocument,
    options
  );
}
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<
  typeof useGetOrdersLazyQuery
>;
export type GetOrdersQueryResult = Apollo.QueryResult<
  GetOrdersQuery,
  GetOrdersQueryVariables
>;
export const GetAdminOrganizationDocument = gql`
  query getAdminOrganization(
    $_id: Int!
    $filter: UserFilter
    $page: Int
    $itemsPerPage: Int
  ) {
    organization(_id: $_id) {
      ...AdminOrganization
      users(filter: $filter, page: $page, itemsPerPage: $itemsPerPage) {
        collection {
          id
          _id
          firstName
          lastName
          email
          userRole
          image {
            _id
          }
        }
        paginationInfo {
          totalCount
        }
      }
    }
  }
  ${AdminOrganizationFragmentDoc}
`;

/**
 * __useGetAdminOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAdminOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminOrganizationQuery({
 *   variables: {
 *      _id: // value for '_id'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetAdminOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdminOrganizationQuery,
    GetAdminOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdminOrganizationQuery,
    GetAdminOrganizationQueryVariables
  >(GetAdminOrganizationDocument, options);
}
export function useGetAdminOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdminOrganizationQuery,
    GetAdminOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdminOrganizationQuery,
    GetAdminOrganizationQueryVariables
  >(GetAdminOrganizationDocument, options);
}
export type GetAdminOrganizationQueryHookResult = ReturnType<
  typeof useGetAdminOrganizationQuery
>;
export type GetAdminOrganizationLazyQueryHookResult = ReturnType<
  typeof useGetAdminOrganizationLazyQuery
>;
export type GetAdminOrganizationQueryResult = Apollo.QueryResult<
  GetAdminOrganizationQuery,
  GetAdminOrganizationQueryVariables
>;
export const UpdateAdminOrganizationDocument = gql`
  mutation updateAdminOrganization($input: updateOrganizationInput!) {
    updateOrganization(input: $input) {
      organization {
        ...AdminOrganization
      }
    }
  }
  ${AdminOrganizationFragmentDoc}
`;
export type UpdateAdminOrganizationMutationFn = Apollo.MutationFunction<
  UpdateAdminOrganizationMutation,
  UpdateAdminOrganizationMutationVariables
>;

/**
 * __useUpdateAdminOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateAdminOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminOrganizationMutation, { data, loading, error }] = useUpdateAdminOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdminOrganizationMutation,
    UpdateAdminOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdminOrganizationMutation,
    UpdateAdminOrganizationMutationVariables
  >(UpdateAdminOrganizationDocument, options);
}
export type UpdateAdminOrganizationMutationHookResult = ReturnType<
  typeof useUpdateAdminOrganizationMutation
>;
export type UpdateAdminOrganizationMutationResult = Apollo.MutationResult<
  UpdateAdminOrganizationMutation
>;
export type UpdateAdminOrganizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdminOrganizationMutation,
  UpdateAdminOrganizationMutationVariables
>;
export const GetOrganizationsDocument = gql`
  query getOrganizations(
    $perPage: Int!
    $page: Int!
    $filter: OrganizationFilter
  ) {
    organizations(itemsPerPage: $perPage, page: $page, filter: $filter) {
      collection {
        ...AdminOrganization
      }
      paginationInfo {
        totalCount
      }
    }
  }
  ${AdminOrganizationFragmentDoc}
`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationsQuery,
    GetOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(
    GetOrganizationsDocument,
    options
  );
}
export function useGetOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationsQuery,
    GetOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationsQuery,
    GetOrganizationsQueryVariables
  >(GetOrganizationsDocument, options);
}
export type GetOrganizationsQueryHookResult = ReturnType<
  typeof useGetOrganizationsQuery
>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationsLazyQuery
>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<
  GetOrganizationsQuery,
  GetOrganizationsQueryVariables
>;
export const CreateOrganizationDocument = gql`
  mutation createOrganization($input: createOrganizationRegistrationInput!) {
    createOrganizationRegistration(input: $input) {
      organizationRegistration {
        id
        fakeId
      }
    }
  }
`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >(CreateOrganizationDocument, options);
}
export type CreateOrganizationMutationHookResult = ReturnType<
  typeof useCreateOrganizationMutation
>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<
  CreateOrganizationMutation
>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;
export const GetOrganizationAdminUserDocument = gql`
  query getOrganizationAdminUser($organization: Int!) {
    organizationAdminUser(organization: $organization) {
      _id
      firstName
      lastName
      image {
        _id
      }
      email
    }
  }
`;

/**
 * __useGetOrganizationAdminUserQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAdminUserQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useGetOrganizationAdminUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationAdminUserQuery,
    GetOrganizationAdminUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationAdminUserQuery,
    GetOrganizationAdminUserQueryVariables
  >(GetOrganizationAdminUserDocument, options);
}
export function useGetOrganizationAdminUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationAdminUserQuery,
    GetOrganizationAdminUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationAdminUserQuery,
    GetOrganizationAdminUserQueryVariables
  >(GetOrganizationAdminUserDocument, options);
}
export type GetOrganizationAdminUserQueryHookResult = ReturnType<
  typeof useGetOrganizationAdminUserQuery
>;
export type GetOrganizationAdminUserLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationAdminUserLazyQuery
>;
export type GetOrganizationAdminUserQueryResult = Apollo.QueryResult<
  GetOrganizationAdminUserQuery,
  GetOrganizationAdminUserQueryVariables
>;
export const ResendOrganizationInviteDocument = gql`
  mutation resendOrganizationInvite($input: resendOrganizationInviteInput!) {
    resendOrganizationInvite(input: $input) {
      clientMutationId
    }
  }
`;
export type ResendOrganizationInviteMutationFn = Apollo.MutationFunction<
  ResendOrganizationInviteMutation,
  ResendOrganizationInviteMutationVariables
>;

/**
 * __useResendOrganizationInviteMutation__
 *
 * To run a mutation, you first call `useResendOrganizationInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOrganizationInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOrganizationInviteMutation, { data, loading, error }] = useResendOrganizationInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendOrganizationInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendOrganizationInviteMutation,
    ResendOrganizationInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendOrganizationInviteMutation,
    ResendOrganizationInviteMutationVariables
  >(ResendOrganizationInviteDocument, options);
}
export type ResendOrganizationInviteMutationHookResult = ReturnType<
  typeof useResendOrganizationInviteMutation
>;
export type ResendOrganizationInviteMutationResult = Apollo.MutationResult<
  ResendOrganizationInviteMutation
>;
export type ResendOrganizationInviteMutationOptions = Apollo.BaseMutationOptions<
  ResendOrganizationInviteMutation,
  ResendOrganizationInviteMutationVariables
>;
export const GetReportDocument = gql`
  query getReport($dateFilter: DateTime) {
    reportOrganizationCounter(dateFilter: $dateFilter) {
      _id
      activeOrganizationsCount
      archivedOrganizationsCount
      usersCount
    }
  }
`;

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      dateFilter: // value for 'dateFilter'
 *   },
 * });
 */
export function useGetReportQuery(
  baseOptions?: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(
    GetReportDocument,
    options
  );
}
export function useGetReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportQuery,
    GetReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(
    GetReportDocument,
    options
  );
}
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>;
export type GetReportLazyQueryHookResult = ReturnType<
  typeof useGetReportLazyQuery
>;
export type GetReportQueryResult = Apollo.QueryResult<
  GetReportQuery,
  GetReportQueryVariables
>;
export const GetOrganizationsReportDocument = gql`
  query getOrganizationsReport(
    $dateFilter: DateTime
    $page: Int
    $perPage: Int
  ) {
    reportOrganizationUserMedicalCaseCounters(
      dateFilter: $dateFilter
      page: $page
      itemsPerPage: $perPage
    ) {
      collection {
        id
        medicalCaseCount
        organizationName
        userCount
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetOrganizationsReportQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsReportQuery({
 *   variables: {
 *      dateFilter: // value for 'dateFilter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetOrganizationsReportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationsReportQuery,
    GetOrganizationsReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationsReportQuery,
    GetOrganizationsReportQueryVariables
  >(GetOrganizationsReportDocument, options);
}
export function useGetOrganizationsReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationsReportQuery,
    GetOrganizationsReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationsReportQuery,
    GetOrganizationsReportQueryVariables
  >(GetOrganizationsReportDocument, options);
}
export type GetOrganizationsReportQueryHookResult = ReturnType<
  typeof useGetOrganizationsReportQuery
>;
export type GetOrganizationsReportLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationsReportLazyQuery
>;
export type GetOrganizationsReportQueryResult = Apollo.QueryResult<
  GetOrganizationsReportQuery,
  GetOrganizationsReportQueryVariables
>;
export const GetAnestheticProtocolDocument = gql`
  query getAnestheticProtocol($_id: Int!) {
    anestheticProtocol(_id: $_id) {
      ...AnestheticProtocol
    }
  }
  ${AnestheticProtocolFragmentDoc}
`;

/**
 * __useGetAnestheticProtocolQuery__
 *
 * To run a query within a React component, call `useGetAnestheticProtocolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnestheticProtocolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnestheticProtocolQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGetAnestheticProtocolQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnestheticProtocolQuery,
    GetAnestheticProtocolQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAnestheticProtocolQuery,
    GetAnestheticProtocolQueryVariables
  >(GetAnestheticProtocolDocument, options);
}
export function useGetAnestheticProtocolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnestheticProtocolQuery,
    GetAnestheticProtocolQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnestheticProtocolQuery,
    GetAnestheticProtocolQueryVariables
  >(GetAnestheticProtocolDocument, options);
}
export type GetAnestheticProtocolQueryHookResult = ReturnType<
  typeof useGetAnestheticProtocolQuery
>;
export type GetAnestheticProtocolLazyQueryHookResult = ReturnType<
  typeof useGetAnestheticProtocolLazyQuery
>;
export type GetAnestheticProtocolQueryResult = Apollo.QueryResult<
  GetAnestheticProtocolQuery,
  GetAnestheticProtocolQueryVariables
>;
export const CreateAnestheticProtocolMedicationCalculationDocument = gql`
  mutation createAnestheticProtocolMedicationCalculation(
    $input: createAnestheticProtocolMedicationCalculationInput!
  ) {
    createAnestheticProtocolMedicationCalculation(input: $input) {
      anestheticProtocolMedicationCalculation {
        ...AnestheticProtocolMedicationCalculation
      }
    }
  }
  ${AnestheticProtocolMedicationCalculationFragmentDoc}
`;
export type CreateAnestheticProtocolMedicationCalculationMutationFn = Apollo.MutationFunction<
  CreateAnestheticProtocolMedicationCalculationMutation,
  CreateAnestheticProtocolMedicationCalculationMutationVariables
>;

/**
 * __useCreateAnestheticProtocolMedicationCalculationMutation__
 *
 * To run a mutation, you first call `useCreateAnestheticProtocolMedicationCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnestheticProtocolMedicationCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnestheticProtocolMedicationCalculationMutation, { data, loading, error }] = useCreateAnestheticProtocolMedicationCalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnestheticProtocolMedicationCalculationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAnestheticProtocolMedicationCalculationMutation,
    CreateAnestheticProtocolMedicationCalculationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAnestheticProtocolMedicationCalculationMutation,
    CreateAnestheticProtocolMedicationCalculationMutationVariables
  >(CreateAnestheticProtocolMedicationCalculationDocument, options);
}
export type CreateAnestheticProtocolMedicationCalculationMutationHookResult = ReturnType<
  typeof useCreateAnestheticProtocolMedicationCalculationMutation
>;
export type CreateAnestheticProtocolMedicationCalculationMutationResult = Apollo.MutationResult<
  CreateAnestheticProtocolMedicationCalculationMutation
>;
export type CreateAnestheticProtocolMedicationCalculationMutationOptions = Apollo.BaseMutationOptions<
  CreateAnestheticProtocolMedicationCalculationMutation,
  CreateAnestheticProtocolMedicationCalculationMutationVariables
>;
export const UpdateAnestheticProtocolMedicationCalculationDocument = gql`
  mutation updateAnestheticProtocolMedicationCalculation(
    $input: updateAnestheticProtocolMedicationCalculationInput!
  ) {
    updateAnestheticProtocolMedicationCalculation(input: $input) {
      anestheticProtocolMedicationCalculation {
        ...AnestheticProtocolMedicationCalculation
      }
    }
  }
  ${AnestheticProtocolMedicationCalculationFragmentDoc}
`;
export type UpdateAnestheticProtocolMedicationCalculationMutationFn = Apollo.MutationFunction<
  UpdateAnestheticProtocolMedicationCalculationMutation,
  UpdateAnestheticProtocolMedicationCalculationMutationVariables
>;

/**
 * __useUpdateAnestheticProtocolMedicationCalculationMutation__
 *
 * To run a mutation, you first call `useUpdateAnestheticProtocolMedicationCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnestheticProtocolMedicationCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnestheticProtocolMedicationCalculationMutation, { data, loading, error }] = useUpdateAnestheticProtocolMedicationCalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnestheticProtocolMedicationCalculationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAnestheticProtocolMedicationCalculationMutation,
    UpdateAnestheticProtocolMedicationCalculationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAnestheticProtocolMedicationCalculationMutation,
    UpdateAnestheticProtocolMedicationCalculationMutationVariables
  >(UpdateAnestheticProtocolMedicationCalculationDocument, options);
}
export type UpdateAnestheticProtocolMedicationCalculationMutationHookResult = ReturnType<
  typeof useUpdateAnestheticProtocolMedicationCalculationMutation
>;
export type UpdateAnestheticProtocolMedicationCalculationMutationResult = Apollo.MutationResult<
  UpdateAnestheticProtocolMedicationCalculationMutation
>;
export type UpdateAnestheticProtocolMedicationCalculationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAnestheticProtocolMedicationCalculationMutation,
  UpdateAnestheticProtocolMedicationCalculationMutationVariables
>;
export const DeleteAnestheticProtocolMedicationCalculationsDocument = gql`
  mutation deleteAnestheticProtocolMedicationCalculations(
    $input: removeBulkAnestheticProtocolMedicationCalculationInput!
  ) {
    removeBulkAnestheticProtocolMedicationCalculation(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteAnestheticProtocolMedicationCalculationsMutationFn = Apollo.MutationFunction<
  DeleteAnestheticProtocolMedicationCalculationsMutation,
  DeleteAnestheticProtocolMedicationCalculationsMutationVariables
>;

/**
 * __useDeleteAnestheticProtocolMedicationCalculationsMutation__
 *
 * To run a mutation, you first call `useDeleteAnestheticProtocolMedicationCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnestheticProtocolMedicationCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnestheticProtocolMedicationCalculationsMutation, { data, loading, error }] = useDeleteAnestheticProtocolMedicationCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnestheticProtocolMedicationCalculationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAnestheticProtocolMedicationCalculationsMutation,
    DeleteAnestheticProtocolMedicationCalculationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAnestheticProtocolMedicationCalculationsMutation,
    DeleteAnestheticProtocolMedicationCalculationsMutationVariables
  >(DeleteAnestheticProtocolMedicationCalculationsDocument, options);
}
export type DeleteAnestheticProtocolMedicationCalculationsMutationHookResult = ReturnType<
  typeof useDeleteAnestheticProtocolMedicationCalculationsMutation
>;
export type DeleteAnestheticProtocolMedicationCalculationsMutationResult = Apollo.MutationResult<
  DeleteAnestheticProtocolMedicationCalculationsMutation
>;
export type DeleteAnestheticProtocolMedicationCalculationsMutationOptions = Apollo.BaseMutationOptions<
  DeleteAnestheticProtocolMedicationCalculationsMutation,
  DeleteAnestheticProtocolMedicationCalculationsMutationVariables
>;
export const CreateAnestheticProtocolRegionalBlockDocument = gql`
  mutation createAnestheticProtocolRegionalBlock(
    $input: createAnestheticProtocolRegionalBlockInput!
  ) {
    createAnestheticProtocolRegionalBlock(input: $input) {
      anestheticProtocolRegionalBlock {
        ...AnestheticProtocolRegionalBlock
      }
    }
  }
  ${AnestheticProtocolRegionalBlockFragmentDoc}
`;
export type CreateAnestheticProtocolRegionalBlockMutationFn = Apollo.MutationFunction<
  CreateAnestheticProtocolRegionalBlockMutation,
  CreateAnestheticProtocolRegionalBlockMutationVariables
>;

/**
 * __useCreateAnestheticProtocolRegionalBlockMutation__
 *
 * To run a mutation, you first call `useCreateAnestheticProtocolRegionalBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnestheticProtocolRegionalBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnestheticProtocolRegionalBlockMutation, { data, loading, error }] = useCreateAnestheticProtocolRegionalBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnestheticProtocolRegionalBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAnestheticProtocolRegionalBlockMutation,
    CreateAnestheticProtocolRegionalBlockMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAnestheticProtocolRegionalBlockMutation,
    CreateAnestheticProtocolRegionalBlockMutationVariables
  >(CreateAnestheticProtocolRegionalBlockDocument, options);
}
export type CreateAnestheticProtocolRegionalBlockMutationHookResult = ReturnType<
  typeof useCreateAnestheticProtocolRegionalBlockMutation
>;
export type CreateAnestheticProtocolRegionalBlockMutationResult = Apollo.MutationResult<
  CreateAnestheticProtocolRegionalBlockMutation
>;
export type CreateAnestheticProtocolRegionalBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateAnestheticProtocolRegionalBlockMutation,
  CreateAnestheticProtocolRegionalBlockMutationVariables
>;
export const UpdateAnestheticProtocolRegionalBlockDocument = gql`
  mutation updateAnestheticProtocolRegionalBlock(
    $input: updateAnestheticProtocolRegionalBlockInput!
  ) {
    updateAnestheticProtocolRegionalBlock(input: $input) {
      anestheticProtocolRegionalBlock {
        ...AnestheticProtocolRegionalBlock
      }
    }
  }
  ${AnestheticProtocolRegionalBlockFragmentDoc}
`;
export type UpdateAnestheticProtocolRegionalBlockMutationFn = Apollo.MutationFunction<
  UpdateAnestheticProtocolRegionalBlockMutation,
  UpdateAnestheticProtocolRegionalBlockMutationVariables
>;

/**
 * __useUpdateAnestheticProtocolRegionalBlockMutation__
 *
 * To run a mutation, you first call `useUpdateAnestheticProtocolRegionalBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnestheticProtocolRegionalBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnestheticProtocolRegionalBlockMutation, { data, loading, error }] = useUpdateAnestheticProtocolRegionalBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnestheticProtocolRegionalBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAnestheticProtocolRegionalBlockMutation,
    UpdateAnestheticProtocolRegionalBlockMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAnestheticProtocolRegionalBlockMutation,
    UpdateAnestheticProtocolRegionalBlockMutationVariables
  >(UpdateAnestheticProtocolRegionalBlockDocument, options);
}
export type UpdateAnestheticProtocolRegionalBlockMutationHookResult = ReturnType<
  typeof useUpdateAnestheticProtocolRegionalBlockMutation
>;
export type UpdateAnestheticProtocolRegionalBlockMutationResult = Apollo.MutationResult<
  UpdateAnestheticProtocolRegionalBlockMutation
>;
export type UpdateAnestheticProtocolRegionalBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdateAnestheticProtocolRegionalBlockMutation,
  UpdateAnestheticProtocolRegionalBlockMutationVariables
>;
export const DeleteAnestheticProtocolRegionalBlocksDocument = gql`
  mutation deleteAnestheticProtocolRegionalBlocks(
    $input: removeBulkAnestheticProtocolRegionalBlockInput!
  ) {
    removeBulkAnestheticProtocolRegionalBlock(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteAnestheticProtocolRegionalBlocksMutationFn = Apollo.MutationFunction<
  DeleteAnestheticProtocolRegionalBlocksMutation,
  DeleteAnestheticProtocolRegionalBlocksMutationVariables
>;

/**
 * __useDeleteAnestheticProtocolRegionalBlocksMutation__
 *
 * To run a mutation, you first call `useDeleteAnestheticProtocolRegionalBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnestheticProtocolRegionalBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnestheticProtocolRegionalBlocksMutation, { data, loading, error }] = useDeleteAnestheticProtocolRegionalBlocksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnestheticProtocolRegionalBlocksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAnestheticProtocolRegionalBlocksMutation,
    DeleteAnestheticProtocolRegionalBlocksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAnestheticProtocolRegionalBlocksMutation,
    DeleteAnestheticProtocolRegionalBlocksMutationVariables
  >(DeleteAnestheticProtocolRegionalBlocksDocument, options);
}
export type DeleteAnestheticProtocolRegionalBlocksMutationHookResult = ReturnType<
  typeof useDeleteAnestheticProtocolRegionalBlocksMutation
>;
export type DeleteAnestheticProtocolRegionalBlocksMutationResult = Apollo.MutationResult<
  DeleteAnestheticProtocolRegionalBlocksMutation
>;
export type DeleteAnestheticProtocolRegionalBlocksMutationOptions = Apollo.BaseMutationOptions<
  DeleteAnestheticProtocolRegionalBlocksMutation,
  DeleteAnestheticProtocolRegionalBlocksMutationVariables
>;
export const UseCalculationsAnestheticProtocolDocument = gql`
  mutation useCalculationsAnestheticProtocol(
    $input: useCalculationsAnestheticProtocolInput!
  ) {
    useCalculationsAnestheticProtocol(input: $input) {
      calculationsAnestheticProtocol {
        medicationCalculations {
          ...MedicationCalculation
        }
        regionalBlocks {
          ...RegionalBlock
        }
      }
    }
  }
  ${MedicationCalculationFragmentDoc}
  ${RegionalBlockFragmentDoc}
`;
export type UseCalculationsAnestheticProtocolMutationFn = Apollo.MutationFunction<
  UseCalculationsAnestheticProtocolMutation,
  UseCalculationsAnestheticProtocolMutationVariables
>;

/**
 * __useUseCalculationsAnestheticProtocolMutation__
 *
 * To run a mutation, you first call `useUseCalculationsAnestheticProtocolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseCalculationsAnestheticProtocolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useCalculationsAnestheticProtocolMutation, { data, loading, error }] = useUseCalculationsAnestheticProtocolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUseCalculationsAnestheticProtocolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UseCalculationsAnestheticProtocolMutation,
    UseCalculationsAnestheticProtocolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UseCalculationsAnestheticProtocolMutation,
    UseCalculationsAnestheticProtocolMutationVariables
  >(UseCalculationsAnestheticProtocolDocument, options);
}
export type UseCalculationsAnestheticProtocolMutationHookResult = ReturnType<
  typeof useUseCalculationsAnestheticProtocolMutation
>;
export type UseCalculationsAnestheticProtocolMutationResult = Apollo.MutationResult<
  UseCalculationsAnestheticProtocolMutation
>;
export type UseCalculationsAnestheticProtocolMutationOptions = Apollo.BaseMutationOptions<
  UseCalculationsAnestheticProtocolMutation,
  UseCalculationsAnestheticProtocolMutationVariables
>;
export const AnestheticProtocolsDocument = gql`
  query anestheticProtocols(
    $filter: AnestheticProtocolFilter
    $search: String
  ) {
    defaultProtocols: anestheticProtocols(
      filter: { equal: { defaultProtocol: true }, start: { name: $search } }
    ) {
      collection {
        ...AnestheticProtocol
      }
    }
    anestheticProtocols(filter: $filter) {
      collection {
        ...AnestheticProtocol
      }
    }
  }
  ${AnestheticProtocolFragmentDoc}
`;

/**
 * __useAnestheticProtocolsQuery__
 *
 * To run a query within a React component, call `useAnestheticProtocolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnestheticProtocolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnestheticProtocolsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAnestheticProtocolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AnestheticProtocolsQuery,
    AnestheticProtocolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AnestheticProtocolsQuery,
    AnestheticProtocolsQueryVariables
  >(AnestheticProtocolsDocument, options);
}
export function useAnestheticProtocolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnestheticProtocolsQuery,
    AnestheticProtocolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AnestheticProtocolsQuery,
    AnestheticProtocolsQueryVariables
  >(AnestheticProtocolsDocument, options);
}
export type AnestheticProtocolsQueryHookResult = ReturnType<
  typeof useAnestheticProtocolsQuery
>;
export type AnestheticProtocolsLazyQueryHookResult = ReturnType<
  typeof useAnestheticProtocolsLazyQuery
>;
export type AnestheticProtocolsQueryResult = Apollo.QueryResult<
  AnestheticProtocolsQuery,
  AnestheticProtocolsQueryVariables
>;
export const CreateAnestheticProtocolDocument = gql`
  mutation createAnestheticProtocol($input: createAnestheticProtocolInput!) {
    createAnestheticProtocol(input: $input) {
      anestheticProtocol {
        ...AnestheticProtocol
      }
    }
  }
  ${AnestheticProtocolFragmentDoc}
`;
export type CreateAnestheticProtocolMutationFn = Apollo.MutationFunction<
  CreateAnestheticProtocolMutation,
  CreateAnestheticProtocolMutationVariables
>;

/**
 * __useCreateAnestheticProtocolMutation__
 *
 * To run a mutation, you first call `useCreateAnestheticProtocolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnestheticProtocolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnestheticProtocolMutation, { data, loading, error }] = useCreateAnestheticProtocolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnestheticProtocolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAnestheticProtocolMutation,
    CreateAnestheticProtocolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAnestheticProtocolMutation,
    CreateAnestheticProtocolMutationVariables
  >(CreateAnestheticProtocolDocument, options);
}
export type CreateAnestheticProtocolMutationHookResult = ReturnType<
  typeof useCreateAnestheticProtocolMutation
>;
export type CreateAnestheticProtocolMutationResult = Apollo.MutationResult<
  CreateAnestheticProtocolMutation
>;
export type CreateAnestheticProtocolMutationOptions = Apollo.BaseMutationOptions<
  CreateAnestheticProtocolMutation,
  CreateAnestheticProtocolMutationVariables
>;
export const UpdateAnestheticProtocolDocument = gql`
  mutation updateAnestheticProtocol($input: updateAnestheticProtocolInput!) {
    updateAnestheticProtocol(input: $input) {
      anestheticProtocol {
        ...AnestheticProtocol
      }
    }
  }
  ${AnestheticProtocolFragmentDoc}
`;
export type UpdateAnestheticProtocolMutationFn = Apollo.MutationFunction<
  UpdateAnestheticProtocolMutation,
  UpdateAnestheticProtocolMutationVariables
>;

/**
 * __useUpdateAnestheticProtocolMutation__
 *
 * To run a mutation, you first call `useUpdateAnestheticProtocolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnestheticProtocolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnestheticProtocolMutation, { data, loading, error }] = useUpdateAnestheticProtocolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnestheticProtocolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAnestheticProtocolMutation,
    UpdateAnestheticProtocolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAnestheticProtocolMutation,
    UpdateAnestheticProtocolMutationVariables
  >(UpdateAnestheticProtocolDocument, options);
}
export type UpdateAnestheticProtocolMutationHookResult = ReturnType<
  typeof useUpdateAnestheticProtocolMutation
>;
export type UpdateAnestheticProtocolMutationResult = Apollo.MutationResult<
  UpdateAnestheticProtocolMutation
>;
export type UpdateAnestheticProtocolMutationOptions = Apollo.BaseMutationOptions<
  UpdateAnestheticProtocolMutation,
  UpdateAnestheticProtocolMutationVariables
>;
export const DeleteAnestheticProtocolsDocument = gql`
  mutation deleteAnestheticProtocols(
    $input: removeBulkAnestheticProtocolInput!
  ) {
    removeBulkAnestheticProtocol(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteAnestheticProtocolsMutationFn = Apollo.MutationFunction<
  DeleteAnestheticProtocolsMutation,
  DeleteAnestheticProtocolsMutationVariables
>;

/**
 * __useDeleteAnestheticProtocolsMutation__
 *
 * To run a mutation, you first call `useDeleteAnestheticProtocolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnestheticProtocolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnestheticProtocolsMutation, { data, loading, error }] = useDeleteAnestheticProtocolsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnestheticProtocolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAnestheticProtocolsMutation,
    DeleteAnestheticProtocolsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAnestheticProtocolsMutation,
    DeleteAnestheticProtocolsMutationVariables
  >(DeleteAnestheticProtocolsDocument, options);
}
export type DeleteAnestheticProtocolsMutationHookResult = ReturnType<
  typeof useDeleteAnestheticProtocolsMutation
>;
export type DeleteAnestheticProtocolsMutationResult = Apollo.MutationResult<
  DeleteAnestheticProtocolsMutation
>;
export type DeleteAnestheticProtocolsMutationOptions = Apollo.BaseMutationOptions<
  DeleteAnestheticProtocolsMutation,
  DeleteAnestheticProtocolsMutationVariables
>;
export const LoginDocument = gql`
  mutation login($username: String!, $password: String!) {
    createAuthentication(input: { username: $username, password: $password }) {
      authentication {
        id
        sessionId
        applicationSettings {
          ...Settings
        }
      }
    }
  }
  ${SettingsFragmentDoc}
`;
export type LoginMutationFn = Apollo.MutationFunction<
  LoginMutation,
  LoginMutationVariables
>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginMutation,
    LoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(
    LoginDocument,
    options
  );
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
  LoginMutation,
  LoginMutationVariables
>;
export const GetApplicationSettingsDocument = gql`
  query getApplicationSettings {
    applicationSettings(id: "application_settings") {
      ...Settings
    }
  }
  ${SettingsFragmentDoc}
`;

/**
 * __useGetApplicationSettingsQuery__
 *
 * To run a query within a React component, call `useGetApplicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetApplicationSettingsQuery,
    GetApplicationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetApplicationSettingsQuery,
    GetApplicationSettingsQueryVariables
  >(GetApplicationSettingsDocument, options);
}
export function useGetApplicationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApplicationSettingsQuery,
    GetApplicationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetApplicationSettingsQuery,
    GetApplicationSettingsQueryVariables
  >(GetApplicationSettingsDocument, options);
}
export type GetApplicationSettingsQueryHookResult = ReturnType<
  typeof useGetApplicationSettingsQuery
>;
export type GetApplicationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetApplicationSettingsLazyQuery
>;
export type GetApplicationSettingsQueryResult = Apollo.QueryResult<
  GetApplicationSettingsQuery,
  GetApplicationSettingsQueryVariables
>;
export const LogoutDocument = gql`
  mutation logout {
    createLogout(input: { clientMutationId: "" }) {
      clientMutationId
    }
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<
  LogoutMutation,
  LogoutMutationVariables
>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options
  );
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation resetPassword($email: String!) {
    createPasswordRecoveryRequest(input: { email: $email }) {
      passwordRecoveryRequest {
        id
      }
    }
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult = Apollo.MutationResult<
  ResetPasswordMutation
>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const PasswordChangeDocument = gql`
  mutation passwordChange($password: String!, $token: String!) {
    createPasswordChange(
      input: { newPassword: $password, passwordRecoveryToken: $token }
    ) {
      passwordChange {
        id
        applicationSettings {
          ...Settings
        }
        sessionId
      }
    }
  }
  ${SettingsFragmentDoc}
`;
export type PasswordChangeMutationFn = Apollo.MutationFunction<
  PasswordChangeMutation,
  PasswordChangeMutationVariables
>;

/**
 * __usePasswordChangeMutation__
 *
 * To run a mutation, you first call `usePasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChangeMutation, { data, loading, error }] = usePasswordChangeMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePasswordChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PasswordChangeMutation,
    PasswordChangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PasswordChangeMutation,
    PasswordChangeMutationVariables
  >(PasswordChangeDocument, options);
}
export type PasswordChangeMutationHookResult = ReturnType<
  typeof usePasswordChangeMutation
>;
export type PasswordChangeMutationResult = Apollo.MutationResult<
  PasswordChangeMutation
>;
export type PasswordChangeMutationOptions = Apollo.BaseMutationOptions<
  PasswordChangeMutation,
  PasswordChangeMutationVariables
>;
export const CompleteRegistrationDocument = gql`
  mutation completeRegistration($input: createRegistrationCompletionInput!) {
    createRegistrationCompletion(input: $input) {
      registrationCompletion {
        id
        sessionId
        applicationSettings {
          ...Settings
        }
      }
    }
  }
  ${SettingsFragmentDoc}
`;
export type CompleteRegistrationMutationFn = Apollo.MutationFunction<
  CompleteRegistrationMutation,
  CompleteRegistrationMutationVariables
>;

/**
 * __useCompleteRegistrationMutation__
 *
 * To run a mutation, you first call `useCompleteRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeRegistrationMutation, { data, loading, error }] = useCompleteRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteRegistrationMutation,
    CompleteRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteRegistrationMutation,
    CompleteRegistrationMutationVariables
  >(CompleteRegistrationDocument, options);
}
export type CompleteRegistrationMutationHookResult = ReturnType<
  typeof useCompleteRegistrationMutation
>;
export type CompleteRegistrationMutationResult = Apollo.MutationResult<
  CompleteRegistrationMutation
>;
export type CompleteRegistrationMutationOptions = Apollo.BaseMutationOptions<
  CompleteRegistrationMutation,
  CompleteRegistrationMutationVariables
>;
export const GetStatesDocument = gql`
  query getStates(
    $page: Int!
    $perPage: Int!
    $ids: [String]
    $search: String
  ) {
    states(
      page: $page
      itemsPerPage: $perPage
      filter: { like: { name: $search }, in: { id: $ids } }
    ) {
      collection {
        _id
        name
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetStatesQuery__
 *
 * To run a query within a React component, call `useGetStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      ids: // value for 'ids'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetStatesQuery(
  baseOptions: Apollo.QueryHookOptions<GetStatesQuery, GetStatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStatesQuery, GetStatesQueryVariables>(
    GetStatesDocument,
    options
  );
}
export function useGetStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStatesQuery,
    GetStatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStatesQuery, GetStatesQueryVariables>(
    GetStatesDocument,
    options
  );
}
export type GetStatesQueryHookResult = ReturnType<typeof useGetStatesQuery>;
export type GetStatesLazyQueryHookResult = ReturnType<
  typeof useGetStatesLazyQuery
>;
export type GetStatesQueryResult = Apollo.QueryResult<
  GetStatesQuery,
  GetStatesQueryVariables
>;
export const GetCitiesDocument = gql`
  query getCities(
    $page: Int!
    $perPage: Int!
    $ids: [String]
    $search: String
    $stateId: String
  ) {
    cities(
      page: $page
      itemsPerPage: $perPage
      filter: {
        like: { name: $search }
        in: { id: $ids }
        equal: { state_id: $stateId }
      }
    ) {
      collection {
        _id
        name
        state {
          _id
          name
        }
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      ids: // value for 'ids'
 *      search: // value for 'search'
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useGetCitiesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(
    GetCitiesDocument,
    options
  );
}
export function useGetCitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCitiesQuery,
    GetCitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(
    GetCitiesDocument,
    options
  );
}
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<
  typeof useGetCitiesLazyQuery
>;
export type GetCitiesQueryResult = Apollo.QueryResult<
  GetCitiesQuery,
  GetCitiesQueryVariables
>;
export const GetZipCodesDocument = gql`
  query getZIPCodes(
    $page: Int!
    $perPage: Int!
    $ids: [String]
    $cityId: String
    $stateId: String
    $search: String
  ) {
    zipCodes(
      page: $page
      itemsPerPage: $perPage
      filter: {
        like: { zipCode: $search }
        in: { id: $ids }
        equal: { city_id: $cityId, city_state_id: $stateId }
      }
    ) {
      collection {
        _id
        zipCode
        city {
          _id
          name
          state {
            _id
            name
          }
        }
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetZipCodesQuery__
 *
 * To run a query within a React component, call `useGetZipCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZipCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZipCodesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      ids: // value for 'ids'
 *      cityId: // value for 'cityId'
 *      stateId: // value for 'stateId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetZipCodesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetZipCodesQuery,
    GetZipCodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetZipCodesQuery, GetZipCodesQueryVariables>(
    GetZipCodesDocument,
    options
  );
}
export function useGetZipCodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetZipCodesQuery,
    GetZipCodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetZipCodesQuery, GetZipCodesQueryVariables>(
    GetZipCodesDocument,
    options
  );
}
export type GetZipCodesQueryHookResult = ReturnType<typeof useGetZipCodesQuery>;
export type GetZipCodesLazyQueryHookResult = ReturnType<
  typeof useGetZipCodesLazyQuery
>;
export type GetZipCodesQueryResult = Apollo.QueryResult<
  GetZipCodesQuery,
  GetZipCodesQueryVariables
>;
export const GetMercuryUrlDocument = gql`
  query getMercuryURL($caseId: Int!) {
    medicalCase(_id: $caseId) {
      mercureUrl
      ...AllCaseData
    }
  }
  ${AllCaseDataFragmentDoc}
`;

/**
 * __useGetMercuryUrlQuery__
 *
 * To run a query within a React component, call `useGetMercuryUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMercuryUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMercuryUrlQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetMercuryUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMercuryUrlQuery,
    GetMercuryUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMercuryUrlQuery, GetMercuryUrlQueryVariables>(
    GetMercuryUrlDocument,
    options
  );
}
export function useGetMercuryUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMercuryUrlQuery,
    GetMercuryUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMercuryUrlQuery, GetMercuryUrlQueryVariables>(
    GetMercuryUrlDocument,
    options
  );
}
export type GetMercuryUrlQueryHookResult = ReturnType<
  typeof useGetMercuryUrlQuery
>;
export type GetMercuryUrlLazyQueryHookResult = ReturnType<
  typeof useGetMercuryUrlLazyQuery
>;
export type GetMercuryUrlQueryResult = Apollo.QueryResult<
  GetMercuryUrlQuery,
  GetMercuryUrlQueryVariables
>;
export const GetFullMedicalCaseDocument = gql`
  query getFullMedicalCase($caseId: Int!) {
    medicalCase(_id: $caseId) {
      ...AllCaseData
    }
  }
  ${AllCaseDataFragmentDoc}
`;

/**
 * __useGetFullMedicalCaseQuery__
 *
 * To run a query within a React component, call `useGetFullMedicalCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullMedicalCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullMedicalCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetFullMedicalCaseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFullMedicalCaseQuery,
    GetFullMedicalCaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFullMedicalCaseQuery,
    GetFullMedicalCaseQueryVariables
  >(GetFullMedicalCaseDocument, options);
}
export function useGetFullMedicalCaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFullMedicalCaseQuery,
    GetFullMedicalCaseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFullMedicalCaseQuery,
    GetFullMedicalCaseQueryVariables
  >(GetFullMedicalCaseDocument, options);
}
export type GetFullMedicalCaseQueryHookResult = ReturnType<
  typeof useGetFullMedicalCaseQuery
>;
export type GetFullMedicalCaseLazyQueryHookResult = ReturnType<
  typeof useGetFullMedicalCaseLazyQuery
>;
export type GetFullMedicalCaseQueryResult = Apollo.QueryResult<
  GetFullMedicalCaseQuery,
  GetFullMedicalCaseQueryVariables
>;
export const UpdateMedicationCalculationsDocument = gql`
  mutation updateMedicationCalculations(
    $input: updateMedicationCalculationInput!
  ) {
    updateMedicationCalculation(input: $input) {
      medicationCalculation {
        ...MedicationCalculation
      }
    }
  }
  ${MedicationCalculationFragmentDoc}
`;
export type UpdateMedicationCalculationsMutationFn = Apollo.MutationFunction<
  UpdateMedicationCalculationsMutation,
  UpdateMedicationCalculationsMutationVariables
>;

/**
 * __useUpdateMedicationCalculationsMutation__
 *
 * To run a mutation, you first call `useUpdateMedicationCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicationCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicationCalculationsMutation, { data, loading, error }] = useUpdateMedicationCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMedicationCalculationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMedicationCalculationsMutation,
    UpdateMedicationCalculationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMedicationCalculationsMutation,
    UpdateMedicationCalculationsMutationVariables
  >(UpdateMedicationCalculationsDocument, options);
}
export type UpdateMedicationCalculationsMutationHookResult = ReturnType<
  typeof useUpdateMedicationCalculationsMutation
>;
export type UpdateMedicationCalculationsMutationResult = Apollo.MutationResult<
  UpdateMedicationCalculationsMutation
>;
export type UpdateMedicationCalculationsMutationOptions = Apollo.BaseMutationOptions<
  UpdateMedicationCalculationsMutation,
  UpdateMedicationCalculationsMutationVariables
>;
export const CreateMedicationCalculationsDocument = gql`
  mutation createMedicationCalculations(
    $input: createMedicationCalculationInput!
  ) {
    createMedicationCalculation(input: $input) {
      medicationCalculation {
        ...MedicationCalculation
      }
    }
  }
  ${MedicationCalculationFragmentDoc}
`;
export type CreateMedicationCalculationsMutationFn = Apollo.MutationFunction<
  CreateMedicationCalculationsMutation,
  CreateMedicationCalculationsMutationVariables
>;

/**
 * __useCreateMedicationCalculationsMutation__
 *
 * To run a mutation, you first call `useCreateMedicationCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicationCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicationCalculationsMutation, { data, loading, error }] = useCreateMedicationCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMedicationCalculationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMedicationCalculationsMutation,
    CreateMedicationCalculationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMedicationCalculationsMutation,
    CreateMedicationCalculationsMutationVariables
  >(CreateMedicationCalculationsDocument, options);
}
export type CreateMedicationCalculationsMutationHookResult = ReturnType<
  typeof useCreateMedicationCalculationsMutation
>;
export type CreateMedicationCalculationsMutationResult = Apollo.MutationResult<
  CreateMedicationCalculationsMutation
>;
export type CreateMedicationCalculationsMutationOptions = Apollo.BaseMutationOptions<
  CreateMedicationCalculationsMutation,
  CreateMedicationCalculationsMutationVariables
>;
export const UpdateCalculationAgreementDocument = gql`
  mutation updateCalculationAgreement(
    $input: updateCalculationAgreementInput!
  ) {
    updateCalculationAgreement(input: $input) {
      calculationAgreement {
        _id
        signedAt
        file {
          _id
          name
        }
      }
    }
  }
`;
export type UpdateCalculationAgreementMutationFn = Apollo.MutationFunction<
  UpdateCalculationAgreementMutation,
  UpdateCalculationAgreementMutationVariables
>;

/**
 * __useUpdateCalculationAgreementMutation__
 *
 * To run a mutation, you first call `useUpdateCalculationAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalculationAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalculationAgreementMutation, { data, loading, error }] = useUpdateCalculationAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalculationAgreementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCalculationAgreementMutation,
    UpdateCalculationAgreementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCalculationAgreementMutation,
    UpdateCalculationAgreementMutationVariables
  >(UpdateCalculationAgreementDocument, options);
}
export type UpdateCalculationAgreementMutationHookResult = ReturnType<
  typeof useUpdateCalculationAgreementMutation
>;
export type UpdateCalculationAgreementMutationResult = Apollo.MutationResult<
  UpdateCalculationAgreementMutation
>;
export type UpdateCalculationAgreementMutationOptions = Apollo.BaseMutationOptions<
  UpdateCalculationAgreementMutation,
  UpdateCalculationAgreementMutationVariables
>;
export const DeleteMedicationCalculationsDocument = gql`
  mutation deleteMedicationCalculations(
    $input: removeBulkMedicationCalculationInput!
  ) {
    removeBulkMedicationCalculation(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteMedicationCalculationsMutationFn = Apollo.MutationFunction<
  DeleteMedicationCalculationsMutation,
  DeleteMedicationCalculationsMutationVariables
>;

/**
 * __useDeleteMedicationCalculationsMutation__
 *
 * To run a mutation, you first call `useDeleteMedicationCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicationCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicationCalculationsMutation, { data, loading, error }] = useDeleteMedicationCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMedicationCalculationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMedicationCalculationsMutation,
    DeleteMedicationCalculationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMedicationCalculationsMutation,
    DeleteMedicationCalculationsMutationVariables
  >(DeleteMedicationCalculationsDocument, options);
}
export type DeleteMedicationCalculationsMutationHookResult = ReturnType<
  typeof useDeleteMedicationCalculationsMutation
>;
export type DeleteMedicationCalculationsMutationResult = Apollo.MutationResult<
  DeleteMedicationCalculationsMutation
>;
export type DeleteMedicationCalculationsMutationOptions = Apollo.BaseMutationOptions<
  DeleteMedicationCalculationsMutation,
  DeleteMedicationCalculationsMutationVariables
>;
export const UpdateDefibMedicationDocument = gql`
  mutation updateDefibMedication($input: updateDefibMedicationInput!) {
    updateDefibMedication(input: $input) {
      defibMedication {
        ...DefibMedication
      }
    }
  }
  ${DefibMedicationFragmentDoc}
`;
export type UpdateDefibMedicationMutationFn = Apollo.MutationFunction<
  UpdateDefibMedicationMutation,
  UpdateDefibMedicationMutationVariables
>;

/**
 * __useUpdateDefibMedicationMutation__
 *
 * To run a mutation, you first call `useUpdateDefibMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefibMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefibMedicationMutation, { data, loading, error }] = useUpdateDefibMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDefibMedicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDefibMedicationMutation,
    UpdateDefibMedicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDefibMedicationMutation,
    UpdateDefibMedicationMutationVariables
  >(UpdateDefibMedicationDocument, options);
}
export type UpdateDefibMedicationMutationHookResult = ReturnType<
  typeof useUpdateDefibMedicationMutation
>;
export type UpdateDefibMedicationMutationResult = Apollo.MutationResult<
  UpdateDefibMedicationMutation
>;
export type UpdateDefibMedicationMutationOptions = Apollo.BaseMutationOptions<
  UpdateDefibMedicationMutation,
  UpdateDefibMedicationMutationVariables
>;
export const CreateDefibMedicationDocument = gql`
  mutation createDefibMedication($input: createDefibMedicationInput!) {
    createDefibMedication(input: $input) {
      defibMedication {
        ...DefibMedication
      }
    }
  }
  ${DefibMedicationFragmentDoc}
`;
export type CreateDefibMedicationMutationFn = Apollo.MutationFunction<
  CreateDefibMedicationMutation,
  CreateDefibMedicationMutationVariables
>;

/**
 * __useCreateDefibMedicationMutation__
 *
 * To run a mutation, you first call `useCreateDefibMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefibMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefibMedicationMutation, { data, loading, error }] = useCreateDefibMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDefibMedicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDefibMedicationMutation,
    CreateDefibMedicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDefibMedicationMutation,
    CreateDefibMedicationMutationVariables
  >(CreateDefibMedicationDocument, options);
}
export type CreateDefibMedicationMutationHookResult = ReturnType<
  typeof useCreateDefibMedicationMutation
>;
export type CreateDefibMedicationMutationResult = Apollo.MutationResult<
  CreateDefibMedicationMutation
>;
export type CreateDefibMedicationMutationOptions = Apollo.BaseMutationOptions<
  CreateDefibMedicationMutation,
  CreateDefibMedicationMutationVariables
>;
export const DeleteDefibMedicationsDocument = gql`
  mutation deleteDefibMedications($input: removeBulkDefibMedicationInput!) {
    removeBulkDefibMedication(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteDefibMedicationsMutationFn = Apollo.MutationFunction<
  DeleteDefibMedicationsMutation,
  DeleteDefibMedicationsMutationVariables
>;

/**
 * __useDeleteDefibMedicationsMutation__
 *
 * To run a mutation, you first call `useDeleteDefibMedicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDefibMedicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDefibMedicationsMutation, { data, loading, error }] = useDeleteDefibMedicationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDefibMedicationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDefibMedicationsMutation,
    DeleteDefibMedicationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDefibMedicationsMutation,
    DeleteDefibMedicationsMutationVariables
  >(DeleteDefibMedicationsDocument, options);
}
export type DeleteDefibMedicationsMutationHookResult = ReturnType<
  typeof useDeleteDefibMedicationsMutation
>;
export type DeleteDefibMedicationsMutationResult = Apollo.MutationResult<
  DeleteDefibMedicationsMutation
>;
export type DeleteDefibMedicationsMutationOptions = Apollo.BaseMutationOptions<
  DeleteDefibMedicationsMutation,
  DeleteDefibMedicationsMutationVariables
>;
export const UpdateFluidBolusDocument = gql`
  mutation updateFluidBolus($input: updateFluidBolusInput!) {
    updateFluidBolus(input: $input) {
      fluidBolus {
        _id
        totalAmount
      }
    }
  }
`;
export type UpdateFluidBolusMutationFn = Apollo.MutationFunction<
  UpdateFluidBolusMutation,
  UpdateFluidBolusMutationVariables
>;

/**
 * __useUpdateFluidBolusMutation__
 *
 * To run a mutation, you first call `useUpdateFluidBolusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFluidBolusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFluidBolusMutation, { data, loading, error }] = useUpdateFluidBolusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFluidBolusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFluidBolusMutation,
    UpdateFluidBolusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFluidBolusMutation,
    UpdateFluidBolusMutationVariables
  >(UpdateFluidBolusDocument, options);
}
export type UpdateFluidBolusMutationHookResult = ReturnType<
  typeof useUpdateFluidBolusMutation
>;
export type UpdateFluidBolusMutationResult = Apollo.MutationResult<
  UpdateFluidBolusMutation
>;
export type UpdateFluidBolusMutationOptions = Apollo.BaseMutationOptions<
  UpdateFluidBolusMutation,
  UpdateFluidBolusMutationVariables
>;
export const DeleteFluidBolusDocument = gql`
  mutation deleteFluidBolus($input: deleteFluidBolusInput!) {
    deleteFluidBolus(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteFluidBolusMutationFn = Apollo.MutationFunction<
  DeleteFluidBolusMutation,
  DeleteFluidBolusMutationVariables
>;

/**
 * __useDeleteFluidBolusMutation__
 *
 * To run a mutation, you first call `useDeleteFluidBolusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFluidBolusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFluidBolusMutation, { data, loading, error }] = useDeleteFluidBolusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFluidBolusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFluidBolusMutation,
    DeleteFluidBolusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFluidBolusMutation,
    DeleteFluidBolusMutationVariables
  >(DeleteFluidBolusDocument, options);
}
export type DeleteFluidBolusMutationHookResult = ReturnType<
  typeof useDeleteFluidBolusMutation
>;
export type DeleteFluidBolusMutationResult = Apollo.MutationResult<
  DeleteFluidBolusMutation
>;
export type DeleteFluidBolusMutationOptions = Apollo.BaseMutationOptions<
  DeleteFluidBolusMutation,
  DeleteFluidBolusMutationVariables
>;
export const CreateFluidBolusDocument = gql`
  mutation createFluidBolus($input: createFluidBolusInput!) {
    createFluidBolus(input: $input) {
      fluidBolus {
        _id
        totalAmount
      }
    }
  }
`;
export type CreateFluidBolusMutationFn = Apollo.MutationFunction<
  CreateFluidBolusMutation,
  CreateFluidBolusMutationVariables
>;

/**
 * __useCreateFluidBolusMutation__
 *
 * To run a mutation, you first call `useCreateFluidBolusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFluidBolusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFluidBolusMutation, { data, loading, error }] = useCreateFluidBolusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFluidBolusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFluidBolusMutation,
    CreateFluidBolusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFluidBolusMutation,
    CreateFluidBolusMutationVariables
  >(CreateFluidBolusDocument, options);
}
export type CreateFluidBolusMutationHookResult = ReturnType<
  typeof useCreateFluidBolusMutation
>;
export type CreateFluidBolusMutationResult = Apollo.MutationResult<
  CreateFluidBolusMutation
>;
export type CreateFluidBolusMutationOptions = Apollo.BaseMutationOptions<
  CreateFluidBolusMutation,
  CreateFluidBolusMutationVariables
>;
export const UpdateRegionalBlockDocument = gql`
  mutation updateRegionalBlock($input: updateRegionalBlockInput!) {
    updateRegionalBlock(input: $input) {
      regionalBlock {
        ...RegionalBlock
      }
    }
  }
  ${RegionalBlockFragmentDoc}
`;
export type UpdateRegionalBlockMutationFn = Apollo.MutationFunction<
  UpdateRegionalBlockMutation,
  UpdateRegionalBlockMutationVariables
>;

/**
 * __useUpdateRegionalBlockMutation__
 *
 * To run a mutation, you first call `useUpdateRegionalBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionalBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionalBlockMutation, { data, loading, error }] = useUpdateRegionalBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionalBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRegionalBlockMutation,
    UpdateRegionalBlockMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRegionalBlockMutation,
    UpdateRegionalBlockMutationVariables
  >(UpdateRegionalBlockDocument, options);
}
export type UpdateRegionalBlockMutationHookResult = ReturnType<
  typeof useUpdateRegionalBlockMutation
>;
export type UpdateRegionalBlockMutationResult = Apollo.MutationResult<
  UpdateRegionalBlockMutation
>;
export type UpdateRegionalBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdateRegionalBlockMutation,
  UpdateRegionalBlockMutationVariables
>;
export const CreateRegionalBlockDocument = gql`
  mutation createRegionalBlock($input: createRegionalBlockInput!) {
    createRegionalBlock(input: $input) {
      regionalBlock {
        ...RegionalBlock
      }
    }
  }
  ${RegionalBlockFragmentDoc}
`;
export type CreateRegionalBlockMutationFn = Apollo.MutationFunction<
  CreateRegionalBlockMutation,
  CreateRegionalBlockMutationVariables
>;

/**
 * __useCreateRegionalBlockMutation__
 *
 * To run a mutation, you first call `useCreateRegionalBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionalBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionalBlockMutation, { data, loading, error }] = useCreateRegionalBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionalBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRegionalBlockMutation,
    CreateRegionalBlockMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRegionalBlockMutation,
    CreateRegionalBlockMutationVariables
  >(CreateRegionalBlockDocument, options);
}
export type CreateRegionalBlockMutationHookResult = ReturnType<
  typeof useCreateRegionalBlockMutation
>;
export type CreateRegionalBlockMutationResult = Apollo.MutationResult<
  CreateRegionalBlockMutation
>;
export type CreateRegionalBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateRegionalBlockMutation,
  CreateRegionalBlockMutationVariables
>;
export const DeleteRegionalBlocksDocument = gql`
  mutation deleteRegionalBlocks($input: removeBulkRegionalBlockInput!) {
    removeBulkRegionalBlock(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteRegionalBlocksMutationFn = Apollo.MutationFunction<
  DeleteRegionalBlocksMutation,
  DeleteRegionalBlocksMutationVariables
>;

/**
 * __useDeleteRegionalBlocksMutation__
 *
 * To run a mutation, you first call `useDeleteRegionalBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionalBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionalBlocksMutation, { data, loading, error }] = useDeleteRegionalBlocksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegionalBlocksMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRegionalBlocksMutation,
    DeleteRegionalBlocksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRegionalBlocksMutation,
    DeleteRegionalBlocksMutationVariables
  >(DeleteRegionalBlocksDocument, options);
}
export type DeleteRegionalBlocksMutationHookResult = ReturnType<
  typeof useDeleteRegionalBlocksMutation
>;
export type DeleteRegionalBlocksMutationResult = Apollo.MutationResult<
  DeleteRegionalBlocksMutation
>;
export type DeleteRegionalBlocksMutationOptions = Apollo.BaseMutationOptions<
  DeleteRegionalBlocksMutation,
  DeleteRegionalBlocksMutationVariables
>;
export const UpdatePatientMiscellaneousDocument = gql`
  mutation updatePatientMiscellaneous($input: updateMiscellaneousGroupInput!) {
    updateMiscellaneousGroup(input: $input) {
      miscellaneousGroup {
        ...MiscellaneousGroup
      }
    }
  }
  ${MiscellaneousGroupFragmentDoc}
`;
export type UpdatePatientMiscellaneousMutationFn = Apollo.MutationFunction<
  UpdatePatientMiscellaneousMutation,
  UpdatePatientMiscellaneousMutationVariables
>;

/**
 * __useUpdatePatientMiscellaneousMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMiscellaneousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMiscellaneousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMiscellaneousMutation, { data, loading, error }] = useUpdatePatientMiscellaneousMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientMiscellaneousMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientMiscellaneousMutation,
    UpdatePatientMiscellaneousMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientMiscellaneousMutation,
    UpdatePatientMiscellaneousMutationVariables
  >(UpdatePatientMiscellaneousDocument, options);
}
export type UpdatePatientMiscellaneousMutationHookResult = ReturnType<
  typeof useUpdatePatientMiscellaneousMutation
>;
export type UpdatePatientMiscellaneousMutationResult = Apollo.MutationResult<
  UpdatePatientMiscellaneousMutation
>;
export type UpdatePatientMiscellaneousMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientMiscellaneousMutation,
  UpdatePatientMiscellaneousMutationVariables
>;
export const UpdatePatientInformationDocument = gql`
  mutation updatePatientInformation($input: updatePatientInput!) {
    updatePatient(input: $input) {
      patient {
        ...PatientInformation
        vaccines {
          collection {
            ...PatientVaccine
          }
        }
        generalAssessment {
          ...GeneralAssessment
        }
        tibialPlateauLevelingOsteotomyPlanning {
          ...TPLO
        }
        patientTests {
          collection {
            ...Test
          }
        }
        treatment {
          ...PatientTreatment
        }
        dentalChartings {
          collection {
            ...DentalCharting
          }
        }
        dentalSketch {
          _id
          name
        }
        dentalSketchComments {
          collection {
            ...DentalSketchComment
          }
        }
      }
    }
  }
  ${PatientInformationFragmentDoc}
  ${PatientVaccineFragmentDoc}
  ${GeneralAssessmentFragmentDoc}
  ${TploFragmentDoc}
  ${TestFragmentDoc}
  ${PatientTreatmentFragmentDoc}
  ${DentalChartingFragmentDoc}
  ${DentalSketchCommentFragmentDoc}
`;
export type UpdatePatientInformationMutationFn = Apollo.MutationFunction<
  UpdatePatientInformationMutation,
  UpdatePatientInformationMutationVariables
>;

/**
 * __useUpdatePatientInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePatientInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientInformationMutation, { data, loading, error }] = useUpdatePatientInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientInformationMutation,
    UpdatePatientInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientInformationMutation,
    UpdatePatientInformationMutationVariables
  >(UpdatePatientInformationDocument, options);
}
export type UpdatePatientInformationMutationHookResult = ReturnType<
  typeof useUpdatePatientInformationMutation
>;
export type UpdatePatientInformationMutationResult = Apollo.MutationResult<
  UpdatePatientInformationMutation
>;
export type UpdatePatientInformationMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientInformationMutation,
  UpdatePatientInformationMutationVariables
>;
export const UpdateClientInformationDocument = gql`
  mutation updateClientInformation($input: updateClientInput!) {
    updateClient(input: $input) {
      client {
        ...ClientInformation
      }
    }
  }
  ${ClientInformationFragmentDoc}
`;
export type UpdateClientInformationMutationFn = Apollo.MutationFunction<
  UpdateClientInformationMutation,
  UpdateClientInformationMutationVariables
>;

/**
 * __useUpdateClientInformationMutation__
 *
 * To run a mutation, you first call `useUpdateClientInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientInformationMutation, { data, loading, error }] = useUpdateClientInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClientInformationMutation,
    UpdateClientInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClientInformationMutation,
    UpdateClientInformationMutationVariables
  >(UpdateClientInformationDocument, options);
}
export type UpdateClientInformationMutationHookResult = ReturnType<
  typeof useUpdateClientInformationMutation
>;
export type UpdateClientInformationMutationResult = Apollo.MutationResult<
  UpdateClientInformationMutation
>;
export type UpdateClientInformationMutationOptions = Apollo.BaseMutationOptions<
  UpdateClientInformationMutation,
  UpdateClientInformationMutationVariables
>;
export const UpdateDisclaimerDocument = gql`
  mutation updateDisclaimer($input: updateDisclaimerInput!) {
    updateDisclaimer(input: $input) {
      disclaimer {
        _id
        signature {
          _id
          name
        }
      }
    }
  }
`;
export type UpdateDisclaimerMutationFn = Apollo.MutationFunction<
  UpdateDisclaimerMutation,
  UpdateDisclaimerMutationVariables
>;

/**
 * __useUpdateDisclaimerMutation__
 *
 * To run a mutation, you first call `useUpdateDisclaimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisclaimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisclaimerMutation, { data, loading, error }] = useUpdateDisclaimerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisclaimerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDisclaimerMutation,
    UpdateDisclaimerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDisclaimerMutation,
    UpdateDisclaimerMutationVariables
  >(UpdateDisclaimerDocument, options);
}
export type UpdateDisclaimerMutationHookResult = ReturnType<
  typeof useUpdateDisclaimerMutation
>;
export type UpdateDisclaimerMutationResult = Apollo.MutationResult<
  UpdateDisclaimerMutation
>;
export type UpdateDisclaimerMutationOptions = Apollo.BaseMutationOptions<
  UpdateDisclaimerMutation,
  UpdateDisclaimerMutationVariables
>;
export const UpdatePatientDropOffDocument = gql`
  mutation updatePatientDropOff($input: updateDropOffInput!) {
    updateDropOff(input: $input) {
      dropOff {
        ...DropOff
      }
    }
  }
  ${DropOffFragmentDoc}
`;
export type UpdatePatientDropOffMutationFn = Apollo.MutationFunction<
  UpdatePatientDropOffMutation,
  UpdatePatientDropOffMutationVariables
>;

/**
 * __useUpdatePatientDropOffMutation__
 *
 * To run a mutation, you first call `useUpdatePatientDropOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientDropOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientDropOffMutation, { data, loading, error }] = useUpdatePatientDropOffMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientDropOffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientDropOffMutation,
    UpdatePatientDropOffMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientDropOffMutation,
    UpdatePatientDropOffMutationVariables
  >(UpdatePatientDropOffDocument, options);
}
export type UpdatePatientDropOffMutationHookResult = ReturnType<
  typeof useUpdatePatientDropOffMutation
>;
export type UpdatePatientDropOffMutationResult = Apollo.MutationResult<
  UpdatePatientDropOffMutation
>;
export type UpdatePatientDropOffMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientDropOffMutation,
  UpdatePatientDropOffMutationVariables
>;
export const UpdateAuthorizationDocument = gql`
  mutation updateAuthorization($input: updateAuthorizationInput!) {
    updateAuthorization(input: $input) {
      authorization {
        _id
        selected
      }
    }
  }
`;
export type UpdateAuthorizationMutationFn = Apollo.MutationFunction<
  UpdateAuthorizationMutation,
  UpdateAuthorizationMutationVariables
>;

/**
 * __useUpdateAuthorizationMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizationMutation, { data, loading, error }] = useUpdateAuthorizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAuthorizationMutation,
    UpdateAuthorizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAuthorizationMutation,
    UpdateAuthorizationMutationVariables
  >(UpdateAuthorizationDocument, options);
}
export type UpdateAuthorizationMutationHookResult = ReturnType<
  typeof useUpdateAuthorizationMutation
>;
export type UpdateAuthorizationMutationResult = Apollo.MutationResult<
  UpdateAuthorizationMutation
>;
export type UpdateAuthorizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAuthorizationMutation,
  UpdateAuthorizationMutationVariables
>;
export const UpdateDisclaimerProcedureDocument = gql`
  mutation updateDisclaimerProcedure($input: updateDisclaimerProcedureInput!) {
    updateDisclaimerProcedure(input: $input) {
      disclaimerProcedure {
        _id
        selected
      }
    }
  }
`;
export type UpdateDisclaimerProcedureMutationFn = Apollo.MutationFunction<
  UpdateDisclaimerProcedureMutation,
  UpdateDisclaimerProcedureMutationVariables
>;

/**
 * __useUpdateDisclaimerProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateDisclaimerProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisclaimerProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisclaimerProcedureMutation, { data, loading, error }] = useUpdateDisclaimerProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisclaimerProcedureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDisclaimerProcedureMutation,
    UpdateDisclaimerProcedureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDisclaimerProcedureMutation,
    UpdateDisclaimerProcedureMutationVariables
  >(UpdateDisclaimerProcedureDocument, options);
}
export type UpdateDisclaimerProcedureMutationHookResult = ReturnType<
  typeof useUpdateDisclaimerProcedureMutation
>;
export type UpdateDisclaimerProcedureMutationResult = Apollo.MutationResult<
  UpdateDisclaimerProcedureMutation
>;
export type UpdateDisclaimerProcedureMutationOptions = Apollo.BaseMutationOptions<
  UpdateDisclaimerProcedureMutation,
  UpdateDisclaimerProcedureMutationVariables
>;
export const UpdateGeneralAssessmentDocument = gql`
  mutation updateGeneralAssessment($input: updatePatientInput!) {
    updatePatient(input: $input) {
      patient {
        generalAssessment {
          ...GeneralAssessment
        }
        dentalChartings {
          collection {
            ...DentalCharting
          }
        }
        dentalSketchComments {
          collection {
            ...DentalSketchComment
          }
        }
        dentalSketch {
          _id
        }
      }
    }
  }
  ${GeneralAssessmentFragmentDoc}
  ${DentalChartingFragmentDoc}
  ${DentalSketchCommentFragmentDoc}
`;
export type UpdateGeneralAssessmentMutationFn = Apollo.MutationFunction<
  UpdateGeneralAssessmentMutation,
  UpdateGeneralAssessmentMutationVariables
>;

/**
 * __useUpdateGeneralAssessmentMutation__
 *
 * To run a mutation, you first call `useUpdateGeneralAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneralAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneralAssessmentMutation, { data, loading, error }] = useUpdateGeneralAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGeneralAssessmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGeneralAssessmentMutation,
    UpdateGeneralAssessmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateGeneralAssessmentMutation,
    UpdateGeneralAssessmentMutationVariables
  >(UpdateGeneralAssessmentDocument, options);
}
export type UpdateGeneralAssessmentMutationHookResult = ReturnType<
  typeof useUpdateGeneralAssessmentMutation
>;
export type UpdateGeneralAssessmentMutationResult = Apollo.MutationResult<
  UpdateGeneralAssessmentMutation
>;
export type UpdateGeneralAssessmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateGeneralAssessmentMutation,
  UpdateGeneralAssessmentMutationVariables
>;
export const UpdateTeethStateDocument = gql`
  mutation updateTeethState($input: updateStatusBulkDentalChartingInput!) {
    updateStatusBulkDentalCharting(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateTeethStateMutationFn = Apollo.MutationFunction<
  UpdateTeethStateMutation,
  UpdateTeethStateMutationVariables
>;

/**
 * __useUpdateTeethStateMutation__
 *
 * To run a mutation, you first call `useUpdateTeethStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeethStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeethStateMutation, { data, loading, error }] = useUpdateTeethStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeethStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeethStateMutation,
    UpdateTeethStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTeethStateMutation,
    UpdateTeethStateMutationVariables
  >(UpdateTeethStateDocument, options);
}
export type UpdateTeethStateMutationHookResult = ReturnType<
  typeof useUpdateTeethStateMutation
>;
export type UpdateTeethStateMutationResult = Apollo.MutationResult<
  UpdateTeethStateMutation
>;
export type UpdateTeethStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeethStateMutation,
  UpdateTeethStateMutationVariables
>;
export const UpdateDentalChartingDocument = gql`
  mutation updateDentalCharting($input: updateDentalChartingInput!) {
    updateDentalCharting(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateDentalChartingMutationFn = Apollo.MutationFunction<
  UpdateDentalChartingMutation,
  UpdateDentalChartingMutationVariables
>;

/**
 * __useUpdateDentalChartingMutation__
 *
 * To run a mutation, you first call `useUpdateDentalChartingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDentalChartingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDentalChartingMutation, { data, loading, error }] = useUpdateDentalChartingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDentalChartingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDentalChartingMutation,
    UpdateDentalChartingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDentalChartingMutation,
    UpdateDentalChartingMutationVariables
  >(UpdateDentalChartingDocument, options);
}
export type UpdateDentalChartingMutationHookResult = ReturnType<
  typeof useUpdateDentalChartingMutation
>;
export type UpdateDentalChartingMutationResult = Apollo.MutationResult<
  UpdateDentalChartingMutation
>;
export type UpdateDentalChartingMutationOptions = Apollo.BaseMutationOptions<
  UpdateDentalChartingMutation,
  UpdateDentalChartingMutationVariables
>;
export const UpdateQuickChartDocument = gql`
  mutation updateQuickChart($input: updateQuickChartBulkDentalChartingInput!) {
    updateQuickChartBulkDentalCharting(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateQuickChartMutationFn = Apollo.MutationFunction<
  UpdateQuickChartMutation,
  UpdateQuickChartMutationVariables
>;

/**
 * __useUpdateQuickChartMutation__
 *
 * To run a mutation, you first call `useUpdateQuickChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickChartMutation, { data, loading, error }] = useUpdateQuickChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuickChartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateQuickChartMutation,
    UpdateQuickChartMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateQuickChartMutation,
    UpdateQuickChartMutationVariables
  >(UpdateQuickChartDocument, options);
}
export type UpdateQuickChartMutationHookResult = ReturnType<
  typeof useUpdateQuickChartMutation
>;
export type UpdateQuickChartMutationResult = Apollo.MutationResult<
  UpdateQuickChartMutation
>;
export type UpdateQuickChartMutationOptions = Apollo.BaseMutationOptions<
  UpdateQuickChartMutation,
  UpdateQuickChartMutationVariables
>;
export const PrintDentalReportDocument = gql`
  mutation printDentalReport($input: createDentalReportPrintInput!) {
    createDentalReportPrint(input: $input) {
      dentalReportPrint {
        id
        file {
          _id
        }
      }
    }
  }
`;
export type PrintDentalReportMutationFn = Apollo.MutationFunction<
  PrintDentalReportMutation,
  PrintDentalReportMutationVariables
>;

/**
 * __usePrintDentalReportMutation__
 *
 * To run a mutation, you first call `usePrintDentalReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintDentalReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printDentalReportMutation, { data, loading, error }] = usePrintDentalReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintDentalReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PrintDentalReportMutation,
    PrintDentalReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PrintDentalReportMutation,
    PrintDentalReportMutationVariables
  >(PrintDentalReportDocument, options);
}
export type PrintDentalReportMutationHookResult = ReturnType<
  typeof usePrintDentalReportMutation
>;
export type PrintDentalReportMutationResult = Apollo.MutationResult<
  PrintDentalReportMutation
>;
export type PrintDentalReportMutationOptions = Apollo.BaseMutationOptions<
  PrintDentalReportMutation,
  PrintDentalReportMutationVariables
>;
export const ExportDentalReportDocument = gql`
  mutation exportDentalReport($input: createDentalReportExportInput!) {
    createDentalReportExport(input: $input) {
      clientMutationId
    }
  }
`;
export type ExportDentalReportMutationFn = Apollo.MutationFunction<
  ExportDentalReportMutation,
  ExportDentalReportMutationVariables
>;

/**
 * __useExportDentalReportMutation__
 *
 * To run a mutation, you first call `useExportDentalReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDentalReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDentalReportMutation, { data, loading, error }] = useExportDentalReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportDentalReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportDentalReportMutation,
    ExportDentalReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportDentalReportMutation,
    ExportDentalReportMutationVariables
  >(ExportDentalReportDocument, options);
}
export type ExportDentalReportMutationHookResult = ReturnType<
  typeof useExportDentalReportMutation
>;
export type ExportDentalReportMutationResult = Apollo.MutationResult<
  ExportDentalReportMutation
>;
export type ExportDentalReportMutationOptions = Apollo.BaseMutationOptions<
  ExportDentalReportMutation,
  ExportDentalReportMutationVariables
>;
export const UpdateDentalSketchCommentDocument = gql`
  mutation updateDentalSketchComment($input: updateDentalSketchCommentInput!) {
    updateDentalSketchComment(input: $input) {
      dentalSketchComment {
        ...DentalSketchComment
      }
    }
  }
  ${DentalSketchCommentFragmentDoc}
`;
export type UpdateDentalSketchCommentMutationFn = Apollo.MutationFunction<
  UpdateDentalSketchCommentMutation,
  UpdateDentalSketchCommentMutationVariables
>;

/**
 * __useUpdateDentalSketchCommentMutation__
 *
 * To run a mutation, you first call `useUpdateDentalSketchCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDentalSketchCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDentalSketchCommentMutation, { data, loading, error }] = useUpdateDentalSketchCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDentalSketchCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDentalSketchCommentMutation,
    UpdateDentalSketchCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDentalSketchCommentMutation,
    UpdateDentalSketchCommentMutationVariables
  >(UpdateDentalSketchCommentDocument, options);
}
export type UpdateDentalSketchCommentMutationHookResult = ReturnType<
  typeof useUpdateDentalSketchCommentMutation
>;
export type UpdateDentalSketchCommentMutationResult = Apollo.MutationResult<
  UpdateDentalSketchCommentMutation
>;
export type UpdateDentalSketchCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateDentalSketchCommentMutation,
  UpdateDentalSketchCommentMutationVariables
>;
export const CreateDentalSketchCommentDocument = gql`
  mutation createDentalSketchComment($input: createDentalSketchCommentInput!) {
    createDentalSketchComment(input: $input) {
      dentalSketchComment {
        ...DentalSketchComment
      }
    }
  }
  ${DentalSketchCommentFragmentDoc}
`;
export type CreateDentalSketchCommentMutationFn = Apollo.MutationFunction<
  CreateDentalSketchCommentMutation,
  CreateDentalSketchCommentMutationVariables
>;

/**
 * __useCreateDentalSketchCommentMutation__
 *
 * To run a mutation, you first call `useCreateDentalSketchCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDentalSketchCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDentalSketchCommentMutation, { data, loading, error }] = useCreateDentalSketchCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDentalSketchCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDentalSketchCommentMutation,
    CreateDentalSketchCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDentalSketchCommentMutation,
    CreateDentalSketchCommentMutationVariables
  >(CreateDentalSketchCommentDocument, options);
}
export type CreateDentalSketchCommentMutationHookResult = ReturnType<
  typeof useCreateDentalSketchCommentMutation
>;
export type CreateDentalSketchCommentMutationResult = Apollo.MutationResult<
  CreateDentalSketchCommentMutation
>;
export type CreateDentalSketchCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateDentalSketchCommentMutation,
  CreateDentalSketchCommentMutationVariables
>;
export const DeleteDentalSketchCommentsDocument = gql`
  mutation deleteDentalSketchComments(
    $input: removeBulkDentalSketchCommentInput!
  ) {
    removeBulkDentalSketchComment(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteDentalSketchCommentsMutationFn = Apollo.MutationFunction<
  DeleteDentalSketchCommentsMutation,
  DeleteDentalSketchCommentsMutationVariables
>;

/**
 * __useDeleteDentalSketchCommentsMutation__
 *
 * To run a mutation, you first call `useDeleteDentalSketchCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDentalSketchCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDentalSketchCommentsMutation, { data, loading, error }] = useDeleteDentalSketchCommentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDentalSketchCommentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDentalSketchCommentsMutation,
    DeleteDentalSketchCommentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDentalSketchCommentsMutation,
    DeleteDentalSketchCommentsMutationVariables
  >(DeleteDentalSketchCommentsDocument, options);
}
export type DeleteDentalSketchCommentsMutationHookResult = ReturnType<
  typeof useDeleteDentalSketchCommentsMutation
>;
export type DeleteDentalSketchCommentsMutationResult = Apollo.MutationResult<
  DeleteDentalSketchCommentsMutation
>;
export type DeleteDentalSketchCommentsMutationOptions = Apollo.BaseMutationOptions<
  DeleteDentalSketchCommentsMutation,
  DeleteDentalSketchCommentsMutationVariables
>;
export const UpdateVaccineDocument = gql`
  mutation updateVaccine($input: updateVaccineInput!) {
    updateVaccine(input: $input) {
      vaccine {
        ...PatientVaccine
      }
    }
  }
  ${PatientVaccineFragmentDoc}
`;
export type UpdateVaccineMutationFn = Apollo.MutationFunction<
  UpdateVaccineMutation,
  UpdateVaccineMutationVariables
>;

/**
 * __useUpdateVaccineMutation__
 *
 * To run a mutation, you first call `useUpdateVaccineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVaccineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVaccineMutation, { data, loading, error }] = useUpdateVaccineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVaccineMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVaccineMutation,
    UpdateVaccineMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateVaccineMutation,
    UpdateVaccineMutationVariables
  >(UpdateVaccineDocument, options);
}
export type UpdateVaccineMutationHookResult = ReturnType<
  typeof useUpdateVaccineMutation
>;
export type UpdateVaccineMutationResult = Apollo.MutationResult<
  UpdateVaccineMutation
>;
export type UpdateVaccineMutationOptions = Apollo.BaseMutationOptions<
  UpdateVaccineMutation,
  UpdateVaccineMutationVariables
>;
export const UpdatePatientTestDocument = gql`
  mutation updatePatientTest($input: updatePatientTestInput!) {
    updatePatientTest(input: $input) {
      patientTest {
        ...Test
      }
    }
  }
  ${TestFragmentDoc}
`;
export type UpdatePatientTestMutationFn = Apollo.MutationFunction<
  UpdatePatientTestMutation,
  UpdatePatientTestMutationVariables
>;

/**
 * __useUpdatePatientTestMutation__
 *
 * To run a mutation, you first call `useUpdatePatientTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientTestMutation, { data, loading, error }] = useUpdatePatientTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientTestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientTestMutation,
    UpdatePatientTestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientTestMutation,
    UpdatePatientTestMutationVariables
  >(UpdatePatientTestDocument, options);
}
export type UpdatePatientTestMutationHookResult = ReturnType<
  typeof useUpdatePatientTestMutation
>;
export type UpdatePatientTestMutationResult = Apollo.MutationResult<
  UpdatePatientTestMutation
>;
export type UpdatePatientTestMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientTestMutation,
  UpdatePatientTestMutationVariables
>;
export const UpdateTreatmentsDocument = gql`
  mutation updateTreatments($input: updateTreatmentInput!) {
    updateTreatment(input: $input) {
      treatment {
        ...PatientTreatment
      }
    }
  }
  ${PatientTreatmentFragmentDoc}
`;
export type UpdateTreatmentsMutationFn = Apollo.MutationFunction<
  UpdateTreatmentsMutation,
  UpdateTreatmentsMutationVariables
>;

/**
 * __useUpdateTreatmentsMutation__
 *
 * To run a mutation, you first call `useUpdateTreatmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTreatmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTreatmentsMutation, { data, loading, error }] = useUpdateTreatmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTreatmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTreatmentsMutation,
    UpdateTreatmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTreatmentsMutation,
    UpdateTreatmentsMutationVariables
  >(UpdateTreatmentsDocument, options);
}
export type UpdateTreatmentsMutationHookResult = ReturnType<
  typeof useUpdateTreatmentsMutation
>;
export type UpdateTreatmentsMutationResult = Apollo.MutationResult<
  UpdateTreatmentsMutation
>;
export type UpdateTreatmentsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTreatmentsMutation,
  UpdateTreatmentsMutationVariables
>;
export const UpdateExamNotesDocument = gql`
  mutation updateExamNotes($input: updateExamNoteInput!) {
    updateExamNote(input: $input) {
      examNote {
        ...PatientExamNote
      }
    }
  }
  ${PatientExamNoteFragmentDoc}
`;
export type UpdateExamNotesMutationFn = Apollo.MutationFunction<
  UpdateExamNotesMutation,
  UpdateExamNotesMutationVariables
>;

/**
 * __useUpdateExamNotesMutation__
 *
 * To run a mutation, you first call `useUpdateExamNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamNotesMutation, { data, loading, error }] = useUpdateExamNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExamNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateExamNotesMutation,
    UpdateExamNotesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateExamNotesMutation,
    UpdateExamNotesMutationVariables
  >(UpdateExamNotesDocument, options);
}
export type UpdateExamNotesMutationHookResult = ReturnType<
  typeof useUpdateExamNotesMutation
>;
export type UpdateExamNotesMutationResult = Apollo.MutationResult<
  UpdateExamNotesMutation
>;
export type UpdateExamNotesMutationOptions = Apollo.BaseMutationOptions<
  UpdateExamNotesMutation,
  UpdateExamNotesMutationVariables
>;
export const UpdatePreAnestheticExamDocument = gql`
  mutation updatePreAnestheticExam($input: updatePreAnestheticExamInput!) {
    updatePreAnestheticExam(input: $input) {
      preAnestheticExam {
        ...PreAnestheticExam
      }
    }
  }
  ${PreAnestheticExamFragmentDoc}
`;
export type UpdatePreAnestheticExamMutationFn = Apollo.MutationFunction<
  UpdatePreAnestheticExamMutation,
  UpdatePreAnestheticExamMutationVariables
>;

/**
 * __useUpdatePreAnestheticExamMutation__
 *
 * To run a mutation, you first call `useUpdatePreAnestheticExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreAnestheticExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreAnestheticExamMutation, { data, loading, error }] = useUpdatePreAnestheticExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreAnestheticExamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePreAnestheticExamMutation,
    UpdatePreAnestheticExamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePreAnestheticExamMutation,
    UpdatePreAnestheticExamMutationVariables
  >(UpdatePreAnestheticExamDocument, options);
}
export type UpdatePreAnestheticExamMutationHookResult = ReturnType<
  typeof useUpdatePreAnestheticExamMutation
>;
export type UpdatePreAnestheticExamMutationResult = Apollo.MutationResult<
  UpdatePreAnestheticExamMutation
>;
export type UpdatePreAnestheticExamMutationOptions = Apollo.BaseMutationOptions<
  UpdatePreAnestheticExamMutation,
  UpdatePreAnestheticExamMutationVariables
>;
export const UpdatePatientPhysicalExamDocument = gql`
  mutation updatePatientPhysicalExam($input: updatePhysicalExamInput!) {
    updatePhysicalExam(input: $input) {
      physicalExam {
        ...PhysicalExam
      }
    }
  }
  ${PhysicalExamFragmentDoc}
`;
export type UpdatePatientPhysicalExamMutationFn = Apollo.MutationFunction<
  UpdatePatientPhysicalExamMutation,
  UpdatePatientPhysicalExamMutationVariables
>;

/**
 * __useUpdatePatientPhysicalExamMutation__
 *
 * To run a mutation, you first call `useUpdatePatientPhysicalExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientPhysicalExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientPhysicalExamMutation, { data, loading, error }] = useUpdatePatientPhysicalExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientPhysicalExamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientPhysicalExamMutation,
    UpdatePatientPhysicalExamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientPhysicalExamMutation,
    UpdatePatientPhysicalExamMutationVariables
  >(UpdatePatientPhysicalExamDocument, options);
}
export type UpdatePatientPhysicalExamMutationHookResult = ReturnType<
  typeof useUpdatePatientPhysicalExamMutation
>;
export type UpdatePatientPhysicalExamMutationResult = Apollo.MutationResult<
  UpdatePatientPhysicalExamMutation
>;
export type UpdatePatientPhysicalExamMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientPhysicalExamMutation,
  UpdatePatientPhysicalExamMutationVariables
>;
export const UpdateDiagnosticTestingDocument = gql`
  mutation updateDiagnosticTesting($input: updateDiagnosticTestingInput!) {
    updateDiagnosticTesting(input: $input) {
      diagnosticTesting {
        ...DiagnosticTesting
      }
    }
  }
  ${DiagnosticTestingFragmentDoc}
`;
export type UpdateDiagnosticTestingMutationFn = Apollo.MutationFunction<
  UpdateDiagnosticTestingMutation,
  UpdateDiagnosticTestingMutationVariables
>;

/**
 * __useUpdateDiagnosticTestingMutation__
 *
 * To run a mutation, you first call `useUpdateDiagnosticTestingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiagnosticTestingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiagnosticTestingMutation, { data, loading, error }] = useUpdateDiagnosticTestingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiagnosticTestingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiagnosticTestingMutation,
    UpdateDiagnosticTestingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDiagnosticTestingMutation,
    UpdateDiagnosticTestingMutationVariables
  >(UpdateDiagnosticTestingDocument, options);
}
export type UpdateDiagnosticTestingMutationHookResult = ReturnType<
  typeof useUpdateDiagnosticTestingMutation
>;
export type UpdateDiagnosticTestingMutationResult = Apollo.MutationResult<
  UpdateDiagnosticTestingMutation
>;
export type UpdateDiagnosticTestingMutationOptions = Apollo.BaseMutationOptions<
  UpdateDiagnosticTestingMutation,
  UpdateDiagnosticTestingMutationVariables
>;
export const UpdateAdditionalDiagnosticTestDocument = gql`
  mutation updateAdditionalDiagnosticTest(
    $input: updateAdditionalDiagnosticTestInput!
  ) {
    updateAdditionalDiagnosticTest(input: $input) {
      additionalDiagnosticTest {
        ...AdditionalDiagnosticTest
      }
    }
  }
  ${AdditionalDiagnosticTestFragmentDoc}
`;
export type UpdateAdditionalDiagnosticTestMutationFn = Apollo.MutationFunction<
  UpdateAdditionalDiagnosticTestMutation,
  UpdateAdditionalDiagnosticTestMutationVariables
>;

/**
 * __useUpdateAdditionalDiagnosticTestMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalDiagnosticTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalDiagnosticTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalDiagnosticTestMutation, { data, loading, error }] = useUpdateAdditionalDiagnosticTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdditionalDiagnosticTestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdditionalDiagnosticTestMutation,
    UpdateAdditionalDiagnosticTestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdditionalDiagnosticTestMutation,
    UpdateAdditionalDiagnosticTestMutationVariables
  >(UpdateAdditionalDiagnosticTestDocument, options);
}
export type UpdateAdditionalDiagnosticTestMutationHookResult = ReturnType<
  typeof useUpdateAdditionalDiagnosticTestMutation
>;
export type UpdateAdditionalDiagnosticTestMutationResult = Apollo.MutationResult<
  UpdateAdditionalDiagnosticTestMutation
>;
export type UpdateAdditionalDiagnosticTestMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdditionalDiagnosticTestMutation,
  UpdateAdditionalDiagnosticTestMutationVariables
>;
export const CreateAdditionalDiagnosticTestDocument = gql`
  mutation createAdditionalDiagnosticTest(
    $input: createAdditionalDiagnosticTestInput!
  ) {
    createAdditionalDiagnosticTest(input: $input) {
      additionalDiagnosticTest {
        ...AdditionalDiagnosticTest
      }
    }
  }
  ${AdditionalDiagnosticTestFragmentDoc}
`;
export type CreateAdditionalDiagnosticTestMutationFn = Apollo.MutationFunction<
  CreateAdditionalDiagnosticTestMutation,
  CreateAdditionalDiagnosticTestMutationVariables
>;

/**
 * __useCreateAdditionalDiagnosticTestMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalDiagnosticTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalDiagnosticTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalDiagnosticTestMutation, { data, loading, error }] = useCreateAdditionalDiagnosticTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdditionalDiagnosticTestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdditionalDiagnosticTestMutation,
    CreateAdditionalDiagnosticTestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAdditionalDiagnosticTestMutation,
    CreateAdditionalDiagnosticTestMutationVariables
  >(CreateAdditionalDiagnosticTestDocument, options);
}
export type CreateAdditionalDiagnosticTestMutationHookResult = ReturnType<
  typeof useCreateAdditionalDiagnosticTestMutation
>;
export type CreateAdditionalDiagnosticTestMutationResult = Apollo.MutationResult<
  CreateAdditionalDiagnosticTestMutation
>;
export type CreateAdditionalDiagnosticTestMutationOptions = Apollo.BaseMutationOptions<
  CreateAdditionalDiagnosticTestMutation,
  CreateAdditionalDiagnosticTestMutationVariables
>;
export const CreateCurrentMedicationDocument = gql`
  mutation createCurrentMedication($input: createCurrentMedicationInput!) {
    createCurrentMedication(input: $input) {
      currentMedication {
        ...CurrentMedication
      }
    }
  }
  ${CurrentMedicationFragmentDoc}
`;
export type CreateCurrentMedicationMutationFn = Apollo.MutationFunction<
  CreateCurrentMedicationMutation,
  CreateCurrentMedicationMutationVariables
>;

/**
 * __useCreateCurrentMedicationMutation__
 *
 * To run a mutation, you first call `useCreateCurrentMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrentMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrentMedicationMutation, { data, loading, error }] = useCreateCurrentMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrentMedicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurrentMedicationMutation,
    CreateCurrentMedicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCurrentMedicationMutation,
    CreateCurrentMedicationMutationVariables
  >(CreateCurrentMedicationDocument, options);
}
export type CreateCurrentMedicationMutationHookResult = ReturnType<
  typeof useCreateCurrentMedicationMutation
>;
export type CreateCurrentMedicationMutationResult = Apollo.MutationResult<
  CreateCurrentMedicationMutation
>;
export type CreateCurrentMedicationMutationOptions = Apollo.BaseMutationOptions<
  CreateCurrentMedicationMutation,
  CreateCurrentMedicationMutationVariables
>;
export const UpdateCurrentMedicationDocument = gql`
  mutation updateCurrentMedication($input: updateCurrentMedicationInput!) {
    updateCurrentMedication(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateCurrentMedicationMutationFn = Apollo.MutationFunction<
  UpdateCurrentMedicationMutation,
  UpdateCurrentMedicationMutationVariables
>;

/**
 * __useUpdateCurrentMedicationMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentMedicationMutation, { data, loading, error }] = useUpdateCurrentMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentMedicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCurrentMedicationMutation,
    UpdateCurrentMedicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCurrentMedicationMutation,
    UpdateCurrentMedicationMutationVariables
  >(UpdateCurrentMedicationDocument, options);
}
export type UpdateCurrentMedicationMutationHookResult = ReturnType<
  typeof useUpdateCurrentMedicationMutation
>;
export type UpdateCurrentMedicationMutationResult = Apollo.MutationResult<
  UpdateCurrentMedicationMutation
>;
export type UpdateCurrentMedicationMutationOptions = Apollo.BaseMutationOptions<
  UpdateCurrentMedicationMutation,
  UpdateCurrentMedicationMutationVariables
>;
export const RemoveBulkCurrentMedicationDocument = gql`
  mutation removeBulkCurrentMedication(
    $input: removeBulkCurrentMedicationInput!
  ) {
    removeBulkCurrentMedication(input: $input) {
      clientMutationId
    }
  }
`;
export type RemoveBulkCurrentMedicationMutationFn = Apollo.MutationFunction<
  RemoveBulkCurrentMedicationMutation,
  RemoveBulkCurrentMedicationMutationVariables
>;

/**
 * __useRemoveBulkCurrentMedicationMutation__
 *
 * To run a mutation, you first call `useRemoveBulkCurrentMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBulkCurrentMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBulkCurrentMedicationMutation, { data, loading, error }] = useRemoveBulkCurrentMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveBulkCurrentMedicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveBulkCurrentMedicationMutation,
    RemoveBulkCurrentMedicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveBulkCurrentMedicationMutation,
    RemoveBulkCurrentMedicationMutationVariables
  >(RemoveBulkCurrentMedicationDocument, options);
}
export type RemoveBulkCurrentMedicationMutationHookResult = ReturnType<
  typeof useRemoveBulkCurrentMedicationMutation
>;
export type RemoveBulkCurrentMedicationMutationResult = Apollo.MutationResult<
  RemoveBulkCurrentMedicationMutation
>;
export type RemoveBulkCurrentMedicationMutationOptions = Apollo.BaseMutationOptions<
  RemoveBulkCurrentMedicationMutation,
  RemoveBulkCurrentMedicationMutationVariables
>;
export const UpdatePatientAvatarDocument = gql`
  mutation updatePatientAvatar($id: Int!, $image: updateFileNestedInput) {
    updatePatient(input: { _id: $id, image: $image }) {
      patient {
        _id
        image {
          _id
        }
      }
    }
  }
`;
export type UpdatePatientAvatarMutationFn = Apollo.MutationFunction<
  UpdatePatientAvatarMutation,
  UpdatePatientAvatarMutationVariables
>;

/**
 * __useUpdatePatientAvatarMutation__
 *
 * To run a mutation, you first call `useUpdatePatientAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientAvatarMutation, { data, loading, error }] = useUpdatePatientAvatarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdatePatientAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientAvatarMutation,
    UpdatePatientAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientAvatarMutation,
    UpdatePatientAvatarMutationVariables
  >(UpdatePatientAvatarDocument, options);
}
export type UpdatePatientAvatarMutationHookResult = ReturnType<
  typeof useUpdatePatientAvatarMutation
>;
export type UpdatePatientAvatarMutationResult = Apollo.MutationResult<
  UpdatePatientAvatarMutation
>;
export type UpdatePatientAvatarMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientAvatarMutation,
  UpdatePatientAvatarMutationVariables
>;
export const CreateFluidAndTemperatureDocument = gql`
  mutation createFluidAndTemperature($input: createFluidTemperatureInput!) {
    createFluidTemperature(input: $input) {
      fluidTemperature {
        ...FluidAndTemperature
      }
    }
  }
  ${FluidAndTemperatureFragmentDoc}
`;
export type CreateFluidAndTemperatureMutationFn = Apollo.MutationFunction<
  CreateFluidAndTemperatureMutation,
  CreateFluidAndTemperatureMutationVariables
>;

/**
 * __useCreateFluidAndTemperatureMutation__
 *
 * To run a mutation, you first call `useCreateFluidAndTemperatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFluidAndTemperatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFluidAndTemperatureMutation, { data, loading, error }] = useCreateFluidAndTemperatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFluidAndTemperatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFluidAndTemperatureMutation,
    CreateFluidAndTemperatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFluidAndTemperatureMutation,
    CreateFluidAndTemperatureMutationVariables
  >(CreateFluidAndTemperatureDocument, options);
}
export type CreateFluidAndTemperatureMutationHookResult = ReturnType<
  typeof useCreateFluidAndTemperatureMutation
>;
export type CreateFluidAndTemperatureMutationResult = Apollo.MutationResult<
  CreateFluidAndTemperatureMutation
>;
export type CreateFluidAndTemperatureMutationOptions = Apollo.BaseMutationOptions<
  CreateFluidAndTemperatureMutation,
  CreateFluidAndTemperatureMutationVariables
>;
export const UpdateFluidAndTemperatureDocument = gql`
  mutation updateFluidAndTemperature($input: updateFluidTemperatureInput!) {
    updateFluidTemperature(input: $input) {
      fluidTemperature {
        ...FluidAndTemperature
      }
    }
  }
  ${FluidAndTemperatureFragmentDoc}
`;
export type UpdateFluidAndTemperatureMutationFn = Apollo.MutationFunction<
  UpdateFluidAndTemperatureMutation,
  UpdateFluidAndTemperatureMutationVariables
>;

/**
 * __useUpdateFluidAndTemperatureMutation__
 *
 * To run a mutation, you first call `useUpdateFluidAndTemperatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFluidAndTemperatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFluidAndTemperatureMutation, { data, loading, error }] = useUpdateFluidAndTemperatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFluidAndTemperatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFluidAndTemperatureMutation,
    UpdateFluidAndTemperatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFluidAndTemperatureMutation,
    UpdateFluidAndTemperatureMutationVariables
  >(UpdateFluidAndTemperatureDocument, options);
}
export type UpdateFluidAndTemperatureMutationHookResult = ReturnType<
  typeof useUpdateFluidAndTemperatureMutation
>;
export type UpdateFluidAndTemperatureMutationResult = Apollo.MutationResult<
  UpdateFluidAndTemperatureMutation
>;
export type UpdateFluidAndTemperatureMutationOptions = Apollo.BaseMutationOptions<
  UpdateFluidAndTemperatureMutation,
  UpdateFluidAndTemperatureMutationVariables
>;
export const CreateAnestheticGasAndOxygenDocument = gql`
  mutation createAnestheticGasAndOxygen($input: createAnestheticGasInput!) {
    createAnestheticGas(input: $input) {
      anestheticGas {
        ...AnestheticGasAndOxygen
      }
    }
  }
  ${AnestheticGasAndOxygenFragmentDoc}
`;
export type CreateAnestheticGasAndOxygenMutationFn = Apollo.MutationFunction<
  CreateAnestheticGasAndOxygenMutation,
  CreateAnestheticGasAndOxygenMutationVariables
>;

/**
 * __useCreateAnestheticGasAndOxygenMutation__
 *
 * To run a mutation, you first call `useCreateAnestheticGasAndOxygenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnestheticGasAndOxygenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnestheticGasAndOxygenMutation, { data, loading, error }] = useCreateAnestheticGasAndOxygenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnestheticGasAndOxygenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAnestheticGasAndOxygenMutation,
    CreateAnestheticGasAndOxygenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAnestheticGasAndOxygenMutation,
    CreateAnestheticGasAndOxygenMutationVariables
  >(CreateAnestheticGasAndOxygenDocument, options);
}
export type CreateAnestheticGasAndOxygenMutationHookResult = ReturnType<
  typeof useCreateAnestheticGasAndOxygenMutation
>;
export type CreateAnestheticGasAndOxygenMutationResult = Apollo.MutationResult<
  CreateAnestheticGasAndOxygenMutation
>;
export type CreateAnestheticGasAndOxygenMutationOptions = Apollo.BaseMutationOptions<
  CreateAnestheticGasAndOxygenMutation,
  CreateAnestheticGasAndOxygenMutationVariables
>;
export const UpdateAnestheticGasAndOxygenDocument = gql`
  mutation updateAnestheticGasAndOxygen($input: updateAnestheticGasInput!) {
    updateAnestheticGas(input: $input) {
      anestheticGas {
        ...AnestheticGasAndOxygen
      }
    }
  }
  ${AnestheticGasAndOxygenFragmentDoc}
`;
export type UpdateAnestheticGasAndOxygenMutationFn = Apollo.MutationFunction<
  UpdateAnestheticGasAndOxygenMutation,
  UpdateAnestheticGasAndOxygenMutationVariables
>;

/**
 * __useUpdateAnestheticGasAndOxygenMutation__
 *
 * To run a mutation, you first call `useUpdateAnestheticGasAndOxygenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnestheticGasAndOxygenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnestheticGasAndOxygenMutation, { data, loading, error }] = useUpdateAnestheticGasAndOxygenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnestheticGasAndOxygenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAnestheticGasAndOxygenMutation,
    UpdateAnestheticGasAndOxygenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAnestheticGasAndOxygenMutation,
    UpdateAnestheticGasAndOxygenMutationVariables
  >(UpdateAnestheticGasAndOxygenDocument, options);
}
export type UpdateAnestheticGasAndOxygenMutationHookResult = ReturnType<
  typeof useUpdateAnestheticGasAndOxygenMutation
>;
export type UpdateAnestheticGasAndOxygenMutationResult = Apollo.MutationResult<
  UpdateAnestheticGasAndOxygenMutation
>;
export type UpdateAnestheticGasAndOxygenMutationOptions = Apollo.BaseMutationOptions<
  UpdateAnestheticGasAndOxygenMutation,
  UpdateAnestheticGasAndOxygenMutationVariables
>;
export const CreateVitalDocument = gql`
  mutation createVital($input: createVitalInput!) {
    createVital(input: $input) {
      vital {
        ...Vital
      }
    }
  }
  ${VitalFragmentDoc}
`;
export type CreateVitalMutationFn = Apollo.MutationFunction<
  CreateVitalMutation,
  CreateVitalMutationVariables
>;

/**
 * __useCreateVitalMutation__
 *
 * To run a mutation, you first call `useCreateVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVitalMutation, { data, loading, error }] = useCreateVitalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVitalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVitalMutation,
    CreateVitalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateVitalMutation, CreateVitalMutationVariables>(
    CreateVitalDocument,
    options
  );
}
export type CreateVitalMutationHookResult = ReturnType<
  typeof useCreateVitalMutation
>;
export type CreateVitalMutationResult = Apollo.MutationResult<
  CreateVitalMutation
>;
export type CreateVitalMutationOptions = Apollo.BaseMutationOptions<
  CreateVitalMutation,
  CreateVitalMutationVariables
>;
export const UpdateVitalDocument = gql`
  mutation updateVital($input: updateVitalInput!) {
    updateVital(input: $input) {
      vital {
        ...Vital
      }
    }
  }
  ${VitalFragmentDoc}
`;
export type UpdateVitalMutationFn = Apollo.MutationFunction<
  UpdateVitalMutation,
  UpdateVitalMutationVariables
>;

/**
 * __useUpdateVitalMutation__
 *
 * To run a mutation, you first call `useUpdateVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVitalMutation, { data, loading, error }] = useUpdateVitalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVitalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVitalMutation,
    UpdateVitalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateVitalMutation, UpdateVitalMutationVariables>(
    UpdateVitalDocument,
    options
  );
}
export type UpdateVitalMutationHookResult = ReturnType<
  typeof useUpdateVitalMutation
>;
export type UpdateVitalMutationResult = Apollo.MutationResult<
  UpdateVitalMutation
>;
export type UpdateVitalMutationOptions = Apollo.BaseMutationOptions<
  UpdateVitalMutation,
  UpdateVitalMutationVariables
>;
export const CreatePostAnestheticVitalDocument = gql`
  mutation createPostAnestheticVital($input: createPostAnestheticVitalInput!) {
    createPostAnestheticVital(input: $input) {
      postAnestheticVital {
        ...PostAnestheticVital
      }
    }
  }
  ${PostAnestheticVitalFragmentDoc}
`;
export type CreatePostAnestheticVitalMutationFn = Apollo.MutationFunction<
  CreatePostAnestheticVitalMutation,
  CreatePostAnestheticVitalMutationVariables
>;

/**
 * __useCreatePostAnestheticVitalMutation__
 *
 * To run a mutation, you first call `useCreatePostAnestheticVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostAnestheticVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostAnestheticVitalMutation, { data, loading, error }] = useCreatePostAnestheticVitalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostAnestheticVitalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePostAnestheticVitalMutation,
    CreatePostAnestheticVitalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePostAnestheticVitalMutation,
    CreatePostAnestheticVitalMutationVariables
  >(CreatePostAnestheticVitalDocument, options);
}
export type CreatePostAnestheticVitalMutationHookResult = ReturnType<
  typeof useCreatePostAnestheticVitalMutation
>;
export type CreatePostAnestheticVitalMutationResult = Apollo.MutationResult<
  CreatePostAnestheticVitalMutation
>;
export type CreatePostAnestheticVitalMutationOptions = Apollo.BaseMutationOptions<
  CreatePostAnestheticVitalMutation,
  CreatePostAnestheticVitalMutationVariables
>;
export const UpdatePostAnestheticVitalDocument = gql`
  mutation updatePostAnestheticVital($input: updatePostAnestheticVitalInput!) {
    updatePostAnestheticVital(input: $input) {
      postAnestheticVital {
        ...PostAnestheticVital
      }
    }
  }
  ${PostAnestheticVitalFragmentDoc}
`;
export type UpdatePostAnestheticVitalMutationFn = Apollo.MutationFunction<
  UpdatePostAnestheticVitalMutation,
  UpdatePostAnestheticVitalMutationVariables
>;

/**
 * __useUpdatePostAnestheticVitalMutation__
 *
 * To run a mutation, you first call `useUpdatePostAnestheticVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostAnestheticVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostAnestheticVitalMutation, { data, loading, error }] = useUpdatePostAnestheticVitalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostAnestheticVitalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePostAnestheticVitalMutation,
    UpdatePostAnestheticVitalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePostAnestheticVitalMutation,
    UpdatePostAnestheticVitalMutationVariables
  >(UpdatePostAnestheticVitalDocument, options);
}
export type UpdatePostAnestheticVitalMutationHookResult = ReturnType<
  typeof useUpdatePostAnestheticVitalMutation
>;
export type UpdatePostAnestheticVitalMutationResult = Apollo.MutationResult<
  UpdatePostAnestheticVitalMutation
>;
export type UpdatePostAnestheticVitalMutationOptions = Apollo.BaseMutationOptions<
  UpdatePostAnestheticVitalMutation,
  UpdatePostAnestheticVitalMutationVariables
>;
export const CreatePatientProcedureDocument = gql`
  mutation createPatientProcedure($input: createPatientProcedureInput!) {
    createPatientProcedure(input: $input) {
      patientProcedure {
        ...PatientProcedure
      }
    }
  }
  ${PatientProcedureFragmentDoc}
`;
export type CreatePatientProcedureMutationFn = Apollo.MutationFunction<
  CreatePatientProcedureMutation,
  CreatePatientProcedureMutationVariables
>;

/**
 * __useCreatePatientProcedureMutation__
 *
 * To run a mutation, you first call `useCreatePatientProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientProcedureMutation, { data, loading, error }] = useCreatePatientProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientProcedureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePatientProcedureMutation,
    CreatePatientProcedureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePatientProcedureMutation,
    CreatePatientProcedureMutationVariables
  >(CreatePatientProcedureDocument, options);
}
export type CreatePatientProcedureMutationHookResult = ReturnType<
  typeof useCreatePatientProcedureMutation
>;
export type CreatePatientProcedureMutationResult = Apollo.MutationResult<
  CreatePatientProcedureMutation
>;
export type CreatePatientProcedureMutationOptions = Apollo.BaseMutationOptions<
  CreatePatientProcedureMutation,
  CreatePatientProcedureMutationVariables
>;
export const UpdatePatientProcedureDocument = gql`
  mutation updatePatientProcedure($input: updatePatientProcedureInput!) {
    updatePatientProcedure(input: $input) {
      patientProcedure {
        ...PatientProcedure
      }
    }
  }
  ${PatientProcedureFragmentDoc}
`;
export type UpdatePatientProcedureMutationFn = Apollo.MutationFunction<
  UpdatePatientProcedureMutation,
  UpdatePatientProcedureMutationVariables
>;

/**
 * __useUpdatePatientProcedureMutation__
 *
 * To run a mutation, you first call `useUpdatePatientProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientProcedureMutation, { data, loading, error }] = useUpdatePatientProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientProcedureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePatientProcedureMutation,
    UpdatePatientProcedureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePatientProcedureMutation,
    UpdatePatientProcedureMutationVariables
  >(UpdatePatientProcedureDocument, options);
}
export type UpdatePatientProcedureMutationHookResult = ReturnType<
  typeof useUpdatePatientProcedureMutation
>;
export type UpdatePatientProcedureMutationResult = Apollo.MutationResult<
  UpdatePatientProcedureMutation
>;
export type UpdatePatientProcedureMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientProcedureMutation,
  UpdatePatientProcedureMutationVariables
>;
export const UpdateMonitoringDocument = gql`
  mutation updateMonitoring($input: updateMonitoringInput!) {
    updateMonitoring(input: $input) {
      monitoring {
        _id
        monitoringBy {
          _id
        }
      }
    }
  }
`;
export type UpdateMonitoringMutationFn = Apollo.MutationFunction<
  UpdateMonitoringMutation,
  UpdateMonitoringMutationVariables
>;

/**
 * __useUpdateMonitoringMutation__
 *
 * To run a mutation, you first call `useUpdateMonitoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonitoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonitoringMutation, { data, loading, error }] = useUpdateMonitoringMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMonitoringMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMonitoringMutation,
    UpdateMonitoringMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMonitoringMutation,
    UpdateMonitoringMutationVariables
  >(UpdateMonitoringDocument, options);
}
export type UpdateMonitoringMutationHookResult = ReturnType<
  typeof useUpdateMonitoringMutation
>;
export type UpdateMonitoringMutationResult = Apollo.MutationResult<
  UpdateMonitoringMutation
>;
export type UpdateMonitoringMutationOptions = Apollo.BaseMutationOptions<
  UpdateMonitoringMutation,
  UpdateMonitoringMutationVariables
>;
export const UpdatePostAnestheticVitalCommentDocument = gql`
  mutation updatePostAnestheticVitalComment(
    $input: updatePostAnestheticVitalCommentInput!
  ) {
    updatePostAnestheticVitalComment(input: $input) {
      postAnestheticVitalComment {
        ...PostAnestheticVitalComment
      }
    }
  }
  ${PostAnestheticVitalCommentFragmentDoc}
`;
export type UpdatePostAnestheticVitalCommentMutationFn = Apollo.MutationFunction<
  UpdatePostAnestheticVitalCommentMutation,
  UpdatePostAnestheticVitalCommentMutationVariables
>;

/**
 * __useUpdatePostAnestheticVitalCommentMutation__
 *
 * To run a mutation, you first call `useUpdatePostAnestheticVitalCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostAnestheticVitalCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostAnestheticVitalCommentMutation, { data, loading, error }] = useUpdatePostAnestheticVitalCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostAnestheticVitalCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePostAnestheticVitalCommentMutation,
    UpdatePostAnestheticVitalCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePostAnestheticVitalCommentMutation,
    UpdatePostAnestheticVitalCommentMutationVariables
  >(UpdatePostAnestheticVitalCommentDocument, options);
}
export type UpdatePostAnestheticVitalCommentMutationHookResult = ReturnType<
  typeof useUpdatePostAnestheticVitalCommentMutation
>;
export type UpdatePostAnestheticVitalCommentMutationResult = Apollo.MutationResult<
  UpdatePostAnestheticVitalCommentMutation
>;
export type UpdatePostAnestheticVitalCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdatePostAnestheticVitalCommentMutation,
  UpdatePostAnestheticVitalCommentMutationVariables
>;
export const UpdateVitalCommentDocument = gql`
  mutation updateVitalComment($input: updateVitalCommentInput!) {
    updateVitalComment(input: $input) {
      vitalComment {
        _id
        comment
        qualityRecovery
        timeExtubation
      }
    }
  }
`;
export type UpdateVitalCommentMutationFn = Apollo.MutationFunction<
  UpdateVitalCommentMutation,
  UpdateVitalCommentMutationVariables
>;

/**
 * __useUpdateVitalCommentMutation__
 *
 * To run a mutation, you first call `useUpdateVitalCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVitalCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVitalCommentMutation, { data, loading, error }] = useUpdateVitalCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVitalCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVitalCommentMutation,
    UpdateVitalCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateVitalCommentMutation,
    UpdateVitalCommentMutationVariables
  >(UpdateVitalCommentDocument, options);
}
export type UpdateVitalCommentMutationHookResult = ReturnType<
  typeof useUpdateVitalCommentMutation
>;
export type UpdateVitalCommentMutationResult = Apollo.MutationResult<
  UpdateVitalCommentMutation
>;
export type UpdateVitalCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateVitalCommentMutation,
  UpdateVitalCommentMutationVariables
>;
export const SetLightMonitoringInformationDocument = gql`
  mutation setLightMonitoringInformation(
    $input: setLightMonitoringInformationInput!
  ) {
    setLightMonitoringInformation(input: $input) {
      lightMonitoringInformation {
        vital {
          ...Vital
        }
        anestheticGas {
          ...AnestheticGasAndOxygen
        }
      }
    }
  }
  ${VitalFragmentDoc}
  ${AnestheticGasAndOxygenFragmentDoc}
`;
export type SetLightMonitoringInformationMutationFn = Apollo.MutationFunction<
  SetLightMonitoringInformationMutation,
  SetLightMonitoringInformationMutationVariables
>;

/**
 * __useSetLightMonitoringInformationMutation__
 *
 * To run a mutation, you first call `useSetLightMonitoringInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLightMonitoringInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLightMonitoringInformationMutation, { data, loading, error }] = useSetLightMonitoringInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetLightMonitoringInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetLightMonitoringInformationMutation,
    SetLightMonitoringInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetLightMonitoringInformationMutation,
    SetLightMonitoringInformationMutationVariables
  >(SetLightMonitoringInformationDocument, options);
}
export type SetLightMonitoringInformationMutationHookResult = ReturnType<
  typeof useSetLightMonitoringInformationMutation
>;
export type SetLightMonitoringInformationMutationResult = Apollo.MutationResult<
  SetLightMonitoringInformationMutation
>;
export type SetLightMonitoringInformationMutationOptions = Apollo.BaseMutationOptions<
  SetLightMonitoringInformationMutation,
  SetLightMonitoringInformationMutationVariables
>;
export const SetFullMonitoringInformationDocument = gql`
  mutation setFullMonitoringInformation(
    $input: setFullMonitoringInformationInput!
  ) {
    setFullMonitoringInformation(input: $input) {
      fullMonitoringInformation {
        fluidTemperature {
          ...FluidAndTemperature
        }
        vital {
          ...Vital
        }
        anestheticGas {
          ...AnestheticGasAndOxygen
        }
      }
    }
  }
  ${FluidAndTemperatureFragmentDoc}
  ${VitalFragmentDoc}
  ${AnestheticGasAndOxygenFragmentDoc}
`;
export type SetFullMonitoringInformationMutationFn = Apollo.MutationFunction<
  SetFullMonitoringInformationMutation,
  SetFullMonitoringInformationMutationVariables
>;

/**
 * __useSetFullMonitoringInformationMutation__
 *
 * To run a mutation, you first call `useSetFullMonitoringInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFullMonitoringInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFullMonitoringInformationMutation, { data, loading, error }] = useSetFullMonitoringInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFullMonitoringInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetFullMonitoringInformationMutation,
    SetFullMonitoringInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetFullMonitoringInformationMutation,
    SetFullMonitoringInformationMutationVariables
  >(SetFullMonitoringInformationDocument, options);
}
export type SetFullMonitoringInformationMutationHookResult = ReturnType<
  typeof useSetFullMonitoringInformationMutation
>;
export type SetFullMonitoringInformationMutationResult = Apollo.MutationResult<
  SetFullMonitoringInformationMutation
>;
export type SetFullMonitoringInformationMutationOptions = Apollo.BaseMutationOptions<
  SetFullMonitoringInformationMutation,
  SetFullMonitoringInformationMutationVariables
>;
export const UpdateTabletDocument = gql`
  mutation updateTablet($input: updateTabletInput!) {
    updateTablet(input: $input) {
      tablet {
        ...Tablet
      }
    }
  }
  ${TabletFragmentDoc}
`;
export type UpdateTabletMutationFn = Apollo.MutationFunction<
  UpdateTabletMutation,
  UpdateTabletMutationVariables
>;

/**
 * __useUpdateTabletMutation__
 *
 * To run a mutation, you first call `useUpdateTabletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTabletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTabletMutation, { data, loading, error }] = useUpdateTabletMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTabletMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTabletMutation,
    UpdateTabletMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTabletMutation,
    UpdateTabletMutationVariables
  >(UpdateTabletDocument, options);
}
export type UpdateTabletMutationHookResult = ReturnType<
  typeof useUpdateTabletMutation
>;
export type UpdateTabletMutationResult = Apollo.MutationResult<
  UpdateTabletMutation
>;
export type UpdateTabletMutationOptions = Apollo.BaseMutationOptions<
  UpdateTabletMutation,
  UpdateTabletMutationVariables
>;
export const CreateTabletDocument = gql`
  mutation createTablet($input: createTabletInput!) {
    createTablet(input: $input) {
      tablet {
        ...Tablet
      }
    }
  }
  ${TabletFragmentDoc}
`;
export type CreateTabletMutationFn = Apollo.MutationFunction<
  CreateTabletMutation,
  CreateTabletMutationVariables
>;

/**
 * __useCreateTabletMutation__
 *
 * To run a mutation, you first call `useCreateTabletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTabletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTabletMutation, { data, loading, error }] = useCreateTabletMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTabletMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTabletMutation,
    CreateTabletMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTabletMutation,
    CreateTabletMutationVariables
  >(CreateTabletDocument, options);
}
export type CreateTabletMutationHookResult = ReturnType<
  typeof useCreateTabletMutation
>;
export type CreateTabletMutationResult = Apollo.MutationResult<
  CreateTabletMutation
>;
export type CreateTabletMutationOptions = Apollo.BaseMutationOptions<
  CreateTabletMutation,
  CreateTabletMutationVariables
>;
export const DeleteTabletsDocument = gql`
  mutation deleteTablets($input: removeBulkTabletInput!) {
    removeBulkTablet(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteTabletsMutationFn = Apollo.MutationFunction<
  DeleteTabletsMutation,
  DeleteTabletsMutationVariables
>;

/**
 * __useDeleteTabletsMutation__
 *
 * To run a mutation, you first call `useDeleteTabletsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTabletsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTabletsMutation, { data, loading, error }] = useDeleteTabletsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTabletsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTabletsMutation,
    DeleteTabletsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTabletsMutation,
    DeleteTabletsMutationVariables
  >(DeleteTabletsDocument, options);
}
export type DeleteTabletsMutationHookResult = ReturnType<
  typeof useDeleteTabletsMutation
>;
export type DeleteTabletsMutationResult = Apollo.MutationResult<
  DeleteTabletsMutation
>;
export type DeleteTabletsMutationOptions = Apollo.BaseMutationOptions<
  DeleteTabletsMutation,
  DeleteTabletsMutationVariables
>;
export const UpdateSuspensionDocument = gql`
  mutation updateSuspension($input: updateSuspensionInput!) {
    updateSuspension(input: $input) {
      suspension {
        ...Suspension
      }
    }
  }
  ${SuspensionFragmentDoc}
`;
export type UpdateSuspensionMutationFn = Apollo.MutationFunction<
  UpdateSuspensionMutation,
  UpdateSuspensionMutationVariables
>;

/**
 * __useUpdateSuspensionMutation__
 *
 * To run a mutation, you first call `useUpdateSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuspensionMutation, { data, loading, error }] = useUpdateSuspensionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSuspensionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSuspensionMutation,
    UpdateSuspensionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSuspensionMutation,
    UpdateSuspensionMutationVariables
  >(UpdateSuspensionDocument, options);
}
export type UpdateSuspensionMutationHookResult = ReturnType<
  typeof useUpdateSuspensionMutation
>;
export type UpdateSuspensionMutationResult = Apollo.MutationResult<
  UpdateSuspensionMutation
>;
export type UpdateSuspensionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSuspensionMutation,
  UpdateSuspensionMutationVariables
>;
export const CreateSuspensionDocument = gql`
  mutation createSuspension($input: createSuspensionInput!) {
    createSuspension(input: $input) {
      suspension {
        ...Suspension
      }
    }
  }
  ${SuspensionFragmentDoc}
`;
export type CreateSuspensionMutationFn = Apollo.MutationFunction<
  CreateSuspensionMutation,
  CreateSuspensionMutationVariables
>;

/**
 * __useCreateSuspensionMutation__
 *
 * To run a mutation, you first call `useCreateSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSuspensionMutation, { data, loading, error }] = useCreateSuspensionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSuspensionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSuspensionMutation,
    CreateSuspensionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSuspensionMutation,
    CreateSuspensionMutationVariables
  >(CreateSuspensionDocument, options);
}
export type CreateSuspensionMutationHookResult = ReturnType<
  typeof useCreateSuspensionMutation
>;
export type CreateSuspensionMutationResult = Apollo.MutationResult<
  CreateSuspensionMutation
>;
export type CreateSuspensionMutationOptions = Apollo.BaseMutationOptions<
  CreateSuspensionMutation,
  CreateSuspensionMutationVariables
>;
export const DeleteSuspensionsDocument = gql`
  mutation deleteSuspensions($input: removeBulkSuspensionInput!) {
    removeBulkSuspension(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteSuspensionsMutationFn = Apollo.MutationFunction<
  DeleteSuspensionsMutation,
  DeleteSuspensionsMutationVariables
>;

/**
 * __useDeleteSuspensionsMutation__
 *
 * To run a mutation, you first call `useDeleteSuspensionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSuspensionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSuspensionsMutation, { data, loading, error }] = useDeleteSuspensionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSuspensionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSuspensionsMutation,
    DeleteSuspensionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSuspensionsMutation,
    DeleteSuspensionsMutationVariables
  >(DeleteSuspensionsDocument, options);
}
export type DeleteSuspensionsMutationHookResult = ReturnType<
  typeof useDeleteSuspensionsMutation
>;
export type DeleteSuspensionsMutationResult = Apollo.MutationResult<
  DeleteSuspensionsMutation
>;
export type DeleteSuspensionsMutationOptions = Apollo.BaseMutationOptions<
  DeleteSuspensionsMutation,
  DeleteSuspensionsMutationVariables
>;
export const UpdateTploDocument = gql`
  mutation updateTplo(
    $input: updateTibialPlateauLevelingOsteotomyPlanningInput!
  ) {
    updateTibialPlateauLevelingOsteotomyPlanning(input: $input) {
      tibialPlateauLevelingOsteotomyPlanning {
        ...TPLO
      }
    }
  }
  ${TploFragmentDoc}
`;
export type UpdateTploMutationFn = Apollo.MutationFunction<
  UpdateTploMutation,
  UpdateTploMutationVariables
>;

/**
 * __useUpdateTploMutation__
 *
 * To run a mutation, you first call `useUpdateTploMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTploMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTploMutation, { data, loading, error }] = useUpdateTploMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTploMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTploMutation,
    UpdateTploMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTploMutation, UpdateTploMutationVariables>(
    UpdateTploDocument,
    options
  );
}
export type UpdateTploMutationHookResult = ReturnType<
  typeof useUpdateTploMutation
>;
export type UpdateTploMutationResult = Apollo.MutationResult<
  UpdateTploMutation
>;
export type UpdateTploMutationOptions = Apollo.BaseMutationOptions<
  UpdateTploMutation,
  UpdateTploMutationVariables
>;
export const MedicalCasesDocument = gql`
  query medicalCases(
    $page: Int
    $itemsPerPage: Int
    $filter: MedicalCaseFilter
    $order: [MedicalCaseFilter_order]
  ) {
    medicalCases(
      page: $page
      itemsPerPage: $itemsPerPage
      filter: $filter
      order: $order
    ) {
      collection {
        ...Case
      }
      paginationInfo {
        totalCount
      }
    }
  }
  ${CaseFragmentDoc}
`;

/**
 * __useMedicalCasesQuery__
 *
 * To run a query within a React component, call `useMedicalCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalCasesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicalCasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MedicalCasesQuery,
    MedicalCasesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MedicalCasesQuery, MedicalCasesQueryVariables>(
    MedicalCasesDocument,
    options
  );
}
export function useMedicalCasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MedicalCasesQuery,
    MedicalCasesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MedicalCasesQuery, MedicalCasesQueryVariables>(
    MedicalCasesDocument,
    options
  );
}
export type MedicalCasesQueryHookResult = ReturnType<
  typeof useMedicalCasesQuery
>;
export type MedicalCasesLazyQueryHookResult = ReturnType<
  typeof useMedicalCasesLazyQuery
>;
export type MedicalCasesQueryResult = Apollo.QueryResult<
  MedicalCasesQuery,
  MedicalCasesQueryVariables
>;
export const CreateMedicalCaseDocument = gql`
  mutation createMedicalCase($input: createMedicalCaseInput!) {
    createMedicalCase(input: $input) {
      medicalCase {
        ...Case
      }
    }
  }
  ${CaseFragmentDoc}
`;
export type CreateMedicalCaseMutationFn = Apollo.MutationFunction<
  CreateMedicalCaseMutation,
  CreateMedicalCaseMutationVariables
>;

/**
 * __useCreateMedicalCaseMutation__
 *
 * To run a mutation, you first call `useCreateMedicalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicalCaseMutation, { data, loading, error }] = useCreateMedicalCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMedicalCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMedicalCaseMutation,
    CreateMedicalCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMedicalCaseMutation,
    CreateMedicalCaseMutationVariables
  >(CreateMedicalCaseDocument, options);
}
export type CreateMedicalCaseMutationHookResult = ReturnType<
  typeof useCreateMedicalCaseMutation
>;
export type CreateMedicalCaseMutationResult = Apollo.MutationResult<
  CreateMedicalCaseMutation
>;
export type CreateMedicalCaseMutationOptions = Apollo.BaseMutationOptions<
  CreateMedicalCaseMutation,
  CreateMedicalCaseMutationVariables
>;
export const UpdateMedicalCaseDocument = gql`
  mutation updateMedicalCase($input: updateMedicalCaseInput!) {
    updateMedicalCase(input: $input) {
      medicalCase {
        ...Case
      }
    }
  }
  ${CaseFragmentDoc}
`;
export type UpdateMedicalCaseMutationFn = Apollo.MutationFunction<
  UpdateMedicalCaseMutation,
  UpdateMedicalCaseMutationVariables
>;

/**
 * __useUpdateMedicalCaseMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalCaseMutation, { data, loading, error }] = useUpdateMedicalCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMedicalCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMedicalCaseMutation,
    UpdateMedicalCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMedicalCaseMutation,
    UpdateMedicalCaseMutationVariables
  >(UpdateMedicalCaseDocument, options);
}
export type UpdateMedicalCaseMutationHookResult = ReturnType<
  typeof useUpdateMedicalCaseMutation
>;
export type UpdateMedicalCaseMutationResult = Apollo.MutationResult<
  UpdateMedicalCaseMutation
>;
export type UpdateMedicalCaseMutationOptions = Apollo.BaseMutationOptions<
  UpdateMedicalCaseMutation,
  UpdateMedicalCaseMutationVariables
>;
export const CopyMedicalCaseDocument = gql`
  mutation copyMedicalCase($input: copyMedicalCaseInput!) {
    copyMedicalCase(input: $input) {
      medicalCase {
        ...Case
      }
    }
  }
  ${CaseFragmentDoc}
`;
export type CopyMedicalCaseMutationFn = Apollo.MutationFunction<
  CopyMedicalCaseMutation,
  CopyMedicalCaseMutationVariables
>;

/**
 * __useCopyMedicalCaseMutation__
 *
 * To run a mutation, you first call `useCopyMedicalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMedicalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMedicalCaseMutation, { data, loading, error }] = useCopyMedicalCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyMedicalCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CopyMedicalCaseMutation,
    CopyMedicalCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CopyMedicalCaseMutation,
    CopyMedicalCaseMutationVariables
  >(CopyMedicalCaseDocument, options);
}
export type CopyMedicalCaseMutationHookResult = ReturnType<
  typeof useCopyMedicalCaseMutation
>;
export type CopyMedicalCaseMutationResult = Apollo.MutationResult<
  CopyMedicalCaseMutation
>;
export type CopyMedicalCaseMutationOptions = Apollo.BaseMutationOptions<
  CopyMedicalCaseMutation,
  CopyMedicalCaseMutationVariables
>;
export const DeleteMedicalCasesDocument = gql`
  mutation deleteMedicalCases($input: removeBulkMedicalCaseInput!) {
    removeBulkMedicalCase(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteMedicalCasesMutationFn = Apollo.MutationFunction<
  DeleteMedicalCasesMutation,
  DeleteMedicalCasesMutationVariables
>;

/**
 * __useDeleteMedicalCasesMutation__
 *
 * To run a mutation, you first call `useDeleteMedicalCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicalCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicalCasesMutation, { data, loading, error }] = useDeleteMedicalCasesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMedicalCasesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMedicalCasesMutation,
    DeleteMedicalCasesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMedicalCasesMutation,
    DeleteMedicalCasesMutationVariables
  >(DeleteMedicalCasesDocument, options);
}
export type DeleteMedicalCasesMutationHookResult = ReturnType<
  typeof useDeleteMedicalCasesMutation
>;
export type DeleteMedicalCasesMutationResult = Apollo.MutationResult<
  DeleteMedicalCasesMutation
>;
export type DeleteMedicalCasesMutationOptions = Apollo.BaseMutationOptions<
  DeleteMedicalCasesMutation,
  DeleteMedicalCasesMutationVariables
>;
export const UpdateMedicalCasesStatusDocument = gql`
  mutation updateMedicalCasesStatus($input: updateStatusBulkMedicalCaseInput!) {
    updateStatusBulkMedicalCase(input: $input) {
      clientMutationId
    }
  }
`;
export type UpdateMedicalCasesStatusMutationFn = Apollo.MutationFunction<
  UpdateMedicalCasesStatusMutation,
  UpdateMedicalCasesStatusMutationVariables
>;

/**
 * __useUpdateMedicalCasesStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalCasesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalCasesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicalCasesStatusMutation, { data, loading, error }] = useUpdateMedicalCasesStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMedicalCasesStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMedicalCasesStatusMutation,
    UpdateMedicalCasesStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMedicalCasesStatusMutation,
    UpdateMedicalCasesStatusMutationVariables
  >(UpdateMedicalCasesStatusDocument, options);
}
export type UpdateMedicalCasesStatusMutationHookResult = ReturnType<
  typeof useUpdateMedicalCasesStatusMutation
>;
export type UpdateMedicalCasesStatusMutationResult = Apollo.MutationResult<
  UpdateMedicalCasesStatusMutation
>;
export type UpdateMedicalCasesStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateMedicalCasesStatusMutation,
  UpdateMedicalCasesStatusMutationVariables
>;
export const ExportMedicalRecordDocument = gql`
  mutation exportMedicalRecord($input: createMedicalRecordExportInput!) {
    createMedicalRecordExport(input: $input) {
      clientMutationId
    }
  }
`;
export type ExportMedicalRecordMutationFn = Apollo.MutationFunction<
  ExportMedicalRecordMutation,
  ExportMedicalRecordMutationVariables
>;

/**
 * __useExportMedicalRecordMutation__
 *
 * To run a mutation, you first call `useExportMedicalRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMedicalRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMedicalRecordMutation, { data, loading, error }] = useExportMedicalRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportMedicalRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportMedicalRecordMutation,
    ExportMedicalRecordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportMedicalRecordMutation,
    ExportMedicalRecordMutationVariables
  >(ExportMedicalRecordDocument, options);
}
export type ExportMedicalRecordMutationHookResult = ReturnType<
  typeof useExportMedicalRecordMutation
>;
export type ExportMedicalRecordMutationResult = Apollo.MutationResult<
  ExportMedicalRecordMutation
>;
export type ExportMedicalRecordMutationOptions = Apollo.BaseMutationOptions<
  ExportMedicalRecordMutation,
  ExportMedicalRecordMutationVariables
>;
export const ExportClientReportDocument = gql`
  mutation exportClientReport($input: createClientReportExportInput!) {
    createClientReportExport(input: $input) {
      clientMutationId
    }
  }
`;
export type ExportClientReportMutationFn = Apollo.MutationFunction<
  ExportClientReportMutation,
  ExportClientReportMutationVariables
>;

/**
 * __useExportClientReportMutation__
 *
 * To run a mutation, you first call `useExportClientReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportClientReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportClientReportMutation, { data, loading, error }] = useExportClientReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportClientReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportClientReportMutation,
    ExportClientReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportClientReportMutation,
    ExportClientReportMutationVariables
  >(ExportClientReportDocument, options);
}
export type ExportClientReportMutationHookResult = ReturnType<
  typeof useExportClientReportMutation
>;
export type ExportClientReportMutationResult = Apollo.MutationResult<
  ExportClientReportMutation
>;
export type ExportClientReportMutationOptions = Apollo.BaseMutationOptions<
  ExportClientReportMutation,
  ExportClientReportMutationVariables
>;
export const ExportReferralRecordDocument = gql`
  mutation exportReferralRecord($input: createReferralDocumentExportInput!) {
    createReferralDocumentExport(input: $input) {
      clientMutationId
    }
  }
`;
export type ExportReferralRecordMutationFn = Apollo.MutationFunction<
  ExportReferralRecordMutation,
  ExportReferralRecordMutationVariables
>;

/**
 * __useExportReferralRecordMutation__
 *
 * To run a mutation, you first call `useExportReferralRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportReferralRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportReferralRecordMutation, { data, loading, error }] = useExportReferralRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportReferralRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportReferralRecordMutation,
    ExportReferralRecordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportReferralRecordMutation,
    ExportReferralRecordMutationVariables
  >(ExportReferralRecordDocument, options);
}
export type ExportReferralRecordMutationHookResult = ReturnType<
  typeof useExportReferralRecordMutation
>;
export type ExportReferralRecordMutationResult = Apollo.MutationResult<
  ExportReferralRecordMutation
>;
export type ExportReferralRecordMutationOptions = Apollo.BaseMutationOptions<
  ExportReferralRecordMutation,
  ExportReferralRecordMutationVariables
>;
export const PrintMedicalRecordDocument = gql`
  mutation printMedicalRecord($input: createMedicalRecordPrintInput!) {
    createMedicalRecordPrint(input: $input) {
      medicalRecordPrint {
        id
        file {
          _id
        }
      }
    }
  }
`;
export type PrintMedicalRecordMutationFn = Apollo.MutationFunction<
  PrintMedicalRecordMutation,
  PrintMedicalRecordMutationVariables
>;

/**
 * __usePrintMedicalRecordMutation__
 *
 * To run a mutation, you first call `usePrintMedicalRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintMedicalRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printMedicalRecordMutation, { data, loading, error }] = usePrintMedicalRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintMedicalRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PrintMedicalRecordMutation,
    PrintMedicalRecordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PrintMedicalRecordMutation,
    PrintMedicalRecordMutationVariables
  >(PrintMedicalRecordDocument, options);
}
export type PrintMedicalRecordMutationHookResult = ReturnType<
  typeof usePrintMedicalRecordMutation
>;
export type PrintMedicalRecordMutationResult = Apollo.MutationResult<
  PrintMedicalRecordMutation
>;
export type PrintMedicalRecordMutationOptions = Apollo.BaseMutationOptions<
  PrintMedicalRecordMutation,
  PrintMedicalRecordMutationVariables
>;
export const PrintClientReportDocument = gql`
  mutation printClientReport($input: createClientReportPrintInput!) {
    createClientReportPrint(input: $input) {
      clientReportPrint {
        id
        file {
          _id
        }
      }
    }
  }
`;
export type PrintClientReportMutationFn = Apollo.MutationFunction<
  PrintClientReportMutation,
  PrintClientReportMutationVariables
>;

/**
 * __usePrintClientReportMutation__
 *
 * To run a mutation, you first call `usePrintClientReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintClientReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printClientReportMutation, { data, loading, error }] = usePrintClientReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintClientReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PrintClientReportMutation,
    PrintClientReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PrintClientReportMutation,
    PrintClientReportMutationVariables
  >(PrintClientReportDocument, options);
}
export type PrintClientReportMutationHookResult = ReturnType<
  typeof usePrintClientReportMutation
>;
export type PrintClientReportMutationResult = Apollo.MutationResult<
  PrintClientReportMutation
>;
export type PrintClientReportMutationOptions = Apollo.BaseMutationOptions<
  PrintClientReportMutation,
  PrintClientReportMutationVariables
>;
export const PrintReferralRecordDocument = gql`
  mutation printReferralRecord($input: createReferralDocumentPrintInput!) {
    createReferralDocumentPrint(input: $input) {
      referralDocumentPrint {
        id
        file {
          _id
        }
      }
    }
  }
`;
export type PrintReferralRecordMutationFn = Apollo.MutationFunction<
  PrintReferralRecordMutation,
  PrintReferralRecordMutationVariables
>;

/**
 * __usePrintReferralRecordMutation__
 *
 * To run a mutation, you first call `usePrintReferralRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintReferralRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printReferralRecordMutation, { data, loading, error }] = usePrintReferralRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintReferralRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PrintReferralRecordMutation,
    PrintReferralRecordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PrintReferralRecordMutation,
    PrintReferralRecordMutationVariables
  >(PrintReferralRecordDocument, options);
}
export type PrintReferralRecordMutationHookResult = ReturnType<
  typeof usePrintReferralRecordMutation
>;
export type PrintReferralRecordMutationResult = Apollo.MutationResult<
  PrintReferralRecordMutation
>;
export type PrintReferralRecordMutationOptions = Apollo.BaseMutationOptions<
  PrintReferralRecordMutation,
  PrintReferralRecordMutationVariables
>;
export const GetVetspireClientsDocument = gql`
  query getVetspireClients($page: Int, $perPage: Int, $name: String) {
    queryVetspireClients(itemsPerPage: $perPage, page: $page, fullName: $name) {
      collection {
        _id
        firstName
        lastName
      }
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetVetspireClientsQuery__
 *
 * To run a query within a React component, call `useGetVetspireClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetspireClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetspireClientsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetVetspireClientsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetVetspireClientsQuery,
    GetVetspireClientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVetspireClientsQuery,
    GetVetspireClientsQueryVariables
  >(GetVetspireClientsDocument, options);
}
export function useGetVetspireClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVetspireClientsQuery,
    GetVetspireClientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVetspireClientsQuery,
    GetVetspireClientsQueryVariables
  >(GetVetspireClientsDocument, options);
}
export type GetVetspireClientsQueryHookResult = ReturnType<
  typeof useGetVetspireClientsQuery
>;
export type GetVetspireClientsLazyQueryHookResult = ReturnType<
  typeof useGetVetspireClientsLazyQuery
>;
export type GetVetspireClientsQueryResult = Apollo.QueryResult<
  GetVetspireClientsQuery,
  GetVetspireClientsQueryVariables
>;
export const GetVetspirePatientsDocument = gql`
  query getVetspirePatients($clientId: String!) {
    queryVetspirePatients(vetspireClientId: $clientId) {
      collection {
        _id
        name
      }
    }
  }
`;

/**
 * __useGetVetspirePatientsQuery__
 *
 * To run a query within a React component, call `useGetVetspirePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVetspirePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVetspirePatientsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetVetspirePatientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVetspirePatientsQuery,
    GetVetspirePatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVetspirePatientsQuery,
    GetVetspirePatientsQueryVariables
  >(GetVetspirePatientsDocument, options);
}
export function useGetVetspirePatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVetspirePatientsQuery,
    GetVetspirePatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVetspirePatientsQuery,
    GetVetspirePatientsQueryVariables
  >(GetVetspirePatientsDocument, options);
}
export type GetVetspirePatientsQueryHookResult = ReturnType<
  typeof useGetVetspirePatientsQuery
>;
export type GetVetspirePatientsLazyQueryHookResult = ReturnType<
  typeof useGetVetspirePatientsLazyQuery
>;
export type GetVetspirePatientsQueryResult = Apollo.QueryResult<
  GetVetspirePatientsQuery,
  GetVetspirePatientsQueryVariables
>;
export const ImportVetspireMedicalCaseDocument = gql`
  mutation importVetspireMedicalCase($input: importVetspireMedicalCaseInput!) {
    importVetspireMedicalCase(input: $input) {
      vetspireMedicalCase {
        medicalCase {
          ...Case
        }
      }
    }
  }
  ${CaseFragmentDoc}
`;
export type ImportVetspireMedicalCaseMutationFn = Apollo.MutationFunction<
  ImportVetspireMedicalCaseMutation,
  ImportVetspireMedicalCaseMutationVariables
>;

/**
 * __useImportVetspireMedicalCaseMutation__
 *
 * To run a mutation, you first call `useImportVetspireMedicalCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportVetspireMedicalCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importVetspireMedicalCaseMutation, { data, loading, error }] = useImportVetspireMedicalCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportVetspireMedicalCaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportVetspireMedicalCaseMutation,
    ImportVetspireMedicalCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImportVetspireMedicalCaseMutation,
    ImportVetspireMedicalCaseMutationVariables
  >(ImportVetspireMedicalCaseDocument, options);
}
export type ImportVetspireMedicalCaseMutationHookResult = ReturnType<
  typeof useImportVetspireMedicalCaseMutation
>;
export type ImportVetspireMedicalCaseMutationResult = Apollo.MutationResult<
  ImportVetspireMedicalCaseMutation
>;
export type ImportVetspireMedicalCaseMutationOptions = Apollo.BaseMutationOptions<
  ImportVetspireMedicalCaseMutation,
  ImportVetspireMedicalCaseMutationVariables
>;
export const ExportMedicalCaseToVetspireDocument = gql`
  mutation exportMedicalCaseToVetspire(
    $input: exportPdfToVetspireMedicalCaseInput!
  ) {
    exportPdfToVetspireMedicalCase(input: $input) {
      clientMutationId
    }
  }
`;
export type ExportMedicalCaseToVetspireMutationFn = Apollo.MutationFunction<
  ExportMedicalCaseToVetspireMutation,
  ExportMedicalCaseToVetspireMutationVariables
>;

/**
 * __useExportMedicalCaseToVetspireMutation__
 *
 * To run a mutation, you first call `useExportMedicalCaseToVetspireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMedicalCaseToVetspireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMedicalCaseToVetspireMutation, { data, loading, error }] = useExportMedicalCaseToVetspireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportMedicalCaseToVetspireMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportMedicalCaseToVetspireMutation,
    ExportMedicalCaseToVetspireMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportMedicalCaseToVetspireMutation,
    ExportMedicalCaseToVetspireMutationVariables
  >(ExportMedicalCaseToVetspireDocument, options);
}
export type ExportMedicalCaseToVetspireMutationHookResult = ReturnType<
  typeof useExportMedicalCaseToVetspireMutation
>;
export type ExportMedicalCaseToVetspireMutationResult = Apollo.MutationResult<
  ExportMedicalCaseToVetspireMutation
>;
export type ExportMedicalCaseToVetspireMutationOptions = Apollo.BaseMutationOptions<
  ExportMedicalCaseToVetspireMutation,
  ExportMedicalCaseToVetspireMutationVariables
>;
export const CreateFileDocument = gql`
  mutation createFile($input: createFileInput!) {
    createFile(input: $input) {
      file {
        _id
        id
        name
        mimeType
        path
        size
      }
    }
  }
`;
export type CreateFileMutationFn = Apollo.MutationFunction<
  CreateFileMutation,
  CreateFileMutationVariables
>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFileMutation,
    CreateFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(
    CreateFileDocument,
    options
  );
}
export type CreateFileMutationHookResult = ReturnType<
  typeof useCreateFileMutation
>;
export type CreateFileMutationResult = Apollo.MutationResult<
  CreateFileMutation
>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<
  CreateFileMutation,
  CreateFileMutationVariables
>;
export const GetAllProceduresDocument = gql`
  query getAllProcedures {
    procedures(itemsPerPage: 1000) {
      collection {
        _id
        name
      }
    }
  }
`;

/**
 * __useGetAllProceduresQuery__
 *
 * To run a query within a React component, call `useGetAllProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProceduresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProceduresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllProceduresQuery,
    GetAllProceduresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllProceduresQuery, GetAllProceduresQueryVariables>(
    GetAllProceduresDocument,
    options
  );
}
export function useGetAllProceduresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllProceduresQuery,
    GetAllProceduresQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllProceduresQuery,
    GetAllProceduresQueryVariables
  >(GetAllProceduresDocument, options);
}
export type GetAllProceduresQueryHookResult = ReturnType<
  typeof useGetAllProceduresQuery
>;
export type GetAllProceduresLazyQueryHookResult = ReturnType<
  typeof useGetAllProceduresLazyQuery
>;
export type GetAllProceduresQueryResult = Apollo.QueryResult<
  GetAllProceduresQuery,
  GetAllProceduresQueryVariables
>;
export const GetAllUsersDocument = gql`
  query getAllUsers {
    users(itemsPerPage: 1000) {
      collection {
        _id
        firstName
        lastName
        userRole
      }
    }
  }
`;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllUsersQuery,
    GetAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
    GetAllUsersDocument,
    options
  );
}
export function useGetAllUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllUsersQuery,
    GetAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(
    GetAllUsersDocument,
    options
  );
}
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<
  typeof useGetAllUsersLazyQuery
>;
export type GetAllUsersQueryResult = Apollo.QueryResult<
  GetAllUsersQuery,
  GetAllUsersQueryVariables
>;
export const GetAllBreedsDocument = gql`
  query getAllBreeds {
    breeds(itemsPerPage: 1000) {
      collection {
        _id
        name
        species
      }
    }
  }
`;

/**
 * __useGetAllBreedsQuery__
 *
 * To run a query within a React component, call `useGetAllBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBreedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBreedsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllBreedsQuery,
    GetAllBreedsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllBreedsQuery, GetAllBreedsQueryVariables>(
    GetAllBreedsDocument,
    options
  );
}
export function useGetAllBreedsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllBreedsQuery,
    GetAllBreedsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllBreedsQuery, GetAllBreedsQueryVariables>(
    GetAllBreedsDocument,
    options
  );
}
export type GetAllBreedsQueryHookResult = ReturnType<
  typeof useGetAllBreedsQuery
>;
export type GetAllBreedsLazyQueryHookResult = ReturnType<
  typeof useGetAllBreedsLazyQuery
>;
export type GetAllBreedsQueryResult = Apollo.QueryResult<
  GetAllBreedsQuery,
  GetAllBreedsQueryVariables
>;
export const GetAllMedicationsDocument = gql`
  query getAllMedications {
    medications(itemsPerPage: 1000) {
      collection {
        _id
        name
        concentration
      }
    }
  }
`;

/**
 * __useGetAllMedicationsQuery__
 *
 * To run a query within a React component, call `useGetAllMedicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMedicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMedicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMedicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllMedicationsQuery,
    GetAllMedicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllMedicationsQuery,
    GetAllMedicationsQueryVariables
  >(GetAllMedicationsDocument, options);
}
export function useGetAllMedicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllMedicationsQuery,
    GetAllMedicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllMedicationsQuery,
    GetAllMedicationsQueryVariables
  >(GetAllMedicationsDocument, options);
}
export type GetAllMedicationsQueryHookResult = ReturnType<
  typeof useGetAllMedicationsQuery
>;
export type GetAllMedicationsLazyQueryHookResult = ReturnType<
  typeof useGetAllMedicationsLazyQuery
>;
export type GetAllMedicationsQueryResult = Apollo.QueryResult<
  GetAllMedicationsQuery,
  GetAllMedicationsQueryVariables
>;
export const GetAllProtocolsDocument = gql`
  query getAllProtocols {
    anestheticProtocols(itemsPerPage: 1000) {
      collection {
        ...AnestheticProtocol
      }
    }
  }
  ${AnestheticProtocolFragmentDoc}
`;

/**
 * __useGetAllProtocolsQuery__
 *
 * To run a query within a React component, call `useGetAllProtocolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProtocolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProtocolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProtocolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllProtocolsQuery,
    GetAllProtocolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllProtocolsQuery, GetAllProtocolsQueryVariables>(
    GetAllProtocolsDocument,
    options
  );
}
export function useGetAllProtocolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllProtocolsQuery,
    GetAllProtocolsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllProtocolsQuery,
    GetAllProtocolsQueryVariables
  >(GetAllProtocolsDocument, options);
}
export type GetAllProtocolsQueryHookResult = ReturnType<
  typeof useGetAllProtocolsQuery
>;
export type GetAllProtocolsLazyQueryHookResult = ReturnType<
  typeof useGetAllProtocolsLazyQuery
>;
export type GetAllProtocolsQueryResult = Apollo.QueryResult<
  GetAllProtocolsQuery,
  GetAllProtocolsQueryVariables
>;
export const GetAllDisclaimersDocument = gql`
  query getAllDisclaimers($organizationId: Int!) {
    organization(_id: $organizationId) {
      _id
      organizationSetting {
        _id
        disclaimerProcedureSettings {
          collection {
            ...DisclaimerProcedureSetting
          }
        }
        authorizationSettings {
          collection {
            ...AuthorizationSetting
          }
        }
        disclaimerText
      }
    }
  }
  ${DisclaimerProcedureSettingFragmentDoc}
  ${AuthorizationSettingFragmentDoc}
`;

/**
 * __useGetAllDisclaimersQuery__
 *
 * To run a query within a React component, call `useGetAllDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDisclaimersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAllDisclaimersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllDisclaimersQuery,
    GetAllDisclaimersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllDisclaimersQuery,
    GetAllDisclaimersQueryVariables
  >(GetAllDisclaimersDocument, options);
}
export function useGetAllDisclaimersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllDisclaimersQuery,
    GetAllDisclaimersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllDisclaimersQuery,
    GetAllDisclaimersQueryVariables
  >(GetAllDisclaimersDocument, options);
}
export type GetAllDisclaimersQueryHookResult = ReturnType<
  typeof useGetAllDisclaimersQuery
>;
export type GetAllDisclaimersLazyQueryHookResult = ReturnType<
  typeof useGetAllDisclaimersLazyQuery
>;
export type GetAllDisclaimersQueryResult = Apollo.QueryResult<
  GetAllDisclaimersQuery,
  GetAllDisclaimersQueryVariables
>;
export const OrganizationDocument = gql`
  query organization($_id: Int!) {
    organization(_id: $_id) {
      ...Organization
      users {
        collection {
          id
          _id
          firstName
          lastName
          email
          userRole
        }
      }
    }
  }
  ${OrganizationFragmentDoc}
`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationQuery,
    OrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(
    OrganizationDocument,
    options
  );
}
export function useOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationQuery,
    OrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(
    OrganizationDocument,
    options
  );
}
export type OrganizationQueryHookResult = ReturnType<
  typeof useOrganizationQuery
>;
export type OrganizationLazyQueryHookResult = ReturnType<
  typeof useOrganizationLazyQuery
>;
export type OrganizationQueryResult = Apollo.QueryResult<
  OrganizationQuery,
  OrganizationQueryVariables
>;
export const UpdateOrganizationDocument = gql`
  mutation updateOrganization($input: updateOrganizationInput!) {
    updateOrganization(input: $input) {
      organization {
        ...Organization
      }
    }
  }
  ${OrganizationFragmentDoc}
`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationMutation,
    UpdateOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationMutation,
    UpdateOrganizationMutationVariables
  >(UpdateOrganizationDocument, options);
}
export type UpdateOrganizationMutationHookResult = ReturnType<
  typeof useUpdateOrganizationMutation
>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<
  UpdateOrganizationMutation
>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>;
export const GetOrganizationAdminDocument = gql`
  query getOrganizationAdmin {
    users(filter: { equal: { userRole: ROLE_ORGANIZATION_ADMIN } }) {
      collection {
        id
        _id
        firstName
        lastName
        email
        image {
          _id
          id
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationAdminQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationAdminQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationAdminQuery,
    GetOrganizationAdminQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationAdminQuery,
    GetOrganizationAdminQueryVariables
  >(GetOrganizationAdminDocument, options);
}
export function useGetOrganizationAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationAdminQuery,
    GetOrganizationAdminQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationAdminQuery,
    GetOrganizationAdminQueryVariables
  >(GetOrganizationAdminDocument, options);
}
export type GetOrganizationAdminQueryHookResult = ReturnType<
  typeof useGetOrganizationAdminQuery
>;
export type GetOrganizationAdminLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationAdminLazyQuery
>;
export type GetOrganizationAdminQueryResult = Apollo.QueryResult<
  GetOrganizationAdminQuery,
  GetOrganizationAdminQueryVariables
>;
export const UpdateOrganizationAdminDocument = gql`
  mutation updateOrganizationAdmin($input: updateUserInput!) {
    updateUser(input: $input) {
      user {
        _id
        firstName
        lastName
        email
        image {
          _id
          path
        }
      }
    }
  }
`;
export type UpdateOrganizationAdminMutationFn = Apollo.MutationFunction<
  UpdateOrganizationAdminMutation,
  UpdateOrganizationAdminMutationVariables
>;

/**
 * __useUpdateOrganizationAdminMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAdminMutation, { data, loading, error }] = useUpdateOrganizationAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationAdminMutation,
    UpdateOrganizationAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationAdminMutation,
    UpdateOrganizationAdminMutationVariables
  >(UpdateOrganizationAdminDocument, options);
}
export type UpdateOrganizationAdminMutationHookResult = ReturnType<
  typeof useUpdateOrganizationAdminMutation
>;
export type UpdateOrganizationAdminMutationResult = Apollo.MutationResult<
  UpdateOrganizationAdminMutation
>;
export type UpdateOrganizationAdminMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationAdminMutation,
  UpdateOrganizationAdminMutationVariables
>;
export const GetUsersDocument = gql`
  query getUsers($itemsPerPage: Int, $page: Int) {
    users(itemsPerPage: $itemsPerPage, page: $page) {
      collection {
        id
        _id
        active
        email
        firstName
        lastName
        userRole
        username
      }
      paginationInfo {
        itemsPerPage
        lastPage
        totalCount
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetUserDocument = gql`
  query getUser($id: Int!) {
    user(_id: $id) {
      id
      _id
      active
      email
      firstName
      lastName
      userRole
      username
      image {
        _id
      }
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($input: createUserInput!) {
    createUser(input: $input) {
      user {
        id
        _id
        username
      }
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserMutation,
    CreateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>;
export type CreateUserMutationResult = Apollo.MutationResult<
  CreateUserMutation
>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($input: updateUserInput!) {
    updateUser(input: $input) {
      user {
        _id
        firstName
        lastName
        email
        image {
          _id
          path
        }
      }
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult = Apollo.MutationResult<
  UpdateUserMutation
>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($input: deleteUserInput!) {
    deleteUser(input: $input) {
      clientMutationId
    }
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult = Apollo.MutationResult<
  DeleteUserMutation
>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const GetAllowedUsersCountDocument = gql`
  query getAllowedUsersCount($id: Int!) {
    user(_id: $id) {
      organization {
        order {
          license {
            maxNumberOfUsers
          }
        }
      }
    }
    users {
      paginationInfo {
        totalCount
      }
    }
  }
`;

/**
 * __useGetAllowedUsersCountQuery__
 *
 * To run a query within a React component, call `useGetAllowedUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedUsersCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllowedUsersCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllowedUsersCountQuery,
    GetAllowedUsersCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllowedUsersCountQuery,
    GetAllowedUsersCountQueryVariables
  >(GetAllowedUsersCountDocument, options);
}
export function useGetAllowedUsersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllowedUsersCountQuery,
    GetAllowedUsersCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllowedUsersCountQuery,
    GetAllowedUsersCountQueryVariables
  >(GetAllowedUsersCountDocument, options);
}
export type GetAllowedUsersCountQueryHookResult = ReturnType<
  typeof useGetAllowedUsersCountQuery
>;
export type GetAllowedUsersCountLazyQueryHookResult = ReturnType<
  typeof useGetAllowedUsersCountLazyQuery
>;
export type GetAllowedUsersCountQueryResult = Apollo.QueryResult<
  GetAllowedUsersCountQuery,
  GetAllowedUsersCountQueryVariables
>;
export const GetOrganizationSettingsDocument = gql`
  query getOrganizationSettings($_id: Int!) {
    organization(_id: $_id) {
      _id
      organizationSetting {
        _id
        authorizationSettings {
          collection {
            ...AuthorizationSetting
          }
        }
        disclaimerProcedureSettings {
          collection {
            ...DisclaimerProcedureSetting
          }
        }
        disclaimerText
        dateFormat
        temperatureUnit
      }
    }
  }
  ${AuthorizationSettingFragmentDoc}
  ${DisclaimerProcedureSettingFragmentDoc}
`;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >(GetOrganizationSettingsDocument, options);
}
export function useGetOrganizationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >(GetOrganizationSettingsDocument, options);
}
export type GetOrganizationSettingsQueryHookResult = ReturnType<
  typeof useGetOrganizationSettingsQuery
>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationSettingsLazyQuery
>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<
  GetOrganizationSettingsQuery,
  GetOrganizationSettingsQueryVariables
>;
export const UpdateAuthorizationSettingDocument = gql`
  mutation updateAuthorizationSetting(
    $input: updateAuthorizationSettingInput!
  ) {
    updateAuthorizationSetting(input: $input) {
      authorizationSetting {
        ...AuthorizationSetting
      }
    }
  }
  ${AuthorizationSettingFragmentDoc}
`;
export type UpdateAuthorizationSettingMutationFn = Apollo.MutationFunction<
  UpdateAuthorizationSettingMutation,
  UpdateAuthorizationSettingMutationVariables
>;

/**
 * __useUpdateAuthorizationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizationSettingMutation, { data, loading, error }] = useUpdateAuthorizationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorizationSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAuthorizationSettingMutation,
    UpdateAuthorizationSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAuthorizationSettingMutation,
    UpdateAuthorizationSettingMutationVariables
  >(UpdateAuthorizationSettingDocument, options);
}
export type UpdateAuthorizationSettingMutationHookResult = ReturnType<
  typeof useUpdateAuthorizationSettingMutation
>;
export type UpdateAuthorizationSettingMutationResult = Apollo.MutationResult<
  UpdateAuthorizationSettingMutation
>;
export type UpdateAuthorizationSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateAuthorizationSettingMutation,
  UpdateAuthorizationSettingMutationVariables
>;
export const UpdateDisclaimerProcedureSettingDocument = gql`
  mutation updateDisclaimerProcedureSetting(
    $input: updateDisclaimerProcedureSettingInput!
  ) {
    updateDisclaimerProcedureSetting(input: $input) {
      disclaimerProcedureSetting {
        ...DisclaimerProcedureSetting
      }
    }
  }
  ${DisclaimerProcedureSettingFragmentDoc}
`;
export type UpdateDisclaimerProcedureSettingMutationFn = Apollo.MutationFunction<
  UpdateDisclaimerProcedureSettingMutation,
  UpdateDisclaimerProcedureSettingMutationVariables
>;

/**
 * __useUpdateDisclaimerProcedureSettingMutation__
 *
 * To run a mutation, you first call `useUpdateDisclaimerProcedureSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisclaimerProcedureSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisclaimerProcedureSettingMutation, { data, loading, error }] = useUpdateDisclaimerProcedureSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisclaimerProcedureSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDisclaimerProcedureSettingMutation,
    UpdateDisclaimerProcedureSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDisclaimerProcedureSettingMutation,
    UpdateDisclaimerProcedureSettingMutationVariables
  >(UpdateDisclaimerProcedureSettingDocument, options);
}
export type UpdateDisclaimerProcedureSettingMutationHookResult = ReturnType<
  typeof useUpdateDisclaimerProcedureSettingMutation
>;
export type UpdateDisclaimerProcedureSettingMutationResult = Apollo.MutationResult<
  UpdateDisclaimerProcedureSettingMutation
>;
export type UpdateDisclaimerProcedureSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateDisclaimerProcedureSettingMutation,
  UpdateDisclaimerProcedureSettingMutationVariables
>;
export const RemoveAuthorizationSettingsDocument = gql`
  mutation removeAuthorizationSettings(
    $input: removeBulkAuthorizationSettingInput!
  ) {
    removeBulkAuthorizationSetting(input: $input) {
      clientMutationId
    }
  }
`;
export type RemoveAuthorizationSettingsMutationFn = Apollo.MutationFunction<
  RemoveAuthorizationSettingsMutation,
  RemoveAuthorizationSettingsMutationVariables
>;

/**
 * __useRemoveAuthorizationSettingsMutation__
 *
 * To run a mutation, you first call `useRemoveAuthorizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAuthorizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAuthorizationSettingsMutation, { data, loading, error }] = useRemoveAuthorizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAuthorizationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAuthorizationSettingsMutation,
    RemoveAuthorizationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveAuthorizationSettingsMutation,
    RemoveAuthorizationSettingsMutationVariables
  >(RemoveAuthorizationSettingsDocument, options);
}
export type RemoveAuthorizationSettingsMutationHookResult = ReturnType<
  typeof useRemoveAuthorizationSettingsMutation
>;
export type RemoveAuthorizationSettingsMutationResult = Apollo.MutationResult<
  RemoveAuthorizationSettingsMutation
>;
export type RemoveAuthorizationSettingsMutationOptions = Apollo.BaseMutationOptions<
  RemoveAuthorizationSettingsMutation,
  RemoveAuthorizationSettingsMutationVariables
>;
export const RemoveDisclaimerProcedureSettingsDocument = gql`
  mutation removeDisclaimerProcedureSettings(
    $input: removeBulkDisclaimerProcedureSettingInput!
  ) {
    removeBulkDisclaimerProcedureSetting(input: $input) {
      clientMutationId
    }
  }
`;
export type RemoveDisclaimerProcedureSettingsMutationFn = Apollo.MutationFunction<
  RemoveDisclaimerProcedureSettingsMutation,
  RemoveDisclaimerProcedureSettingsMutationVariables
>;

/**
 * __useRemoveDisclaimerProcedureSettingsMutation__
 *
 * To run a mutation, you first call `useRemoveDisclaimerProcedureSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDisclaimerProcedureSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDisclaimerProcedureSettingsMutation, { data, loading, error }] = useRemoveDisclaimerProcedureSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDisclaimerProcedureSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDisclaimerProcedureSettingsMutation,
    RemoveDisclaimerProcedureSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveDisclaimerProcedureSettingsMutation,
    RemoveDisclaimerProcedureSettingsMutationVariables
  >(RemoveDisclaimerProcedureSettingsDocument, options);
}
export type RemoveDisclaimerProcedureSettingsMutationHookResult = ReturnType<
  typeof useRemoveDisclaimerProcedureSettingsMutation
>;
export type RemoveDisclaimerProcedureSettingsMutationResult = Apollo.MutationResult<
  RemoveDisclaimerProcedureSettingsMutation
>;
export type RemoveDisclaimerProcedureSettingsMutationOptions = Apollo.BaseMutationOptions<
  RemoveDisclaimerProcedureSettingsMutation,
  RemoveDisclaimerProcedureSettingsMutationVariables
>;
export const CreateAuthorizationSettingDocument = gql`
  mutation createAuthorizationSetting(
    $input: createAuthorizationSettingInput!
  ) {
    createAuthorizationSetting(input: $input) {
      authorizationSetting {
        ...AuthorizationSetting
      }
    }
  }
  ${AuthorizationSettingFragmentDoc}
`;
export type CreateAuthorizationSettingMutationFn = Apollo.MutationFunction<
  CreateAuthorizationSettingMutation,
  CreateAuthorizationSettingMutationVariables
>;

/**
 * __useCreateAuthorizationSettingMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizationSettingMutation, { data, loading, error }] = useCreateAuthorizationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorizationSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAuthorizationSettingMutation,
    CreateAuthorizationSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAuthorizationSettingMutation,
    CreateAuthorizationSettingMutationVariables
  >(CreateAuthorizationSettingDocument, options);
}
export type CreateAuthorizationSettingMutationHookResult = ReturnType<
  typeof useCreateAuthorizationSettingMutation
>;
export type CreateAuthorizationSettingMutationResult = Apollo.MutationResult<
  CreateAuthorizationSettingMutation
>;
export type CreateAuthorizationSettingMutationOptions = Apollo.BaseMutationOptions<
  CreateAuthorizationSettingMutation,
  CreateAuthorizationSettingMutationVariables
>;
export const CreateDisclaimerProcedureSettingDocument = gql`
  mutation createDisclaimerProcedureSetting(
    $input: createDisclaimerProcedureSettingInput!
  ) {
    createDisclaimerProcedureSetting(input: $input) {
      disclaimerProcedureSetting {
        ...DisclaimerProcedureSetting
      }
    }
  }
  ${DisclaimerProcedureSettingFragmentDoc}
`;
export type CreateDisclaimerProcedureSettingMutationFn = Apollo.MutationFunction<
  CreateDisclaimerProcedureSettingMutation,
  CreateDisclaimerProcedureSettingMutationVariables
>;

/**
 * __useCreateDisclaimerProcedureSettingMutation__
 *
 * To run a mutation, you first call `useCreateDisclaimerProcedureSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDisclaimerProcedureSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDisclaimerProcedureSettingMutation, { data, loading, error }] = useCreateDisclaimerProcedureSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDisclaimerProcedureSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDisclaimerProcedureSettingMutation,
    CreateDisclaimerProcedureSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDisclaimerProcedureSettingMutation,
    CreateDisclaimerProcedureSettingMutationVariables
  >(CreateDisclaimerProcedureSettingDocument, options);
}
export type CreateDisclaimerProcedureSettingMutationHookResult = ReturnType<
  typeof useCreateDisclaimerProcedureSettingMutation
>;
export type CreateDisclaimerProcedureSettingMutationResult = Apollo.MutationResult<
  CreateDisclaimerProcedureSettingMutation
>;
export type CreateDisclaimerProcedureSettingMutationOptions = Apollo.BaseMutationOptions<
  CreateDisclaimerProcedureSettingMutation,
  CreateDisclaimerProcedureSettingMutationVariables
>;
export const UpdateOrganizationSettingDocument = gql`
  mutation updateOrganizationSetting($input: updateOrganizationSettingInput!) {
    updateOrganizationSetting(input: $input) {
      organizationSetting {
        _id
        disclaimerText
        temperatureUnit
        dateFormat
      }
    }
  }
`;
export type UpdateOrganizationSettingMutationFn = Apollo.MutationFunction<
  UpdateOrganizationSettingMutation,
  UpdateOrganizationSettingMutationVariables
>;

/**
 * __useUpdateOrganizationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingMutation, { data, loading, error }] = useUpdateOrganizationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationSettingMutation,
    UpdateOrganizationSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationSettingMutation,
    UpdateOrganizationSettingMutationVariables
  >(UpdateOrganizationSettingDocument, options);
}
export type UpdateOrganizationSettingMutationHookResult = ReturnType<
  typeof useUpdateOrganizationSettingMutation
>;
export type UpdateOrganizationSettingMutationResult = Apollo.MutationResult<
  UpdateOrganizationSettingMutation
>;
export type UpdateOrganizationSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationSettingMutation,
  UpdateOrganizationSettingMutationVariables
>;
